// Generated by scripts/translate-i18n/compile-i18n-index.js (npm run compile:i18n:index).
// Do not edit by hand: edit web-app/i18n/extracted/*.json and recompile.
// Core catalogue, one locale: what every page loads. Untranslated keys already hold the English text.
const messages: Record<string, string> = {
  "aboutEmployerScore.backToRankings": "Back to Companies",
  "aboutEmployerScore.breadcrumb.current": "Employer score",
  "aboutEmployerScore.breadcrumb.parent": "Companies",
  "aboutEmployerScore.intro": "The JobCrawls Employer Score rates employers on a letter-grade scale, from A down to E, derived from patterns we can measure consistently across job listings. It is meant to highlight employers who communicate clearly, structure compensation fairly, and advertise flexible, candidate-friendly roles, not to replace your own interviews and diligence.",
  "aboutEmployerScore.limits.changes": "Weights and signals may evolve as we improve detection; we aim to keep the methodology directionally stable.",
  "aboutEmployerScore.limits.listings": "Scores reflect what employers publish in listings we index, not internal HR policies we cannot see.",
  "aboutEmployerScore.limits.notEndorsement": "A higher score is not an endorsement, guarantee of quality, or legal/financial advice.",
  "aboutEmployerScore.limits.title": "Important limitations",
  "aboutEmployerScore.pillar.benefits.body": "We count how many distinct benefits and perks (health cover, pension top-ups, equipment budgets, and similar) employers mention across their listings, plus vacation time above Finland's statutory minimum.",
  "aboutEmployerScore.pillar.benefits.title": "Benefits & perks",
  "aboutEmployerScore.pillar.flex.body": "Remote and hybrid options are scored from how consistently employers advertise flexible work models across their open roles.",
  "aboutEmployerScore.pillar.flex.title": "Flexibility (remote / hybrid)",
  "aboutEmployerScore.pillar.growth.body": "When listings include seniority structure and career progression cues, we interpret that as stronger internal growth paths.",
  "aboutEmployerScore.pillar.growth.title": "Growth signals",
  "aboutEmployerScore.pillar.pay.body": "When we have enough listings with structured salary ranges, we score how competitive the typical band is against the Finnish market.",
  "aboutEmployerScore.pillar.pay.title": "Pay (posted salary bands)",
  "aboutEmployerScore.pillar.stability.body": "We look at hiring continuity over time: employers that maintain steady, non-spiky hiring patterns score higher than those with chaotic posting behavior.",
  "aboutEmployerScore.pillar.stability.title": "Hiring stability",
  "aboutEmployerScore.pillar.transparency.body": "We track how often listings disclose a real, non-estimated salary instead of a vague \"competitive salary\" line, and how often they document a recruitment-process timeline candidates can expect.",
  "aboutEmployerScore.pillar.transparency.title": "Transparency",
  "aboutEmployerScore.pillars.title": "What goes into the score",
  "aboutEmployerScore.tierExplainer": "We show a grade rather than an exact number on purpose: employers close together shouldn't look more different than the underlying signal actually supports. Grades, from strongest to weakest: A, B, C, D, E.",
  "aboutEmployerScore.title": "How the Employer Score works",
  "applyAutofill.applyManually": "Apply on the employer's site instead",
  "applyAutofill.coverLetterLabel": "Cover letter (optional)",
  "applyAutofill.email": "Email",
  "applyAutofill.failedGeneric": "We couldn't finish submitting this application automatically.",
  "applyAutofill.firstName": "First name",
  "applyAutofill.lastName": "Last name",
  "applyAutofill.no": "No",
  "applyAutofill.nothingSentYet": "Nothing has been sent to the employer yet.",
  "applyAutofill.pageTitle": "Review your application",
  "applyAutofill.phone": "Phone",
  "applyAutofill.polling": "Submitting your application now, this can take a minute…",
  "applyAutofill.preparing": "Preparing your application…",
  "applyAutofill.regenerate": "Regenerate",
  "applyAutofill.submitTo": "Submit to {company}",
  "applyAutofill.submitting": "Submitting…",
  "applyAutofill.viewInTracker": "View in your tracker",
  "applyAutofill.yes": "Yes",
  "auth.signInPrompt.closeLabel": "Close",
  "auth.signInPrompt.description": "Activate your account to save jobs, sync progress, and pick up your search on any device.",
  "auth.signInPrompt.primaryAction": "Activate account",
  "auth.signInPrompt.secondaryAction": "Maybe later",
  "auth.signInPrompt.title": "Sign in to save jobs",
  "backoffice.accessDenied.home": "Back to JobCrawls",
  "backoffice.accessDenied.signIn": "Sign in",
  "backoffice.accessDenied.signOut": "Sign out",
  "backoffice.accessDenied.signedInAs": "You are signed in as {email}, which is not authorized for the backoffice. If you have another account, sign out and sign in with that one.",
  "backoffice.accessDenied.signedOut": "The backoffice is restricted to authorized accounts. Sign in with one to continue.",
  "backoffice.accessDenied.title": "No backoffice access",
  "backoffice.businessDevelopment.nav": "Business Development",
  "backoffice.category.engineering": "Engineering Tools",
  "backoffice.dashboard": "Dashboard",
  "backoffice.dataExport.nav": "Data export",
  "backoffice.emailAlerts.nav": "Email alerts",
  "backoffice.experiments.nav": "Feature flags & experiments",
  "backoffice.frameKit.nav": "Frame Kit",
  "backoffice.hub.desc.businessDevelopment": "Monetisation plans, strategy notes, and market research for reference.",
  "backoffice.hub.desc.dashboard": "Manage company crawls, pipeline health, and crawl tooling.",
  "backoffice.hub.desc.dataExport": "Fulfill a GDPR access or portability request by exporting one user's stored data as JSON.",
  "backoffice.hub.desc.emailAlerts": "Monitor job-alert sends, bounces, complaints, and unsubscribes.",
  "backoffice.hub.desc.experiments": "Toggle personal feature-flag cookies, and start/pause/stop live A/B tests and fake-door flags.",
  "backoffice.hub.desc.frameKit": "Make social and marketing graphics from a screenshot and a headline, export as PNG.",
  "backoffice.hub.desc.mcpKeys": "Mint internal-scope MCP API keys for ops/analytics tooling.",
  "backoffice.hub.desc.outreachCrm": "Draft, preview, and send outreach email; track status, opens, and follow-ups.",
  "backoffice.hub.desc.pipelineLogs": "Live tail of crawl, enrich, and indexing Lambda logs.",
  "backoffice.hub.desc.search": "Typesense collection health and live search inspector.",
  "backoffice.hub.desc.srpIndexability": "Check live index/noindex and robots.txt decisions for any SRP URL.",
  "backoffice.hub.desc.testing": "Integration health checks and debug toggles.",
  "backoffice.hub.desc.userAgents": "CloudFront and WAF request logs: bots, user agents, countries and status codes.",
  "backoffice.hub.nav": "All tools",
  "backoffice.mcpKeys.nav": "API keys",
  "backoffice.nav.breadcrumb": "Breadcrumb",
  "backoffice.nav.close": "Close",
  "backoffice.nav.current": "Current",
  "backoffice.nav.findTool": "Find a tool",
  "backoffice.nav.hint": "Arrow keys to move, Enter to open, Shift+Enter to pin or unpin",
  "backoffice.nav.jumpToTool": "Jump to backoffice tool",
  "backoffice.nav.noResults": "No tools match \"{query}\".",
  "backoffice.nav.pin": "Pin {tool}",
  "backoffice.nav.pinned": "Pinned",
  "backoffice.nav.recent": "Recent",
  "backoffice.nav.searchLabel": "Search backoffice tools",
  "backoffice.nav.searchPlaceholder": "Search tools…",
  "backoffice.nav.unpin": "Unpin {tool}",
  "backoffice.outreachCrm.nav": "Outreach CRM",
  "backoffice.pipelineLogs.nav": "Pipeline logs",
  "backoffice.search.nav": "Search cluster",
  "backoffice.srpIndexability.nav": "SRP indexability",
  "backoffice.subpage.hiringSignals": "Hiring signals market entry",
  "backoffice.subpage.monetisationPlan": "Monetisation plan",
  "backoffice.testing": "Testing",
  "backoffice.title": "Backoffice",
  "backoffice.userAgents.nav": "Bot & WAF traffic",
  "bestCompanies.breadcrumb.current": "Employers",
  "bestCompanies.hub.watchlistStrip.following": "Following <b>{count}</b>",
  "bestCompanies.hub.watchlistStrip.newThisWeek": "<b>{count} new</b> roles this week",
  "bestCompanies.hub.watchlistStrip.open": "Open in My Jobs →",
  "bestCompanies.row.networkWorthy": "Worth networking with",
  "breadcrumb.benefits": "Benefits",
  "breadcrumb.company": "Company",
  "breadcrumb.educationLevel": "Education",
  "breadcrumb.industry": "Industry",
  "breadcrumb.isDriversLicenseRequired": "Driver's License",
  "breadcrumb.isOpenApplication": "Open Application",
  "breadcrumb.jobType": "Job Type",
  "breadcrumb.jobs": "Jobs",
  "breadcrumb.language": "Language",
  "breadcrumb.level": "Level",
  "breadcrumb.location": "Location",
  "breadcrumb.navigation": "Breadcrumb navigation",
  "breadcrumb.peopleManagementTier": "Management",
  "breadcrumb.remote": "Remote",
  "breadcrumb.skillsAndTechnologies": "Skills/Tech",
  "checklist.field.addTrigger": "Add checklist",
  "checklist.field.placeholder": "Add a task and press Enter…",
  "checklist.field.progressTrigger": "{done}/{total} done",
  "checklist.field.remove": "Remove task {text}",
  "collectiveAgreements.aiTranslatedBadge": "Machine-translated",
  "collectiveAgreements.bindingLegend": "What \"unresolved\" means:",
  "collectiveAgreements.bindingLegendBody": "the Confirmation Board didn't name that agreement in any of the annual reviews we have on file; that's a genuine gap in the record, not a \"no.\"",
  "collectiveAgreements.bindingNo": "Not generally binding",
  "collectiveAgreements.bindingUnknown": "Unknown",
  "collectiveAgreements.bindingYes": "Binding",
  "collectiveAgreements.breadcrumb.current": "Collective Agreements",
  "collectiveAgreements.decisionNoPrefix": "Decision no.",
  "collectiveAgreements.editorialStandardsLinkLabel": "editorial standards",
  "collectiveAgreements.eyebrow": "Reference · Finlex & Ministry of Social Affairs and Health",
  "collectiveAgreements.filterLabel": "Filter collective agreements by name",
  "collectiveAgreements.filterPlaceholder": "Search by agreement name…",
  "collectiveAgreements.intro": "A työehtosopimus sets the minimum pay and terms for a job. Which one applies depends on the employer's industry and the kind of role. We link job ads to our best guess automatically; this is the full source list, so you can check that guess yourself.",
  "collectiveAgreements.noResults": "No agreements match your search.",
  "collectiveAgreements.pdfFi": "PDF (Finnish)",
  "collectiveAgreements.pdfSv": "PDF (Swedish)",
  "collectiveAgreements.resultsCount": "Showing {shown} of {total} agreements ({binding} confirmed generally binding)",
  "collectiveAgreements.scopeHeading": "Scope of application",
  "collectiveAgreements.scopeUnavailable": "No scope-of-application text is available for this agreement.",
  "collectiveAgreements.sourceLanguageDisclaimer": "Agreement names and scope text below are shown in English/Swedish where a machine translation is available, and in the original Finnish otherwise: Finlex publishes no official translation of them. These translations are unofficial and may contain errors; the original Finnish wording from Finlex is authoritative. Other text on this page may also be machine-translated; see our {editorialStandardsLink}.",
  "collectiveAgreements.stat.binding": "Confirmed binding",
  "collectiveAgreements.stat.total": "Agreements on file",
  "collectiveAgreements.stat.unresolved": "Status unresolved",
  "collectiveAgreements.title": "Finnish collective agreements",
  "collectiveAgreements.viewOnFinlex": "Finlex",
  "company.bulkFollow.cta": "{count, plural, one {Follow this company} other {Follow all {count}}}",
  "company.bulkFollow.followedToast": "{count, plural, one {Following 1 company. Watchlist updated} other {Following {count} companies. Watchlist updated}}",
  "company.follow.createAccount": "Activate account",
  "company.follow.cta": "Follow",
  "company.follow.emailPrompt.enabled": "You're set. New roles from companies you follow will be in your job-alert emails.",
  "company.follow.emailPrompt.failed": "Couldn't turn on email updates. You can enable them any time from the Alerts page.",
  "company.follow.emailPrompt.offer": "Following {company}. Want an email when they post new roles?",
  "company.follow.emailPrompt.pendingConfirmation": "Almost there: confirm your email in your inbox to activate updates.",
  "company.follow.emailPrompt.turnOn": "Turn on",
  "company.follow.followedToast": "Following. Watchlist updated",
  "company.follow.following": "Following",
  "company.follow.followingCheck": "Following ✓",
  "company.follow.undo": "Undo",
  "company.follow.unfollow": "Unfollow",
  "company.follow.unfollowedToast": "Unfollowed. You won’t be notified of their new roles",
  "company.follow.viewWatchlist": "View →",
  "company.logoAlt": "{company} logo",
  "company.logoAltGeneric": "Employer logo",
  "companyChart.caption.averaging": "averaging {avg} jobs per month",
  "companyChart.caption.hiringDeclining": "{companyName}'s hiring is declining",
  "companyChart.caption.hiringGrowing": "{companyName}'s hiring is growing",
  "companyChart.caption.hiringRapidlyDeclining": "{companyName}'s hiring is rapidly declining",
  "companyChart.caption.hiringRapidlyGrowing": "{companyName}'s hiring is rapidly growing",
  "companyChart.caption.hiringStable": "{companyName}'s hiring is stable",
  "companyChart.caption.levelDistributionDouble": "{companyName} hires mostly at the {level1} and {level2} levels.",
  "companyChart.caption.levelDistributionSingle": "{companyName} hires mostly at the {level} level.",
  "companyChart.caption.levelDistributionTriple": "{companyName} hires mostly at the {level1}, {level2}, and {level3} levels.",
  "companyChart.caption.locationDistributionDouble": "{companyName} hires mostly in {location1} and {location2}.",
  "companyChart.caption.locationDistributionSingle": "{companyName} hires mostly in {location}.",
  "companyChart.caption.locationDistributionTriple": "{companyName} hires mostly in {location1}, {location2}, and {location3}.",
  "companyChart.caption.margin": "and a profit margin of {margin}",
  "companyChart.caption.marginOnly": "{companyName} had a profit margin of {margin} in 2024",
  "companyChart.caption.profitable": "{companyName} was profitable in 2024",
  "companyChart.caption.remotenessHybrid": "{companyName} hires mostly hybrid positions.",
  "companyChart.caption.remotenessOnsite": "{companyName} hires mostly onsite positions.",
  "companyChart.caption.remotenessRemote": "{companyName} hires mostly remote positions.",
  "companyChart.caption.revenue": "{companyName} had revenue of {revenue} in 2024",
  "companyChart.caption.revenueWith": "with revenue of {revenue}",
  "companyChart.caption.roleDistributionDouble": "{companyName} hires mostly {role1} and {role2} roles.",
  "companyChart.caption.roleDistributionSingle": "{companyName} hires mostly {role} roles.",
  "companyChart.caption.roleDistributionTriple": "{companyName} hires mostly {role1}, {role2}, and {role3} roles.",
  "companyChart.caption.unprofitable": "{companyName} was unprofitable in 2024",
  "companyChart.caption.workforceRate": "({rate}% of their workforce)",
  "companyChart.financialOverview": "Financial Overview (2024)",
  "companyChart.insufficientData": "Limited data available - trends require at least 3 months of data",
  "companyChart.monthlyHiringTrends": "Monthly Hiring Trends",
  "companyChart.moreCategories": "+{count} more",
  "companyChart.profit": "Profit",
  "companyChart.profitMargin": "Profit Margin",
  "companyChart.revenue": "Revenue",
  "companyChart.trend.declining": "Declining",
  "companyChart.trend.growing": "Growing",
  "companyChart.trend.insufficientData": "Limited Data",
  "companyChart.trend.rapidlyDeclining": "Rapidly Declining",
  "companyChart.trend.rapidlyGrowing": "Rapidly Growing",
  "companyChart.trend.stable": "Stable",
  "companyChart.trendDescription.declining": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.growing": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.rapidlyDeclining": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.rapidlyGrowing": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.simpleDeclining": "Hiring {avg} jobs/month on average",
  "companyChart.trendDescription.simpleGrowing": "Hiring {avg} jobs/month on average",
  "companyChart.trendDescription.simpleStable": "Hiring {avg} jobs/month on average",
  "companyChart.trendDescription.stable": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyGroupingToggle.label": "Group jobs by company",
  "companyHeader.jobCount": "{count, plural, one {# open position} other {# open positions}}",
  "companyHeader.locationCount": "{count, plural, one {# location} other {# locations}}",
  "companyInsight.bodyNoLocations": "appears in {count, plural, one {# indexed job posting} other {# indexed job postings}} in JobCrawls' Finland dataset since {sinceDate}. This reflects historical index data, not a live count of open vacancies.",
  "companyInsight.bodyWithLocations": "appears in {count, plural, one {# indexed job posting} other {# indexed job postings}} in JobCrawls' Finland dataset since {sinceDate}. In that historical index, the strongest location signals for this employer are {locationList}.",
  "companyInsight.englishRequirement": "{percent}% of those indexed postings mention English as a requirement.",
  "companyProfile.commonBenefits.heading": "Common benefits",
  "companyProfile.communityInsights.consTitle": "Common complaints",
  "companyProfile.communityInsights.heading": "What people say online",
  "companyProfile.communityInsights.prosTitle": "What people like",
  "companyProfile.communityInsights.sentimentInsufficient": "Not enough data",
  "companyProfile.communityInsights.sentimentMixed": "Mixed",
  "companyProfile.communityInsights.sentimentNegative": "Mostly negative",
  "companyProfile.communityInsights.sentimentPositive": "Mostly positive",
  "companyProfile.communityInsights.sourcesTitle": "Sources",
  "companyProfile.communityInsights.subtitle": "Summarized from public Reddit, Suomi24, and forum discussion",
  "companyProfile.companyFacts.benefitsLabel": "Benefits",
  "companyProfile.companyFacts.contactLabel": "Contact",
  "companyProfile.companyFacts.corporateHistoryLabel": "Ownership",
  "companyProfile.companyFacts.heading": "Good to know",
  "companyProfile.companyFacts.officeLocationsLabel": "Offices",
  "companyProfile.companyFacts.remotePolicyLabel": "Remote work",
  "companyProfile.companyFacts.teamLabel": "Team",
  "companyProfile.companyFacts.teamLinkText": "Meet the team",
  "companyProfile.companyFacts.valuesLabel": "Values",
  "companyProfile.ownedBrands.heading": "Owned brands",
  "companyProfile.siteSources.sourceLabel": "Source",
  "cookie.consent.accept": "Accept analytics",
  "cookie.consent.analyticsBody": "Helps us spot searches that return no results and pages people get stuck on, so we can fix them. Some visits are recorded so we can see where a page breaks: what you type is always hidden, pages with your own account, profile or applications are never recorded, and recordings are deleted after 30 days. Optional, and never used for ads.",
  "cookie.consent.analyticsTitle": "Analytics",
  "cookie.consent.banner": "We use essential cookies to run JobCrawls. With your OK, we also use privacy-friendly analytics and record some visits, never what you type. It helps us spot searches that come up empty and pages people get stuck on, so we can fix them faster. Never for ads. You can change your mind anytime.",
  "cookie.consent.cancel": "Cancel",
  "cookie.consent.manage": "Manage preferences",
  "cookie.consent.modalTitle": "Cookie preferences",
  "cookie.consent.necessaryNote": "Essential cookies (session, preferences, security) are always used so the site works.",
  "cookie.consent.nudge": "You can turn on privacy-friendly analytics anytime. It helps us catch broken searches faster.",
  "cookie.consent.privacyLink": "Privacy Policy",
  "cookie.consent.reject": "Reject non-essential",
  "cookie.consent.save": "Save choices",
  "cookie.consent.title": "Cookies and privacy",
  "employerPortal.nav": "Employer portal",
  "employerScoreCard.dimension.benefits": "benefits",
  "employerScoreCard.dimension.flexibility": "flexibility",
  "employerScoreCard.dimension.growth": "growth",
  "employerScoreCard.dimension.pay": "pay",
  "employerScoreCard.dimension.stability": "stability",
  "employerScoreCard.dimension.transparency": "transparency",
  "employerScoreCard.disclaimer": "Computed from job data signals, not reviews",
  "employerScoreCard.howWeCalculate": "How we calculate this",
  "employerScoreCard.methodology": "This grade is based on salary competitiveness from posted bands (where we have enough listings), remote and hybrid flexibility, hiring stability over time, growth signals from role mix and hiring volume trends, benefits and perks mentioned in postings, and transparency (how often postings disclose a real, non-estimated salary and a recruitment-process timeline).",
  "employerScoreCard.strongestAt": "Strongest at {dimension}",
  "employerScoreCard.subscore.benefits": "Benefits",
  "employerScoreCard.subscore.flexibility": "Flexibility",
  "employerScoreCard.subscore.growth": "Growth",
  "employerScoreCard.subscore.pay": "Pay",
  "employerScoreCard.subscore.stability": "Stability",
  "employerScoreCard.subscore.transparency": "Transparency",
  "employerScoreCard.title": "JobCrawls Employer Score",
  "engagement.nav.signIn": "Sign in",
  "engagement.trustpilotPrompt.leaveReview": "Leave a review",
  "engagement.trustpilotPrompt.offer": "You've been using My Jobs. Would you share an honest review of JobCrawls on Trustpilot?",
  "feedback.button.label": "Give us feedback",
  "feedback.cancel": "Cancel",
  "feedback.error": "Failed to submit feedback. Please try again.",
  "feedback.label": "Your Feedback",
  "feedback.modal.close": "Close",
  "feedback.modal.description": "We'd love to hear your thoughts. Share your feedback to help us improve.",
  "feedback.modal.title": "Send Feedback",
  "feedback.placeholder": "Tell us what we should change or add...",
  "feedback.postSubmit.signInBody": "Activate your account so we can reply if we have questions about your feedback.",
  "feedback.postSubmit.signInButton": "Sign in or activate account",
  "feedback.postSubmit.signInTitle": "Want us to follow up?",
  "feedback.submit": "Submit",
  "feedback.submitting": "Submitting...",
  "feedback.success": "Thank you! Your feedback has been submitted.",
  "filters.allFilters.navigation": "All filter options",
  "filters.connector.and": "AND",
  "filters.connector.or": "OR",
  "filters.top.ariaLabel": "Filter categories",
  "filters.top.clearAll": "Clear all filters",
  "footer.aboutJobcrawls": "About JobCrawls",
  "footer.accessibilityStatementLink": "Accessibility statement",
  "footer.allLocations": "All locations",
  "footer.bestEmployers": "Employers",
  "footer.brandDescription": "JobCrawls is a job search engine for Finland. Jobs from Finnish employers and remote jobs from abroad, updated every day in English, Finnish and Swedish.",
  "footer.browseAllPages": "Browse all pages",
  "footer.businessIdLabel": "Business ID",
  "footer.colCompany": "Company",
  "footer.colEmployersAndDevelopers": "Employers & developers",
  "footer.colFindJobs": "Find jobs",
  "footer.colJobSeekers": "Job seekers",
  "footer.collectiveAgreementsLink": "Collective agreements",
  "footer.connectorPrivacy": "Connector privacy",
  "footer.contact": "Contact",
  "footer.cookieSettings": "Cookie settings",
  "footer.copyright": "© 2026 {company}",
  "footer.editorialStandards": "Editorial standards",
  "footer.featuresLink": "Features",
  "footer.forDevelopers": "For Developers",
  "footer.forEmployersLink": "For employers",
  "footer.freeCareersPageLink": "Careers page",
  "footer.guidesAndArticles": "Guides & articles",
  "footer.howCrawlerWorks": "How our crawler works",
  "footer.jobsInEspoo": "Jobs in Espoo",
  "footer.jobsInHelsinki": "Jobs in Helsinki",
  "footer.jobsInOulu": "Jobs in Oulu",
  "footer.jobsInTampere": "Jobs in Tampere",
  "footer.jobsInTurku": "Jobs in Turku",
  "footer.openJobsInFinland": "Open jobs in Finland",
  "footer.partnerships": "Media partnerships",
  "footer.privacy": "Privacy Policy",
  "footer.remoteJobs": "Remote jobs",
  "footer.rolesIndex": "Jobs by role",
  "footer.salariesByRole": "Salaries by role",
  "footer.signIn": "Sign in",
  "footer.sitemap": "Site Map",
  "footer.terms": "Terms of Service",
  "forEmployers.contact.desc": "Tell us what you're interested in and a bit about your team.",
  "forEmployers.contact.error": "Something went wrong. Please try again.",
  "forEmployers.contact.interest.branding": "Employer Branding Support",
  "forEmployers.contact.interest.careers": "Hosted Careers Page",
  "forEmployers.contact.interest.other": "Something else",
  "forEmployers.contact.interestLabel": "What are you interested in?",
  "forEmployers.contact.learnMore": "Learn More About Us",
  "forEmployers.contact.placeholder": "Tell us about your hiring needs…",
  "forEmployers.contact.submit": "Send Inquiry",
  "forEmployers.contact.submitting": "Submitting…",
  "forEmployers.contact.success": "Thanks! We'll get back to you soon.",
  "forEmployers.contact.title": "Express interest",
  "forEmployers.cta.expressInterest": "Express Interest",
  "forEmployers.cta.seeScore": "See How the Employer Score Works",
  "forEmployers.hero.body": "We crawl your careers page directly, so job seekers find your real listings next to real salary data. No posting, no dashboard. If you want more, we also offer a hosted careers page and hands-on employer branding support.",
  "forEmployers.hero.point.automatic": "Your public listings appear without signing up",
  "forEmployers.hero.point.real": "Real crawl data, straight from your own site",
  "forEmployers.hero.point.score": "Transparent, published Employer Score",
  "forEmployers.hero.point.trilingual": "Available in EN, FI, SV",
  "forEmployers.new.branding.cta": "Talk to us about branding",
  "forEmployers.new.branding.desc": "We work directly with your team to sharpen how your company profile reads (culture, values, and role clarity).",
  "forEmployers.new.branding.title": "Employer Branding Support",
  "forEmployers.new.careers.cta": "Get a hosted careers page",
  "forEmployers.new.careers.desc": "No careers page? We host a branded one for you. You paste your job ad links and we handle the rest. Your site's open-positions button finally has somewhere real to point.",
  "forEmployers.new.careers.learnMore": "Learn more",
  "forEmployers.new.careers.pilotNote": "We're opening this up to a small group of employers first.",
  "forEmployers.new.careers.title": "Hosted Careers Page",
  "forEmployers.new.subtitle": "We're opening these up to a small group of employers first.",
  "forEmployers.new.title": "New: ways to stand out",
  "forEmployers.score.cta": "Read the full methodology",
  "forEmployers.score.ctaBestCompanies": "See the Companies rankings",
  "forEmployers.score.desc": "One letter grade across six pillars, fully published.",
  "forEmployers.score.pillar.benefits": "Benefits & perks",
  "forEmployers.score.pillar.flex": "Flexibility",
  "forEmployers.score.pillar.growth": "Growth signals",
  "forEmployers.score.pillar.pay": "Pay",
  "forEmployers.score.pillar.stability": "Hiring stability",
  "forEmployers.score.pillar.transparency": "Transparency",
  "forEmployers.score.title": "The Employer Score",
  "forEmployers.subtitle": "Your open roles already show up here, automatically, in English, Finnish, and Swedish.",
  "forEmployers.title": "For Employers",
  "forEmployers.today.step1.desc": "We read the job listings already public on your own site and show them on JobCrawls. You do not need to submit anything, and you can ask us to change or remove a listing.",
  "forEmployers.today.step1.title": "We crawl your careers page",
  "forEmployers.today.step2.desc": "Through search, salary comparisons, and our Companies rankings, available in English, Finnish, and Swedish.",
  "forEmployers.today.step2.title": "Job seekers find you",
  "forEmployers.today.step3.desc": "On pay transparency, flexibility, hiring stability, and growth signals. The same published methodology applies to every company we score.",
  "forEmployers.today.step3.title": "You get scored, transparently",
  "forEmployers.today.title": "How you already show up",
  "forEmployers.values.desc": "We only want to be worth your applicants' time. That means showing measurable signals of pay transparency and stability. We build anything new, like employer branding support, on top of that standard, not around it.",
  "forEmployers.values.title": "Our values",
  "freeCareersPage.breadcrumb": "Careers page",
  "freeCareersPage.cta": "Get your careers page",
  "freeCareersPage.cta.hint": "Tell us your company name and we'll take it from there.",
  "freeCareersPage.cta.pilotNote": "We're opening these up to a small group of employers first, so we read and set up every request ourselves.",
  "freeCareersPage.features.apply": "Candidates apply through your original LinkedIn ad, so there's no new inbox to watch",
  "freeCareersPage.features.branded": "Your branding: logo, colors, and your own intro text",
  "freeCareersPage.features.fresh": "Listings expire automatically when the ad closes",
  "freeCareersPage.features.languages": "Three languages: English, Finnish, and Swedish",
  "freeCareersPage.features.search": "Your roles also appear in JobCrawls search",
  "freeCareersPage.features.title": "What's included",
  "freeCareersPage.features.zero": "Nothing to install or maintain: no plugins, no CMS",
  "freeCareersPage.hero.subtitle": "Hiring through LinkedIn but have nowhere on your own site to show it? We host a branded careers page for you (your logo, your colors, your open roles) with nothing to install or maintain.",
  "freeCareersPage.hero.title": "A branded careers page for your company",
  "freeCareersPage.how.step1.desc": "One email to get started. We create your branded page (logo, brand color, and an intro you can edit) in English, Finnish, and Swedish.",
  "freeCareersPage.how.step1.title": "We set up your page",
  "freeCareersPage.how.step2.desc": "Post on LinkedIn like you already do, then paste the ad's link into your portal. We pull in the details, translate them, and keep the listing fresh. It disappears automatically when the ad closes.",
  "freeCareersPage.how.step2.title": "Paste your job links",
  "freeCareersPage.how.step3.desc": "Change your website's “Open positions” button to link to your new careers page, so people who visit your site find your openings.",
  "freeCareersPage.how.step3.title": "Point your site at it",
  "freeCareersPage.how.title": "How it works",
  "freeCareersPage.portalLink": "Already set up? Open your employer portal",
  "freeCareersPage.whyFree.desc": "JobCrawls is a job search engine for Finland. When your careers page lives with us, your openings become part of our index (jobs that would otherwise only exist on LinkedIn), and the link from your website tells search engines (and us) the page is really yours.",
  "freeCareersPage.whyFree.title": "Why we host it",
  "hit.applicationDeadline": "Deadline: {date}",
  "hit.companyInsights.cue": "Company insights",
  "hit.companyLinkTitle": "Open company profile: data and insights for {company}",
  "hit.companyProfile.aria": "View company profile, hiring data, and insights for {company}",
  "hit.driversLicenseRequired": "Driver's Licence Required",
  "hit.hidden": "Hidden",
  "hit.hide.button": "Hide",
  "hit.hide.menu": "Hide",
  "hit.jobTitle": "Job",
  "hit.linkCopied": "Link copied to clipboard!",
  "hit.locationLinkAria": "Search for jobs in {location}",
  "hit.locationLinkTitle": "Search for jobs in {location}",
  "hit.locationNotAvailable": "Location not available",
  "hit.markAsApplied.menu": "Mark as Applied",
  "hit.markAsState": "Mark as {state}",
  "hit.moreOptions": "More options",
  "hit.openApplication": "Open Application",
  "hit.postedDate": "Posted: {date}",
  "hit.postedDate.detail": "Posted: {date}",
  "hit.removeApplied": "Remove from applied",
  "hit.salaryNotSpecified.card": "Salary not specified",
  "hit.save": "Save",
  "hit.save.detail": "Save",
  "hit.saved": "Saved",
  "hit.saved.detail": "Saved",
  "hit.seeAd": "Details",
  "hit.share.detail": "Share",
  "hit.shareError": "Something went wrong while trying to share this job.",
  "hit.shareError.retry": "Retry",
  "hit.summerJob": "Summer Job",
  "hit.toast.applied": "Marked as applied",
  "hit.toast.hidden": "Job hidden",
  "hit.toast.hidden.undo": "Undo",
  "hit.toast.savedWithCount": "Saved: {count, plural, one {# job} other {# jobs}} in My Jobs",
  "hit.toast.unapplied": "Removed from applied",
  "hit.toast.unhidden": "Job unhidden",
  "hit.toast.unsaved": "Job removed from saved",
  "hit.toast.viewMyJobs": "View →",
  "hit.toast.viewed": "Marked as viewed",
  "hit.unhide": "Unhide job",
  "hitGroup.openRoles": "{count, plural, one {# open role} other {# open roles}}",
  "hitGroup.viewCompanyProfile": "View company profile",
  "hitV2.estMonthly": "Est. Monthly",
  "hitV2.monthly": "Monthly",
  "hitV2.viewJob": "View job",
  "hub.bottomNav.alerts": "Alerts",
  "hub.bottomNav.ariaLabel": "Hub navigation",
  "hub.bottomNav.profile": "Profile",
  "hub.guestSyncNote": "Saved on this device; {signIn} to sync across devices",
  "hub.guestSyncNote.signIn": "sign in",
  "hub.nav.myJobs": "My Jobs",
  "hub.nav.myJobs.count": "{savedCount} saved · {activeCount} active",
  "hub.nav.profile": "Profile & CV",
  "hub.nav.searchesAlerts": "Searches & Alerts",
  "hub.nav.searchesAlerts.newCount": "{count} new",
  "hub.nav.watchlist": "Watchlist",
  "hub.nav.watchlist.newsCount": "{count} with news",
  "instantsearch.searchBoxLink.placeholder": "Search for jobs",
  "instantsearch.searchbox.placeholder": "Search jobs, language, or city",
  "job.copyCompanyName": "Copy company name",
  "jobAlerts.confirm.confirm": "Confirm",
  "jobAlerts.confirm.errorBody": "Something went wrong. Please try again in a moment.",
  "jobAlerts.confirm.explanation": "Confirm your email address to start receiving job alert emails from JobCrawls.",
  "jobAlerts.confirm.heading": "Confirm your job alerts",
  "jobAlerts.confirm.invalidLink": "This confirmation link is invalid or has expired. Turn alerts on again from your saved searches to get a new one.",
  "jobAlerts.confirm.successBody": "You're all set. We'll email you when new jobs match your saved searches.",
  "jobAlerts.confirm.successHeading": "Your email is confirmed",
  "jobAlerts.confirm.working": "Confirming…",
  "jobAlerts.newMatches.errorBody": "We couldn't load your new matches. Please try again in a moment.",
  "jobAlerts.newMatches.viewAllInSection": "View all {count} new matches",
  "jobAlerts.panel.activeStatus.v2": "Turn on alerts for individual searches below to start receiving them.",
  "jobAlerts.panel.detailCopy.v2": "Weekly on Monday mornings by default, or daily if you prefer. Sent to {email}. Turn off anytime here, or from the link in every email.",
  "jobAlerts.panel.disable": "Turn off alerts",
  "jobAlerts.panel.enable": "Turn on alerts",
  "jobAlerts.panel.error": "Saving failed. Please try again.",
  "jobAlerts.panel.frequencyDaily": "Daily",
  "jobAlerts.panel.frequencyDailyHint": "Every day",
  "jobAlerts.panel.frequencyLegend": "How often",
  "jobAlerts.panel.frequencyWeekly.v2": "Weekly",
  "jobAlerts.panel.frequencyWeeklyHint": "Monday mornings",
  "jobAlerts.panel.heading": "Job alerts",
  "jobAlerts.panel.languageLegend": "{channels, select, email {Email language} other {Alert language}}",
  "jobAlerts.panel.leadCopy": "Get new jobs that match your saved searches by email, notifications, or both.",
  "jobAlerts.panel.noEmail": "Your account has no email address, so alerts are unavailable.",
  "jobAlerts.panel.pendingStatus.v2": "Check your inbox to confirm your email and activate alerts.",
  "jobAlerts.panel.privacyLink": "Privacy policy",
  "jobAlerts.panel.sectionHeading": "Alert settings",
  "jobAlerts.panel.seeNewMatches": "See new matches now",
  "jobAlerts.panel.statusOff": "Off",
  "jobAlerts.panel.statusOn": "On",
  "jobAlerts.panel.statusPending": "Confirming",
  "jobAlerts.panel.update": "Save changes",
  "jobAlerts.toggle.failed": "Couldn't save. Try again",
  "jobAlerts.toggle.label": "{delivery, select, push {Notify me of new matches} both {Email and notify me of new matches} other {Email me new matches}}",
  "jobAlerts.toggle.needsSubscription": "Turn on job alerts above first",
  "jobAlerts.unsubscribe.confirm": "Unsubscribe",
  "jobAlerts.unsubscribe.errorBody": "Something went wrong. Please try again in a moment.",
  "jobAlerts.unsubscribe.explanation": "This stops all job alert emails from JobCrawls to your address. Your saved searches stay untouched.",
  "jobAlerts.unsubscribe.heading": "Unsubscribe from job alerts",
  "jobAlerts.unsubscribe.invalidLink": "This unsubscribe link is invalid or incomplete. Use the link from a recent alert email, or manage alerts from your saved searches when signed in.",
  "jobAlerts.unsubscribe.successBody": "You will no longer receive job alert emails. You can re-enable alerts anytime from your saved searches when signed in.",
  "jobAlerts.unsubscribe.successHeading": "You are unsubscribed",
  "jobAlerts.unsubscribe.working": "Unsubscribing…",
  "jobAlerts.watchlistDigest.combined": "Combined with your job alerts",
  "jobAlerts.watchlistDigest.error.v2": "Couldn't save. Please try again.",
  "jobAlerts.watchlistDigest.frequencyLegend": "How often for watchlist updates",
  "jobAlerts.watchlistDigest.legend": "Watchlist updates",
  "jobAlerts.watchlistDigest.saving": "Saving…",
  "jobAlerts.watchlistDigest.separate": "Send separately",
  "jobChart.popover.categoriesShown": "Categories shown",
  "jobChart.popover.companyContext": "Based on {companyName} listings in our data.",
  "jobChart.popover.count": "Job postings",
  "jobChart.popover.monthKey": "Period",
  "jobChart.popover.share": "Share of chart",
  "jobChart.popover.totalInRing": "Total in this ring",
  "jobChart.segmentHint": "Tap or hover a segment for details.",
  "jobDetail.lastSeen.daysAgo": "{value, plural, one {Updated {value} day ago} other {Updated {value} days ago}}",
  "jobDetail.lastSeen.hoursAgo": "{value, plural, one {Updated {value} hour ago} other {Updated {value} hours ago}}",
  "jobDetail.lastSeen.minutesAgo": "{value, plural, one {Updated {value} minute ago} other {Updated {value} minutes ago}}",
  "jobDetail.relatedPages.intro": "The role, city, employer and pay pages behind this listing.",
  "jobDetail.relatedPages.title": "Explore more",
  "jobDetail.roleHub.jobsInCity": "{role} jobs in {city}",
  "jobDetail.roleHub.moreJobs": "More {role} jobs",
  "jobDetail.save.alsoFollowAction": "Follow",
  "jobDetail.save.alsoFollowToast": "Job saved. Follow {company} to hear about their next roles?",
  "jobDetail.save.nowFollowingToast": "Following {company}. New roles will show on your watchlist.",
  "jobDetail.similarJobs.algoliaListTitle": "Similar jobs",
  "jobDetail.similarJobs.description": "Discover more opportunities that match your interests and skills",
  "jobDetail.similarJobs.seeAll": "See all",
  "jobDetail.similarJobs.sourceNote": "From JobCrawls search: same role title and primary location as this listing (this job excluded). Up to 8 results.",
  "jobDetail.similarJobs.title": "Related Opportunities",
  "jobDetail.viewOnMapCommute": "See on map & check your commute",
  "jobDetailAlertCta.bannerText": "Never miss a new {role} job like this",
  "jobDetailAlertCta.bannerTextWithLocation": "Never miss a new {role} job in {location}",
  "jobDetailAlertCta.ctaButton": "Get job alerts",
  "jobDetailAlertCta.dismissLabel": "Dismiss",
  "jobDetailAlertCta.errorText": "Something went wrong. We couldn't turn on alerts. Please try again.",
  "jobDetailAlertCta.manageLink": "Manage alerts",
  "jobDetailAlertCta.pendingText": "Almost there: check your inbox to confirm your email and activate alerts.",
  "jobDetailAlertCta.subText": "Weekly or daily digest. Unsubscribe anytime.",
  "jobDetailAlertCta.successText": "You're set. {channels, select, push {We'll notify you} both {We'll email and notify you} other {We'll email you}} about jobs like this.",
  "jobDetailPage.404.backHome": "Back to Home",
  "jobDetailPage.404.description": "Sorry, we couldn't find this job. It may have been removed or the link is incorrect.",
  "jobDetailPage.404.heading": "This page is not found",
  "jobDetailPage.aboutCompany": "About",
  "jobDetailPage.applicationDeadline": "Application deadline",
  "jobDetailPage.applied": "Applied ✓",
  "jobDetailPage.applyMoreOptions": "More apply options",
  "jobDetailPage.applyNavigation": "Apply to job",
  "jobDetailPage.applyNow": "Apply",
  "jobDetailPage.autofillApplyCta": "Autofill this application",
  "jobDetailPage.availableLanguages": "Available in:",
  "jobDetailPage.benefits": "Benefits",
  "jobDetailPage.benefitsAndPerks": "Benefits & perks",
  "jobDetailPage.businessId": "Business ID",
  "jobDetailPage.byRemoteness": "By Remoteness",
  "jobDetailPage.chartsDataRange": "Data shown is based on historical job postings from our database.",
  "jobDetailPage.companiesHiringInLocation": "Companies Hiring in {location}",
  "jobDetailPage.companyCollapsedBody": "Expand to view trend charts, location distribution, language demand, and map details.",
  "jobDetailPage.companyDistributionDescription": "Showing top {count} companies by number of job postings",
  "jobDetailPage.companyInfoFromTradeRegister": "Includes details from the Finnish Trade Register.",
  "jobDetailPage.contact": "Contact:",
  "jobDetailPage.coverLetter.basedOn": "Based on: {entries}",
  "jobDetailPage.coverLetter.copied": "Copied!",
  "jobDetailPage.coverLetter.copy": "Copy text",
  "jobDetailPage.coverLetter.download": "Download cover letter",
  "jobDetailPage.coverLetter.editHint": "Edit the text below before copying or downloading; it's yours to adjust.",
  "jobDetailPage.coverLetter.failed": "Could not draft your cover letter. Try again later.",
  "jobDetailPage.coverLetter.generateCta": "Draft my cover letter",
  "jobDetailPage.coverLetter.intro": "Draft a cover letter using your profile and this job; you can edit it before downloading.",
  "jobDetailPage.coverLetter.networkError": "Network error. Check your connection.",
  "jobDetailPage.coverLetter.notConfigured": "Cover letter drafting is not enabled for this environment.",
  "jobDetailPage.coverLetter.overclaimWarning": "We couldn't find \"{skill}\" in your profile; make sure this is true.",
  "jobDetailPage.coverLetter.quotaExceeded": "You've hit today's cover letter limit; it resets tomorrow.",
  "jobDetailPage.coverLetter.sourceCompany": "Company info",
  "jobDetailPage.coverLetter.sourceSkills": "Skills",
  "jobDetailPage.coverLetter.ungroundedFlag": "{count, plural, one {One part} other {# parts}} of this letter wasn't tied to anything specific in your profile; please check {count, plural, one {it's} other {they're}} accurate.",
  "jobDetailPage.description": "Job Description",
  "jobDetailPage.estimatedExpiry": "Estimated expiry",
  "jobDetailPage.estimatedNetSalary.explanation": "Estimated {year} take-home pay after Finnish income tax, pension, and unemployment insurance contributions. Assumes the national average municipal tax rate ({rate}%), no church tax, and standard deductions only; your actual net pay depends on your municipality, church membership, age, and family situation.",
  "jobDetailPage.expandCompanyData": "Expand company information to view trends, distributions, and map",
  "jobDetailPage.expired.backToSearch": "Back to search results",
  "jobDetailPage.hideCharts": "Hide Charts",
  "jobDetailPage.hiringSnapshotSeo.activeListings": "Active listings",
  "jobDetailPage.hiringSnapshotSeo.caption": "Current open roles at {company} on JobCrawls",
  "jobDetailPage.hiringSnapshotSeo.location": "Location",
  "jobDetailPage.languageNavigation": "Available languages",
  "jobDetailPage.languageRequirements": "Language Requirements",
  "jobDetailPage.lastSeenAgoCompact": "{days, plural, =0 {today} one {#d ago} other {#d ago}}",
  "jobDetailPage.lastSeenDetail": "Last updated: {date}{ago}",
  "jobDetailPage.listingCompanyIndustryLabel": "Listing",
  "jobDetailPage.loadingMap": "Loading map...",
  "jobDetailPage.locationAndRemotenessDistribution": "Location & Remoteness Distribution",
  "jobDetailPage.locationDistribution": "Location Distribution",
  "jobDetailPage.mapError": "Unable to load map",
  "jobDetailPage.matchBreakdown.collapse": "Collapse match breakdown",
  "jobDetailPage.matchBreakdown.expand": "Expand match breakdown",
  "jobDetailPage.matchBreakdown.title": "How this job matches your profile",
  "jobDetailPage.noItems": "No items to show.",
  "jobDetailPage.officialRegisterName": "Registered name",
  "jobDetailPage.originalLanguage": "Original",
  "jobDetailPage.perks": "Perks",
  "jobDetailPage.postedAgo": "{days, plural, =0 {Posted today} one {Posted 1 day ago} other {Posted # days ago}}",
  "jobDetailPage.recruitmentProcess": "Recruitment process",
  "jobDetailPage.remotenessDistribution": "Remoteness Distribution",
  "jobDetailPage.remotenessDistribution.short": "Remoteness",
  "jobDetailPage.requiredLanguages": "Required Languages",
  "jobDetailPage.requirements": "Requirements",
  "jobDetailPage.responsibilities": "Responsibilities",
  "jobDetailPage.roleAndRoleLevelDistribution": "Role & Role Level Distribution",
  "jobDetailPage.roleDistribution": "Role Distribution",
  "jobDetailPage.roleLevelDistribution": "Role Level Distribution",
  "jobDetailPage.roleLevelSnapshotSeo.activeListings": "Active listings",
  "jobDetailPage.roleLevelSnapshotSeo.caption": "Current role-level mix at {company} on JobCrawls",
  "jobDetailPage.roleLevelSnapshotSeo.level": "Role level",
  "jobDetailPage.roleSnapshotSeo.activeListings": "Active listings",
  "jobDetailPage.roleSnapshotSeo.caption": "Current role mix at {company} on JobCrawls",
  "jobDetailPage.roleSnapshotSeo.role": "Role type",
  "jobDetailPage.salarySourceBadge.estimated": "Estimated",
  "jobDetailPage.salarySourceBadge.fromListing": "Listed",
  "jobDetailPage.salarySourceBadge.unverified": "Unverified",
  "jobDetailPage.section.company": "Company Information",
  "jobDetailPage.section.jobDetails": "Job Details",
  "jobDetailPage.seeLocation": "See Location",
  "jobDetailPage.showCharts": "Show Charts",
  "jobDetailPage.showCompanyContact": "Show Company Contact",
  "jobDetailPage.showContact": "Show Contact Email",
  "jobDetailPage.showingItemsAboveThreshold": "Showing only items above {percentage}%",
  "jobDetailPage.skillsAndTechnologies": "Skills & technologies",
  "jobDetailPage.specialisations": "Specialisations",
  "jobDetailPage.tailorCv.emptyProfile": "Fill in your profile first: we need your work experience or skills to tailor a CV.",
  "jobDetailPage.tailorCv.goToProfile": "Go to your profile",
  "jobDetailPage.tailorCv.tabCoverLetter": "Cover letter",
  "jobDetailPage.tailorCv.tabCv": "CV",
  "jobDetailPage.tailorCv.title": "Tailor my CV for this job",
  "jobDetailPage.tailorCvCta": "Tailor my CV for this job",
  "jobDetailPage.tradeRegisterWebsite": "Trade register website",
  "jobDetailPage.tyomarkkinatori.about": "<strong>Työmarkkinatori</strong> is Finland's official public employment service portal, operated by the Ministry of Economic Affairs and Employment (TEM). It lists job openings from across the Finnish public sector, municipalities, and employers who use the government's recruitment infrastructure.",
  "jobDetailPage.tyomarkkinatori.dataSourceAttribution": "Source: <link>Job Market Finland customer information system</link>",
  "jobDetailPage.tyomarkkinatori.whyWeIndex": "We include Työmarkkinatori listings so that JobCrawls covers the full breadth of the Finnish job market, including roles that only appear through official government channels and would otherwise be missed.",
  "jobDetailPage.watchCompanyVideo": "Watch Company Video",
  "jobDetailPageV2.awardsAndCertifications": "Awards & certifications",
  "jobDetailPageV2.collectiveAgreement.browseAll": "Browse all Finnish collective agreements",
  "jobDetailPageV2.collectiveAgreement.confidence": "{percent}% confidence",
  "jobDetailPageV2.collectiveAgreement.explicit": "Employer states this job follows the {agreementName} collective agreement.",
  "jobDetailPageV2.collectiveAgreement.inferred": "Best guess: {agreementName} collective agreement, inferred from this employer's industry and the role; could be a different one.",
  "jobDetailPageV2.coreValues": "Core values",
  "jobDetailPageV2.daysAgo": "{days, plural, one {# day ago} other {# days ago}}",
  "jobDetailPageV2.daysLeft": "{days, plural, one {# day left} other {# days left}}",
  "jobDetailPageV2.daysOpen.longer": "Open {days, plural, one {# day} other {# days}}, longer than the usual {typical} for this role",
  "jobDetailPageV2.daysOpen.usual": "Open {days, plural, one {# day} other {# days}}. This role usually stays open about {typical} days",
  "jobDetailPageV2.deadline": "Deadline {date}",
  "jobDetailPageV2.descriptionDisclaimer": "This is the employer's own ad. Pay, requirements and the other details on this page are our reading of it, not facts the employer confirmed.",
  "jobDetailPageV2.employerOverview": "About the employer",
  "jobDetailPageV2.employerScore.aria": "Employer Score {tier}. See the full company profile",
  "jobDetailPageV2.employerScore.label": "Employer Score",
  "jobDetailPageV2.estTakeHome": "Est. take-home {amount}",
  "jobDetailPageV2.estTakeHome.infoLabel": "What assumptions does this estimate use?",
  "jobDetailPageV2.estimatedExpiry": "Est. expiry {date}",
  "jobDetailPageV2.experienceYears": "{years} {years, plural, one {year} other {years}} experience",
  "jobDetailPageV2.financialOverview": "Financial overview",
  "jobDetailPageV2.fitLedger.action.addLanguage": "Speak {list}? Add it to your profile",
  "jobDetailPageV2.fitLedger.action.fillProfile": "Fill in your profile for a real comparison",
  "jobDetailPageV2.fitLedger.action.tailorCv": "Tailor your CV to this role",
  "jobDetailPageV2.fitLedger.action.weights": "Change what matters most to you",
  "jobDetailPageV2.fitLedger.basis.current": "Compared with your current role. Set a desired job on your profile to compare against what you actually want.",
  "jobDetailPageV2.fitLedger.basis.desired": "Compared with the job you said you want on your profile; where you left something blank, your current role is used instead.",
  "jobDetailPageV2.fitLedger.cell.benefitsNow": "{count, plural, one {# benefit now} other {# benefits now}}",
  "jobDetailPageV2.fitLedger.cell.more": "+{count} more",
  "jobDetailPageV2.fitLedger.cell.notSet": "Not set",
  "jobDetailPageV2.fitLedger.cell.notStated": "Not stated",
  "jobDetailPageV2.fitLedger.cell.weeks": "{weeks, plural, one {# week} other {# weeks}} / year",
  "jobDetailPageV2.fitLedger.cell.youSuffix": "You: {value}",
  "jobDetailPageV2.fitLedger.kicker.searches": "Estimated from your searches",
  "jobDetailPageV2.fitLedger.noun.benefits": "benefits",
  "jobDetailPageV2.fitLedger.noun.jobType": "contract type",
  "jobDetailPageV2.fitLedger.noun.languages": "languages",
  "jobDetailPageV2.fitLedger.noun.location": "location",
  "jobDetailPageV2.fitLedger.noun.remoteness": "working style",
  "jobDetailPageV2.fitLedger.noun.roleLevel": "seniority",
  "jobDetailPageV2.fitLedger.noun.salary": "pay",
  "jobDetailPageV2.fitLedger.noun.title": "the role",
  "jobDetailPageV2.fitLedger.noun.vacation": "time off",
  "jobDetailPageV2.fitLedger.perMonth": "{amount} / mo",
  "jobDetailPageV2.fitLedger.row.benefits": "Benefits",
  "jobDetailPageV2.fitLedger.row.jobType": "Contract",
  "jobDetailPageV2.fitLedger.row.keywords": "Keywords",
  "jobDetailPageV2.fitLedger.row.languages": "Languages",
  "jobDetailPageV2.fitLedger.row.location": "Location",
  "jobDetailPageV2.fitLedger.row.remoteness": "Work style",
  "jobDetailPageV2.fitLedger.row.roleLevel": "Level",
  "jobDetailPageV2.fitLedger.row.salary": "Pay",
  "jobDetailPageV2.fitLedger.row.searchCompany": "Employer",
  "jobDetailPageV2.fitLedger.row.searchRoles": "Role & field",
  "jobDetailPageV2.fitLedger.row.title": "Role",
  "jobDetailPageV2.fitLedger.row.vacation": "Time off",
  "jobDetailPageV2.fitLedger.verdict.A": "Strong fit",
  "jobDetailPageV2.fitLedger.verdict.B": "Good fit",
  "jobDetailPageV2.fitLedger.verdict.C": "Mixed fit",
  "jobDetailPageV2.fitLedger.verdict.D": "Weak fit",
  "jobDetailPageV2.fitLedger.verdict.F": "Not a fit on paper",
  "jobDetailPageV2.fitLedger.verdict.allMiddle": "Every factor lands somewhere in the middle.",
  "jobDetailPageV2.fitLedger.verdict.gaps": "{count, plural, one {The gap: {list}.} other {The gaps: {list}.}}",
  "jobDetailPageV2.fitLedger.verdict.noGaps": "Nothing stands out as a gap.",
  "jobDetailPageV2.fitLedger.verdict.strengths": "{list} {count, plural, one {lines up} other {line up}} with what you want.",
  "jobDetailPageV2.homeCommute.addHome": "Add your home address once and you'll see your commute time on every job.",
  "jobDetailPageV2.homeCommute.addressLabel": "Your home address",
  "jobDetailPageV2.homeCommute.calculating": "Calculating travel times…",
  "jobDetailPageV2.homeCommute.cancelChange": "Keep current",
  "jobDetailPageV2.homeCommute.change": "Change",
  "jobDetailPageV2.homeCommute.changeHome": "Search a new home address.",
  "jobDetailPageV2.homeCommute.chip": "{time} from home",
  "jobDetailPageV2.homeCommute.fromHome": "From {home}",
  "jobDetailPageV2.homeCommute.hours": "{hours} h",
  "jobDetailPageV2.homeCommute.hoursMinutes": "{hours} h {minutes} min",
  "jobDetailPageV2.homeCommute.minutes": "{minutes} min",
  "jobDetailPageV2.homeCommute.noTransit": "Public transport times aren't available yet.",
  "jobDetailPageV2.homeCommute.privacyNote": "Saved to your profile and only used for travel times. Never shared with employers.",
  "jobDetailPageV2.homeCommute.unavailable": "Travel times aren't available for this address.",
  "jobDetailPageV2.includesVariablePay": "+ variable pay",
  "jobDetailPageV2.jobDescription": "Job description",
  "jobDetailPageV2.lastSeen": "Last updated {date}",
  "jobDetailPageV2.locationModal.close": "Close map",
  "jobDetailPageV2.locationModal.headingWithCount": "{count, plural, one {Job location} other {Job locations · {count} sites}}",
  "jobDetailPageV2.locationModal.title": "Job location",
  "jobDetailPageV2.mapChip": "Map",
  "jobDetailPageV2.mapChip.locationCount": "{count} locations",
  "jobDetailPageV2.matchBreakdown.overallLabel": "overall match",
  "jobDetailPageV2.numberOfPositions": "{count} openings",
  "jobDetailPageV2.officePhotos": "Company photos",
  "jobDetailPageV2.openRoles": "{count} open roles",
  "jobDetailPageV2.originallyListedAs": "Originally listed as {amount}",
  "jobDetailPageV2.otherLocations": "+{count} other locations",
  "jobDetailPageV2.postedOn": "Posted {date}",
  "jobDetailPageV2.profit": "Profit",
  "jobDetailPageV2.profitMargin": "Profit margin",
  "jobDetailPageV2.revenue": "Revenue",
  "jobDetailPageV2.salaryCompares": "How this salary compares",
  "jobDetailPageV2.salaryEstimateSampleSize": "Estimated from {count, plural, one {# comparable listing} other {# comparable listings}}",
  "jobDetailPageV2.salaryGauge.benchmark.companyLocation": "this company in {location}",
  "jobDetailPageV2.salaryGauge.benchmark.companySalaryStats": "this company",
  "jobDetailPageV2.salaryGauge.benchmark.locationMarket": "all roles in {location}",
  "jobDetailPageV2.salaryGauge.benchmark.title": "{title} roles",
  "jobDetailPageV2.salaryGauge.benchmark.titleLocation": "{title} in {location}",
  "jobDetailPageV2.salaryGauge.benchmark.titleRoleLevel": "{roleLevel} level roles",
  "jobDetailPageV2.salaryGauge.headline": "{percent}% {direction, select, above {above} other {below}} {benchmark}",
  "jobDetailPageV2.salaryGauge.headlineLevel": "In line with {benchmark}",
  "jobDetailPageV2.salaryGauge.headlineNoJobSalary": "Benchmarked against {benchmark}",
  "jobDetailPageV2.salaryGauge.thisOffer": "This offer",
  "jobDetailPageV2.taxIcebergLink": "See the full tax breakdown →",
  "jobDetailPageV2.vacationWeeks": "{count, plural, one {# week vacation} other {# weeks vacation}}",
  "jobDetailPageV2.viewCompany": "View company",
  "jobDetailPageV2.watchCompanyVideo": "Watch company video",
  "juniors.careerGuide.salary.entryLevel.body": "We don't publish fixed entry-level pay ranges here. Our salary hub shows pay bands for junior roles straight from live Finnish job listings, by role and city.",
  "juniors.careerGuide.salary.entryLevel.cta": "See live junior salary data",
  "juniors.companies.hero.description": "Companies in Finland with a profile on JobCrawls. Open one to see its live openings and hiring signals.",
  "layoutErrorFallback.body": "Please try reloading the page. If the problem continues, we have been notified.",
  "layoutErrorFallback.home": "Go to home",
  "layoutErrorFallback.reload": "Reload page",
  "layoutErrorFallback.title": "Something went wrong",
  "locationHub.hero.title.breadcrumb": "Explore Jobs by Location",
  "locationsHub.abroad.heading": "Abroad",
  "locationsHub.abroad.subheading": "Roles in other countries from employers operating in Finland.",
  "locationsHub.cities.englishLabel": "English required",
  "locationsHub.cities.flexLabel": "Remote or hybrid",
  "locationsHub.cities.heading": "Biggest cities",
  "locationsHub.cities.jobsLabel": "open",
  "locationsHub.cities.salaryLabel": "Median pay",
  "locationsHub.cities.subheading": "The eight cities hiring the most right now. Pay is the median listed in postings; shares are of currently open roles.",
  "locationsHub.directory.heading": "All towns",
  "locationsHub.directory.subheading": "By region. The number is open listings.",
  "locationsHub.directory.townCount": "{count} towns · {jobs}",
  "locationsHub.footnote": "Figures are computed straight from the search index and refresh daily. Pay is the median of monthly salaries stated in listings; a region's pay is its largest city's median when the region has no aggregate of its own.",
  "locationsHub.h1": "Where in Finland is hiring?",
  "locationsHub.lede": "{jobs} open jobs across 18 regions and {towns} towns in Finland. Type a role or skill and see where it's being hired. Switch the metric to see where you can work without Finnish or remotely.",
  "locationsHub.map.ariaLabel": "Map of Finland by region",
  "locationsHub.map.attribution": "Region boundaries: Statistics Finland (CC BY 4.0)",
  "locationsHub.metric.count.help": "Open listings",
  "locationsHub.metric.count.label": "Open",
  "locationsHub.metric.flex.help": "Share of roles that aren't location-bound",
  "locationsHub.metric.flex.label": "Remote or hybrid",
  "locationsHub.metric.noFi.help": "Share of roles that don't require Finnish",
  "locationsHub.metric.noFi.label": "No Finnish",
  "locationsHub.metric.week.help": "Posted in the last week",
  "locationsHub.metric.week.label": "New in 7 days",
  "locationsHub.panel.ctaAll": "All {count} jobs: {region}",
  "locationsHub.panel.ctaQuery": "Show {count} matches: {region}",
  "locationsHub.panel.flexLabel": "Remote or hybrid work",
  "locationsHub.panel.headlineLabelQuery": "matches for “{query}”",
  "locationsHub.panel.kickerQuery": "“{query}” · region",
  "locationsHub.panel.kickerRegion": "Region",
  "locationsHub.panel.medianSalaryLabel": "Median pay",
  "locationsHub.panel.noFinnishLabel": "No Finnish required",
  "locationsHub.panel.noSalaryData": "no data",
  "locationsHub.panel.rank": "{rank}. / {total} · {metric}",
  "locationsHub.panel.topRolesHeading": "Most searched roles",
  "locationsHub.panel.topTownsHeading": "Largest towns",
  "locationsHub.panel.weekLabel": "New in the last 7 days",
  "locationsHub.query.all": "All",
  "locationsHub.query.cook": "Cook",
  "locationsHub.query.electrician": "Electrician",
  "locationsHub.query.nurse": "Nurse",
  "locationsHub.query.python": "Python",
  "locationsHub.rankList.region": "Region",
  "locationsHub.rankList.share": "Relative to the top",
  "locationsHub.rankList.value": "Value",
  "locationsHub.remote.heading": "Remote work",
  "locationsHub.remote.hybridChip": "Hybrid",
  "locationsHub.remote.remoteChip": "Remote",
  "locationsHub.search.label": "Role, skill, or employer",
  "locationsHub.search.placeholder": "Role, skill, or employer",
  "locationsHub.search.submit": "Show on map",
  "map.commute.addSecond": "Add a second starting point",
  "map.commute.addressAriaLabel": "Search for a starting address",
  "map.commute.addressPlaceholder": "Or type an address…",
  "map.commute.button": "Commute search",
  "map.commute.clear": "Clear commute filter",
  "map.commute.customMinutesAriaLabel": "Custom commute time in minutes",
  "map.commute.error": "Couldn't load the commute area. Try again.",
  "map.commute.loading": "Finding the commute area…",
  "map.commute.minutes": "{minutes} min",
  "map.commute.minutesUnit": "min",
  "map.commute.profile.cycling": "Bike",
  "map.commute.profile.driving": "Drive",
  "map.commute.profile.transit": "Transit",
  "map.commute.profile.walking": "Walk",
  "map.commute.prompt": "Click the map to set your starting point",
  "map.commute.promptSecond": "Click the map to set the second starting point",
  "map.commute.removeSecond": "Remove second starting point",
  "map.commute.transitApproxNote": "Transit area is approximate",
  "map.companies.none": "No companies in this area",
  "map.companies.openRoles": "{count, plural, one {# open role} other {# open roles}}",
  "map.companyLogoAlt": "Company logo",
  "map.densityZoomPrompt": "Zoom in to see individual jobs and company logos",
  "map.densityZoomPrompt.button": "Zoom in",
  "map.draw.button": "Draw an area",
  "map.draw.cancel": "Cancel",
  "map.draw.clear": "Clear drawn area",
  "map.draw.finish": "Finish ({count})",
  "map.draw.prompt": "Click the map to outline an area",
  "map.newThisWeekToggle": "New this week",
  "map.noJobs": "No jobs in this area",
  "map.perCapitaToggle": "Per 1,000 residents",
  "map.popup.close": "Close",
  "map.pulse.button": "Hiring pulse",
  "map.pulse.error": "Couldn't load hiring history",
  "map.pulse.loading": "Loading hiring history…",
  "map.pulse.pause": "Pause",
  "map.pulse.play": "Play",
  "map.pulse.scrubber": "Week",
  "map.pulse.weekOf": "Week of {date}",
  "map.remoteCard.label": "{count, plural, one {# remote job} other {# remote jobs}}",
  "map.remoteCard.more": "+{count} more",
  "map.resetView": "Reset map to show all of Finland",
  "map.tokenMissing": "Map view requires Mapbox access token",
  "map.tools.hideLabels": "Hide labels",
  "map.tools.showLabels": "Show labels",
  "map.unknownLocation": "Unknown location",
  "map.workInEnglishToggle": "Jobs in English",
  "marketHeader.language.english": "English",
  "marketHeader.language.finlandComparison": "Finland: {finlandEnglish}% English",
  "marketHeader.language.label": "Language Demand",
  "marketHeader.language.mixed": "Mixed",
  "marketHeader.languageSeo.caption": "Language demand in {location}",
  "marketHeader.languageSeo.english": "English",
  "marketHeader.languageSeo.language": "Language category",
  "marketHeader.languageSeo.localLanguages": "Local languages",
  "marketHeader.languageSeo.share": "Share of listings",
  "marketHeader.nearbyMarkets": "Nearby markets",
  "marketHeader.qa.languageAnswer": "{percent}% of jobs require English.",
  "marketHeader.qa.languageAnswerFallback": "Language requirements vary by role.",
  "marketHeader.qa.languageQuestion": "What languages are required in {location}?",
  "marketHeader.qa.remoteAnswerFallback": "Remote work options are available.",
  "marketHeader.qa.remoteAnswerWithPercent": "{percent}% of roles are remote or hybrid.",
  "marketHeader.qa.salaryAnswerFallback": "Salary data available.",
  "marketHeader.qa.salaryAnswerWithValue": "Average salary is {salary}.",
  "marketHeader.qa.salaryQuestion": "What is the average salary in {location}?",
  "marketHeader.rail.samplesUpdatedDaily": "{count} open jobs · updated daily",
  "marketHeader.removeLocation": "Remove location",
  "marketHeader.salary.finlandComparison": "Finland avg: {finlandAvg}",
  "marketHeader.salary.label": "Salary Trends",
  "marketHeader.salary.range": "Salary range",
  "marketHeader.salary.rangePercentile": "25th-75th percentile range",
  "marketHeader.salaryPercentileSeo.caption": "Advertised salary distribution in {location}, Finland (full-time roles)",
  "marketHeader.salaryPercentileSeo.p25": "25th percentile",
  "marketHeader.salaryPercentileSeo.p50": "Median (50th percentile)",
  "marketHeader.salaryPercentileSeo.p75": "75th percentile",
  "marketHeader.salaryPercentileSeo.percentile": "Percentile",
  "marketHeader.salaryPercentileSeo.salary": "Monthly salary (EUR)",
  "marketHeader.salaryPercentileSeo.sampleSize": "Based on {count} job postings with explicit salary data in {location}, Finland.",
  "marketHeader.toggle": "Toggle market header",
  "marketHeader.updated": "Updated:",
  "marketHeader.workModel.finlandComparison": "Finland: {finlandRemote}% remote/hybrid",
  "marketHeader.workModel.label": "Work Model",
  "marketHeader.workModel.noData": "Flexible",
  "marketHeader.workModelSeo.caption": "Work model distribution in {location}",
  "marketHeader.workModelSeo.hybrid": "Hybrid",
  "marketHeader.workModelSeo.model": "Work model",
  "marketHeader.workModelSeo.onsite": "Onsite",
  "marketHeader.workModelSeo.remote": "Remote",
  "marketHeader.workModelSeo.share": "Share of listings",
  "marketingConsent.checkbox.description": "Optional. Unsubscribe anytime.",
  "marketingConsent.checkbox.label": "Job market emails and tips",
  "matchDonut.ariaLabel": "Match score: {score}%",
  "matchDonut.breakdown.benefits": "Benefits",
  "matchDonut.breakdown.languages": "Languages",
  "matchDonut.breakdown.remoteness": "Remoteness",
  "matchDonut.breakdown.salary": "Salary",
  "matchDonut.breakdown.title": "Match Score Breakdown",
  "matchDonut.breakdown.vacation": "Vacation",
  "matchDonut.loginPrompt.createAccount": "Activate account",
  "matchDonut.loginPrompt.description": "Create a profile and add your current job details to see how well jobs match your preferences",
  "matchDonut.loginPrompt.title": "Login to see your match score",
  "matchDonut.loginPromptAria": "Log in to see your match score",
  "matchDonut.profilePrompt.description": "Add your current job details and preferences on your profile to see how well jobs match.",
  "matchDonut.profilePrompt.goToProfile": "Go to profile",
  "matchDonut.profilePrompt.title": "Complete your profile to see your match score",
  "matchDonut.profilePromptAria": "Complete your profile to see your match score",
  "matchDonut.searchBreakdown.employer": "Employer & industry",
  "matchDonut.searchBreakdown.keywords": "Search keywords",
  "matchDonut.searchBreakdown.location": "Location",
  "matchDonut.searchBreakdown.remoteness": "Remoteness",
  "matchDonut.searchBreakdown.roleFit": "Role & field",
  "matchDonut.searchInference.bullet.company": "You’ve shown interest in employers like {company}; we factor that into the score.",
  "matchDonut.searchInference.bullet.keywords": "Your searches included terms like \"{terms}\"; we compared them to this job’s title and role.",
  "matchDonut.searchInference.bullet.locations": "You’ve searched in areas such as {locations}; this listing’s location is compared to that.",
  "matchDonut.searchInference.bullet.remoteness": "You often use remoteness filters ({values}); this job is scored against those preferences.",
  "matchDonut.searchInference.bullet.roles": "Your searches include role filters such as {hints}; similar signals are compared to this job.",
  "matchDonut.searchInference.intro": "We don’t have your profile yet, so this score estimates fit using filters and keywords from searches you’ve run on JobCrawls (recent activity counts more).",
  "matchDonut.searchInference.title": "Match from your recent searches",
  "modal.close": "Close",
  "nav.index.employersHiring": "employers hiring",
  "nav.index.newToday": "new today",
  "nav.index.openJobs": "open jobs",
  "nav.index.remote": "remote",
  "nav.index.updatedAgo": "Updated {minutes} min ago",
  "nav.search.placeholder": "Search jobs, skills or city",
  "nav.search.shortcutAria": "Shortcut: / to focus search",
  "nav.sheet.alerts": "New matches by email",
  "nav.sheet.alertsNote": "<em>{n}</em> new today, only the ones that fit",
  "nav.sheet.alertsNoteLoading": "new today, only the ones that fit",
  "nav.sheet.device": "On this device only. Sign in to keep them everywhere and get alerts.",
  "nav.sheet.email": "or use email",
  "nav.sheet.fine": "You can sign out any time.",
  "nav.sheet.free": "Account",
  "nav.sheet.google": "Continue with Google",
  "nav.sheet.keep": "Keep what you have",
  "nav.sheet.keepGoogle": "Keep these, continue with Google",
  "nav.sheet.kit": "Tailored CV and cover letter",
  "nav.sheet.kitNote": "one click per job",
  "nav.sheet.searches": "{n} recent searches",
  "nav.sheet.track": "Track every application",
  "nav.sheet.trackNote": "saved, applied, interviews: one board",
  "nav.sheet.viewed": "Last viewed",
  "nav.sheet.viewedCount": "{n, plural, one {# viewed job} other {# viewed jobs}}",
  "nav.tape.and": "and",
  "nav.tape.clearAll": "Clear all",
  "nav.tape.not": "not",
  "nav.tape.only": "only",
  "nav.tape.or": "or",
  "nav.tape.quickAddPrefix": "+ {label}",
  "nav.tape.results": "{count} results",
  "nav.tape.sortNewest": "newest first",
  "nav.tape.sortSalary": "highest salary first",
  "nav.view.list": "List",
  "nav.view.map": "Map",
  "navigation.home.breadcrumb": "Home",
  "navigation.language": "Language",
  "navigation.language.label": "Language",
  "navigation.menu": "Menu",
  "navigation.menu.continue": "Pick up where you left off",
  "navigation.menu.explore": "Explore",
  "navigation.menu.heading": "Menu",
  "navigation.menu.more": "More",
  "navigation.menu.note.apiKeys": "keys for Claude or ChatGPT",
  "navigation.menu.note.employers": "who's hiring now",
  "navigation.menu.note.feedback": "tell us what's missing",
  "navigation.menu.note.followed": "{count} followed",
  "navigation.menu.note.install": "add to your home screen",
  "navigation.menu.note.jobs": "all open roles",
  "navigation.menu.note.locations": "jobs by city",
  "navigation.menu.note.myJobsEmpty": "nothing saved yet",
  "navigation.menu.note.profileEmpty": "build your CV",
  "navigation.menu.note.profilePct": "{pct}% complete",
  "navigation.menu.note.remote": "work from anywhere",
  "navigation.menu.note.reset": "back to all jobs",
  "navigation.menu.note.resources": "guides and articles",
  "navigation.menu.note.roles": "jobs by title",
  "navigation.menu.note.salaries": "pay by role",
  "navigation.menu.note.searches": "saved searches",
  "navigation.menu.note.watchlistEmpty": "follow employers",
  "navigation.menu.open": "Open menu",
  "navigation.menu.searchPrompt": "Search {count} open jobs",
  "navigation.menu.searchSubmit": "Search",
  "navigation.menu.signInHint": "Keep saved jobs and alerts in sync across your devices.",
  "navigation.menu.translatorTools": "Translator tools",
  "navigation.menu.unit.hiring": "hiring",
  "navigation.menu.unit.open": "open",
  "navigation.menu.unit.remote": "remote",
  "navigation.mobileBottomBar.ariaLabel": "Mobile navigation",
  "navigation.search.reset": "Reset search",
  "notes.field.add": "Add note",
  "notes.field.placeholder": "Add a private note…",
  "numberSelector.any": "Any",
  "numberSelector.decrease": "Decrease",
  "numberSelector.increase": "Increase",
  "pagination.ariaLabel": "Job search results pagination",
  "pagination.first": "First",
  "pagination.keyboardShortcuts": "Keyboard shortcuts",
  "pagination.last": "Last",
  "pagination.next": "Next",
  "pagination.previous": "Previous",
  "postSignup.alertNudge.enabled": "You're set. We'll email you about new jobs matching your searches.",
  "postSignup.alertNudge.failed": "Couldn't turn on job alerts. You can enable them any time from the Alerts page.",
  "postSignup.alertNudge.offer": "Welcome to JobCrawls! Want an email when new jobs matching your interests appear?",
  "postSignup.alertNudge.pendingConfirmation": "Almost there: confirm your email in your inbox to activate alerts.",
  "postSignup.alertNudge.turnOn": "Turn on",
  "profile.account.delete.button": "Delete account",
  "profile.account.delete.cancel": "Cancel",
  "profile.account.delete.close": "Close",
  "profile.account.delete.confirm": "Delete account",
  "profile.account.delete.confirmBody": "This permanently deletes your account, saved jobs, searches, application kits, and CV. This cannot be undone.",
  "profile.account.delete.confirmTitle": "Delete your account?",
  "profile.account.delete.done": "Your account has been deleted. Signing you out…",
  "profile.account.delete.error": "Something went wrong. Please try again.",
  "profile.account.delete.working": "Deleting…",
  "profile.account.title": "Account",
  "profile.aiApply": "Apply",
  "profile.aiLoading": "Thinking…",
  "profile.aiSuggestionsDisclaimer": "These are automatically drafted starting points based only on your job titles and degrees, not verified facts about you. Read each one and edit it to match what's actually true before applying.",
  "profile.aiSuggestionsEmpty": "Your profile looks complete. Add more experience or leave some fields empty and try again.",
  "profile.aiSuggestionsTitle": "Suggested wording",
  "profile.applicationDetails.emailPlaceholder": "Email",
  "profile.applicationDetails.firstNamePlaceholder": "First name",
  "profile.applicationDetails.lastNamePlaceholder": "Last name",
  "profile.applicationDetails.phonePlaceholder": "Phone",
  "profile.applicationDetails.salaryExpectationPlaceholder": "Salary expectation (annual)",
  "profile.applicationDetails.workAuthorization.euEeaCitizen": "EU/EEA citizen",
  "profile.applicationDetails.workAuthorization.finnishCitizen": "Finnish citizen",
  "profile.applicationDetails.workAuthorization.notAuthorized": "Not currently authorized to work here",
  "profile.applicationDetails.workAuthorization.permanentResident": "Permanent resident",
  "profile.applicationDetails.workAuthorization.requiresSponsorship": "Require visa sponsorship",
  "profile.applicationDetails.workAuthorization.validWorkPermit": "Have a valid work permit",
  "profile.closePreview": "Close preview",
  "profile.closeSuggestions": "Close",
  "profile.commuteMode.label": "I usually travel by",
  "profile.cvDownloadFailed": "Failed to download your CV. Please try again.",
  "profile.cvDownloadFailed.retry": "Retry",
  "profile.cvExportPdfFailed": "Failed to export PDF. Please try again.",
  "profile.cvExportPdfFailed.retry": "Retry",
  "profile.cvImport.notConfigured": "CV import is not enabled for this environment.",
  "profile.cvUploadError": "Please upload a PDF file",
  "profile.cvUploadFailed": "Failed to upload CV. Please try again.",
  "profile.cvUploadSizeError": "File size must be less than 5MB",
  "profile.downloadCV": "Download my CV",
  "profile.homeAddress.hint": "Sets the default starting point for the job map's commute search, so you don't have to click the map every time. Optional, only visible to you, and only ever sent to Mapbox to look up the coordinates, never shared with employers.",
  "profile.homeAddress.placeholder": "Search an address…",
  "profile.homeAddress.remove": "Remove",
  "profile.linkedInImport.placeholder": "https://www.linkedin.com/in/your-profile/",
  "profile.linkedInImport.sectionTitle": "LinkedIn profile",
  "profile.loading": "Loading...",
  "profile.prefillFromSearches.banner": "We filled in some fields from your recent job searches. Review them and adjust anything that looks off.",
  "profile.prefillFromSearches.dismiss": "Dismiss",
  "profile.profilePhoto.errorCompressedTooLarge": "Image is still too large after compression. Try a smaller original.",
  "profile.profilePhoto.errorProcess": "Could not process this image. Try another file.",
  "profile.profilePhoto.errorTooLarge": "Image is too large (max 5 MB).",
  "profile.profilePhoto.errorType": "Use a JPEG, PNG, WebP, or GIF image.",
  "profile.profilePhoto.remove": "Remove uploaded photo",
  "profile.profilePhoto.uploadAria": "Upload or change profile photo",
  "recentSearches.delete": "Remove",
  "recentSearches.noSearches": "You haven't saved any searches yet.",
  "role.follow.createAccount": "Activate account",
  "role.follow.cta": "Watch role",
  "role.follow.emailPrompt.enabled": "You're set. New postings in roles you watch will be in your job-alert emails.",
  "role.follow.emailPrompt.failed": "Couldn't turn on email updates. You can enable them any time from the Alerts page.",
  "role.follow.emailPrompt.offer": "Watching {role}. Want an email when new postings appear?",
  "role.follow.emailPrompt.pendingConfirmation": "Almost there: confirm your email in your inbox to activate updates.",
  "role.follow.emailPrompt.turnOn": "Turn on",
  "role.follow.undo": "Undo",
  "role.follow.unwatchedToast": "Stopped watching. You won’t be notified of new postings for this role",
  "role.follow.watchedToast": "Watching {role}. New postings will show on your watchlist",
  "role.follow.watching": "Watching",
  "rolesIndex.breadcrumb": "Roles",
  "salary.period.day": "/day",
  "salary.period.hour": "/hr",
  "salary.period.month": "/mo",
  "salary.period.year": "/yr",
  "salaryChart.seoTable.caption": "Monthly salary comparison for {title}",
  "salaryChart.seoTable.lowerBound": "Lower bound (25th percentile)",
  "salaryChart.seoTable.market": "Market",
  "salaryChart.seoTable.median": "Median",
  "salaryChart.seoTable.upperBound": "Upper bound (75th percentile)",
  "salaryChart.thisRole": "this role",
  "salaryChart.thisRoleLevel": "this role level",
  "salaryDisplayToggle.label": "Show original currency",
  "salaryIndexPage.taxIcebergLink": "The tax iceberg calculator",
  "salaryInsight.above": "This role's salary of <strong>{salary}</strong> is <strong>{percent}%</strong> above {benchmark}.",
  "salaryInsight.below": "This role's salary of <strong>{salary}</strong> is <strong>{percent}%</strong> below {benchmark}.",
  "salaryInsight.benchmark.finlandOnly": "the Finland-wide median in our salary data",
  "salaryInsight.benchmark.finlandWithRole": "the Finland-wide median for {role} roles",
  "salaryInsight.benchmark.locationOnly": "the median salary in {location}",
  "salaryInsight.benchmark.locationWithRole": "the median for {role} roles in {location}",
  "salaryMethodology.backToSalary": "Back to the salary guide",
  "salaryMethodology.breadcrumb.current": "Salary methodology",
  "salaryMethodology.breadcrumb.parent": "Salary guide",
  "salaryMethodology.byline": "Written by {author}",
  "salaryMethodology.intro": "Every salary figure on JobCrawls (medians, ranges, and per-role or per-city stats) goes through the same pipeline. Here is exactly what that pipeline does.",
  "salaryMethodology.limits.confidence": "Stats built from fewer than 10 postings are labelled as low-confidence. Treat them as a rough guide, not a precise figure.",
  "salaryMethodology.limits.disclaimer": "Salary data is derived from published job listings and may not represent total compensation. Figures are in EUR/month and count only salaries stated in the listings. JobCrawls estimates for listings without a salary are never included.",
  "salaryMethodology.limits.notVerified": "We do not independently verify what employers publish. Figures reflect what listings state, not audited payroll data.",
  "salaryMethodology.limits.title": "Important limitations",
  "salaryMethodology.step1.body": "Our extraction pass pulls salary figures directly from the posting text. It is explicitly instructed not to guess a number from vague phrases like \"competitive salary\": if the listing does not state a figure, we do not invent one here.",
  "salaryMethodology.step1.title": "We collect salaries stated in the listing",
  "salaryMethodology.step2.body": "When a listing has no stated salary, we estimate one from a credibility-weighted blend of comparable postings for the same title, location, role level, and company, weighted more heavily toward broader, larger samples when a narrow one is thin. Estimated figures are labelled as estimates wherever they appear next to a job listing, so you can always tell a stated salary from an inferred one.",
  "salaryMethodology.step2.title": "We estimate when nothing is stated, and flag it",
  "salaryMethodology.step3.body": "Listings state pay in different ways (hourly, monthly, annual), and periods are sometimes mislabeled. We convert every figure to monthly EUR and run a plausibility check (roughly €500–€30,000/month, with the top of a range no more than 5× the bottom) to catch placeholder or garbled data before it reaches any statistic.",
  "salaryMethodology.step3.title": "We normalize every figure to monthly EUR",
  "salaryMethodology.step4.body": "With fewer than 5 postings we apply no trimming: there is not enough data to safely discard anything. From 5–24 postings we trim using an interquartile-range check. At 25 or more postings we apply a stricter 10th–90th percentile trim before computing the median, mean, and percentiles.",
  "salaryMethodology.step4.title": "We trim outliers based on sample size",
  "salaryMethodology.step5.body": "A single unusual posting can otherwise set an entire published range. The low and high figures we show are the 10th percentile of minimums and the 90th percentile of maximums across the sample, not the single lowest or highest number we saw.",
  "salaryMethodology.step5.title": "The displayed range is not the raw min and max",
  "salaryMethodology.steps.heading": "The pipeline, step by step",
  "salaryMethodology.title": "How we compute salary statistics",
  "salaryRolePage.alsoKnownAs": "Also listed under: {titles}",
  "salaryRolePage.breadcrumb.salaryData": "Salary Data",
  "salaryRolePage.cityTable.footnote": "Bar shows P25–P75 band. Vertical line = median. All values in EUR/month.",
  "salaryRolePage.cityTable.title": "{roleTitle} Salary by City",
  "salaryRolePage.examplePostings.inactiveBadge": "No longer active",
  "salaryRolePage.examplePostings.title": "Based on postings like these",
  "salaryRolePage.hiringCompanies.browseAll": "Browse best employers in Finland →",
  "salaryRolePage.hiringCompanies.empty": "Browse all ranked employers to find one hiring for this kind of role.",
  "salaryRolePage.hiringCompanies.sub": "From our employer rankings. Some may be worth reaching out to directly even without an open listing.",
  "salaryRolePage.hiringCompanies.title": "Companies hiring {roleTitle}s",
  "salaryRolePage.intro": "Based on job listing data from Finnish employers. Updated regularly.",
  "salaryRolePage.rangeBar.popoverListings": "{count, plural, one {Based on # job listing} other {Based on # job listings}}",
  "salaryRolePage.remotePanel.title": "{roleTitle}: Remote Work in Finland",
  "salaryRolePage.seeOpenJobs": "See open {roleTitle} jobs →",
  "salaryStats.aboveMarket": "This salary is above the market median",
  "salaryStats.atMarket": "This salary is competitive with the market median",
  "salaryStats.belowMarket": "This salary is below the market median",
  "salaryStats.perDay": "per day",
  "salaryStats.perHour": "per hour",
  "salaryStats.perMonth": "per month",
  "salaryStats.perYear": "per year",
  "savedSearches.card.dragAria": "Drag to reorder \"{title}\"",
  "savedSearches.card.moveDownAria": "Move \"{title}\" down",
  "savedSearches.card.moveUpAria": "Move \"{title}\" up",
  "savedSearches.card.selectAria": "Select \"{title}\"",
  "savedSearches.confirmRemove.bulkBody": "{count} saved searches and their alert settings will be removed.",
  "savedSearches.confirmRemove.bulkTitle": "Remove {count} searches?",
  "savedSearches.confirmRemove.cancel": "Cancel",
  "savedSearches.confirmRemove.close": "Close",
  "savedSearches.confirmRemove.confirm": "Remove",
  "savedSearches.confirmRemove.singleBody": "“{title}” and its saved alert settings will be removed.",
  "savedSearches.confirmRemove.singleTitle": "Remove this search?",
  "savedSearches.confirmRemove.working": "Removing…",
  "savedSearches.emptyHint": "Run a search with keywords or filters on the jobs page and it will show up here automatically. You can also pin one with “Save search”.",
  "savedSearches.folder.collapseToggle": "Toggle folder",
  "savedSearches.folder.count": "{count, plural, one {# search} other {# searches}}",
  "savedSearches.folder.delete": "Delete folder",
  "savedSearches.folder.menuAria": "Folder options",
  "savedSearches.folder.moveDown": "Move down",
  "savedSearches.folder.moveUp": "Move up",
  "savedSearches.folder.rename": "Rename",
  "savedSearches.folder.renameSave": "Save",
  "savedSearches.folder.sheetClose": "Close",
  "savedSearches.folder.unsorted": "Unsorted",
  "savedSearches.newMatchesBadge": "{count} new",
  "savedSearches.noFilterResults": "No saved searches match “{filterText}”.",
  "savedSearches.openSearchAria": "Open search: {title}",
  "savedSearches.rename.action": "Name this search",
  "savedSearches.rename.placeholder": "e.g. Backend jobs in Helsinki",
  "savedSearches.rename.save": "Save",
  "savedSearches.summary.location": "Location: {values}",
  "savedSearches.summary.page": "Page {page}",
  "savedSearches.summary.sortDate": "Sort: newest",
  "savedSearches.summary.sortSalary": "Sort: salary",
  "savedSearches.summary.worldwide": "All countries",
  "savedSearches.toolbar.cancelSelect": "Cancel",
  "savedSearches.toolbar.deleteSelected": "Delete",
  "savedSearches.toolbar.filterAria": "Filter saved searches",
  "savedSearches.toolbar.filterPlaceholder": "Filter your searches…",
  "savedSearches.toolbar.moveToFolder": "Move to folder",
  "savedSearches.toolbar.moveToNewFolder": "New folder…",
  "savedSearches.toolbar.moveToUnsorted": "Unsorted",
  "savedSearches.toolbar.newFolderButton": "New folder",
  "savedSearches.toolbar.newFolderPrompt": "Folder name",
  "savedSearches.toolbar.newFolderSave": "Create",
  "savedSearches.toolbar.selectAll": "Select all",
  "savedSearches.toolbar.selectButton": "Select",
  "savedSearches.toolbar.selectedCount": "{count, plural, one {# selected} other {# selected}}",
  "savedSearches.toolbar.sortAlphabetical": "A–Z",
  "savedSearches.toolbar.sortAria": "Sort saved searches",
  "savedSearches.toolbar.sortCustom": "Custom order",
  "savedSearches.toolbar.sortNewest": "Newest",
  "savedSearches.toolbar.sortSuggested": "Suggested",
  "search.bestCompaniesStrip.hubCta": "Companies hiring in Finland →",
  "search.bestCompaniesStrip.label": "Top employers",
  "search.controls.navigation": "Search controls and filters",
  "search.jobCount": "{count, number} jobs",
  "search.noresults.clearAllParameters": "Clear all search parameters",
  "search.noresults.description": "Try adjusting your search or filters to find more opportunities.",
  "search.noresults.filtersLabel": "Filters:",
  "search.noresults.goToFirstPage": "Go to page 1",
  "search.noresults.hybridJobs": "Hybrid jobs",
  "search.noresults.pageLabel": "Page:",
  "search.noresults.popularSearches": "Popular searches",
  "search.noresults.queryLabel": "Query:",
  "search.noresults.removeQuery": "Remove",
  "search.noresults.searchParameters": "Your Search Parameters",
  "search.noresults.searchTips": "Search Tips",
  "search.noresults.tip1": "Try using broader search terms or remove some filters",
  "search.noresults.tip2": "Check your spelling or try alternative keywords",
  "search.noresults.tip3": "Browse popular categories above to discover new opportunities",
  "search.noresults.title": "No results found",
  "search.noresults.unavailable.description": "Our job search is temporarily unavailable. Try refreshing the page, or check out these pages in the meantime.",
  "search.noresults.unavailable.exploreResources": "Read career resources",
  "search.noresults.unavailable.exploreSalary": "Explore salary data",
  "search.noresults.unavailable.linksLabel": "In the meantime",
  "search.noresults.unavailable.retry": "Try again",
  "search.noresults.unavailable.title": "We're having trouble loading jobs",
  "search.refinements.advancedFilters": "Advanced Filters",
  "search.refinements.advancedFilters.aria": "Advanced Filters",
  "search.refinements.allFilters.aria": "All Filters",
  "search.refinements.benefits.label": "Benefits",
  "search.refinements.clearAll": "Clear all ({count})",
  "search.refinements.company": "Company",
  "search.refinements.company.label": "Company",
  "search.refinements.company.openProfileAria": "Open company profile for {company}{count, plural, =0 {} other {, {count} open roles on JobCrawls}}",
  "search.refinements.company.searchPlaceholder": "Search companies...",
  "search.refinements.educationLevel.detail": "Education Level",
  "search.refinements.educationLevel.label": "Education Level",
  "search.refinements.excludeApplied.label": "Exclude Applied Jobs",
  "search.refinements.excludeConsultingCompany.filter": "Hide Consulting Company Postings",
  "search.refinements.excludeFreelance.filter": "Hide Freelance Postings",
  "search.refinements.excludeJobs": "Exclude Jobs",
  "search.refinements.excludeRecruitmentCompany.filter": "Hide Recruitment Agency Postings",
  "search.refinements.excludeSaved.label": "Exclude Saved Jobs",
  "search.refinements.excludeViewed.label": "Exclude Viewed Jobs",
  "search.refinements.field.label": "Field",
  "search.refinements.headcount.chip": "Up to {count} employees",
  "search.refinements.headcount.max": "Max Headcount",
  "search.refinements.industry.label": "Industry",
  "search.refinements.isDriversLicenseRequired.filter": "Driver's Licence Required",
  "search.refinements.isOpenApplication.filter": "Open Application",
  "search.refinements.job": "Job",
  "search.refinements.jobTitle": "Job Title",
  "search.refinements.jobType.label": "Job Type",
  "search.refinements.languages.label": "Languages",
  "search.refinements.lastSeen.all": "All",
  "search.refinements.lastSeen.aria": "Date posted",
  "search.refinements.lastSeen.past1Month": "Past 1 month",
  "search.refinements.lastSeen.past1Week": "Past 1 week",
  "search.refinements.lastSeen.past24Hours": "Past 24 hours",
  "search.refinements.lastSeen.past2Weeks": "Past 2 weeks",
  "search.refinements.lastSeen.past3Days": "Past 3 days",
  "search.refinements.lastSeen.past6Hours": "Past 6 hours",
  "search.refinements.location": "Location",
  "search.refinements.location.searchPlaceholder": "Search locations...",
  "search.refinements.peopleManagementTier.label": "People Management Tier",
  "search.refinements.posted.section": "Posted",
  "search.refinements.quickFilter.salary": "€{amount}+",
  "search.refinements.quickFilter.thisWeek": "This week",
  "search.refinements.quickFilters.heading": "Quick filters",
  "search.refinements.regionTags.breadcrumb.root": "All Locations",
  "search.refinements.regionTags.drillIn": "Browse {value}",
  "search.refinements.regionTags.finlandQuickChip": "Finland",
  "search.refinements.regionTags.group.continent": "Continents",
  "search.refinements.regionTags.group.country": "Countries",
  "search.refinements.regionTags.group.finland": "Finland",
  "search.refinements.regionTags.group.recruitingRegion": "Regions",
  "search.refinements.regionTags.label": "Region",
  "search.refinements.regionTags.remoteCountLabel": "{value} remote",
  "search.refinements.regionTags.showBeyondFinland": "Show locations outside Finland",
  "search.refinements.regionTags.worldQuickChip": "World",
  "search.refinements.remoteness.heading": "Remoteness",
  "search.refinements.roleLevel.label": "Role Level",
  "search.refinements.salary": "Salary",
  "search.refinements.salary.min": "Minimum Salary",
  "search.refinements.search.placeholder": "Search...",
  "search.refinements.showJobsInFinlandOnly": "Show jobs in Finland only",
  "search.refinements.showLess": "Show less",
  "search.refinements.showMore": "Show more",
  "search.refinements.showResults": "Show {count} results",
  "search.refinements.showResultsNoCount": "Show results",
  "search.refinements.skillsAndTechnologies.label": "Skills & Technologies",
  "search.refinements.sort.section": "Sort",
  "search.refinements.vacationWeeks": "Vacation Weeks",
  "search.refinements.vacationWeeks.chip": "{count}+ vacation weeks",
  "search.results.title": "Job Search Results",
  "search.resultsPerPage.aria": "Results per page",
  "search.resultsPerPage.optionLabel": "{count} per page",
  "search.signInCta.button": "Activate account",
  "search.topRolesStrip.hubCta": "Salary data for Finland roles →",
  "search.topRolesStrip.label": "In-demand roles",
  "sort.ariaLabel": "Sort results",
  "sort.newest": "Newest",
  "sort.relevance": "Relevance",
  "sort.salary": "Salary",
  "srpAlertCta.bannerText": "Stop checking back. Get told when new jobs like this are posted.",
  "srpAlertCta.ctaButton": "Get job alerts",
  "srpAlertCta.dismissLabel": "Dismiss",
  "srpAlertCta.errorText": "Something went wrong. We couldn't turn on alerts. Please try again.",
  "srpAlertCta.manageLink": "Manage alerts",
  "srpAlertCta.pendingText": "Almost there: check your inbox to confirm your email and activate alerts.",
  "srpAlertCta.subText": "Daily or weekly. Turn off anytime.",
  "srpAlertCta.successText": "You're set. {channels, select, push {We'll notify you} both {We'll email and notify you} other {We'll email you}} about jobs like this.",
  "stats.appliedJobs": "{count} applied jobs",
  "stats.finlandJobsSubtitle": "Jobs available in Finnish or remotely to Finnish residents",
  "stats.newThisWeekInline": "· {count, number} new this week",
  "stats.savedJobs": "{count} saved jobs",
  "stats.viewedJobs": "{count} viewed jobs",
  "tags.field.addTrigger": "Add tag",
  "tags.field.placeholder": "Tag and press Enter…",
  "tags.field.remove": "Remove tag {tag}",
  "taxIceberg.accuracyNote": "Checked against Veronmaksajat's {year} wage-earner table: within €1 at 15 income levels from €20,000 to €200,000.",
  "taxIceberg.advanced.group.deductions": "Deductions",
  "taxIceberg.advanced.group.employer": "Employer",
  "taxIceberg.advanced.group.otherIncome": "Other income",
  "taxIceberg.advanced.group.person": "About you",
  "taxIceberg.advanced.group.picture": "Picture",
  "taxIceberg.advanced.toggle": "Advanced options: deductions, other income, employer, family",
  "taxIceberg.agents.body": "Every salary has its own page: {urlTemplate}, with the options above as query parameters (municipality, employer, vat, church, age, children, sole, union, commuting, dividends, gains, own, assets). The same result as JSON: {apiUrl}. AI assistants can call the {tool} tool on the JobCrawls MCP connector ({connectorUrl}).",
  "taxIceberg.agents.heading": "For assistants like ChatGPT, and for developers",
  "taxIceberg.amounts.perMonth": "All amounts per month",
  "taxIceberg.amounts.perYear": "All amounts per year",
  "taxIceberg.backToSalary": "Back to the salary guide",
  "taxIceberg.breadcrumb.current": "Tax iceberg",
  "taxIceberg.breadcrumb.parent": "Salary guide",
  "taxIceberg.breakdown.capitalGross": "Dividends and capital gains",
  "taxIceberg.breakdown.capitalTax": "Capital income tax",
  "taxIceberg.breakdown.gross": "Gross salary",
  "taxIceberg.breakdown.heading": "Full breakdown",
  "taxIceberg.breakdown.investmentsKeep": "You keep from dividends and gains",
  "taxIceberg.breakdown.investmentsTax": "Tax on dividends and gains",
  "taxIceberg.breakdown.netPay": "Net pay",
  "taxIceberg.breakdown.totalIn": "Everything that comes in before tax",
  "taxIceberg.breakdown.trueCost": "True cost to employer (gross + employer contributions)",
  "taxIceberg.byline": "Written by {author}",
  "taxIceberg.compare.add": "Compare with another salary",
  "taxIceberg.compare.hint": "Icebergs are drawn to the same scale, so you can compare them directly.",
  "taxIceberg.compare.remove": "Remove this salary from the comparison",
  "taxIceberg.copyLink": "Copy link",
  "taxIceberg.copyLink.copied": "Copied",
  "taxIceberg.destinations.averageMunicipality": "the average municipality",
  "taxIceberg.destinations.employmentFund": "Employment Fund",
  "taxIceberg.destinations.employmentFund.desc": "Unemployment insurance contributions: earnings-related unemployment allowance, adult education allowance, pension accrual during unemployment.",
  "taxIceberg.destinations.heading": "Where the money goes",
  "taxIceberg.destinations.insurers": "Insurers",
  "taxIceberg.destinations.insurers.desc": "The employer's accident and group life insurance premiums.",
  "taxIceberg.destinations.intro": "Every euro below the waterline has one recipient by law. Open the municipality and the state to see what they spend it on.",
  "taxIceberg.destinations.kela": "Kela health insurance",
  "taxIceberg.destinations.kela.desc": "Medical-care and daily-allowance contributions and the employer's health insurance contribution: sickness and parental allowances, reimbursements for medicines and private doctors.",
  "taxIceberg.destinations.legend": "Dark part of a bar: withheld from your pay. Light part: paid by your employer on top. The municipal and state splits follow their published spending (municipal accounts 2025, state budget 2026); they are proportional, not earmarked.",
  "taxIceberg.destinations.muni.administrationOther": "Administration and other",
  "taxIceberg.destinations.muni.basicEducation": "Basic education (comprehensive school)",
  "taxIceberg.destinations.muni.cultureSport": "Culture, libraries, sport and youth",
  "taxIceberg.destinations.muni.earlyChildhood": "Early childhood and pre-primary education",
  "taxIceberg.destinations.muni.employmentBusiness": "Employment services and business development",
  "taxIceberg.destinations.muni.streetsParksPlanning": "Streets, parks, planning, housing and rescue",
  "taxIceberg.destinations.muni.upperSecondary": "Upper secondary and vocational education",
  "taxIceberg.destinations.municipality": "Your municipality ({name})",
  "taxIceberg.destinations.municipality.desc": "Municipal income tax, spent by {name} on its own services.",
  "taxIceberg.destinations.parish": "Your parish",
  "taxIceberg.destinations.parish.desc": "Church tax to the Evangelical Lutheran parish of your municipality.",
  "taxIceberg.destinations.pensions": "Earnings-related pensions",
  "taxIceberg.destinations.pensions.desc": "Your and your employer's TyEL contributions, paid to pension insurers: they fund today's pensions and build your own pension record.",
  "taxIceberg.destinations.state": "The state",
  "taxIceberg.destinations.state.administrationOther": "Administration and other",
  "taxIceberg.destinations.state.agriculture": "Agriculture and forestry",
  "taxIceberg.destinations.state.debtInterest": "Interest on state debt",
  "taxIceberg.destinations.state.defence": "Defence",
  "taxIceberg.destinations.state.desc": "State income tax{vat}, spent through the {year} state budget.",
  "taxIceberg.destinations.state.education": "Education, science and culture",
  "taxIceberg.destinations.state.employmentEconomy": "Employment and the economy",
  "taxIceberg.destinations.state.environment": "Environment",
  "taxIceberg.destinations.state.eu": "EU membership contributions",
  "taxIceberg.destinations.state.foreignAffairs": "Foreign affairs and development aid",
  "taxIceberg.destinations.state.healthSocialCounties": "Health and social care (wellbeing services counties)",
  "taxIceberg.destinations.state.municipalGrants": "State grants to municipalities",
  "taxIceberg.destinations.state.securityJustice": "Police, rescue, border and justice",
  "taxIceberg.destinations.state.socialSecurity": "Social security: Kela benefits and state pensions",
  "taxIceberg.destinations.state.transport": "Transport and communications",
  "taxIceberg.destinations.state.vat": "and VAT",
  "taxIceberg.destinations.total": "{total} {period} in taxes and contributions",
  "taxIceberg.destinations.yle": "Yle",
  "taxIceberg.destinations.yle.desc": "The Yle tax funds public broadcasting.",
  "taxIceberg.detail.capital.unlistedLight": "Own-company dividend within the 8% yield: {light} taxed on 25%",
  "taxIceberg.detail.capital.unlistedSplit": "Own-company dividend: {light} lightly taxed (25%), {heavy} at 85%",
  "taxIceberg.detail.employee.capitalTax": "Capital income tax on dividends and gains: {amount}",
  "taxIceberg.detail.employee.church": "Church tax: {amount}",
  "taxIceberg.detail.employee.commutingDeducted": "Commuting deduction applied: {amount}",
  "taxIceberg.detail.employee.credit": "Earned-income tax credit: {amount}",
  "taxIceberg.detail.employee.dailyAllowance": "Daily allowance contribution: {amount}",
  "taxIceberg.detail.employee.medical": "Medical care contribution: {amount}",
  "taxIceberg.detail.employee.municipal": "Municipal tax ({rate}): {amount}",
  "taxIceberg.detail.employee.pension": "Your pension contribution: {amount}",
  "taxIceberg.detail.employee.state": "State income tax: {amount}",
  "taxIceberg.detail.employee.unemployment": "Your unemployment insurance: {amount}",
  "taxIceberg.detail.employee.unionDeducted": "Union fees deducted from taxable income: {amount}",
  "taxIceberg.detail.employee.unlistedEarned": "Own-company dividend beyond the 8% yield, taxed as earned income: {amount}",
  "taxIceberg.detail.employee.yle": "Yle tax: {amount}",
  "taxIceberg.detail.employer.accident": "Accident & group life insurance: {amount}",
  "taxIceberg.detail.employer.health": "Health insurance contribution: {amount}",
  "taxIceberg.detail.employer.tyel": "Pension (TyEL) {rate}: {amount}",
  "taxIceberg.detail.employer.unemployment": "Unemployment insurance: {amount}",
  "taxIceberg.detail.investments.gains": "Capital gains: {amount} (taxable in full)",
  "taxIceberg.detail.investments.gross": "Dividends and gains before tax: {amount}",
  "taxIceberg.detail.investments.listed": "Dividends from listed companies: {amount} (85% taxable)",
  "taxIceberg.detail.investments.minusTax": "minus tax on them: {amount}",
  "taxIceberg.detail.investments.own": "Dividends from your own company: {amount}",
  "taxIceberg.detail.net.minusVat": "minus VAT paid when you spend it: {amount}",
  "taxIceberg.detail.net.payslip": "Net pay on your payslip: {amount}",
  "taxIceberg.detail.net.shareOfGross": "{share} of your gross salary",
  "taxIceberg.detail.share": "{share} of what it costs to employ you",
  "taxIceberg.detail.share.investments": "{share} of your dividends and gains",
  "taxIceberg.detail.vat.assumption": "Assumes {share} of net pay is spent, taxed at a blended VAT rate of {rate}",
  "taxIceberg.detail.vat.basis": "Spending patterns from Statistics Finland by income level",
  "taxIceberg.genericEstimateNote.both": "Using the national-average municipal tax rate ({rate}) and a blended unemployment-insurance rate. Pick a municipality and employer payroll size above for a more precise figure.",
  "taxIceberg.genericEstimateNote.employerSize": "Using a blended unemployment-insurance rate. Pick your employer's payroll size above for a more precise figure.",
  "taxIceberg.genericEstimateNote.municipal": "Using the national-average municipal tax rate ({rate}). Pick your municipality above for a more precise figure.",
  "taxIceberg.headlineStat": "It costs {trueEmployerCost} to employ you, but you only get to keep {netAfterVat} of it once tax and VAT are both counted.",
  "taxIceberg.headlineStat.noVat": "It costs {trueEmployerCost} to employ you, but you only get to keep {netAfterVat} of it after tax.",
  "taxIceberg.headlineStat.withCapital": "Your salary and investments add up to {total} before tax, but you only get to keep {netAfterVat} once tax and VAT are both counted.",
  "taxIceberg.headlineStat.withCapital.noVat": "Your salary and investments add up to {total} before tax, but you only get to keep {netAfterVat} after tax.",
  "taxIceberg.iceberg.title.month": "{amount} / month",
  "taxIceberg.iceberg.title.year": "{amount} / year",
  "taxIceberg.input.advancedOptions.toggle": "Advanced options (municipality, employer size)",
  "taxIceberg.input.age.hint": "Pension and unemployment contributions depend on it",
  "taxIceberg.input.age.label": "Age (affects pension and unemployment contributions)",
  "taxIceberg.input.age.placeholder": "Working age",
  "taxIceberg.input.age.short": "Age",
  "taxIceberg.input.capitalGains.hint": "Taxable in full as capital income",
  "taxIceberg.input.capitalGains.label": "Capital gains (net of purchase price)",
  "taxIceberg.input.children.hint": "Raises the earned-income credit",
  "taxIceberg.input.children.label": "Minor children (raises the earned-income credit)",
  "taxIceberg.input.children.short": "Minor children",
  "taxIceberg.input.church.hint": "Adds church tax of about {rate}",
  "taxIceberg.input.church.label": "Church member (church tax about {rate})",
  "taxIceberg.input.church.short": "Church member",
  "taxIceberg.input.commuting.hint": "Deductible above {ownLiability}, up to {max} a year",
  "taxIceberg.input.commuting.label": "Commuting costs (deductible above {ownLiability}, up to {max} a year)",
  "taxIceberg.input.commuting.short": "Commuting costs",
  "taxIceberg.input.detail.full": "Every tax",
  "taxIceberg.input.detail.hint": "Show one band per tax and contribution",
  "taxIceberg.input.detail.label": "Iceberg strata",
  "taxIceberg.input.detail.simple": "Four layers",
  "taxIceberg.input.dividends.hint": "85% taxable as capital income",
  "taxIceberg.input.dividends.label": "Dividends from listed companies",
  "taxIceberg.input.employerSize.hint": "Sets the unemployment-insurance rate",
  "taxIceberg.input.employerSize.label": "Employer's total payroll (affects unemployment insurance rate)",
  "taxIceberg.input.employerSize.large": "Over €2.5M/year",
  "taxIceberg.input.employerSize.short": "Employer's total payroll",
  "taxIceberg.input.employerSize.small": "Under €2.5M/year",
  "taxIceberg.input.employerSize.unknown": "Not sure",
  "taxIceberg.input.municipality.label": "Municipality (for municipal tax rate)",
  "taxIceberg.input.municipality.placeholder": "National average",
  "taxIceberg.input.netAssets.hint": "Optional; empty assumes the dividend stays within the 8% yield",
  "taxIceberg.input.netAssets.label": "Your share of the company's net assets",
  "taxIceberg.input.option.no": "No",
  "taxIceberg.input.option.yes": "Yes",
  "taxIceberg.input.otherIncome.hint": "Taxed as capital income at {lower} up to {threshold} and {upper} above; no employer cost. Your own company must first pay its 20% corporate tax, which is not shown here.",
  "taxIceberg.input.period.month": "Month",
  "taxIceberg.input.period.year": "Year",
  "taxIceberg.input.salary.label": "Gross salary",
  "taxIceberg.input.salary.modeLabel": "Enter a gross salary or a target net",
  "taxIceberg.input.salary.modeNet": "Net salary (target)",
  "taxIceberg.input.salary.presetGross": "{amount} gross",
  "taxIceberg.input.salary.presetNet": "{amount} net",
  "taxIceberg.input.salary.presets": "Pick a common salary",
  "taxIceberg.input.soleGuardian.hint": "Doubles the per-child credit",
  "taxIceberg.input.soleGuardian.label": "Sole guardian",
  "taxIceberg.input.unionFees.hint": "Deducted in full from earned income",
  "taxIceberg.input.unionFees.label": "Union and unemployment fund fees",
  "taxIceberg.input.unit.month": "/ month",
  "taxIceberg.input.unit.year": "/ year",
  "taxIceberg.input.unlistedDividends.hint": "Unlisted: 25% taxable up to {cap} a year within an 8% yield",
  "taxIceberg.input.unlistedDividends.label": "Dividends from your own company",
  "taxIceberg.input.vat.hint": "Adds the VAT you pay when you spend your net pay",
  "taxIceberg.input.vat.label": "Count VAT on what you spend",
  "taxIceberg.intro": "Your payslip shows one number. What employing you really costs, and what you keep after tax and contributions, sit below the waterline. Enter a gross salary to see your own iceberg.",
  "taxIceberg.investments.stat": "Your dividends and capital gains add {gross}, of which you keep {net}.",
  "taxIceberg.investments.title": "Dividends & capital gains",
  "taxIceberg.keepRateStat": "You keep {rate} of what it actually costs to employ you.",
  "taxIceberg.keepRateStat.total": "You keep {rate} of everything that comes in.",
  "taxIceberg.layer.capitalTax": "Capital income tax",
  "taxIceberg.layer.church": "Church tax",
  "taxIceberg.layer.employeeDailyAllowance": "Daily allowance contribution",
  "taxIceberg.layer.employeePension": "Your pension contribution",
  "taxIceberg.layer.employeeTax": "Your income tax & contributions",
  "taxIceberg.layer.employeeUnemployment": "Your unemployment insurance",
  "taxIceberg.layer.employerAccident": "Accident and group life insurance",
  "taxIceberg.layer.employerContributions": "Employer contributions",
  "taxIceberg.layer.employerHealth": "Employer's health insurance",
  "taxIceberg.layer.employerTyel": "Employer pension (TyEL)",
  "taxIceberg.layer.employerUnemployment": "Employer's unemployment insurance",
  "taxIceberg.layer.investmentEarnedTax": "Income tax on own-company dividend",
  "taxIceberg.layer.investmentTax": "Tax on dividends & gains",
  "taxIceberg.layer.medicalCare": "Medical care contribution",
  "taxIceberg.layer.municipalTax": "Municipal tax",
  "taxIceberg.layer.netAfterVat": "What you actually keep",
  "taxIceberg.layer.stateTax": "State income tax",
  "taxIceberg.layer.vat": "VAT when you spend it",
  "taxIceberg.layer.yle": "Yle tax",
  "taxIceberg.methodology.capital": "Dividends and capital gains: taxed as capital income at {lower} up to {threshold} of taxable capital income and {upper} above (Verohallinto, 2026). Dividends from listed companies are 85% taxable and 15% exempt. Dividends from an unlisted company you own: up to an 8% yield on your share of its net assets, 25% is taxable capital income for the first {cap} a year and 85% above that; the part beyond the 8% yield is 75% taxable earned income. The company's own 20% corporate tax, capital-income deductions and loss carry-forwards are not modelled.",
  "taxIceberg.methodology.deductions": "Deductions: union and unemployment-fund fees are deducted in full from earned income; commuting costs are deductible above the {ownLiability} own-liability share up to {max} a year (Verohallinto, 2026). Church tax uses the Evangelical Lutheran parish rate of the chosen municipality (Verohallinto, 2026 decision), or the {churchRate} national average when none is chosen.",
  "taxIceberg.methodology.destinations": "Where the money goes: each contribution and tax is attributed to its recipient by law (pension insurers, the Employment Fund, Kela, the municipality, the state, the parish, Yle, insurers). The municipal euro is then split by what the chosen municipality spent on each task in 2025 (net operating costs, Kuntaliitto from Valtiokonttori data; national average when no municipality is chosen), and the state euro by the 2026 state budget regrouped by purpose, with the wellbeing services counties, municipal grants, EU contributions and state pensions separated out of the Ministry of Finance class. Those splits are proportional attributions, not earmarks.",
  "taxIceberg.methodology.employeeTax": "Income tax, municipal tax, church tax, Yle tax, employee pension and unemployment insurance, and the earned-income tax credit: computed per Verohallinto's (Finnish Tax Administration) 2026 withholding basis and Finlex's 2026 tax scale act.",
  "taxIceberg.methodology.employerAccident": "Occupational accident and group life insurance ({accidentRate} combined, industry average): Tapaturmavakuutuskeskus (TVK) annual forecast. Actual employer rates vary by industry risk class and cannot be personalized without knowing the specific employer.",
  "taxIceberg.methodology.employerOther": "Employer unemployment insurance ({unemploymentLow}–{unemploymentHigh}, tiered by payroll size) and health insurance contribution ({healthInsurance}): Työllisyysrahasto and Verohallinto, 2026 rates.",
  "taxIceberg.methodology.employerTyel": "Employer pension contribution (TyEL), {tyelRate}: Eläketurvakeskus (Finnish Centre for Pensions), 2026 contribution rates. This rate became flat across all ages in the 2026 reform; before 2026 it was banded by employee age.",
  "taxIceberg.methodology.heading": "Sources & methodology",
  "taxIceberg.methodology.intro": "Every figure below traces to a named, checkable source. Nothing here is estimated without saying so.",
  "taxIceberg.methodology.limitations": "This is an estimate, not tax advice: it assumes standard deductions, full-year residence, and no fringe benefits, and the VAT figure assumes typical spending patterns for your income level rather than your actual receipts.",
  "taxIceberg.methodology.municipal": "Municipal tax rates for all 308 reporting municipalities: Suomen Kuntaliitto (Association of Finnish Municipalities), official 2026 rate table, sourced from Verohallinto.",
  "taxIceberg.methodology.vat": "VAT rates: Verohallinto (25.5% standard, 13.5% reduced for food/restaurants/books/medicine/transport/accommodation as of 2026). How much of your income is actually spent (versus saved) at each income level: Statistics Finland's Household Consumption Survey, 2022, the most recent wave, broken down by income quintile (the finest breakdown Statistics Finland publishes).",
  "taxIceberg.methodology.vatInterpolation": "The 5 quintile data points are real survey data; the smooth curve between them is our own interpolation, not raw Statistics Finland output.",
  "taxIceberg.netModeStat": "For {net} in hand you need {gross} gross.",
  "taxIceberg.perMonthWord": "a month",
  "taxIceberg.perYearWord": "a year",
  "taxIceberg.popularNets": "Or start from what you want in hand",
  "taxIceberg.popularNets.link": "{amount} net",
  "taxIceberg.popularSalaries": "See the iceberg for other salaries",
  "taxIceberg.popularSalaries.link": "{amount} / month",
  "taxIceberg.raise.employer": "It costs your employer {cost} more.",
  "taxIceberg.raise.heading": "What would a raise leave you?",
  "taxIceberg.raise.result": "A {raise} raise leaves you {gain} more {period}: you keep {kept} of it.",
  "taxIceberg.raise.sliderLabel": "Raise amount",
  "taxIceberg.resetOptions": "Reset options",
  "taxIceberg.roles.all": "All roles with salary data",
  "taxIceberg.roles.heading": "Roles that pay about {amount} a month",
  "taxIceberg.roles.intro": "Each role’s national median, the same figure as its salary page: Statistics Finland’s earnings for the occupation raised to today where the occupation is covered, otherwise the pay stated in job ads. Open a role for its range, cities and current openings.",
  "taxIceberg.roles.postings": "{count, plural, one {# posting} other {# postings}}",
  "taxIceberg.share": "Share",
  "taxIceberg.share.email": "Send by email",
  "taxIceberg.share.linkedin": "Share on LinkedIn",
  "taxIceberg.share.menuLabel": "Share this iceberg",
  "taxIceberg.share.whatsapp": "Share on WhatsApp",
  "taxIceberg.share.x": "Share on X",
  "taxIceberg.sources.heading": "Sources",
  "taxIceberg.summary.capital": "Dividends and capital gains: {amount}",
  "taxIceberg.summary.delta": "vs. the first salary: {deltaGross} gross, {deltaKept} kept",
  "taxIceberg.summary.gross": "Gross salary: {amount}",
  "taxIceberg.summary.investmentsKeep": "You keep {amount} ({rate} of it)",
  "taxIceberg.summary.investmentsTax": "Tax on it: {amount}",
  "taxIceberg.summary.keep": "You keep {amount} ({rate} of the true cost)",
  "taxIceberg.summary.trueCost": "True cost to employer: {amount}",
  "taxIceberg.taxCard.backTax": "At {card} your card withholds about {amountYear} a year too little ({amountMonth} a month): expect back taxes.",
  "taxIceberg.taxCard.barCard": "Your tax card",
  "taxIceberg.taxCard.barSalary": "Tax on this salary",
  "taxIceberg.taxCard.extra": "Additional rate",
  "taxIceberg.taxCard.extraHint": "Above the limit",
  "taxIceberg.taxCard.heading": "Is your tax card right?",
  "taxIceberg.taxCard.intro": "The income tax on this salary comes to {actual} of gross. Compare that with the withholding rate printed on your tax card.",
  "taxIceberg.taxCard.limit": "Income limit",
  "taxIceberg.taxCard.limitHint": "€ per year, optional",
  "taxIceberg.taxCard.limitToggle": "My card has an income limit",
  "taxIceberg.taxCard.note": "Withholding covers taxes only; pension and unemployment contributions are deducted separately. Only the standard deductions are counted, so a card that includes your own deductions can be lower on purpose.",
  "taxIceberg.taxCard.onTarget": "At {card} your card matches this salary: the difference is under €60 a year.",
  "taxIceberg.taxCard.rate": "Rate on your tax card",
  "taxIceberg.taxCard.refund": "At {card} your card withholds about {amountYear} a year too much ({amountMonth} a month): expect a refund.",
  "taxIceberg.taxCard.where": "In OmaVero it is the base rate (perusprosentti) on your tax card.",
  "taxIceberg.taxRateStat": "Your tax rate on this salary: {rate} (with pension and unemployment contributions: {total})",
  "taxIceberg.taxYearNote": "Calculated with the {year} tax rules",
  "taxIceberg.title": "The tax iceberg: what your salary really costs, and what you actually keep",
  "taxIceberg.toolbar.employerSize": "Employer's payroll",
  "taxIceberg.toolbar.municipality": "Municipality",
  "taxIceberg.vatField.label": "VAT",
  "taxIceberg.visual.ariaLabel": "Tax icebergs floating in the sea in front of Helsinki. The visible tip is the pay you actually keep; the much larger mass below the waterline is tax and contributions.",
  "tools.applicationKits.cvBadge": "CV ready",
  "tools.applicationKits.deleteKit": "Delete",
  "tools.applicationKits.downloadCv": "Download CV",
  "tools.applicationKits.downloadLetter": "Download letter",
  "tools.applicationKits.emptyBody": "Tailor a CV or draft a cover letter from any job page and it'll be saved here automatically.",
  "tools.applicationKits.emptyTitle": "No application kits yet",
  "tools.applicationKits.lead": "Your tailored CVs and cover letters, saved per job. Reopen, review, or download anytime.",
  "tools.applicationKits.letterBadge": "Letter ready",
  "tools.applicationKits.openJob": "Open job page",
  "tools.applicationKits.title": "Application Kits",
  "tools.applicationKits.updatedOn": "Updated {date}",
  "tools.applicationState.applied": "Applied",
  "tools.applicationState.hidden": "Hidden",
  "tools.applicationState.label": "State:",
  "tools.applicationState.updated": "State updated to {state}",
  "tools.exportApplied.button": "Export applications for reporting",
  "tools.exportApplied.close": "Close",
  "tools.exportApplied.colDateApplied": "Date applied",
  "tools.exportApplied.colEmployer": "Employer",
  "tools.exportApplied.colLink": "Link",
  "tools.exportApplied.colMethod": "Method",
  "tools.exportApplied.colPosition": "Position",
  "tools.exportApplied.description": "A ready-to-copy list of what you applied to and when. Keep this open while you fill out your report, or download it as a spreadsheet.",
  "tools.exportApplied.downloadCsv": "Download CSV",
  "tools.exportApplied.empty": "No applications in this date range yet.",
  "tools.exportApplied.from": "From",
  "tools.exportApplied.methodExternal": "Other application (your link)",
  "tools.exportApplied.methodListing": "Job listing",
  "tools.exportApplied.rowCount": "{count, plural, one {# application} other {# applications}}",
  "tools.exportApplied.title": "Export your applications",
  "tools.exportApplied.to": "To",
  "tools.exportApplied.viewLink": "Open",
  "tools.externalApplication.add": "Add to applied",
  "tools.externalApplication.adding": "Adding…",
  "tools.externalApplication.closeModal": "Close",
  "tools.externalApplication.error.disallowedScheme": "Only http and https links are allowed.",
  "tools.externalApplication.error.empty": "Enter a link to the job or application page.",
  "tools.externalApplication.error.invalid": "That does not look like a valid URL.",
  "tools.externalApplication.error.syncFailed": "Could not save. Check your connection or try signing in.",
  "tools.externalApplication.error.tooLong": "That link is too long.",
  "tools.externalApplication.lead": "Paste a link to a job you applied to on another site. It appears with your other applications on this page.",
  "tools.externalApplication.title": "Track an application elsewhere",
  "tools.externalApplication.titleLabel": "Title (optional)",
  "tools.externalApplication.urlLabel": "Job link",
  "tools.externalApplication.urlPlaceholder": "https://…",
  "tools.history.emptyHidden": "You haven't hidden any jobs.",
  "tools.history.emptyViewed": "You have not viewed any jobs yet.",
  "tools.history.hiddenTab": "Hidden ({count})",
  "tools.history.resetViewed": "Reset viewed jobs",
  "tools.history.showMore": "Show more",
  "tools.history.viewedTab": "Viewed ({count})",
  "tools.historySummary.counts": "Viewed {viewedCount} · Hidden {hiddenCount}",
  "tools.historySummary.heading": "History",
  "tools.historySummary.openDrawer": "Open history",
  "tools.jobFlowSankey.applied": "Applied",
  "tools.jobFlowSankey.browsed": "Browsed",
  "tools.jobFlowSankey.conversionSummary": "{interviewRate}% reached interview · {offerRate}% got an offer",
  "tools.jobFlowSankey.emptyState": "Not enough data to display your activity yet. View, save, or apply to jobs to see your journey visualized!",
  "tools.jobFlowSankey.hideActivityChart": "Hide activity chart",
  "tools.jobFlowSankey.hired": "Hired",
  "tools.jobFlowSankey.interviewing": "Interviewing",
  "tools.jobFlowSankey.offer": "Offer",
  "tools.jobFlowSankey.rejected": "Rejected",
  "tools.jobFlowSankey.saved": "Saved",
  "tools.jobFlowSankey.showActivityChart": "Show activity chart",
  "tools.jobFlowSankey.viewed": "Viewed",
  "tools.kanban.addExternalApplication": "Add off-site application",
  "tools.kanban.cancelSelectMode": "Cancel",
  "tools.kanban.chip.appliedAgo": "Applied {relativeAge}",
  "tools.kanban.column.applied": "Applied",
  "tools.kanban.column.collapse": "Collapse {column} column",
  "tools.kanban.column.expand": "Expand {column} column",
  "tools.kanban.column.hired": "Hired",
  "tools.kanban.column.interviewing": "Interviewing",
  "tools.kanban.column.offer": "Offer",
  "tools.kanban.column.rejected": "Rejected",
  "tools.kanban.column.saved": "Saved",
  "tools.kanban.companyFilterAll": "All companies",
  "tools.kanban.companyFilterLabel": "Filter by company",
  "tools.kanban.confirmRemove.appliedBody": "“{jobTitle}” will leave your application board. You can apply again from search later.",
  "tools.kanban.confirmRemove.appliedTitle": "Remove from applications?",
  "tools.kanban.confirmRemove.cancel": "Cancel",
  "tools.kanban.confirmRemove.close": "Close",
  "tools.kanban.confirmRemove.confirm": "Remove",
  "tools.kanban.confirmRemove.savedBody": "“{jobTitle}” will be removed from saved jobs.",
  "tools.kanban.confirmRemove.savedTitle": "Remove from saved?",
  "tools.kanban.confirmRemove.working": "Removing…",
  "tools.kanban.deadlineChip": "Closes in {days, plural, one {# day} other {# days}}",
  "tools.kanban.dragHandle": "Drag to move to another column or position",
  "tools.kanban.emptyColumn": "None yet",
  "tools.kanban.hideInactive": "Hide no longer active jobs",
  "tools.kanban.keepLooking": "Keep looking →",
  "tools.kanban.loadingApplications": "Loading your applications…",
  "tools.kanban.mobile.close": "Close",
  "tools.kanban.mobile.emptyTab": "No applications in {stage}.",
  "tools.kanban.mobile.moveTo": "Move to",
  "tools.kanban.mobile.searchPlaceholder": "Search company or role",
  "tools.kanban.mobile.sortCompanyAsc": "Company (A–Z)",
  "tools.kanban.mobile.sortDateAsc": "Oldest first",
  "tools.kanban.mobile.sortDateDesc": "Newest first",
  "tools.kanban.mobile.sortLabel": "Sort by",
  "tools.kanban.mobile.sortTitleAsc": "Job title (A–Z)",
  "tools.kanban.mobile.tabAll": "All",
  "tools.kanban.mobile.viewJob": "View job posting",
  "tools.kanban.moveSelectedTo": "Move to…",
  "tools.kanban.removeFailed": "Could not update. Try again.",
  "tools.kanban.removeFailed.retry": "Retry",
  "tools.kanban.removeIcon.applied": "Remove from applications",
  "tools.kanban.removeIcon.saved": "Remove from saved jobs",
  "tools.kanban.removeSelected": "Remove",
  "tools.kanban.savedJob.expired": "No longer active",
  "tools.kanban.savedJob.findSimilar": "Find similar →",
  "tools.kanban.searchLabel": "Search",
  "tools.kanban.searchPlaceholder": "Search company or role",
  "tools.kanban.selectCard": "Select {title}",
  "tools.kanban.selectMode": "Select",
  "tools.kanban.selectedCount": "{count, plural, one {# selected} other {# selected}}",
  "tools.kanban.sortCompanyAsc": "Company (A–Z)",
  "tools.kanban.sortDateAsc": "Oldest first",
  "tools.kanban.sortDateDesc": "Newest first",
  "tools.kanban.sortLabel": "Sort by",
  "tools.kanban.moreMenu": "More actions",
  "tools.kanban.moreMenuClose": "Close menu",
  "tools.kanban.sortClosingSoon": "Closing soonest",
  "tools.kanban.sortTitleAsc": "Job title (A–Z)",
  "tools.kanban.staleChip": "Follow up? {days, plural, one {# day} other {# days}} since applying",
  "tools.kanban.title": "Applications by stage",
  "tools.kanban.untitledJob": "Untitled job",
  "tooltip.allFilters": "Open all filters to refine your job search by location, salary, work type, and more",
  "tooltip.view.list": "Switch to list view to see jobs in a compact list format",
  "tooltip.view.map": "Switch to map view to see job locations on a map",
  "usermenu.account": "Account",
  "usermenu.apiKeys": "Search in Claude or ChatGPT",
  "usermenu.installPwa": "Install App",
  "usermenu.logout": "Log Out",
  "usermenu.profile": "My Profile",
  "usermenu.theme": "Theme",
  "usermenu.theme.auto": "Auto",
  "usermenu.theme.dark": "Dark",
  "usermenu.theme.light": "Light",
  "usermenu.translationInspector": "Translation inspector",
  "view.list": "List view",
  "view.map": "Map view",
  "watchlist.company.closedRoles": "{count, plural, one {# role you saw is no longer open} other {# roles you saw are no longer open}}",
  "watchlist.company.dataUnavailable": "Company data isn't available right now.",
  "watchlist.company.employerScore": "employer score",
  "watchlist.company.hiringActivity": "Hiring activity",
  "watchlist.company.hiringPace": "Posted {count} jobs this month, about {multiple}× their usual pace",
  "watchlist.company.hiringTrend.declining": "Declining",
  "watchlist.company.hiringTrend.growing": "Growing",
  "watchlist.company.hiringTrend.stable": "Stable",
  "watchlist.company.newRolesBadge": "+{count} new",
  "watchlist.company.newSinceLastVisit": "New since your last visit",
  "watchlist.company.openRoles": "open roles",
  "watchlist.company.roleMatch": "{score}% match",
  "watchlist.company.scoreGradeDropped": "Employer grade dropped to {tier} since your last visit",
  "watchlist.company.scoreGradeImproved": "Employer grade improved to {tier} since your last visit",
  "watchlist.company.similarEmpty": "Couldn't find similar companies right now.",
  "watchlist.company.similarTrigger": "Similar companies",
  "watchlist.company.sparklineLabel": "Job postings per month, last {months} months",
  "watchlist.compare.company": "Company",
  "watchlist.compare.exportCsv": "Export CSV",
  "watchlist.compare.flexibility": "Flexibility",
  "watchlist.compare.jobsPerMonth": "Jobs/mo",
  "watchlist.compare.newBadge": "+{count} new",
  "watchlist.compare.openRoles": "Open roles",
  "watchlist.compare.pay": "Pay",
  "watchlist.compare.remote": "Remote",
  "watchlist.compare.salary": "Median salary €/mo",
  "watchlist.compare.score": "Score",
  "watchlist.compare.share": "Share",
  "watchlist.compare.shareCopied": "Link copied. Anyone with it can view this comparison",
  "watchlist.compare.stability": "Stability",
  "watchlist.compare.topRoles": "Mostly hiring",
  "watchlist.empty.body": "Follow a company from its profile page to track new roles, employer score, and hiring trend here.",
  "watchlist.empty.title": "You aren't following any companies yet.",
  "watchlist.roles.heading": "Roles you watch",
  "watchlist.roles.newBadge": "+{count} new",
  "watchlist.roles.newSinceLastVisit": "New since your last visit",
  "watchlist.roles.openCount": "{count, plural, one {# open job} other {# open jobs}}",
  "watchlist.roles.unwatch": "Stop watching",
  "watchlist.sharedCompare.banner": "You're viewing a comparison someone shared with you, not your own watchlist.",
  "watchlist.sharedCompare.cta": "Start your own watchlist →",
  "watchlist.sharedCompare.empty": "This shared comparison doesn't have any companies to show.",
  "watchlist.sharedCompare.loading": "Loading the shared comparison…",
  "watchlist.suggestions.heading": "Companies you might want to watch",
  "watchlist.suggestions.reasonIndustry": "Similar to companies you follow",
  "watchlist.suggestions.reasonIndustryScoreDiff": "Scores {delta} points higher than your average follow",
  "watchlist.suggestions.reasonSavedJobs": "{count, plural, one {You saved # of their jobs} other {You saved # of their jobs}}",
  "watchlist.suggestions.reasonTopRated": "Top-rated employer",
  "watchlist.thresholdAlert.add": "Add alert",
  "watchlist.thresholdAlert.cancel": "Cancel",
  "watchlist.thresholdAlert.condition.above": "rises above",
  "watchlist.thresholdAlert.condition.below": "drops below",
  "watchlist.thresholdAlert.metric.employerScore": "Employer score",
  "watchlist.thresholdAlert.metric.openRoles": "Open roles",
  "watchlist.thresholdAlert.remove": "Remove alert",
  "watchlist.thresholdAlert.save": "Save alert",
  "watchlist.thresholdAlert.summaryAbove": "{metric} above {value}",
  "watchlist.thresholdAlert.summaryBelow": "{metric} below {value}",
  "watchlist.view.cards": "Cards",
  "watchlist.view.compare": "Compare",
  "profile.applying.addAddress": "Add",
  "profile.applying.addContact": "Add",
  "profile.applying.addNoticePeriod": "Add your notice period",
  "profile.applying.addPay": "Add",
  "profile.applying.availability": "Availability",
  "profile.applying.contact": "Contact",
  "profile.applying.currentPay": "Current pay",
  "profile.applying.doneOf": "{done} of {total} done",
  "profile.applying.eyebrow": "Applying",
  "profile.applying.homeCommute": "Home and commute",
  "profile.applying.payExpectation": "Pay expectation",
  "profile.applying.rightToWork": "Right to work",
  "profile.applying.workAuth.unset": "Add",
  "profile.applyingSummary.workAuth.euEea": "EU / EEA citizen",
  "profile.applyingSummary.workAuth.finnish": "Finnish citizen",
  "profile.applyingSummary.workAuth.notAuthorized": "Not authorized",
  "profile.applyingSummary.workAuth.permanent": "Permanent resident",
  "profile.applyingSummary.workAuth.permit": "Have a work permit",
  "profile.applyingSummary.workAuth.sponsorship": "Need sponsorship",
  "profile.availability.earliestStart": "Earliest start date",
  "profile.availability.noticePeriod.immediately": "Immediately",
  "profile.availability.noticePeriod.longer": "Longer than 3 months",
  "profile.availability.noticePeriod.oneMonth": "1 month",
  "profile.availability.noticePeriod.threeMonths": "3 months",
  "profile.availability.noticePeriod.twoMonths": "2 months",
  "profile.availability.noticePeriod.twoWeeks": "2 weeks",
  "profile.availability.status.activelyLooking": "Actively looking",
  "profile.availability.status.notLooking": "Not looking",
  "profile.availability.status.open": "Open to offers",
  "profile.availability.status.unset": "Not set",
  "profile.availability.statusLabel": "Status",
  "profile.cv.add": "Add",
  "profile.cv.addHeadline": "Add a headline",
  "profile.cv.edit": "Edit",
  "profile.cv.editHeadlineAria": "Edit headline and summary",
  "profile.cv.education": "Education",
  "profile.cv.educationEmpty": "No education added yet.",
  "profile.cv.experience": "Experience",
  "profile.cv.experienceEmpty": "No work experience added yet.",
  "profile.cv.languages": "Languages",
  "profile.cv.languagesEmpty": "No languages added yet.",
  "profile.cv.licences": "Licences and cards",
  "profile.cv.licencesEmpty": "No licences added yet.",
  "profile.cv.projects": "Projects",
  "profile.cv.skills": "Skills",
  "profile.cv.skillsEmpty": "Add at least a few skills.",
  "profile.cvTranslate.button": "Translate from English",
  "profile.cvTranslate.draftNote": "Translation is a draft. Nothing is saved until you review it.",
  "profile.cvTranslate.emptyTitle": "Your {locale, select, fi {Finnish} sv {Swedish} other {English}} CV is empty",
  "profile.cvTranslate.failed": "Translation failed. Please try again.",
  "profile.cvTranslate.orWriteByHand": "Or write it by hand instead.",
  "profile.cvTranslate.translating": "Translating…",
  "profile.cvTranslate.whatWillTranslate": "Headline and summary, Experience, Education and projects, Skills",
  "profile.cvTranslateReview.acceptAll": "Accept all",
  "profile.cvTranslateReview.empty": "Nothing to review yet.",
  "profile.cvTranslateReview.title": "Review translation",
  "profile.downloadData.failed": "Failed to download your data. Please try again.",
  "profile.editChips.licencesPlaceholder": "Add a licence or card",
  "profile.editChips.removeAria": "Remove {value}",
  "profile.editChips.skillsPlaceholder": "Add a skill",
  "profile.editCurrentPay.privateNote": "Private. Only used to improve your match score, never shown to employers.",
  "profile.editCurrentPay.workPercentage": "Work percentage",
  "profile.editCurrentPay.workPercentagePlaceholder": "100",
  "profile.editEducation.degree": "Degree",
  "profile.editEducation.institution": "Institution",
  "profile.editEducation.remove": "Remove this education",
  "profile.editEducation.title": "Edit education",
  "profile.editExperience.company": "Company",
  "profile.editExperience.currentlyWorkHere": "I currently work here",
  "profile.editExperience.description": "What you did",
  "profile.editExperience.end": "End",
  "profile.editExperience.none": "No role selected.",
  "profile.editExperience.remove": "Remove this role",
  "profile.editExperience.start": "Start",
  "profile.editExperience.tailoredHint": "Tailored CVs work best with team size and tools used.",
  "profile.editExperience.tightenWithAi": "Tighten the wording",
  "profile.editExperience.title": "Edit role",
  "profile.editExperience.titleField": "Title",
  "profile.editHeader.headlinePlaceholder": "e.g. Product Designer",
  "profile.editHeader.summary": "Summary (1 to 3 sentences)",
  "profile.editHeader.title": "Edit headline",
  "profile.editLanguages.addPlaceholder": "Add a language",
  "profile.editLanguages.level.a1": "A1",
  "profile.editLanguages.level.a2": "A2",
  "profile.editLanguages.level.b1": "B1",
  "profile.editLanguages.level.b2": "B2",
  "profile.editLanguages.level.c1": "C1",
  "profile.editLanguages.level.c2": "C2",
  "profile.editLanguages.level.native": "Native",
  "profile.editLanguages.removeAria": "Remove language",
  "profile.editMatching.benefits": "Benefits",
  "profile.editMatching.benefitsPlaceholder": "Search benefits...",
  "profile.editMatching.industries": "Industries",
  "profile.editMatching.industriesPlaceholder": "Search industries...",
  "profile.editMatching.jobType": "Job type",
  "profile.editMatching.jobTypePlaceholder": "Full-time, part-time...",
  "profile.editMatching.liveCount": "{count} open jobs match right now",
  "profile.editMatching.locations": "Locations",
  "profile.editMatching.morePreferences": "More preferences",
  "profile.editMatching.payFloor": "Pay floor, € / month",
  "profile.editMatching.payFloorHint": "Jobs under your floor score lower, they are not hidden.",
  "profile.editMatching.roleLevel": "Role level",
  "profile.editMatching.roleLevelPlaceholder": "Junior, mid-level, senior...",
  "profile.editMatching.roles": "Roles",
  "profile.editMatching.rolesPlaceholder": "Search job titles...",
  "profile.editMatching.title": "What you are looking for",
  "profile.editMatching.vacationWeeks": "Holiday weeks",
  "profile.editMatching.workModel": "Work model",
  "profile.editProject.remove": "Remove this project",
  "profile.editProject.title": "Edit project",
  "profile.editProject.year": "Year",
  "profile.header.editAria": "Edit headline and profile details",
  "profile.howto.applying": "Applying.",
  "profile.howto.applyingBody": "Contact and pay details fill in job application forms for you.",
  "profile.howto.cv": "CV.",
  "profile.howto.cvBody": "Your experience, in EN/FI/SV, powers tailored CVs and cover letters.",
  "profile.howto.matching": "Matching.",
  "profile.howto.matchingBody": "What you're looking for scores every job for you.",
  "profile.howto.noSaveButton": "Everything saves as you type. No save button.",
  "profile.importance.less": "Less",
  "profile.importance.more": "More",
  "profile.importance.normal": "Normal",
  "profile.importance.pay": "Pay",
  "profile.importance.remote": "Remote or hybrid",
  "profile.importance.rescoreNote": "Saved. Your matches are rescored as you tap.",
  "profile.importance.title": "What matters most",
  "profile.linkedInImport.disabledNote": "LinkedIn import is temporarily unavailable. You can still paste your LinkedIn URL from the headline sheet.",
  "profile.matching.adjust": "Adjust",
  "profile.matching.edit": "Edit",
  "profile.matching.emailMeNewOnes": "Email me new ones",
  "profile.matching.eyebrow": "Job matching",
  "profile.matching.factor.benefits": "benefits",
  "profile.matching.factor.jobType": "job type",
  "profile.matching.factor.languages": "languages",
  "profile.matching.factor.location": "location",
  "profile.matching.factor.remoteness": "remote work",
  "profile.matching.factor.roleLevel": "role level",
  "profile.matching.factor.salary": "pay",
  "profile.matching.factor.title": "job title",
  "profile.matching.factor.vacation": "holiday weeks",
  "profile.matching.hero": "open jobs match what you are looking for",
  "profile.matching.seeThem": "See them",
  "profile.matching.weighsMost": "Weighs most: {factors}",
  "profile.quickStart.fromSearches": "From your searches:",
  "profile.quickStart.moreLater": "Pay, role level and what matters most come next. All optional.",
  "profile.quickStart.start": "Start matching",
  "profile.quickStart.title": "Three answers and we can score every job for you",
  "profile.quickStart.workModel": "Work model",
  "profile.savedStatus.justNow": "Saved just now",
  "profile.savedStatus.minutesAgo": "Saved {minutes, plural, one {# minute} other {# minutes}} ago",
  "profile.savedStatus.saved": "Saved",
  "profile.savedStatus.saving": "Saving...",
  "profile.sheet.close": "Close",
  "profile.sheet.done": "Done",
  "profile.strength.allDone": "Your profile is ready to generate great CVs.",
  "profile.strength.applying.done": "Applying ready",
  "profile.strength.applying.progress": "Applying {done} of {total}",
  "profile.strength.cv": "CV ready",
  "profile.strength.matching": "Matching ready",
  "profile.visibility.downloadData": "Download my data",
  "profile.visibility.howItsUsed": "How this profile is used",
  "profile.visibility.onlyYou": "Only you can see this profile.",
  "profile.visibility.recruiterNote": "Recruiters see an anonymous version only if you turn it on in the Recruiters tab.",
  "profile.applying.currentPayPrivate": "Private, only for your match score",
  "profile.cv.untitled": "Untitled",
  "profile.matching.alertBusy": "Setting up...",
  "profile.matching.alertFailed": "Could not set up alerts. Try again.",
  "profile.matching.alertOn": "Alerts on for this search",
  "profile.matching.alertPending": "Check your inbox to confirm",
  "profile.strength.item.applyingAvailability": "add your notice period so employers know when you can start",
  "profile.strength.item.applyingContact": "add your contact details",
  "profile.strength.item.applyingCurrentPay": "add your current pay",
  "profile.strength.item.applyingSalaryExpectation": "add your pay expectation",
  "profile.strength.item.applyingWorkAuthorization": "add your right to work",
  "profile.strength.item.cvEducation": "add your education",
  "profile.strength.item.cvExperience": "add your work experience",
  "profile.strength.item.cvHeadline": "add a headline to your CV",
  "profile.strength.item.cvSkills": "add at least 3 skills",
  "profile.strength.item.matchingLocations": "add where you want to work",
  "profile.strength.item.matchingTitles": "add the roles you want",
  "profile.strength.item.matchingWorkModel": "pick remote, hybrid or on-site",
  "profile.strength.nextItem": "Next: {item}",
  "profile.importance.example": "A job that fits all your preferences would score {ideal}. The same job outside your locations, on-site and paying less: {worse}.",
  "profile.importance.notSet": "Not set",
  "profile.importance.payAgainst": "Against your {amount} € minimum",
  "profile.editChips.add": "Add",
  "profile.licenceOptions.alcoholPassport": "Alcohol serving passport",
  "profile.licenceOptions.drivingB": "Driving licence B",
  "profile.licenceOptions.drivingC": "Driving licence C",
  "profile.licenceOptions.drivingCE": "Driving licence CE",
  "profile.licenceOptions.drivingD": "Driving licence D",
  "profile.licenceOptions.electricalSafety": "Electrical safety SFS 6002",
  "profile.licenceOptions.firstAidEA1": "First aid EA1",
  "profile.licenceOptions.firstAidEA2": "First aid EA2",
  "profile.licenceOptions.forkliftCard": "Forklift licence",
  "profile.licenceOptions.hotWorkCard": "Hot work card",
  "profile.licenceOptions.hygienePassport": "Hygiene passport",
  "profile.licenceOptions.medicationPermit": "Medication administration permit (LOVe)",
  "profile.licenceOptions.nursingLicence": "Valvira registration (healthcare)",
  "profile.licenceOptions.occupationalSafetyCard": "Occupational safety card",
  "profile.licenceOptions.professionalDriverCPC": "Professional driver qualification (CPC)",
  "profile.licenceOptions.roadSafety1": "Road safety card (Tieturva 1)",
  "profile.licenceOptions.securityGuardCard": "Security guard card",
  "profile.licenceOptions.stewardCard": "Steward card",
  "profile.licenceOptions.taxiLicence": "Taxi driver licence",
  "profile.licenceOptions.waterHygiene": "Water hygiene passport",
  "profile.locationPicker.allFinland": "Anywhere in Finland",
  "profile.locationPicker.citiesIn": "Cities in {region}",
  "profile.locationPicker.finlandRegions": "Regions of Finland",
  "profile.locationPicker.removeAria": "Remove {place}",
  "profile.locationPicker.searchPlaceholder": "Search a city, region or country",
  "profile.locationPicker.type.admin1": "region",
  "profile.locationPicker.type.city": "city",
  "profile.locationPicker.type.continent": "continent",
  "profile.locationPicker.type.country": "country",
  "profile.locationPicker.type.recruitingRegion": "area",
  "profile.locationPicker.unresolved": "Not on our map yet, kept as typed",
  "careerPaths.add": "Add",
  "careerPaths.emptyResults": "We could not find a confident match for those skills. Try adding a few more.",
  "careerPaths.errorGeneric": "Something went wrong generating suggestions. Please try again.",
  "careerPaths.errorRateLimited": "Too many requests right now. Please wait a moment and try again.",
  "careerPaths.errorUnavailable": "Career path suggestions are temporarily unavailable.",
  "careerPaths.heading": "Discover careers your skills transfer to",
  "careerPaths.intro": "Add your skills below and we will suggest adjacent roles they transfer to, each backed by real, live job listings.",
  "careerPaths.jobCount": "{count, plural, one {# open job} other {# open jobs}}",
  "careerPaths.loading": "Finding adjacent roles for you…",
  "careerPaths.minSkillsHint": "Add at least 2 skills to get suggestions.",
  "careerPaths.removeAria": "Remove {value}",
  "careerPaths.resultsHeading": "Roles your skills could take you to",
  "careerPaths.skillPlaceholder": "Type a skill and press Enter",
  "careerPaths.skillsLabel": "Your skills",
  "careerPaths.submit": "Show me career paths",
  "careerPaths.viewJobs": "View jobs",
  "profile.careerPaths.heading": "Searches you could try",
  "profile.careerPaths.jobCount": "{count, plural, one {# job} other {# jobs}}",
  "savedSearches.card.alertingBadge": "Alerting",
  "savedSearches.card.open": "Open results",
  "searchesHub.overview.changeSettings": "Digest settings",
  "searchesHub.overview.digestTitle": "{delivery, select, push {Notifications} both {Email and notifications} other {Email digest}}",
  "searchesHub.overview.frequencyDaily": "Daily",
  "searchesHub.overview.frequencyWeekly": "Weekly",
  "searchesHub.overview.headlineEmpty": "Your alerts start with a search",
  "searchesHub.overview.headlineGuest": "Let your searches watch the market for you",
  "searchesHub.overview.headlineNew": "{count, plural, one {# new match} other {# new matches}}",
  "searchesHub.overview.headlineNoneAlerting": "No search is alerting yet",
  "searchesHub.overview.headlineQuiet": "Nothing new since your last digest",
  "searchesHub.overview.lastSent": "Last sent {when}",
  "searchesHub.overview.neverSent": "First digest on the way",
  "searchesHub.overview.nextSend": "Next digest {when}",
  "searchesHub.overview.offHint": "One weekly or daily digest of every new match, by email or notification. Turn it off anytime.",
  "searchesHub.overview.pendingHint": "Open the confirmation email we sent to start receiving digests.",
  "searchesHub.overview.radarAria": "{alerting} of {total} saved searches are alerting",
  "searchesHub.overview.sendsTo": "to {email}",
  "searchesHub.overview.signInCta": "Sign in",
  "searchesHub.overview.statSaved": "{count, plural, one {# saved} other {# saved}}",
  "searchesHub.overview.statWatching": "{count, plural, one {# alerting} other {# alerting}}",
  "searchesHub.overview.statusOff": "Off",
  "searchesHub.overview.statusOn": "On",
  "searchesHub.overview.statusPending": "Confirming",
  "searchesHub.overview.subEmpty": "Run a search on the jobs page. It lands here, and one switch turns it into a job alert.",
  "searchesHub.overview.subGuest": "Sign in to sync your searches across devices, see new matches live, and get alerts by email or notification.",
  "searchesHub.overview.subNew": "since your last digest, across {count, plural, one {# alerting search} other {# alerting searches}}",
  "searchesHub.overview.subNoneAlerting": "Switch on alerts for a search below and we will watch it for you.",
  "searchesHub.overview.subQuiet": "Watching {count, plural, one {# search} other {# searches}} for you. New matches show up here first, then {delivery, select, push {as a notification} both {in your inbox and as a notification} other {in your inbox}}.",
  "searchesHub.overview.turnOn": "Turn on job alerts",
  "savedSearches.noStatusResults": "No searches here yet. Switch on alerts for a search to see it under Alerting.",
  "savedSearches.toolbar.statusAlerting": "Alerting",
  "savedSearches.toolbar.statusAll": "All",
  "savedSearches.toolbar.statusFilterAria": "Show searches",
  "savedSearches.toolbar.statusPaused": "Paused",
  "searchesHub.loading": "Loading your searches…",
  "salaryRolePage.exposure.augmentationNote": "Research suggests AI is more likely to change parts of this job than replace it entirely.",
  "salaryRolePage.exposure.band.high": "High exposure",
  "salaryRolePage.exposure.band.low": "Low exposure",
  "salaryRolePage.exposure.band.medium": "Medium exposure",
  "salaryRolePage.exposure.exposedTasksHeading": "Tasks more exposed to AI",
  "salaryRolePage.exposure.heading": "AI & automation exposure",
  "salaryRolePage.exposure.relatedRolesHeading": "Lower-exposure roles to consider",
  "salaryRolePage.exposure.resilientTasksHeading": "Tasks less exposed to AI",
  "salaryRolePage.exposure.sourceLabel": "Source: {source}",
  "searchesHub.insight.closingSoon": "{count, plural, one {# closes within a week} other {# close within a week}}",
  "searchesHub.insight.jobsNow": "{count, plural, =0 {No jobs right now} one {# job right now} other {# jobs right now}}",
  "searchesHub.insight.newThisWeek": "{count, plural, =0 {none new this week} one {# new this week} other {# new this week}}",
  "searchesHub.insight.trendDown": "Slowing down",
  "searchesHub.insight.trendUp": "Picking up",
  "searchesHub.sheet.close": "Close",
  "tools.kanban.deselectAll": "Deselect all",
  "tools.kanban.mobile.cancelSelect": "Cancel",
  "tools.kanban.mobile.deselectAll": "Deselect all",
  "tools.kanban.mobile.removeSelected": "Remove",
  "tools.kanban.mobile.selectAll": "Select all",
  "tools.kanban.mobile.selectRow": "Select {title}",
  "tools.kanban.mobile.selectToggle": "Select",
  "tools.kanban.mobile.selectedCount": "{count, plural, one {# selected} other {# selected}}",
  "tools.kanban.selectAll": "Select all",
  "savedSearches.card.tune": "Tune",
  "searchesHub.edit.cancel": "Cancel",
  "searchesHub.edit.counting": "Counting…",
  "searchesHub.edit.filtersLabel": "Other filters",
  "searchesHub.edit.keepsAlert": "Your alert, name and folder stay attached.",
  "searchesHub.edit.keywordsLabel": "Keywords",
  "searchesHub.edit.keywordsPlaceholder": "e.g. backend developer",
  "searchesHub.edit.liveCount": "{count, plural, =0 {No jobs match yet} one {# job matches} other {# jobs match}}",
  "searchesHub.edit.liveNew": "{count} new this week",
  "searchesHub.edit.locationLabel": "Where",
  "searchesHub.edit.locationPlaceholder": "Add a city or region",
  "searchesHub.edit.remoteOnly": "Remote only",
  "searchesHub.edit.removeAria": "Remove {label}",
  "searchesHub.edit.save": "Save changes",
  "searchesHub.edit.saving": "Saving…",
  "searchesHub.edit.title": "Tune this search",
  "searchesHub.inbox.allClear": "All caught up. Anything new lands here first.",
  "searchesHub.inbox.applied": "Applied",
  "searchesHub.inbox.closingSoon": "Closes {date}",
  "searchesHub.inbox.dismissAria": "Not interested in {title}",
  "searchesHub.inbox.fromSearch": "via {label}",
  "searchesHub.inbox.heading": "{count, plural, one {# new job} other {# new jobs}} since your last digest",
  "searchesHub.inbox.matchPct": "{score}% match",
  "searchesHub.inbox.more": "Show {count} more",
  "searchesHub.inbox.noProfile": "Fill in your profile to rank these by fit.",
  "searchesHub.inbox.saveAria": "Save {title}",
  "searchesHub.inbox.saved": "Saved",
  "searchesHub.inbox.strongFirst": "Best fit for your profile first",
  "searchesHub.overview.closingSoon": "{count, plural, one {# closes within a week} other {# close within a week}}",
  "searchesHub.overview.liveTotal": "{count, plural, one {# live job} other {# live jobs}} across your searches",
  "searchesHub.overview.previewDigest": "Preview email",
  "searchesHub.overview.strongMatches": "{count, plural, one {# strong match for your profile} other {# strong matches for your profile}}",
  "searchesHub.preview.error": "We couldn't build the preview right now. Try again in a moment.",
  "searchesHub.preview.loading": "Building your email…",
  "searchesHub.preview.noAlerts": "No search has alerts on yet, so this email would be empty. Switch one on below and come back.",
  "searchesHub.preview.note": "Rendered with the same template as the real email, from what your alerts have found so far.",
  "searchesHub.preview.subjectLabel": "Subject",
  "searchesHub.preview.title": "Your next digest",
  "searchesHub.suggestion.accept": "Watch it",
  "searchesHub.suggestion.accepting": "Adding…",
  "searchesHub.suggestion.ask": "Watch that?",
  "searchesHub.suggestion.dismissAria": "Dismiss suggestion",
  "searchesHub.suggestion.lead": "You've opened {count} {title} jobs in the last two weeks.",
  "searchesHub.suggestion.leadWithRegion": "You've opened {count} {title} jobs in the last two weeks. Watch {title} in {region}?",
  "searchesHub.suggestion.liveCount": "{count, plural, one {# job right now} other {# jobs right now}}, {fresh} new this week",
  "searchesHub.tuning.applying": "Updating…",
  "searchesHub.tuning.broadBody": "{count} jobs match, but each digest shows only the top 10 per search. Narrow it so the right ones surface.",
  "searchesHub.tuning.broadTitle": "Too broad for a useful digest",
  "searchesHub.tuning.emptyTitle": "This search matches nothing right now",
  "searchesHub.tuning.fixAddRegion": "Limit to {region}",
  "searchesHub.tuning.fixCount": "{count, plural, one {# job} other {# jobs}}",
  "searchesHub.tuning.fixDropFacet": "Drop the {facet} filter",
  "searchesHub.tuning.fixDropQualifier": "Remove \"{word}\"",
  "searchesHub.tuning.fixSortByDate": "Show newest first",
  "searchesHub.tuning.fixWidenToRegion": "Widen to {region}",
  "searchesHub.tuning.narrowBody": "An alert on this search will stay silent. Try one of these:",
  "searchesHub.tuning.staleTitle": "Nothing new here in 30 days",
  "searchesHub.insight.jobsCaption": "{count, plural, one {job now} other {jobs now}}",
  "searchesHub.insight.newShort": "+{count} this week",
  "savedSearches.attr.benefits": "Benefits",
  "savedSearches.attr.companyId": "Company",
  "savedSearches.attr.companyIndustry": "Industry",
  "savedSearches.attr.educationLevel": "Education",
  "savedSearches.attr.field": "Field",
  "savedSearches.attr.headcount": "Company size",
  "savedSearches.attr.isSummerJob": "Summer job",
  "savedSearches.attr.jobType": "Job type",
  "savedSearches.attr.location": "Location",
  "savedSearches.attr.normalisedRoleLevel": "Level",
  "savedSearches.attr.normalisedTitle": "Role",
  "savedSearches.attr.optionalLanguages": "Nice-to-have languages",
  "savedSearches.attr.peopleManagementTier": "Management",
  "savedSearches.attr.regionTags": "Location",
  "savedSearches.attr.remoteness": "Work mode",
  "savedSearches.attr.requiredLanguages": "Languages",
  "savedSearches.attr.skillsAndTechnologies": "Skills",
  "savedSearches.name.allJobs": "All jobs",
  "savedSearches.name.fieldJobs": "{field} jobs",
  "savedSearches.name.hybridPrefix": "Hybrid {name}",
  "savedSearches.name.inPlace": "{name} in {place}",
  "savedSearches.name.jobsAt": "Jobs at {company}",
  "savedSearches.name.levelJobs": "{level} jobs",
  "savedSearches.name.remotePrefix": "Remote {name}",
  "savedSearches.name.roleJobs": "{role} jobs",
  "savedSearches.name.summerJobs": "Summer jobs",
  "savedSearches.name.typeJobs": "{type} jobs",
  "savedSearches.name.worldwide": "{name}, worldwide",
  "savedSearches.toolbar.organizeAria": "Organize",
  "salaryRolePage.exposure.matchBasis": "Estimate for the broader occupation category: {occupationGroup}",
  "tools.jobFlowSankey.whereNow": "Where your applications are now",
  "tools.jobSheet.checklist": "To-do",
  "tools.jobSheet.done": "Done",
  "tools.jobSheet.markApplied": "I applied",
  "tools.jobSheet.notes": "Notes",
  "tools.jobSheet.privateHint": "Only you can see these.",
  "tools.jobSheet.stage": "Stage",
  "tools.jobSheet.tags": "Tags",
  "tools.myJobs.addExternalTile": "Applied somewhere else? Add it here",
  "tools.myJobs.clearSearch": "Clear search",
  "tools.myJobs.companyFilterChip": "Company: {company}",
  "tools.myJobs.hideSection": "Hide",
  "tools.myJobs.noMatches": "Nothing matches “{query}”.",
  "tools.myJobs.row.hasNote": "Note",
  "tools.myJobs.row.offSite": "Off-site",
  "tools.myJobs.row.savedAgo": "Saved {relativeAge}",
  "tools.myJobs.showSection": "Show",
  "tools.myJobs.stageFilterLabel": "Filter by stage",
  "tools.myJobs.upNext.followUp": "Follow up? No reply in {days, plural, one {# day} other {# days}}",
  "tools.myJobs.upNext.heading": "Up next",
  "tools.myJobs.upNext.offer": "Offer waiting for your answer",
  "tools.myJobs.upNext.prep": "Interview prep: {done} of {total} done",
  "tools.myJobs.upNext.showAll": "Show all {count}",
  "tools.myJobs.upNext.showFewer": "Show fewer",
  "tools.kanban.addShort": "Add",
  "tools.kanban.card.hint": "Click for details, drag to move",
  "tools.kanban.card.openPosting": "Open job posting",
  "salaryInference.marketMedianFromSimilar": "The employer did not state pay in this listing. We show the median minimum–maximum band from similar jobs on JobCrawls, using the most specific slice we have: company + job title + location when possible, otherwise title + location, otherwise seniority, otherwise title alone. Amounts are in EUR per month.",
  "salaryInference.marketMedianFromSimilarLowConfidence": "The employer did not state pay in this listing, and we found only {sampleSize} comparable posting(s) for this specific role, so this estimate leans mostly on the broader local market rather than this exact job title. Treat it as a rough guide, not a precise figure. Amounts are in EUR per month.",
  "salaryInference.marketMedianFromSimilarWithCount": "The employer did not state pay in this listing. We show the median minimum–maximum band from similar jobs on JobCrawls, based on {sampleSize} comparable postings, using the most specific slice we have: company + job title + location when possible, otherwise title + location, otherwise seniority, otherwise title alone. Amounts are in EUR per month.",
  "salaryInference.numericWithoutListingQuote": "Our pipeline extracted a pay range for this ad, but we do not have a short verbatim salary quote from the listing text. Treat the numbers as unverified.",
  "jobDetailPageV2.deadlinePassed": "Deadline passed {date}",
  "jobDetailPageV2.matchDonut.emptyLabel": "See your match",
  "jobDetailPageV2.mostHiredRoles.allTime": "Most-hired roles (all time)",
  "jobDetailPageV2.roleLevelMix.allTime": "Role-level mix (all time)",
  "jobDetailPageV2.topLocations.allTime": "Top locations (all time):",
  "marketHeader.nearbyRegionLink": "All of {region}",
  "marketHeader.workModel.flexibleWork": "Flexible Work",
  "marketHeader.workModel.hybridPopular": "Hybrid Popular",
  "marketHeader.workModel.primarilyOnsite": "Primarily Onsite",
  "marketHeader.workModel.remoteFriendly": "Remote-Friendly",
  "cityPageV2.breadcrumb.ariaLabel": "Breadcrumb",
  "cityPageV2.breadcrumb.jobs": "Jobs",
  "cityPageV2.map.ariaLabel": "Map of {region}",
  "cityPageV2.map.attribution": "Boundaries: Statistics Finland (CC BY 4.0)",
  "cityPageV2.map.openMap": "Open map",
  "cityPageV2.employers.heading": "Direct employers hiring the most in {town}",
  "cityPageV2.faq.title": "Frequently asked about jobs in {town}",
  "cityPageV2.intro.lede": "{count, plural, one {<b># open job</b>} other {<b># open jobs</b>}} in {town}, from employers' own career sites and Työmarkkinatori in one search.",
  "cityPageV2.intro.weekClause": "{count, plural, one {# new} other {# new}} in the last week.",
  "cityPageV2.map.captionSub": "{count, plural, one {# open job} other {# open jobs}} in {region}",
  "cityPageV2.map.captionTitle": "{town} and nearby towns",
  "cityPageV2.market.pay": "Pay",
  "cityPageV2.market.payBasis": "{count, plural, one {Based on # listing that states pay.} other {Based on # listings that state pay.}}",
  "cityPageV2.market.paySentence": "Median <b>{median}</b>. Half of all salaries fall within {range}.",
  "cityPageV2.market.topFields": "Fields with the most jobs",
  "cityPageV2.market.townHeading": "{town} job market",
  "cityPageV2.market.workMode": "How the work is done",
  "cityPageV2.nearby.allRegion": "All jobs in {region} ({count})",
  "cityPageV2.nearby.alsoNear": "Also nearby:",
  "cityPageV2.nearby.heading": "Jobs in nearby towns",
  "cityPageV2.tile.averagePay": "average pay",
  "cityPageV2.tile.averagePaySub": "salary data: {count, plural, one {# posting} other {# postings}}",
  "cityPageV2.tile.english": "require English",
  "cityPageV2.tile.openJobs": "{count, plural, one {open job} other {open jobs}}",
  "cityPageV2.tile.openJobsSub": "{count} new in 7 days",
  "cityPageV2.tile.remote": "remote or hybrid",
  "cityPageV2.employers.headingInflected": "Direct employers hiring the most in {townLocative}",
  "cityPageV2.faq.titleInflected": "Frequently asked about jobs in {townGenitive}",
  "cityPageV2.intro.ledeInflected": "{count, plural, one {<b># open job</b>} other {<b># open jobs</b>}} in {townLocative}, from employers' own career sites and Työmarkkinatori in one search.",
  "cityPageV2.map.captionSubInflected": "{count, plural, one {# open job} other {# open jobs}} in {regionLocative}",
  "cityPageV2.market.townHeadingInflected": "{townGenitive} job market",
  "cityPageV2.nearby.allRegionInflected": "All jobs in {regionGenitive} ({count})",
  "cityPageV2.tile.finnishSub": "Finnish required {percent}",
  "cityPageV2.tile.remoteSplit": "{hybrid} hybrid, {remote} remote",
  "map.panel.followViewport": "Update list as I move the map",
  "map.panel.searchThisArea": "Search this area",
  "map.preview.next": "Next",
  "map.preview.openJob": "Open job",
  "map.sheet.collapse": "Show less, see more of the map",
  "map.sheet.expand": "Show more results",
  "cityPageV2.employers.allCta": "All employers →",
  "map.lens.groupLabel": "Map view",
  "map.lens.volume": "Open jobs",
  "map.lens.work": "Work mode",
  "map.commute.byLabel": "By",
  "map.commute.fromLabel": "From",
  "map.commute.legendInReach": "In reach",
  "map.commute.legendOutside": "Outside",
  "map.commute.moreTowns": "+ {count, plural, one {# more town} other {# more towns}}",
  "map.commute.originFromMap": "Point picked on the map",
  "map.commute.panelTitle": "Jobs you can actually get to",
  "map.commute.reachCount": "{count, plural, one {job in reach} other {jobs in reach}}",
  "map.commute.withinLabel": "Within",
  "map.alert.cta": "Alert me",
  "map.alert.on": "Alert on",
  "map.area.allTowns": "All {count} places",
  "map.area.breadcrumbLabel": "Map location",
  "map.area.clearFilters": "Clear filters",
  "map.area.countLine": "{countStrong} open jobs · same count as the map",
  "map.area.country": "Finland",
  "map.area.emptyBody": "Try another town or drop a filter.",
  "map.area.emptyTitle": "Nothing matches here yet",
  "map.area.fallbackTitle": "This map area",
  "map.area.nextPage": "Next page",
  "map.area.openAsList": "Open as list",
  "map.area.pageOf": "{page} / {pages}",
  "map.area.pagerLabel": "Result pages",
  "map.area.prevPage": "Previous page",
  "map.area.showCompanies": "Companies",
  "map.area.showJobs": "Back to jobs",
  "map.area.showsSalary": "Shows salary",
  "map.area.sortLabel": "Sort",
  "map.area.sortMatch": "Best match",
  "map.area.sortNewest": "Newest",
  "map.area.summary": "{count, plural, one {# job listed} other {# jobs listed}}",
  "map.area.summaryCapped": "{shown} of {total} listed. Zoom in to see them all.",
  "map.area.townGroup": "Town",
  "map.explorer.colourBy": "Colour the map by",
  "map.explorer.commuteDesc": "Only show jobs within your commute",
  "map.explorer.commuteTitle": "Commute reach",
  "map.explorer.controlsLabel": "Map controls",
  "map.explorer.lede": "{count, plural, one {# open job} other {# open jobs}} across {places, plural, one {# place} other {# places}} on the map. Pick a place to look inside it.",
  "map.explorer.regionTotal": "Region total",
  "map.explorer.ringShare": "The number in each ring is the hybrid-or-remote share.",
  "map.explorer.title": "Where Finland is hiring",
  "map.lens.topField": "Top field",
  "map.lens.topFieldDesc": "What each place hires most",
  "map.lens.volumeDesc": "Bigger circle, more openings",
  "map.lens.workDesc": "Onsite, hybrid or remote mix",
  "map.place.browseAll": "Browse all {count} jobs here",
  "map.place.hiringMostFor": "Hiring most for",
  "map.place.openJobsHere": "{count, plural, one {open job here} other {open jobs here}}",
  "map.placeInsight.field": "{field} leads in {leads} of {places} places.",
  "map.placeInsight.fieldException": "{place} is the only one where {field} comes first.",
  "map.placeInsight.volume": "{top} alone holds {percent}% of the jobs on the map. {second} comes next with {count}.",
  "map.placeInsight.volumeSingle": "{top} holds {percent}% of the jobs on the map.",
  "map.placeInsight.work": "{place} is the flexible one: {percent}% of its listings are hybrid or remote, against {comparePercent}% in {comparePlace}.",
  "map.placeInsight.workSingle": "{place} leads on flexibility: {percent}% of its listings are hybrid or remote.",
  "map.ring.aria": "{name}, {count, plural, one {# open job} other {# open jobs}}",
  "map.ring.flexibleShare": "{percent}% flexible",
  "map.ring.unnamed": "Map area",
  "map.workMode.hybrid": "Hybrid {count}",
  "map.workMode.hybridLabel": "Hybrid",
  "map.workMode.onsite": "Onsite {count}",
  "map.workMode.onsiteLabel": "Onsite",
  "map.workMode.remote": "Remote {count}",
  "map.workMode.remoteLabel": "Remote",
  "map.pin.ariaSingle": "{title}, {company}",
  "map.pin.groupJobs": "{count, plural, one {# job here} other {# jobs here}}",
  "map.preview.groupPosition": "{index} / {total} here",
  "map.preview.prev": "Previous",
  "map.area.backToOverview": "Overview",
  "map.place.jobsHere": "Jobs here, newest first",
  "map.card.listed": "Listed {age}",
  "map.card.seen": "updated {age}",
  "map.pin.noExactAddressTitle": "{town}: no exact address",
  "map.preview.noExactAddress": "no exact address",
  "hitCardB2.details.finnishNotRequired": "Finnish not required",
  "hitCardB2.details.postedOn": "Posted {date}",
  "hitCardB2.details.toggle": "More details",
  "hitCardB2.newBadge": "New",
  "hitCardB2.salary.estimateNote": ", estimate",
  "hitCardB2.viewJob.short": "View",
  "hitCardB2.details.languageLabel": "{count, plural, one {Language} other {Languages}}",
  "hitCardB2.details.openDaysBig": "{days, plural, one {# day} other {# days}}",
  "hitCardB2.details.openLabel": "Open",
  "hitCardB2.details.marketLabel": "Pay vs market",
  "hitCardB2.employerGrade.aria": "Employer score {grade}",
  "hitCardB2.salary.marketTooltip": "Market for similar jobs: {range}/mo (median {median}, {basis, select, official {Statistics Finland with job-ad differences} other {{count, plural, one {# job} other {# jobs}}}})",
  "srpSalaryStrip.apply": "Show these {count}",
  "srpSalaryStrip.brushLabel": "{count} / {total} between {lo} and {hi}",
  "srpSalaryStrip.cappedNote": "(showing the first {shown} of {total})",
  "srpSalaryStrip.clear": "Clear",
  "srpSalaryStrip.rangeFrom": "From (k€/mo)",
  "srpSalaryStrip.rangeTo": "To (k€/mo)",
  "srpSalaryStrip.selectRange": "Select range",
  "srpSalaryStrip.textSummary": "Median {median}/mo, typical range (P25–P75) {p25} to {p75} per month, based on {count} employer-stated salaries.",
  "srpSalaryStrip.outliersAbove": "{count} over {value}",
  "srpBottomPanel.alertFrequency.daily": "Daily",
  "srpBottomPanel.alertFrequency.weekly": "Weekly",
  "srpBottomPanel.alertOn": "Alert on",
  "srpBottomPanel.asideAriaLabel": "Your job search activity",
  "srpBottomPanel.asideTitleActive": "Your job search",
  "srpBottomPanel.asideTitleExample": "See how your search progresses",
  "srpBottomPanel.copySignedInNoActivity": "This fills in as you browse, save and apply to jobs.",
  "srpBottomPanel.copySignedOut": "Sign in to see your own path: browsed, saved, applied and interviews. You'll also get job alerts for new postings.",
  "srpBottomPanel.editAlert": "Edit",
  "srpBottomPanel.exampleTag": "Example",
  "srpBottomPanel.genericSearchName": "Current search",
  "srpBottomPanel.jobCount": "{count, plural, one {# open job} other {# open jobs}}",
  "srpBottomPanel.myJobsLink": "My Jobs →",
  "srpBottomPanel.nationwide": "all of Finland",
  "srpBottomPanel.realAriaSummaryPrefix": "Your job search activity",
  "srpBottomPanel.salaryHeading": "Salaries",
  "srpBottomPanel.salaryInlineCount": "{count, plural, one {# posting} other {# postings}} with an employer-stated salary",
  "srpBottomPanel.signIn": "Sign in",
  "srpBottomPanel.saveSearch": "Save search",
  "srpBottomPanel.savedSearch": "Saved",
  "srpBottomPanel.dragHint": "Drag across the chart to filter by salary",
  "srpBottomPanel.filterWithNumbers": "Enter amounts",
  "srpBottomPanel.flow.interviewing": "Interview",
  "srpBottomPanel.flowAria": "{prefix}: {summary}",
  "srpBottomPanel.salaryFloorAlert": "Alert: over €{amount}/mo",
  "srpBottomPanel.salaryFloorAlertFailed": "Could not create the alert. Try again.",
  "srpBottomPanel.salaryStatsRich": "median <b>{median}/mo</b> · typical range <b>{p25}–{p75}/mo</b>",
  "srpBottomPanel.typicalRangeBand": "typical range",
  "srpSalaryStrip.rangeFromPlaceholder": "from",
  "srpSalaryStrip.rangeToPlaceholder": "to",
  "srpSalaryStrip.rangeUnit": "k€/mo",
  "hitTableB2.col.company": "Company",
  "hitTableB2.col.language": "Language",
  "hitTableB2.col.level": "Level",
  "hitTableB2.col.location": "Location",
  "hitTableB2.col.salary": "Salary",
  "hitTableB2.col.salary.minLabel": "Minimum salary (EUR/mo)",
  "hitTableB2.col.salary.sortHighLow": "Highest salary first",
  "hitTableB2.col.seen": "Updated",
  "hitTableB2.col.seen.sortNewest": "Newest first",
  "hitTableB2.col.title": "Job",
  "hitTableB2.col.title.placeholder": "Search job titles and keywords",
  "hitTableB2.header.clear": "Clear",
  "hitTableB2.header.noMatches": "No matches",
  "hitTableB2.header.searchPlaceholder": "Search...",
  "payModeToggle.ariaLabel": "Salary display",
  "payModeToggle.forYou": "For you",
  "payModeToggle.gross": "Gross",
  "payModeToggle.net": "Take-home",
  "payModeToggle.netAssumptions": "Estimated monthly take-home pay after tax, using the national-average municipal tax rate, no church tax, and standard deductions only. \"For you\" uses your own municipality when you're signed in and it's set on your profile.",
  "payModeToggle.suffix.takeHome": "take-home",
  "srpB2ViewToggle.ariaLabel": "View",
  "srpB2ViewToggle.cards": "Cards",
  "srpB2ViewToggle.map": "Map",
  "srpB2ViewToggle.table": "Table",
  "srpBottomPanel.salaryHeadingNet": "Take-home pay",
  "hitTableB2.header.sortSectionLabel": "Sort",
  "srpBottomPanel.salaryCaveat.assumptionAverage": "the national-average municipal tax rate",
  "srpBottomPanel.salaryCaveat.assumptionMunicipality": "the {municipality} municipal tax rate",
  "srpBottomPanel.salaryCaveat.calculatorLink": "Calculate yours",
  "srpBottomPanel.salaryCaveat.text": "Take-home pay is an estimate: calculated using {assumption}, without church tax or union dues. Your actual amount depends on your own tax card.",
  "search.refinements.locationAnywhere": "Anywhere",
  "searchPanel.addWithItHeading": "Add with it",
  "searchPanel.allCount": "All {count}",
  "searchPanel.allOpenJobs": "All open jobs",
  "searchPanel.anywhereSuffix": "anywhere",
  "searchPanel.baselineFinland": "In Finland",
  "searchPanel.baselineWorldwide": "Worldwide",
  "searchPanel.browseFieldHeading": "Browse a field",
  "searchPanel.clearAria": "Clear search",
  "searchPanel.closeAria": "Close search",
  "searchPanel.exampleHint": "Try typing \"senior react helsinki\"",
  "searchPanel.finlandUnspecified": "Finland (unspecified)",
  "searchPanel.firstMatchesHeading": "First matches",
  "searchPanel.hintParsed": "Backspace to remove the last word, Enter to show jobs",
  "searchPanel.hintTyping": "Up/down to move, Enter to search, Tab to add as a filter",
  "searchPanel.inputAriaLabel": "Search jobs",
  "searchPanel.insideTheseHeading": "Inside these {count}",
  "searchPanel.jobsSuffix": "jobs",
  "searchPanel.launchpadUnavailable": "Couldn't load suggestions right now. You can still search directly.",
  "searchPanel.lensKickerListAs": "List {label} as {attributeLabel}",
  "searchPanel.lensKickerMention": "Mention {query}",
  "searchPanel.narrowsHeading": "How each word narrows it",
  "searchPanel.needFinnish": "need Finnish",
  "searchPanel.oftenWithHeading": "Often with",
  "searchPanel.openJobsSuffix": "open jobs",
  "searchPanel.recentHeading": "Recent",
  "searchPanel.remoteScoped": "Remote ({scope})",
  "searchPanel.remoteWorldwide": "{name} (global)",
  "searchPanel.removeTokenAria": "Remove {label}",
  "searchPanel.rightNowKicker": "Right now",
  "searchPanel.scopeMoreFilters": "+{count}",
  "searchPanel.searchAsPlainWords": "Search as plain words",
  "searchPanel.showJobsButton": "Show {count} jobs",
  "searchPanel.textRowKind": "Text",
  "searchPanel.topMatchesHeading": "Top matches",
  "searchPanel.whereTheyAreKicker": "Where they are",
  "searchPanel.widenItHeading": "Widen it",
  "searchPanel.workSetupHeading": "Work setup",
  "searchPanel.workSetupHybrid": "Hybrid",
  "searchPanel.workSetupOnsite": "Onsite",
  "searchPanel.workSetupRemote": "Remote",
  "map.alert.offHint": "Get an email when new jobs match these filters. You can turn it off any time.",
  "map.alert.onHint": "You'll get an email when new jobs match these filters. Click to turn the alert off.",
  "map.controls.zoomIn": "Zoom in",
  "map.controls.zoomOut": "Zoom out",
  "srpBottomPanel.copyGuestWithActivity": "Saved on this device only. Activate your account to keep your job search on every device and get job alerts for new postings.",
  "map.commute.homeBadge": "Home",
  "map.place.placesNav": "Places on the map",
  "nav.search.whatLabel": "What",
  "nav.search.whereLabel": "Where",
  "usermenu.legalReviewPack": "Legal review pack",
  "usermenu.translationReview": "Review translations",
  "usermenu.translationSuggestions": "My translation suggestions",
  "usermenu.translatorGuide": "Translator guide",
  "nav.sheet.continueGuest": "Continue without signing in",
  "nav.sheet.keepLinkedin": "Keep these, continue with LinkedIn",
  "nav.sheet.linkedin": "Continue with LinkedIn",
  "hitCardB2.details.openHoursBig": "{hours, plural, one {# hour} other {# hours}}",
  "hitCardB2.details.openLessThanHour": "Less than an hour",
  "cityPageV2.categories.heading": "Popular job categories in {town}",
  "cityPageV2.categories.headingInflected": "Popular job categories in {townLocative}",
  "marketHeader.qa.employersAnswer": "The employers with the most open jobs in {location} include {companies}.",
  "marketHeader.qa.employersQuestion": "Which companies are hiring in {location}?",
  "marketHeader.qa.fieldsAnswer": "Most jobs in {location} are in {fields}.",
  "marketHeader.qa.fieldsQuestion": "What kinds of jobs are available in {location}?",
  "marketHeader.qa.openJobsAnswer": "{count, plural, one {There is # open job} other {There are # open jobs}} in {location} on JobCrawls right now, collected from employers' own career sites and Työmarkkinatori.",
  "marketHeader.qa.openJobsQuestion": "How many jobs are open in {location}?",
  "jobDetailPageV2.salaryGauge.benchmark.roleLevel": "{level, select, intern {intern-level roles} junior {junior roles} mid {mid-level roles} senior {senior roles} expert {expert-level roles} manager {manager-level roles} director {director-level roles} executive {executive roles} other {roles at this level}}",
  "companyProfile.financials.employees": "Employees",
  "companyProfile.financials.fiscalYear": "Financial year ending {date}",
  "companyProfile.financials.heading": "Financials",
  "companyProfile.financials.netProfit": "Profit for the year",
  "companyProfile.financials.operatingProfit": "Operating profit",
  "companyProfile.financials.profitTrend": "Profit by financial year",
  "companyProfile.financials.revenue": "Revenue",
  "companyProfile.financials.revenueTrend": "Revenue by financial year",
  "companyProfile.financials.sourceStatements": "PRH digital financial statements",
  "companyProfile.financials.sourceTax": "Finnish Tax Administration public tax data",
  "companyProfile.financials.sourcesBoth": "Sources: {statements} and {tax}, CC BY 4.0.",
  "companyProfile.financials.sourcesStatementsOnly": "Source: {statements}, CC BY 4.0.",
  "companyProfile.financials.sourcesTaxOnly": "Source: {tax}, CC BY 4.0.",
  "companyProfile.financials.taxHeading": "Corporate income tax",
  "companyProfile.financials.taxNote": "Taxable income is a tax figure, not revenue or accounting profit. It can be zero for profitable companies, for example within a group.",
  "companyProfile.financials.taxYear": "Tax year",
  "companyProfile.financials.taxableIncome": "Taxable income",
  "companyProfile.financials.taxesPaid": "Taxes",
  "companyProfile.financials.totalAssets": "Total assets",
  "companyProfile.lifecycle.bankruptcy": "In bankruptcy",
  "companyProfile.lifecycle.ceased": "Ceased",
  "companyProfile.lifecycle.liquidation": "In liquidation",
  "companyProfile.lifecycle.noticeBody": "According to the Finnish trade register, this company is winding down or no longer operates. Any job listings shown here may no longer be open.",
  "companyProfile.lifecycle.noticeHeading": "{companyName}: {status}",
  "companyProfile.lifecycle.noticeSource": "Source: Finnish Patent and Registration Office (PRH).",
  "companyProfile.lifecycle.registered": "Registered",
  "companyProfile.lifecycle.restructuring": "In corporate restructuring",
  "companyProfile.lifecycle.since": "{status} since {date}",
  "employersCity.beta": "Beta",
  "employersCity.card.close": "Close",
  "employersCity.card.cta": "{count, plural, one {See # open job} other {See # open jobs}} at {name}",
  "employersCity.card.grade": "Employer grade",
  "employersCity.card.history": "New jobs per month",
  "employersCity.card.more": "Click for the full card",
  "employersCity.card.na": "n/a",
  "employersCity.card.peak": "peak {count} / mo",
  "employersCity.card.rank": "#{rank} by {measure}",
  "employersCity.card.remote": "Remote or hybrid",
  "employersCity.card.roles": "Hiring most for",
  "employersCity.card.salary": "Salary band / mo",
  "employersCity.card.seniority": "Seniority of openings",
  "employersCity.card.since": "Since {year}",
  "employersCity.card.small": "Small employer",
  "employersCity.card.workModel": "How they work",
  "employersCity.cities": "Cities",
  "employersCity.colourBy": "Colour by",
  "employersCity.compressed": "Compressed",
  "employersCity.controls": "Controls",
  "employersCity.coverageAll": "all {total}",
  "employersCity.coverageSome": "{count} of {total} have data",
  "employersCity.districts": "City districts",
  "employersCity.flyHint": "Click to fly there",
  "employersCity.heightScale": "Height scale",
  "employersCity.heightShows": "Height shows",
  "employersCity.hideControls": "Hide",
  "employersCity.hint": "Drag to orbit · Ctrl + scroll to zoom · right-drag to pan",
  "employersCity.jobsCount": "{count, plural, one {# job} other {# jobs}}",
  "employersCity.label.counts": "{employers, plural, one {# employer} other {# employers}} · {jobs, plural, one {# job} other {# jobs}}",
  "employersCity.legend.garden": "Rooftop garden and flag: grade B or better",
  "employersCity.legend.grade": "Grade {grade}",
  "employersCity.legend.house": "Wooden town houses",
  "employersCity.legend.noData": "No data for this measure",
  "employersCity.legend.office": "City blocks",
  "employersCity.legend.rural": "Small employers (1–3 open jobs)",
  "employersCity.legend.tower": "Skyscrapers",
  "employersCity.level.director": "Director",
  "employersCity.level.intern": "Intern",
  "employersCity.level.junior": "Junior",
  "employersCity.level.manager": "Manager",
  "employersCity.level.mid": "Mid",
  "employersCity.level.senior": "Senior",
  "employersCity.loadError": "The city could not be loaded right now.",
  "employersCity.loading": "Building the city…",
  "employersCity.logos": "Company logos",
  "employersCity.margin.high": "Margin 15% or more",
  "employersCity.margin.loss": "Loss-making",
  "employersCity.margin.low": "Profitable, under 15%",
  "employersCity.margin.none": "No financials",
  "employersCity.margin.zero": "Break-even",
  "employersCity.metric.emp": "Employees",
  "employersCity.metric.jobs": "Open jobs",
  "employersCity.metric.profit": "Profit",
  "employersCity.metric.rem": "Remote and hybrid share",
  "employersCity.metric.rev": "Revenue",
  "employersCity.metric.sal": "Median salary",
  "employersCity.mode.grade": "Grade",
  "employersCity.mode.margin": "Margin",
  "employersCity.mode.natural": "Natural",
  "employersCity.mode.sector": "Sector",
  "employersCity.mode.trend": "Trend",
  "employersCity.nightNote": "At night, lit windows show hiring momentum: growing employers keep more lights on.",
  "employersCity.noWebgl": "Your browser cannot show the 3D view. The list shows the same employers.",
  "employersCity.outskirts": "Outskirts",
  "employersCity.outskirtsCounts": "{count, plural, one {# small employer} other {# small employers}}, 1–3 open jobs each",
  "employersCity.pillar.flex": "Flexibility",
  "employersCity.pillar.growth": "Growth",
  "employersCity.pillar.pay": "Pay",
  "employersCity.pillar.stability": "Stability",
  "employersCity.proportional": "Proportional",
  "employersCity.resetView": "Reset view",
  "employersCity.retry": "Try again",
  "employersCity.sceneAria": "3D city of employers in Finland. Each building is an employer; taller buildings have more open jobs.",
  "employersCity.search.label": "Find an employer",
  "employersCity.search.none": "No employer by that name here",
  "employersCity.search.placeholder": "e.g. Wolt, Nordea, Supercell",
  "employersCity.sector.biz": "Business & finance",
  "employersCity.sector.build": "Construction & property",
  "employersCity.sector.health": "Health & care",
  "employersCity.sector.industry": "Industry & engineering",
  "employersCity.sector.other": "Unclassified",
  "employersCity.sector.public": "Education & public",
  "employersCity.sector.staff": "Staffing & recruitment",
  "employersCity.sector.tech": "Tech & IT",
  "employersCity.sector.trade": "Retail & hospitality",
  "employersCity.stat.employers": "employers",
  "employersCity.stat.growing": "growing",
  "employersCity.stat.jobs": "open jobs",
  "employersCity.tallest": "Tallest buildings",
  "employersCity.timeOfDay": "Time of day",
  "employersCity.tod.afternoon": "Afternoon",
  "employersCity.tod.dusk": "Dusk",
  "employersCity.tod.golden": "Golden hour",
  "employersCity.tod.night": "Night",
  "employersCity.tod.noon": "Noon",
  "employersCity.toggle.aria": "How to show employers",
  "employersCity.toggle.city": "City",
  "employersCity.toggle.list": "List",
  "employersCity.trend.down": "Slowing hiring",
  "employersCity.trend.flat": "Steady hiring",
  "employersCity.trend.up": "Growing hiring",
  "employersCity.unknownCity": "Location not listed",
  "employersCity.view.city": "City",
  "employersCity.view.map": "Finland map",
  "employersCity.work.hybrid": "Hybrid",
  "employersCity.work.onsite": "On-site",
  "employersCity.work.remote": "Remote",
  "employersCity.zoomHint": "Hold Ctrl (⌘ on Mac) and scroll to zoom the city",
  "employersCity.collapse": "Exit full screen",
  "employersCity.colour": "Colour",
  "employersCity.expand": "Full screen",
  "employersCity.explore": "Explore",
  "employersCity.gotIt": "Got it",
  "employersCity.height": "Height",
  "employersCity.loadingBuild": "Building the city…",
  "employersCity.loadingData": "Loading employers…",
  "employersCity.moreControls": "More controls",
  "employersCity.onboarding": "Click a building to meet the employer. Drag to look around.",
  "employersCity.tooltipJobs": "{count, plural, one {# open job} other {# open jobs}} · grade {grade}",
  "employersCity.legend.brand": "Company brand colour",
  "employersCity.legend.brandNone": "No brand colour on record",
  "employersCity.mode.brand": "Brand",
  "employersHub.browse.allEmployers": "All employers in Finland",
  "employersHub.browse.aria": "Browse employers",
  "employersHub.browse.az": "All employers A to Z",
  "employersHub.browse.city": "Companies by city",
  "employersHub.browse.industry": "Companies by industry",
  "employersHub.browse.region": "Companies by region",
  "employersHub.card.kicker.open": "Open now",
  "employersHub.card.kicker.pay": "Pays well above this page",
  "employersHub.card.kicker.remote": "Mostly remote",
  "employersHub.card.kicker.rising": "Hiring pace rising",
  "employersHub.card.kicker.roleMix": "Who they hire",
  "employersHub.card.kicker.size": "Large employer",
  "employersHub.card.open": "{count, plural, one {open role} other {open roles}}",
  "employersHub.card.payMultiple": "typical posted band /mo, about {multiple}× the typical band on this page",
  "employersHub.card.payPerMonth": "/mo",
  "employersHub.card.remote": "of {count, plural, one {# open role} other {# open roles}} are remote or hybrid",
  "employersHub.card.rising": "{count, plural, one {# open role} other {# open roles}} now · new postings by month",
  "employersHub.card.staff": "staff in Finland · {count, plural, one {# open role} other {# open roles}}",
  "employersHub.empty": "No employers match. Remove a filter or try another search.",
  "employersHub.fact.busiest": "of the {sample} busiest hirers here are staffing agencies. They have their own tab, so they don’t crowd out direct employers.",
  "employersHub.fact.busiest.kicker": "Agencies",
  "employersHub.fact.pay": "of these employers post a pay band in their job ads.",
  "employersHub.fact.pay.kicker": "Pay transparency",
  "employersHub.filters": "Filters",
  "employersHub.filters.clearAll": "Clear all",
  "employersHub.filters.close": "Close filters",
  "employersHub.filters.growing": "Growing",
  "employersHub.filters.industry": "Industry",
  "employersHub.filters.pace": "Hiring pace",
  "employersHub.filters.pay": "Typical posted pay",
  "employersHub.filters.payFloor": "€{amount}k+ /mo",
  "employersHub.filters.remote": "Mostly remote or hybrid",
  "employersHub.filters.remove": "Remove filter: {label}",
  "employersHub.filters.show": "Show {count, plural, one {# employer} other {# employers}}",
  "employersHub.filters.size": "Company size",
  "employersHub.filters.sizeLarge": "Over 500 staff",
  "employersHub.filters.sizeMid": "50 to 500 staff",
  "employersHub.filters.sizeSmall": "Under 50 staff",
  "employersHub.filters.workMode": "Work mode",
  "employersHub.largest.answer": "Of the employers hiring right now, {name} has the most staff in Finland, about {staff} people according to the trade register. It has {count, plural, one {# open role} other {# open roles}} on JobCrawls today.",
  "employersHub.largest.heading": "Largest employers that are hiring",
  "employersHub.largest.lede": "Ranked by staff in Finland from the trade register, with the roles each has open on JobCrawls today.",
  "employersHub.largest.open": "{count} open",
  "employersHub.largest.question": "Who is the largest employer hiring {place}?",
  "employersHub.map.aria": "Employers on this page, sized by {measure}",
  "employersHub.map.kicker": "What this shows",
  "employersHub.map.note.hiring": "These {count} hold {sum} of the {total} open roles here.",
  "employersHub.map.note.hiringNoTotal": "Block size is the number of open roles.",
  "employersHub.map.note.pay": "Block size is the typical posted pay. {missing, plural, =0 {} one {# employer here posts no pay.} other {# employers here post no pay.}}",
  "employersHub.map.note.size": "Block size is staff in Finland, from the trade register. {missing, plural, =0 {} one {# employer here has no headcount on file yet.} other {# employers here have no headcount on file yet.}}",
  "employersHub.pagePosition": "Page {page} of {totalPages} · the map and the cards show the same {count} employers",
  "employersHub.pagination.aria": "Employer pages",
  "employersHub.pagination.next": "Next",
  "employersHub.pagination.previous": "Previous",
  "employersHub.pagination.showing": "Showing {from}–{to} of {total} employers",
  "employersHub.search.aria": "Search employers",
  "employersHub.search.clear": "Clear search",
  "employersHub.search.placeholder": "Search employers by name, industry or role",
  "employersHub.sentence": "Who’s hiring {place}?",
  "employersHub.sentence.allFinland": "All of Finland",
  "employersHub.sentence.aria": "Choose where to look",
  "employersHub.sentence.finland": "in Finland",
  "employersHub.sentence.inPlace": "in {place}",
  "employersHub.sentence.menuTitle": "Employers in",
  "employersHub.sort.hiring": "Open roles",
  "employersHub.sort.hiringHint": "Most roles open today",
  "employersHub.sort.label": "Sort",
  "employersHub.sort.pay": "Pay",
  "employersHub.sort.payHint": "Highest typical posted pay",
  "employersHub.sort.relevance": "Best match",
  "employersHub.sort.size": "Largest employers",
  "employersHub.sort.sizeHint": "Most staff in Finland",
  "employersHub.standout.heading": "What stands out",
  "employersHub.standout.lede": "Each card leads with the one thing that makes that employer different",
  "employersHub.tab.agencies": "Staffing agencies",
  "employersHub.tab.aria": "Employer type",
  "employersHub.tab.direct": "Direct employers",
  "employersHub.tile.open": "{count, plural, one {# open role} other {# open roles}}",
  "employersHub.tile.pay": "typical pay /mo",
  "employersHub.tile.staff": "staff in Finland",
  "employersHub.unavailable": "Employers aren’t available right now. Try again in a moment.",
  "employersHub.view.aria": "How to show employers",
  "employersHub.view.blocks": "Blocks",
  "employersHub.view.city": "3D city",
  "employersHub.fact.aria": "Facts about these employers",
  "employersHub.filters.forYou": "For you",
  "employersHub.filters.myRole": "Hiring {title}",
  "employersHub.map.note.score": "Block size is the JobCrawls Employer Score, shown as a grade. It is worked out from pay, flexibility, hiring stability, growth, benefits and pay transparency in job ads.",
  "employersHub.sort.score": "Employer score",
  "employersHub.sort.scoreHint": "Highest JobCrawls Employer Score",
  "employersHub.tile.score": "employer score",
  "backoffice.subpage.companyDataProduct": "Company data product",
  "cvCheck.allDone": "Nothing left to fix. Your CV covers everything the check looks at.",
  "cvCheck.band.good": "Good",
  "cvCheck.band.needsWork": "Needs work",
  "cvCheck.band.strong": "Strong",
  "cvCheck.dismiss": "Not relevant for me",
  "cvCheck.emptyIntro": "Start filling in your CV and the check scores it as you go, against what Finnish recruiters look for.",
  "cvCheck.fix": "Fix this",
  "cvCheck.gain": "+{points}",
  "cvCheck.heading": "CV check",
  "cvCheck.listLabel": "Recommended fixes",
  "cvCheck.matchingJobs": "See open jobs that match your CV",
  "cvCheck.outOf": "/ 100",
  "cvCheck.restoreDismissed": "{count, plural, one {# check hidden as not relevant. Show it again} other {# checks hidden as not relevant. Show them again}}",
  "cvCheck.rule.cliches.title": "Replace filler phrases",
  "cvCheck.rule.cliches.why": "Found: {examples}. Show it with an example instead, such as what you or your team achieved.",
  "cvCheck.rule.contact.title": "Add both an email and a phone number",
  "cvCheck.rule.contact.why": "Finnish recruiters often call first. Give them both ways to reach you.",
  "cvCheck.rule.datesComplete.title": "Add start dates",
  "cvCheck.rule.datesComplete.why": "{missing, plural, one {# entry is} other {# entries are}} missing a start date. Use month and year, for example 3/2022.",
  "cvCheck.rule.dutyPhrasing.title": "Describe results, not duties",
  "cvCheck.rule.dutyPhrasing.why": "{count, plural, one {# role starts} other {# roles start}} with a duty, like \"responsible for\". Lead with what you achieved instead.",
  "cvCheck.rule.education.title": "Add your education",
  "cvCheck.rule.education.why": "Finnish employers expect it even after years of experience. Use the official degree name, for example Tradenomi (AMK).",
  "cvCheck.rule.experienceOrEducation.title": "Add your work experience",
  "cvCheck.rule.experienceOrEducation.why": "Short and part-time jobs count too. List the newest first.",
  "cvCheck.rule.firstPerson.title": "Use fewer first-person words",
  "cvCheck.rule.firstPerson.why": "Finnish CVs are written in a matter-of-fact style. Start sentences with the action.",
  "cvCheck.rule.gaps.title": "Explain the gap in your work history",
  "cvCheck.rule.gaps.why": "{count, plural, one {There is a gap} other {There are # gaps}} of over a year. A short line such as \"studies\" or \"career break\" answers the question before it is asked.",
  "cvCheck.rule.headline.title": "Add a headline that says what you do",
  "cvCheck.rule.headline.why": "One line under your name that says what you do, for example \"Sales manager, B2B software\".",
  "cvCheck.rule.headlineLength.title": "Make your headline short and plain",
  "cvCheck.rule.headlineLength.why": "One line, normal capitalisation, under 80 characters.",
  "cvCheck.rule.languagesListed.title": "Add your languages",
  "cvCheck.rule.languagesListed.why": "Language skills are their own section on a Finnish CV. List your mother tongue and every language you can work in.",
  "cvCheck.rule.length.title": "Shorten your CV to 2 pages",
  "cvCheck.rule.length.why": "Finnish CVs are 1 to 2 pages. Cut older roles down to one line each.",
  "cvCheck.rule.name.title": "Add your name",
  "cvCheck.rule.name.why": "Your name goes at the top of the CV. Recruiters file applications by it.",
  "cvCheck.rule.quantifiedResults.title": "Add numbers to your results",
  "cvCheck.rule.quantifiedResults.why": "{withNumbers} of {total} roles mention a concrete result. Numbers (customers, %, euros, team size) stand out to recruiters.",
  "cvCheck.rule.roleDescriptions.title": "{missing, plural, one {# role has no description} other {# roles have no description}}",
  "cvCheck.rule.roleDescriptions.why": "Two or three lines per role on what you got done is enough.",
  "cvCheck.rule.skillsCount.title": "Add more skills",
  "cvCheck.rule.skillsCount.why": "You have {count}. List 6 to 10 that the jobs you want ask for: search and job matching look at them.",
  "cvCheck.rule.summary.title": "Write a profile of 2 to 4 sentences",
  "cvCheck.rule.summary.why": "It is the first thing a recruiter reads. Say what you do, for whom, and one result.",
  "cvCheck.rule.summaryLength.title": "Shorten your profile text",
  "cvCheck.rule.summaryLength.why": "Keep it to 2 to 4 sentences ({chars} characters now). Recruiters skim it in seconds.",
  "cvCheck.rule.workLanguage.title": "Add your Finnish, Swedish or English level",
  "cvCheck.rule.workLanguage.why": "Most job ads in Finland ask for one of them. Add your level even if it is basic.",
  "cvCheck.showAll": "Show {count} more",
  "cvCheck.warning.birthDate.title": "Your date of birth is not needed",
  "cvCheck.warning.birthDate.why": "Employers in Finland may not choose by age, so a CV does not need it.",
  "cvCheck.warning.family.title": "Leave out family details",
  "cvCheck.warning.family.why": "Marital status, pregnancy and children do not belong on a CV, and employers may not ask about them.",
  "cvCheck.warning.found": "Found on your CV: {match}",
  "cvCheck.warning.health.title": "Leave out health details",
  "cvCheck.warning.health.why": "Employers may not ask about your health. You can discuss any adjustments later if you want to.",
  "cvCheck.warning.personalId.title": "Remove your personal identity code",
  "cvCheck.warning.personalId.why": "Never put your personal identity code on a CV. An employer only needs it once they hire you.",
  "cvCheck.warning.religion.title": "Leave out religion",
  "cvCheck.warning.religion.why": "A CV does not need it, and employers may not ask about it.",
  "cvStudio.preview.download": "Download PDF",
  "cvStudio.preview.templateGroup": "CV template",
  "cvStudio.preview.title": "Your CV as a document",
  "cvStudio.template.basic": "Basic",
  "cvStudio.template.experienced": "Experienced professional",
  "cvStudio.template.graduate": "Recent graduate",
  "cvStudio.template.photo": "With photo",
  "cvStudio.template.skills": "Skills-based",
  "cvStudio.template.student": "Student or first job",
  "cvCheck.emptyStart": "Start with your headline",
  "cvCheck.rewrite": "Suggest a rewrite",
  "cvJobMatch.addSkillLabel": "Add {skill} to your CV skills",
  "cvJobMatch.empty.body": "Add your CV once and every job shows which of its skills you have, which are missing and whether you meet the language requirements. Free, no account needed.",
  "cvJobMatch.empty.cta": "Add your CV",
  "cvJobMatch.empty.title": "How well does your CV match this job?",
  "cvJobMatch.eyebrow": "Your CV vs this job",
  "cvJobMatch.improve": "Check and improve my CV",
  "cvJobMatch.languageMet": "{language} required: on your CV",
  "cvJobMatch.languageMissing": "{language} required: not on your CV",
  "cvJobMatch.matchedLabel": "Skills on your CV",
  "cvJobMatch.mentionedIntro": "Your CV mentions these but doesn't list them as skills. Add them so recruiters and search see them:",
  "cvJobMatch.missingHonesty": "If you have one of these, add it to your CV with where you used it. If not, the job may still be worth applying for: ads list wishes, not only must-haves.",
  "cvJobMatch.missingIntro": "Not on your CV:",
  "cvJobMatch.rail.empty": "Check your CV against this job",
  "cvJobMatch.rail.requirements": "Your CV against the requirements",
  "cvJobMatch.rail.skills": "Your CV: {have} of {total} skills",
  "cvJobMatch.requirementsHeadline": "Requirements against your CV",
  "cvJobMatch.skillsHeadline": "Your CV shows {have} of the {total} skills this job lists",
  "cvJobMatch.tailor": "Tailor my CV for this job",
  "cvJobMatch.years": "Asks for {required}+ years of experience. Your CV shows about {years}.",
  "cvJobMatch.yearsUnknown": "Asks for {required}+ years of experience. Add dates to your roles to compare.",
  "cvRewrite.again": "New suggestions",
  "cvRewrite.back": "Back to suggestions",
  "cvRewrite.editLabel": "Edit before saving",
  "cvRewrite.error.empty": "No safe suggestion this time: every option added facts that aren't on your CV. Try again, or edit the text yourself.",
  "cvRewrite.error.failed": "Suggestions aren't available right now. Try again in a moment.",
  "cvRewrite.error.quota": "You've used today's suggestions. They reset tomorrow.",
  "cvRewrite.fillPlaceholder": "Replace [?] with your real number, or remove it.",
  "cvRewrite.honesty": "Suggestions only reword what you wrote. Anything that would need a number you didn't give is marked [?].",
  "cvRewrite.loading": "Writing suggestions…",
  "cvRewrite.needsInput": "Replace [?] with your real number before saving.",
  "cvRewrite.now.role": "Your description of {role} now",
  "cvRewrite.now.summary": "Your profile text now",
  "cvRewrite.save": "Save to my CV",
  "cvRewrite.title": "Suggested rewrites",
  "cvRewrite.useThis": "Use this",
  "cvStudio.docxFailed": "Could not create the Word file. Please try again.",
  "cvStudio.panel.heading": "Live preview",
  "cvStudio.preview.downloadWord": "Word",
  "hitCardB2.details.cvSkillCount": "On your CV: {have} of {total}",
  "hitCardB2.details.skillOnCv": "On your CV",
  "interviewPrep.evidence": "From your CV, {role}: {note}",
  "interviewPrep.fb.example": "A concrete example",
  "interviewPrep.fb.length": "1 to 2 minutes spoken ({words} words)",
  "interviewPrep.fb.private": "Your practice answers stay in this window and aren't saved.",
  "interviewPrep.fb.result": "A result, ideally a number",
  "interviewPrep.guestCta": "Create a free account to prepare",
  "interviewPrep.practice": "Practise your answer",
  "jobAdCheck.cta": "Check my CV",
  "jobAdCheck.label": "Job ad text",
  "jobAdCheck.nothing": "We couldn't recognise skills or requirements in this text. Paste the full ad, including the requirements.",
  "jobAdCheck.placeholder": "Paste the job ad here…",
  "jobAdCheck.privacy": "The ad and your CV are compared in your browser. Nothing is sent or saved.",
  "jobAdCheck.subtitle": "Paste any ad to see which of its skills your CV shows and which are missing.",
  "jobAdCheck.title": "Check your CV against a job ad",
  "jobDetailPage.coverLetter.guestCta": "Create a free account to draft it",
  "jobDetailPage.tailorCv.tabInterview": "Interview",
  "resignation.copied": "Copied",
  "resignation.copy": "Copy text",
  "resignation.custom": "From my contract or collective agreement:",
  "resignation.customUnit": "Notice period unit",
  "resignation.customValue": "Notice period length",
  "resignation.employer": "Employer",
  "resignation.letter": "Your letter (edit freely)",
  "resignation.notice": "Notice period",
  "resignation.recipient": "Addressed to (optional)",
  "resignation.subtitle": "Got the new job? Write your resignation with the right notice period and end date.",
  "resignation.title": "Resignation letter",
  "resignation.unit.days": "days",
  "resignation.unit.months": "months",
  "resignation.word": "Download Word",
  "tailorReview.accept": "Accept",
  "tailorReview.addSkill.title": "Add {skill} to your skills",
  "tailorReview.addSkill.why": "Your CV already mentions it ({where}) and the ad lists it, but it isn't in your skills list.",
  "tailorReview.after": "After",
  "tailorReview.before": "Before",
  "tailorReview.bulletOrder.title": "Lead your {role} role with the line about {keyword}",
  "tailorReview.confirm.back": "Back to the changes",
  "tailorReview.confirm.cta": "Confirm",
  "tailorReview.confirm.note": "This creates a tailored copy for this job. Your main CV stays as it is.",
  "tailorReview.confirm.title": "{accepted, plural, =0 {You accepted no changes.} one {You accepted 1 of {total} changes.} other {You accepted # of {total} changes.}}",
  "tailorReview.continue": "Review and confirm",
  "tailorReview.coverLetter": "Write a cover letter",
  "tailorReview.decideAll": "{left, plural, one {Decide on # more change to continue.} other {Decide on # more changes to continue.}}",
  "tailorReview.done.guest": "Your tailored CV for this job is ready to download, no account needed.",
  "tailorReview.done.saved": "Tailored CV saved for this job. Your main CV is unchanged.",
  "tailorReview.download": "Download tailored CV (PDF)",
  "tailorReview.downloadCv": "Download my CV (PDF)",
  "tailorReview.downloadWord": "Word",
  "tailorReview.guestSave": "This tailored version isn't saved anywhere yet. {link} to keep it with the job and track your application.",
  "tailorReview.guestSaveLink": "Create a free account",
  "tailorReview.intro": "{count, plural, one {One small change} other {# small changes}} to present your CV for this job. Nothing new is written: only what's already on your CV is put in a better order. Accept or reject each one.",
  "tailorReview.nothing": "Your CV already presents what this job lists as well as it can without inventing anything. Nothing to change.",
  "tailorReview.reject": "Reject",
  "tailorReview.skillsLine": "Your skills list names {before} of the {total} skills this job lists, {after} with the changes you accept.",
  "tailorReview.skillsLineDone": "Your skills list now names {after} of the {total} skills this job lists (it named {before}).",
  "tailorReview.skillsOrder.title": "Put the skills this job lists first",
  "cvCheck.breakdownLabel": "Score by area",
  "cvCheck.category.clarity": "Clarity",
  "cvCheck.category.essentials": "Essentials",
  "cvCheck.category.finnishFit": "Finnish fit",
  "cvCheck.category.impact": "Impact",
  "cvCheck.category.tone": "Tone",
  "cvCheck.draft": "Write a draft for me",
  "cvRewrite.now.facts": "Written only from what's on your CV",
  "cvStudio.accent.burgundy": "Burgundy",
  "cvStudio.accent.forest": "Forest green",
  "cvStudio.accent.ink": "Black",
  "cvStudio.accent.navy": "Navy",
  "cvStudio.accent.teal": "Teal",
  "cvStudio.guestBanner.importing": "Reading your CV…",
  "cvStudio.guestImport.done": "Imported. Check the details and your CV score below.",
  "cvStudio.guestImport.noText": "We couldn't read text from that PDF. If it's a scanned image, fill in the template instead.",
  "cvStudio.guestImport.quota": "You've reached today's import limit without an account. Create a free account to import more.",
  "cvStudio.guestImport.tooLarge": "Without an account the file can be at most 3 MB.",
  "cvStudio.guestMerge.body": "Which one do you want to keep? The other one is discarded.",
  "cvStudio.guestMerge.keepSaved": "Keep my saved CV",
  "cvStudio.guestMerge.title": "You made a CV before signing in, and your account already has one.",
  "cvStudio.guestMerge.useGuest": "Use the CV I just made",
  "cvStudio.style.group": "CV style",
  "cvVersions.cancel": "Cancel",
  "cvVersions.confirmOpen": "Opening “{name}” replaces the CV you're editing now. Save the current one as a version first?",
  "cvVersions.defaultName": "My CV",
  "cvVersions.delete": "Delete version {name}",
  "cvVersions.empty": "No saved versions yet.",
  "cvVersions.full": "You have {max} versions, the maximum. Delete one to save another.",
  "cvVersions.nameLabel": "Name for this version",
  "cvVersions.open": "Open in editor",
  "cvVersions.openWithoutSaving": "Open without saving",
  "cvVersions.previous": "Previous CV",
  "cvVersions.save": "Save current CV as a version",
  "cvVersions.saveAndOpen": "Save current and open",
  "cvVersions.subtitle": "Keep different CVs for different kinds of jobs, and switch between them.",
  "cvVersions.title": "CV versions ({count})",
  "coverTemplate.company": "Company",
  "coverTemplate.contact": "Contact person (optional)",
  "coverTemplate.copied": "Copied",
  "coverTemplate.copy": "Copy text",
  "coverTemplate.email": "Email",
  "coverTemplate.letter": "Your letter (edit freely)",
  "coverTemplate.motivation": "Why this job? (1 to 2 sentences)",
  "coverTemplate.name": "Your name",
  "coverTemplate.phone": "Phone",
  "coverTemplate.privacy": "Everything stays in your browser. Nothing is sent or saved.",
  "coverTemplate.reset": "Undo my edits and follow the fields again",
  "coverTemplate.role": "Job title you apply for",
  "coverTemplate.start": "When could you start?",
  "coverTemplate.strengthN": "Strength {n}",
  "coverTemplate.strengths": "What you bring, with a result if you can (up to 3)",
  "coverTemplate.whyCompany": "Why this employer? (1 to 2 sentences)",
  "coverTemplate.word": "Download Word",
  "hitCardB2.cvBadge": "CV {have}/{total}",
  "profileTabs.attention": "has an unfinished step",
  "profileTabs.cv": "CV",
  "profileTabs.label": "Profile sections",
  "profileTabs.match": "Search & applying",
  "profileTabs.tools": "Letters & account",
  "resignation.date": "Date you hand it in",
  "resignation.endDate": "Your employment ends on {date}. Your employment contract or collective agreement may set a different period; check it before sending. This is not legal advice.",
  "resignation.name": "Your name",
  "resignation.statutory.over5": "Over 5 years in this job: one month (the default by law)",
  "resignation.statutory.upTo5": "Up to 5 years in this job: 14 days (the default by law)",
  "srpCvOrder.offHint": "Uses the skills on your CV, in Finnish, Swedish or English.",
  "srpCvOrder.onHint": "Jobs with your job titles and more of your {count, plural, one {# CV skill} other {# CV skills}} come first. Nothing is hidden.",
  "srpCvOrder.toggle": "Match my CV",
  "tools.kanban.cvSent.detail": "{format} downloaded {date}, {changes, plural, =0 {base CV with no tailoring changes} one {with 1 tailoring change} other {with # tailoring changes}}",
  "tools.kanban.cvSent.label": "CV sent {date}",
  "cvStudio.design.banded": "Banded",
  "cvStudio.design.centered": "Centered",
  "cvStudio.design.classic": "Classic",
  "cvStudio.design.compact": "Compact",
  "cvStudio.design.label": "Design",
  "profile.cv.addDescription": "Add what you did and achieved, one line per point",
  "profile.cv.addSummary": "Add a profile: 2 to 4 sentences on what you do and what you are looking for",
  "profile.cv.descriptionLabel": "Description of {role}",
  "profile.cv.headlineLabel": "Headline",
  "profile.cv.summaryLabel": "Profile text",
  "tailorLoader.note": "This can take up to a minute. You'll see every change before anything is used.",
  "tailorLoader.step.check": "Checking every change against your CV",
  "tailorLoader.step.match": "Matching your experience to what they ask for",
  "tailorLoader.step.polish": "Polishing the wording, without inventing anything",
  "tailorLoader.step.read": "Reading the job ad",
  "tailorLoader.title": "Making it perfect…",
  "tailorReview.fallback.error": "Full tailoring didn't finish this time. Here are quick tweaks instead; you can close this and try again.",
  "tailorReview.fallback.guest": "{link} for full tailoring that rewords your experience for this job. Quick tweaks for now:",
  "tailorReview.fallback.guestLink": "Create a free account",
  "tailorReview.fallback.quota": "You've used today's full tailoring. Here are quick tweaks instead; full tailoring is back tomorrow.",
  "tailorReview.headline.title": "A headline for this job",
  "tailorReview.introAi": "{count, plural, one {One change} other {# changes}} to fit this job, written from what's already on your CV. Nothing new is added: no new skills, employers, dates or numbers. Check each one and accept or reject it.",
  "tailorReview.rewrite.title": "Reword {name} for this job",
  "tailorReview.skillsSelection.title": "Lead with the skills this job cares about",
  "cvStudio.header.guestNote": "Free, no account needed.",
  "cvStudio.header.guestNoteTemplate": "Template: {template}. Free, no account needed.",
  "cvStudio.header.guestSave": "Save it to a free account",
  "cvStudio.header.import": "Import CV (PDF)",
  "profile.header.addName": "Add your name",
  "cvStudio.mobileBar.download": "Download PDF",
  "cvStudio.mobileBar.preview": "Preview",
  "tailorLoader.letter.check": "Checking it only says what your CV shows",
  "tailorLoader.letter.note": "Usually 10 to 20 seconds. You can edit everything before you use it.",
  "tailorLoader.letter.pick": "Picking what fits from your CV",
  "tailorLoader.letter.title": "Writing your letter…",
  "tailorLoader.letter.write": "Writing your letter",
  "jobDetailPage.coverLetter.guestTemplate": "Or fill in a template yourself",
  "facetAutocomplete.toggle": "Show options",
  "cvStudio.preview.noAccount": "No account needed to download.",
  "cvJobMatch.empty.guides": "No CV yet? Start from a {template}. Writing the application? {letter}.",
  "cvJobMatch.empty.letterLink": "Cover letter template and examples",
  "cvJobMatch.empty.templateLink": "free CV template",
  "cvCheck.aiNeedsAccount": "Needs a free account",
  "cvCheck.breakdownToggle": "Breakdown",
  "applyAutofill.copyValue": "Copy {label}",
  "applyAutofill.failedBotDetection": "This employer's form asks for a human check, so this one has to be sent by you. Your reviewed answers are below, ready to copy.",
  "applyAutofill.failedRejected": "The employer's form didn't accept the application. Open the form to see what it needs.",
  "applyAutofill.failedTimeout": "The employer's site took too long to respond. Check your email for a confirmation before you try again.",
  "applyAutofill.failedUnrecognizedForm": "We couldn't read this employer's form, so this one has to be sent by you. Your reviewed answers are below, ready to copy.",
  "applyAutofill.nameLabel": "Name",
  "applyAutofill.stillProcessing": "Still submitting. Your tracker updates when it's done, so you can close this window.",
  "applyAutofill.errorAlreadySubmitted": "This application has already been sent. Check your tracker for its status.",
  "applyAutofill.errorConfirmLimit": "You've sent {limit} applications with autofill today. You can send more tomorrow, or apply on the employer's site now.",
  "applyAutofill.errorNotAvailable": "Autofill isn't available for this employer yet.",
  "backoffice.subpage.applyAutofill": "Apply autofill outcomes",
  "copyKit.addDetails": "Add your details to fill this faster",
  "copyKit.close": "Close",
  "copyKit.coverLetter": "Cover letter",
  "copyKit.downloadCv": "Download CV for this job",
  "copyKit.downloadLetter": "Download cover letter",
  "copyKit.downloads": "Documents",
  "copyKit.email": "Email",
  "copyKit.linkedin": "LinkedIn",
  "copyKit.name": "Name",
  "copyKit.noCv": "No CV made for this job yet.",
  "copyKit.noCvLink": "Upload or build a CV in your profile",
  "copyKit.openApplication": "Open the application",
  "copyKit.phone": "Phone",
  "copyKit.salary": "Salary expectation (per year)",
  "copyKit.title": "Copy kit: everything to paste",
  "jobDetailPage.copyKitCta": "Copy kit: everything to paste",
  "jobDetailPage.returnPrompt.applied": "Applied",
  "jobDetailPage.returnPrompt.label": "Application check",
  "jobDetailPage.returnPrompt.notYet": "Not yet",
  "jobDetailPage.returnPrompt.question": "Did you apply to {company}?",
  "tools.applicationKits.interviewPrep": "Interview prep",
  "tools.interviewKit.errorGeneric": "We couldn't prepare the kit. Please try again in a moment.",
  "tools.interviewKit.errorNotFound": "We couldn't find this job or employer.",
  "tools.interviewKit.errorQuota": "You've reached today's interview kit limit. It resets tomorrow.",
  "tools.interviewKit.generated": "Generated {date}",
  "tools.interviewKit.lead": "Facts about the employer with the source next to every claim, the questions you are likely to be asked with what from your CV to talk about, and questions to ask them.",
  "tools.interviewKit.licence": "Contains data from {sources}, licensed CC BY 4.0.",
  "tools.interviewKit.loading": "Loading...",
  "tools.interviewKit.missingCompany": "Open the interview kit from a job page so we know which employer to look up.",
  "tools.interviewKit.notRegisteredBody": "The trade register lists this company as \"{state}\"{since, select, none {} other { since {since}}}. Make sure the employer is still active before you share personal details.",
  "tools.interviewKit.notRegisteredTitle": "Check this employer before you prepare",
  "tools.interviewKit.openJob": "Back to the job",
  "tools.interviewKit.prepare": "Prepare my interview kit",
  "tools.interviewKit.preparing": "Preparing your kit. This takes about 20 seconds.",
  "tools.interviewKit.refresh": "Refresh kit",
  "tools.interviewKit.section.ask": "Questions to ask them",
  "tools.interviewKit.section.company": "Company in 60 seconds",
  "tools.interviewKit.section.direction": "Where they're heading",
  "tools.interviewKit.section.hiringNow": "Why they might be hiring now",
  "tools.interviewKit.section.likelyQuestions": "Likely questions",
  "tools.interviewKit.section.process": "The interview process",
  "tools.interviewKit.section.salary": "The salary question",
  "tools.interviewKit.section.workplace": "What it's like to work there",
  "tools.interviewKit.sourceAsOf": "{source}, {date}",
  "tools.interviewKit.sourceDefault": "Source",
  "tools.interviewKit.title": "Interview kit",
  "tools.interviewPrep.link": "Interview prep",
  "tools.interviewPrep.prompt.cta": "Prepare for this interview",
  "tools.interviewPrep.prompt.dismiss": "Dismiss",
  "tools.interviewPrep.prompt.title": "Interview coming up at {company}?",
  "tools.interviewPrep.prompt.titleNoCompany": "Interview coming up?",
  "tools.myJobs.quietNudge.interviewing": "Interviewing",
  "tools.myJobs.quietNudge.moveInterviewingLabel": "Move {title} to Interviewing",
  "tools.myJobs.quietNudge.moveRejectedLabel": "Move {title} to Rejected",
  "tools.myJobs.quietNudge.question": "Heard back from {company}? You applied {days, plural, one {# day} other {# days}} ago.",
  "tools.myJobs.quietNudge.questionNoCompany": "Heard back about {title}? You applied {days, plural, one {# day} other {# days}} ago.",
  "tools.myJobs.quietNudge.rejected": "Rejected",
  "tools.myJobs.quietNudge.snoozeLabel": "Still waiting on {title}, remind me in two weeks",
  "tools.myJobs.quietNudge.stillWaiting": "Still waiting",
  "applyAutofill.chooseAnswer": "Choose an answer",
  "applyAutofill.saveForNextTime": "Use this answer next time",
  "applyAutofill.sourceDraft": "Draft, check this",
  "applyAutofill.sourceProfile": "From your profile",
  "fitCheck.addToProfile": "Open profile",
  "fitCheck.deadline.ok": "Closes in {days, plural, one {# day} other {# days}}.",
  "fitCheck.deadline.passed": "The deadline passed {days, plural, one {# day} other {# days}} ago.",
  "fitCheck.deadline.soon": "Applications close in {days, plural, =0 {less than a day} one {# day} other {# days}}.",
  "fitCheck.drivingLicence.ok": "The ad requires a driving licence, and your profile lists one.",
  "fitCheck.drivingLicence.unknown": "Add your driving licence to your profile to check this.",
  "fitCheck.drivingLicence.warn": "The ad requires a driving licence. Your profile doesn't list a matching one.",
  "fitCheck.experience.ok": "The ad asks for {required}+ years. Your profile adds up to {years}.",
  "fitCheck.experience.unknown": "The ad asks for {required}+ years. Add your work history to check this.",
  "fitCheck.experience.warn": "The ad asks for {required}+ years. Your profile adds up to {years}.",
  "fitCheck.language.ok": "{language} at the level the ad asks for.",
  "fitCheck.language.unknown": "Add your {language} level to your profile to check this.",
  "fitCheck.language.warn": "The ad asks for {level} {language}. Your profile says {profileLevel}.",
  "fitCheck.levelNative": "native",
  "fitCheck.location.ok": "{location} is in your preferred locations.",
  "fitCheck.location.unknown": "Add your preferred locations to check {location}.",
  "fitCheck.location.warn": "On-site or hybrid in {location}, outside your preferred locations.",
  "fitCheck.status.ok": "Fits",
  "fitCheck.status.unknown": "Unknown",
  "fitCheck.status.warn": "Check",
  "fitCheck.summaryClear": "Nothing in the ad rules you out",
  "fitCheck.title": "Before you apply",
  "fitCheck.workPermit.ok": "Your work permit status fits what the ad says.",
  "fitCheck.workPermit.unknown": "Add your work permit status to check this.",
  "fitCheck.workPermit.warn": "The ad says the employer doesn't sponsor work permits.",
  "jobDetail.applicationsGoThrough": "Applications go through {vendor}",
  "profile.answers.alcoholPass": "Alcohol pass (anniskelupassi)",
  "profile.answers.firstAid": "First aid certificate",
  "profile.answers.firstAid.ea1": "First aid 1 (EA1)",
  "profile.answers.firstAid.ea2": "First aid 2 (EA2)",
  "profile.answers.firstAid.none": "None",
  "profile.answers.group.cards": "Cards and permits",
  "profile.answers.group.other": "Other",
  "profile.answers.group.practical": "Practical",
  "profile.answers.heading": "Application answers",
  "profile.answers.heardAboutUs": "How did you hear about us?",
  "profile.answers.hygiene": "Hygiene passport (hygieniapassi)",
  "profile.answers.intro": "Answer once, and autofill reuses these on application forms. Salary, work permit, languages, driving licence, notice period and start date come from the rest of your profile.",
  "profile.answers.no": "No",
  "profile.answers.ownCar": "Own car available",
  "profile.answers.relocate": "Willing to relocate",
  "profile.answers.roadSafety": "Road safety card (tieturva)",
  "profile.answers.safetyCard": "Occupational safety card (työturvallisuuskortti)",
  "profile.answers.saved.deleteAria": "Delete saved answer: {question}",
  "profile.answers.saved.empty": "Answers you choose to reuse while applying will show up here.",
  "profile.answers.saved.heading": "Saved answers",
  "profile.answers.securityClearance": "Consent to a security clearance (turvallisuusselvitys)",
  "profile.answers.shiftWork": "Willing to do shift work",
  "profile.answers.travel": "Willing to travel for work",
  "profile.answers.travel.no": "No",
  "profile.answers.travel.occasionally": "Occasionally",
  "profile.answers.travel.often": "Often",
  "profile.answers.unanswered": "Not answered",
  "profile.answers.yes": "Yes",
  "quickApply.badge": "Quick apply",
  "search.refinements.quickApply.filter": "Quick apply only",
  "applyAutofill.updateBankToo": "Update this in my saved answers too",
  "applyAutofill.updateProfileToo": "Update my profile too",
  "applyAutofill.answerToSend": "{count, plural, one {Answer # question to send.} other {Answer # questions to send.}}",
  "applyAutofill.basedOn": "Based on: {basis}",
  "applyAutofill.coverLetter.useKit": "Use your cover letter for this job",
  "applyAutofill.cv.open": "Open",
  "applyAutofill.cv.tailoredNote": "Your tailored CV for this job can't be sent this way yet.",
  "applyAutofill.cv.title": "The CV on your profile",
  "applyAutofill.details.title": "Your details",
  "applyAutofill.header.jobVia": "{title} · {company} · via {vendor}",
  "applyAutofill.header.sent": "Application sent",
  "applyAutofill.progress.answered": "{count, plural, =0 {None of them were in your profile yet} one {# answered from your profile} other {# answered from your profile}}",
  "applyAutofill.progress.drafting": "{count, plural, one {Drafting # answer for you to check} other {Drafting # answers for you to check}}",
  "applyAutofill.progress.found": "{count, plural, =0 {No extra questions on the form} one {Found # question} other {Found # questions}}",
  "applyAutofill.progress.opening": "Opening {company}'s application form",
  "applyAutofill.receipt.answers": "{count, plural, =0 {No screening questions} one {# screening answer} other {# screening answers}}",
  "applyAutofill.receipt.checkIn": "If it goes quiet, we'll check in with you on {date}.",
  "applyAutofill.receipt.coverLetter": "A cover letter",
  "applyAutofill.receipt.cv": "Your CV from your profile",
  "applyAutofill.receipt.interviewKit": "Get ready for the interview",
  "applyAutofill.receipt.next": "What happens next",
  "applyAutofill.receipt.saved": "{count, plural, one {# answer saved for next time} other {# answers saved for next time}}",
  "applyAutofill.receipt.sentAt": "Sent at {time}",
  "applyAutofill.receipt.sentVia": "Sent at {time} via {vendor}",
  "applyAutofill.receipt.title": "Sent to {company}",
  "applyAutofill.section.documents": "Sent with it",
  "applyAutofill.section.questions": "The employer's questions",
  "applyAutofill.sending": "Sending to {company}…",
  "applyAutofill.sourceEdited": "Edited by you",
  "applyAutofill.sourceMissing": "Needs your answer",
  "applyAutofill.summary.allSet": "Everything came from your profile. Read it through and send.",
  "applyAutofill.summary.chipDrafts": "{count, plural, one {# draft to check} other {# drafts to check}}",
  "applyAutofill.summary.chipKnown": "{count} from your profile",
  "applyAutofill.summary.chipMissing": "{count} to answer",
  "applyAutofill.summary.filled": "We filled {filled} of {total} fields.",
  "applyAutofill.summary.needsYou": "{count, plural, one {# needs you. It's at the top.} other {# need you. They're at the top.}}",
  "companyProfile.contracts.count": "{count, plural, one {# EU-wide contract award in the last 24 months} other {# EU-wide contract awards in the last 24 months}}",
  "companyProfile.contracts.heading": "Public contracts won",
  "companyProfile.contracts.notice": "Notice",
  "companyProfile.emissions.basisEea": "CO₂ reported by the company's industrial facilities, including biogenic CO₂.",
  "companyProfile.emissions.basisEts": "Verified emissions of the company's installations in the EU Emissions Trading System.",
  "companyProfile.emissions.heading": "Reported emissions",
  "companyProfile.emissions.value": "tonnes of CO₂ in {year}",
  "companyProfile.funding.awards": "{count, plural, one {# award} other {# awards}}",
  "companyProfile.funding.businessFinland": "Business Finland grants and loans",
  "companyProfile.funding.directEu": "Other direct EU funding",
  "companyProfile.funding.heading": "Public funding",
  "companyProfile.funding.horizon": "EU research projects (Horizon)",
  "companyProfile.funding.latestYear": "latest {year}",
  "companyProfile.funding.projects": "{count, plural, one {# project} other {# projects}}",
  "companyProfile.funding.stateAid": "State aid",
  "companyProfile.group.brands": "Brands",
  "companyProfile.group.directParent": "Direct parent",
  "companyProfile.group.heading": "Ownership and brands",
  "companyProfile.group.parent": "Owned by",
  "companyProfile.group.subsidiaries": "Subsidiaries",
  "companyProfile.group.ultimateParent": "Ultimate parent",
  "companyProfile.licences.heading": "Licences and permits",
  "companyProfile.licences.kind.alcoholAlkoRetail": "Alko retail outlet",
  "companyProfile.licences.kind.alcoholManufacture": "Alcohol manufacturing licences",
  "companyProfile.licences.kind.alcoholRetail": "Alcohol retail licences",
  "companyProfile.licences.kind.alcoholServing": "Alcohol serving licences",
  "companyProfile.licences.kind.alcoholServingPreapproved": "Approved catering premises for serving alcohol",
  "companyProfile.licences.kind.alcoholWholesale": "Alcohol wholesale licences",
  "companyProfile.licences.kind.goodsTransport": "Goods transport licence",
  "companyProfile.licences.kind.goodsTransportRegistration": "Goods transport registration (light vehicles)",
  "companyProfile.licences.kind.passengerTransport": "Passenger transport licence",
  "companyProfile.licences.kind.pharmaMarketing": "Medicine marketing authorisations",
  "companyProfile.licences.kind.plantProtection": "Plant protection product authorisations",
  "companyProfile.licences.kind.taxi": "Taxi licence",
  "companyProfile.licences.kind.taxiRegistration": "Taxi service registration",
  "companyProfile.licences.since": "first granted {date}",
  "companyProfile.openData.source.asOf": "data as of {date}",
  "companyProfile.openData.source.multiple": "Sources: {sources}",
  "companyProfile.openData.source.ownAnalysis": "JobCrawls analysis of {dataset}",
  "companyProfile.openData.source.single": "Source: {sources}",
  "companyProfile.publicSector.buyer.municipality": "Municipalities",
  "companyProfile.publicSector.buyer.other": "Other public bodies",
  "companyProfile.publicSector.buyer.state": "State",
  "companyProfile.publicSector.buyer.wellbeing": "Wellbeing services counties",
  "companyProfile.publicSector.buyerCount": "{count, plural, one {# public buyer} other {# public buyers}}",
  "companyProfile.publicSector.heading": "Sales to the public sector",
  "companyProfile.publicSector.intro": "Invoices paid to {company} by public buyers that publish their purchases: the State and some cities and wellbeing services counties. Other buyers are not included.",
  "companyProfile.publicSector.latestTotal": "paid in {year}",
  "companyProfile.publicSector.topBuyers": "Largest buyers, all years",
  "companyProfile.publicSector.vatNote": "Publishers report amounts with and without VAT, so treat the totals as approximate.",
  "companyProfile.registry.ceo": "CEO",
  "companyProfile.registry.employerSince": "Employer register",
  "companyProfile.registry.exchange": "Listed on",
  "companyProfile.registry.heading": "Registry details",
  "companyProfile.registry.otherNames": "Other registered names",
  "companyProfile.registry.prepaymentSince": "Prepayment register",
  "companyProfile.registry.showAllNames": "Show all {count}",
  "companyProfile.registry.since": "since {date}",
  "companyProfile.registry.vatNumber": "VAT number",
  "companyProfile.registry.vatSince": "VAT register",
  "companyProfile.sections.employer": "Working there",
  "companyProfile.sections.hiring": "Hiring",
  "companyProfile.sections.hiringIntro": "Computed from every job ad we have seen from {company}, not only the ones open today.",
  "companyProfile.sections.jobs": "Open jobs",
  "companyProfile.sections.money": "Money",
  "companyProfile.sections.moneyIntro": "Official figures from public registers. Each card names its source.",
  "companyProfile.sections.navLabel": "On this page",
  "companyProfile.sections.pay": "Pay",
  "companyProfile.sections.registry": "Company details",
  "companyProfile.sections.timeline": "Timeline",
  "companyProfile.sections.timelineIntro": "Changes in the official registers, public contracts won and the first job ad in a new field, newest first.",
  "companyProfile.signals.adsCount": "{count, plural, one {# ad} other {# ads}}",
  "companyProfile.signals.heading": "What their job ads say",
  "companyProfile.signals.newFields": "Started hiring in a new field",
  "companyProfile.signals.newFieldsHint": "Their first job ad in this field since we started tracking them.",
  "companyProfile.signals.provider.benefit": "employee benefits",
  "companyProfile.signals.provider.health": "occupational health",
  "companyProfile.signals.providers": "Benefit and occupational health providers",
  "companyProfile.signals.systems": "Tools and systems you would work with",
  "companyProfile.tech.accounting": "Accounting",
  "companyProfile.tech.advertising": "Advertising",
  "companyProfile.tech.analytics": "Analytics",
  "companyProfile.tech.automation": "Automation",
  "companyProfile.tech.bi": "Reporting and BI",
  "companyProfile.tech.cadPlm": "CAD and PLM",
  "companyProfile.tech.careersSite": "Careers site",
  "companyProfile.tech.cdn": "CDN",
  "companyProfile.tech.chat": "Chat",
  "companyProfile.tech.cloud": "Cloud",
  "companyProfile.tech.cms": "Content management",
  "companyProfile.tech.consent": "Cookie consent",
  "companyProfile.tech.conversational": "Conversational marketing",
  "companyProfile.tech.crm": "CRM",
  "companyProfile.tech.data": "Data",
  "companyProfile.tech.devTools": "Developer tools",
  "companyProfile.tech.ecommerce": "Online store",
  "companyProfile.tech.emailMarketing": "Email marketing",
  "companyProfile.tech.erp": "ERP",
  "companyProfile.tech.hr": "HR",
  "companyProfile.tech.itsm": "IT service management",
  "companyProfile.tech.marketingAutomation": "Marketing automation",
  "companyProfile.tech.tagManagement": "Tag management",
  "companyProfile.tech.visitorId": "Visitor identification",
  "companyProfile.tech.webFramework": "Web framework",
  "companyProfile.timeline.addressChanged": "Registered address changed",
  "companyProfile.timeline.bankruptcy": "Declared bankrupt",
  "companyProfile.timeline.boardChange": "Board of directors changed",
  "companyProfile.timeline.businessLineChanged": "Main line of business changed",
  "companyProfile.timeline.contractWon": "Won a public contract from {buyer}",
  "companyProfile.timeline.demerger": "Demerger registered",
  "companyProfile.timeline.firstHire": "First job ad in {field}",
  "companyProfile.timeline.liquidation": "Went into liquidation",
  "companyProfile.timeline.managingDirectorChange": "Managing director changed",
  "companyProfile.timeline.merger": "Merger registered",
  "companyProfile.timeline.nameChanged": "Name changed to {name}",
  "companyProfile.timeline.newCompany": "Company registered",
  "companyProfile.timeline.registerEnteredEmployer": "Entered the employer register",
  "companyProfile.timeline.registerEnteredPrepayment": "Entered the prepayment register",
  "companyProfile.timeline.registerEnteredVat": "Entered the VAT register",
  "companyProfile.timeline.registerLeftEmployer": "Removed from the employer register",
  "companyProfile.timeline.registerLeftPrepayment": "Removed from the prepayment register",
  "companyProfile.timeline.registerLeftVat": "Removed from the VAT register",
  "companyProfile.timeline.relocated": "Registered office moved to another municipality",
  "companyProfile.timeline.removedFromRegister": "Removed from the Trade Register",
  "companyProfile.timeline.restructuring": "Entered corporate restructuring",
  "companyProfile.timeline.showAll": "Show all {count} events",
  "companyProfile.timeline.websiteChanged": "Website address changed",
  "companyProfile.website.heading": "Website technology",
  "companyProfile.badges.employerSince": "Employer since {year}",
  "companyProfile.badges.employerSinceCaption": "Employer register",
  "companyProfile.badges.growing": "Hiring is growing",
  "companyProfile.badges.growingCaption": "More ads lately",
  "companyProfile.badges.hiring": "Hiring now",
  "companyProfile.badges.hiringCaption": "{count, plural, one {# open job} other {# open jobs}}",
  "companyProfile.badges.interns": "Hires interns",
  "companyProfile.badges.internsCaption": "{ads} ads so far",
  "companyProfile.badges.listed": "Listed company",
  "companyProfile.badges.listedCaption": "On a stock exchange",
  "companyProfile.badges.newCompany": "New company",
  "companyProfile.badges.newCompanyCaption": "Registered {date}",
  "companyProfile.badges.noDegree": "No degree needed",
  "companyProfile.badges.noDegreeCaption": "{pct}% of roles",
  "companyProfile.badges.partTime": "Part-time roles",
  "companyProfile.badges.paysAboveMarket": "Pays above market",
  "companyProfile.badges.paysAboveMarketCaption": "{role} +{pct}%",
  "companyProfile.badges.publicSupplier": "Public-sector supplier",
  "companyProfile.badges.publicSupplierCaption": "{count, plural, one {# contract} other {# contracts}} in 2 years",
  "companyProfile.badges.railLabel": "Key facts",
  "companyProfile.badges.remoteFriendly": "Remote-friendly",
  "companyProfile.badges.remoteFriendlyCaption": "{pct}% remote or hybrid",
  "companyProfile.badges.sharePctOfAds": "{pct}% of ads",
  "companyProfile.badges.visaSupport": "Mentions visa or relocation help",
  "companyProfile.badges.visaSupportCaption": "In {ads, plural, one {# ad} other {# ads}} from the last 12 months",
  "companyProfile.badges.withoutFinnish": "Roles without Finnish",
  "companyProfile.facts.sourceAds": "job ads",
  "companyProfile.facts.sourcePrh": "PRH",
  "companyProfile.facts.sourcePublic": "public invoices",
  "companyProfile.facts.sourceTax": "Tax Administration",
  "companyProfile.facts.sourceTed": "TED",
  "companyProfile.jobProfile.adsBasis": "Based on {ads, plural, one {# job ad} other {# job ads}} we have seen from {company}.",
  "companyProfile.jobProfile.adsCount": "{count, plural, one {# ad} other {# ads}}",
  "companyProfile.jobProfile.asksHeading": "What they ask for",
  "companyProfile.jobProfile.asksIntro": "Use these words in your application.",
  "companyProfile.jobProfile.benefitsHeading": "Benefits in their job ads",
  "companyProfile.jobProfile.benefitsIntro": "Share of ads that mention each benefit. Many ads list none, so a low share means \"sometimes\", not \"never\".",
  "companyProfile.jobProfile.colAds": "Ads with pay",
  "companyProfile.jobProfile.colPay": "Pays",
  "companyProfile.jobProfile.colRole": "Role",
  "companyProfile.jobProfile.colVsMarket": "vs Finland",
  "companyProfile.jobProfile.contract": "Contract",
  "companyProfile.jobProfile.education": "Education, of ads that state it",
  "companyProfile.jobProfile.hybrid": "hybrid",
  "companyProfile.jobProfile.languageRequired": "require {language}",
  "companyProfile.jobProfile.languageWanted": "want {language} ({required}% require it)",
  "companyProfile.jobProfile.languages": "Languages",
  "companyProfile.jobProfile.leading": "Leading people",
  "companyProfile.jobProfile.leadingValue": "{pct}% of ads that say include managing people",
  "companyProfile.jobProfile.onsite": "on site",
  "companyProfile.jobProfile.payHeading": "Roles and pay",
  "companyProfile.jobProfile.payIntro": "Advertised monthly pay for its most common roles, against the same role across Finland.",
  "companyProfile.jobProfile.payNote": "Medians of ads that state pay. The tick is what the role pays in Finland, the same figure as its salary page (Statistics Finland where the occupation is covered). \"vs Finland\" compares the low end with the same role's ads at all employers.",
  "companyProfile.jobProfile.providers": "Providers named in ads:",
  "companyProfile.jobProfile.remote": "remote",
  "companyProfile.jobProfile.skills": "Skills, share of ads",
  "companyProfile.jobProfile.software": "Software named in ads",
  "companyProfile.jobProfile.termsHeading": "How they hire",
  "companyProfile.jobProfile.workModel": "Work model",
  "companyProfile.jobs.filterLabel": "Open jobs by field and type",
  "companyProfile.jobs.headingCount": "{count, plural, one {# open job at {company}} other {# open jobs at {company}}}",
  "companyProfile.lifeline.barLabel": "{month}: {count, plural, one {# ad} other {# ads}}",
  "companyProfile.lifeline.chartLabel": "Job ads per month over the last three years, peaking at {count} in {month}",
  "companyProfile.lifeline.employerSince": "Employer register",
  "companyProfile.lifeline.heading": "{company} over the last three years",
  "companyProfile.lifeline.laneContracts": "Contracts",
  "companyProfile.lifeline.laneFields": "New fields",
  "companyProfile.lifeline.laneRegistry": "Registry",
  "companyProfile.lifeline.legendAds": "Job ads per month",
  "companyProfile.lifeline.peak": "Peak: {count} ads in {month}. A month with very few ads can be a gap in our crawling rather than a hiring freeze. Hover a mark for details.",
  "companyProfile.lifeline.registered": "Registered",
  "companyProfile.notKnown.financials": "Financial statements. None filed in the open register yet.",
  "companyProfile.notKnown.heading": "Not known yet",
  "companyProfile.notKnown.intro": "What we will add as the data arrives.",
  "companyProfile.notKnown.pay": "Pay and hiring patterns. Built from its ads over time.",
  "companyProfile.notKnown.publicSales": "Public-sector sales. None found in the public invoices we track.",
  "companyProfile.notKnown.score": "Employer Score. We grade a company once we have seen enough of its job ads.",
  "companyProfile.notKnown.tax": "Corporate tax. The Tax Administration publishes it each autumn, for the year before.",
  "companyProfile.sections.similar": "Similar",
  "companyProfile.similar.grade": "Grade {grade}",
  "companyProfile.similar.heading": "Similar employers",
  "companyProfile.similar.hiresRole": "Also hires: {role}",
  "companyProfile.similar.intro": "Same industry, or hiring for the same roles. Median advertised pay on one scale.",
  "companyProfile.similar.noPay": "Pay rarely stated",
  "companyProfile.similar.openJobs": "{count, plural, =0 {No open jobs} one {# open job} other {# open jobs}}",
  "companyProfile.similar.sameIndustry": "Same industry",
  "companyProfile.similar.thisEmployer": "This employer",
  "companyProfile.badges.builtFrom": "Built from {ads, plural, =0 {} one {# job ad and } other {# job ads and }}{sources, plural, one {# public data source} other {# public data sources}}",
  "companyProfile.facts.capContracts": "public contracts in 2 years",
  "companyProfile.facts.capEmployer": "in the employer register since",
  "companyProfile.facts.capFinnish": "of ads require Finnish",
  "companyProfile.facts.capHiring": "job ads a month",
  "companyProfile.facts.capNewFields": "{count, plural, one {new field} other {new fields}} in 18 months",
  "companyProfile.facts.capPay": "pay vs Finland median",
  "companyProfile.facts.capPublic": "from public buyers, {year}",
  "companyProfile.facts.capRegistered": "registered",
  "companyProfile.facts.capTax": "corporate tax, {year}",
  "companyProfile.jobProfile.payLegend": "Bar: what {company} advertises. Tick: Finland median for the role.",
  "companyProfile.lifeline.average": "12-month average: {count}",
  "interviewPrep.kitIntro": "Your interview kit for this job: facts about the employer, the questions you're likely to be asked with what from your CV to talk about, practice with instant feedback, and questions to ask them.",
  "interviewPrep.noEmployer": "We don't know this job's employer well enough to build an interview kit yet.",
  "interviewPrep.openFullPage": "Open as a page",
  "tools.interviewKit.progress.cvSent": "Tailored CV sent {date}",
  "tools.interviewKit.progress.cvTailored": "CV tailored",
  "tools.interviewKit.progress.cvTodo": "Tailor your CV",
  "tools.interviewKit.progress.heading": "Your application",
  "tools.interviewKit.progress.letterDone": "Cover letter written",
  "tools.interviewKit.progress.letterTodo": "Write a cover letter",
  "tools.interviewKit.progress.stage": "Stage: {stage}",
  "tools.interviewKit.usedProfileCv": "Your answers are matched to your CV.",
  "tools.interviewKit.usedTailoredCv": "Your answers are matched to the CV you tailored for this job.",
  "salaryRolePage.hiringCompanies.liveSub": "{count, plural, one {# employer has an open job for this role right now.} other {# employers have open jobs for this role right now.}}",
  "salaryRolePage.hiringCompanies.openJobs": "{count, plural, one {# open job} other {# open jobs}}",
  "salaryRolePage.hiringCompanies.showAll": "Show all {count} employers",
  "companyProfile.hero.lede": "{company} has {count, plural, one {# open job} other {# open jobs}} right now{hasExamples, select, yes {, including {examples}} other {}}.",
  "employersHub.more.heading": "More employers on this page",
  "search.bestCompaniesStrip.labelScoped": "Direct employers hiring the most",
  "cityPageV2.employers.headingAll": "Top employers in {town}",
  "cityPageV2.employers.headingAllInflected": "Top employers in {townLocative}",
  "salaryRolePage.v2.ask.benefits": "Benefits",
  "salaryRolePage.v2.ask.contract": "Contract type",
  "salaryRolePage.v2.ask.footnote": "Numbers are open ads that mention it, out of {count}.",
  "salaryRolePage.v2.ask.languages": "Required languages",
  "salaryRolePage.v2.ask.skills": "Skills",
  "salaryRolePage.v2.ask.title": "What the ads ask for and offer",
  "salaryRolePage.v2.employers.footnote": "Employers with at least {min} open ads that state a salary.",
  "salaryRolePage.v2.employers.title": "Who pays what",
  "salaryRolePage.v2.faq.aGood": "The median {median} is {dir, select, up {{pct}% above} down {{pct}% below} other {at}} the median of all Finnish job ads that state a salary ({all}).",
  "salaryRolePage.v2.faq.qGood": "Is {roleTitle} pay good?",
  "salaryRolePage.v2.faq.qPay": "What does a {roleTitle} earn in Finland?",
  "salaryRolePage.v2.finding.cite": "Cite",
  "salaryRolePage.v2.finding.citeText": "JobCrawls ({year}). {roleTitle} salary in Finland: public and private employers. {date}. {url}",
  "salaryRolePage.v2.finding.copied": "Link copied",
  "salaryRolePage.v2.finding.copyLink": "Copy link",
  "salaryRolePage.v2.finding.detail": "Median of the pay stated in open ads for this role. {publicCount} public and {privateCount} private ads. Base pay, without shift supplements.",
  "salaryRolePage.v2.finding.eyebrow": "Finding · {month}",
  "salaryRolePage.v2.finding.official": "In actual earnings the gap is {gap}: wellbeing areas {wellbeing}, private sector {privateSector} (Statistics Finland {year}).",
  "salaryRolePage.v2.headingWithYear": "{roleTitle} Salary in Finland {year}",
  "salaryRolePage.v2.insightEmployerEyebrow": "Employer matters",
  "salaryRolePage.v2.insightEnglishOnly": "{pct}% of open ads accept English",
  "salaryRolePage.v2.insightLanguageDetail": "Required languages in {count} open ads: {list}.",
  "salaryRolePage.v2.insightLanguageEyebrow": "Languages",
  "salaryRolePage.v2.insightSectorDetail": "Median pay in open ads: public {publicPay} ({publicCount} ads), private {privatePay} ({privateCount} ads).",
  "salaryRolePage.v2.insightSectorLess": "Private employers advertise about {gap} more a month than public ones",
  "salaryRolePage.v2.insightSectorMore": "Public employers advertise about {gap} more a month than private ones",
  "salaryRolePage.v2.insightSwedish": "{pct}% of open ads require Swedish",
  "salaryRolePage.v2.level.director": "Director",
  "salaryRolePage.v2.level.executive": "Executive",
  "salaryRolePage.v2.level.expert": "Expert",
  "salaryRolePage.v2.level.intern": "Intern",
  "salaryRolePage.v2.level.junior": "Junior",
  "salaryRolePage.v2.level.manager": "Supervisor or manager",
  "salaryRolePage.v2.level.mid": "Mid-level",
  "salaryRolePage.v2.level.senior": "Senior",
  "salaryRolePage.v2.levels.sub": "Median advertised pay by the role level stated in the ad.",
  "salaryRolePage.v2.levels.title": "Pay by seniority",
  "salaryRolePage.v2.official.local": "Municipalities",
  "salaryRolePage.v2.official.private": "Private sector",
  "salaryRolePage.v2.official.state": "State",
  "salaryRolePage.v2.official.wellbeing": "Wellbeing areas",
  "salaryRolePage.v2.provDaysOpen": "Ads typically stay open {days} days",
  "salaryRolePage.v2.provPostings": "{count, plural, one {# job ad with a salary} other {# job ads with a salary}}",
  "salaryRolePage.v2.provStatedShare": "{pct}% of open ads state the salary",
  "salaryRolePage.v2.provUpdated": "Updated {date}",
  "salaryRolePage.v2.sector.agency": "Staffing agency",
  "salaryRolePage.v2.sector.agencyShort": "Staffing agencies",
  "salaryRolePage.v2.sector.private": "Private company",
  "salaryRolePage.v2.sector.privateShort": "Private employers",
  "salaryRolePage.v2.sector.public": "Wellbeing area or municipality",
  "salaryRolePage.v2.sector.publicShort": "Public employers",
  "salaryRolePage.v2.topJobs.all": "All {count} open jobs",
  "salaryRolePage.v2.topJobs.sub": "Stated pay compared with the median {median}.",
  "salaryRolePage.v2.topJobs.title": "Best-paying open jobs",
  "salaryRolePage.v2.vsMedian": "{dir, select, up {+{pct}% vs median} down {−{pct}% vs median} other {at the median}}",
  "roleHubs.allFields": "All fields",
  "roleHubs.cardOpen": "{count, plural, one {open job} other {open jobs}}",
  "roleHubs.cardPay": "{multiple}× the typical role here, {count} open jobs",
  "roleHubs.cardRising": "{pct}% of its {count} open jobs were posted this week",
  "roleHubs.cardSalaryLink": "Salary",
  "roleHubs.catalogHeading": "All roles by field",
  "roleHubs.catalogLede": "Every role page with its open jobs and median pay. Roles with too few open jobs for a page of their own are listed without a link.",
  "roleHubs.factsAria": "Key figures",
  "roleHubs.kickerOpen": "Open now",
  "roleHubs.kickerPay": "Pays above the rest",
  "roleHubs.kickerRising": "Hiring picks up",
  "roleHubs.mapNoteNew": "Block size is the number of jobs posted in the last 7 days.",
  "roleHubs.mapNoteOpen": "The {count} roles with most open jobs hold {sum} of the {total} open jobs in all listed roles.",
  "roleHubs.mapNotePay": "Block size is the estimated median pay. Roles without enough salary data are left out.",
  "roleHubs.measureAria": "Size blocks by",
  "roleHubs.measureNew": "New this week",
  "roleHubs.measureOpen": "Open jobs",
  "roleHubs.measurePay": "Median pay",
  "roleHubs.perMonth": "/mo",
  "roleHubs.pickGroup": "Pick a field",
  "roleHubs.placeAll": "in Finland",
  "roleHubs.roles.factNew": "{role}: {count} jobs posted in the last 7 days.",
  "roleHubs.roles.factNewKicker": "Most new this week",
  "roleHubs.roles.factPay": "{role}: estimated median {pay} a month, the highest of the 30 roles with most open jobs.",
  "roleHubs.roles.factPayKicker": "Best paid of the big ones",
  "roleHubs.roles.factTop": "{role}: {count} open jobs, {pct}% of all jobs in these roles.",
  "roleHubs.roles.factTopKicker": "Most open jobs",
  "roleHubs.roles.faqA": "Right now {first} ({firstCount} open jobs), {second} ({secondCount}) and {third} ({thirdCount}). The counts come from employers’ own career sites and Työmarkkinatori and refresh daily.",
  "roleHubs.roles.faqQ": "Which roles have the most open jobs in Finland?",
  "roleHubs.roles.heading": "Open jobs by role",
  "roleHubs.roles.sentence": "Which roles are hiring {place}?",
  "roleHubs.salary.cardActualCaption": "actual median earnings vs {ads} in ads (Statistics Finland)",
  "roleHubs.salary.cardHighCaption": "{multiple}× the typical role here · {count} ads",
  "roleHubs.salary.cardMedianCaption": "a month · {count} ads · middle half {p25}–{p75}",
  "roleHubs.salary.cardWideCaption": "between the lower and upper quarter of the range, median {median}",
  "roleHubs.salary.catalogHeading": "Salaries for every role",
  "roleHubs.salary.catalogLede": "Estimated median pay from job ads and Statistics Finland earnings data. Roles with the most data first in each field.",
  "roleHubs.salary.factAds": "The median of every Finnish job ad that states a salary. Ads state base pay, so they sit below actual earnings.",
  "roleHubs.salary.factAdsKicker": "Median in job ads",
  "roleHubs.salary.factMean": "Mean monthly earnings of full-time employees; the median is {median}. Statistics Finland {year}.",
  "roleHubs.salary.factMeanKicker": "Average pay in Finland",
  "roleHubs.salary.factTransparency": "of the {total} open jobs in Finland state the salary in the ad.",
  "roleHubs.salary.factTransparencyKicker": "Pay transparency",
  "roleHubs.salary.faqABest": "By our estimate from job ads and Statistics Finland data, the best-paid roles right now are {first} ({firstPay}), {second} ({secondPay}) and {third} ({thirdPay}).",
  "roleHubs.salary.faqAMean": "Statistics Finland puts the average monthly earnings of full-time employees at {mean} and the median at {median} ({year}). Job ads that state a salary have a median of {ads}, since they usually give the base pay without supplements.",
  "roleHubs.salary.faqQBest": "Which roles pay the most in Finland?",
  "roleHubs.salary.faqQMean": "What is the average salary in Finland?",
  "roleHubs.salary.heading": "Salary comparison {year}: average and median pay by role",
  "roleHubs.salary.kickerActual": "Earns more than the ads say",
  "roleHubs.salary.kickerHigh": "Pays above the rest",
  "roleHubs.salary.kickerMedian": "Estimated median",
  "roleHubs.salary.kickerWide": "Wide pay range",
  "roleHubs.salary.lowPaidHeading": "Lowest-paid roles",
  "roleHubs.salary.methodLink": "How we calculate these numbers",
  "roleHubs.salary.rankLede": "Estimated median pay, roles with at least {min} job ads with a salary.",
  "roleHubs.salary.sentence": "What does work pay {place}?",
  "roleHubs.salary.sourceOfficial": "Official earnings: Statistics Finland, Structure of Earnings {year}, updated with the index of wage and salary earnings (CC BY 4.0).",
  "roleHubs.salary.stripAllAds": "all ads {pay}",
  "roleHubs.salary.stripHeading": "Every role on one scale",
  "roleHubs.salary.stripLede": "Estimated median pay, one dot per role, grouped by field. The line is the median of all job ads.",
  "roleHubs.salary.topPaidHeading": "Best-paid roles",
  "roleHubs.searchClear": "Clear search",
  "roleHubs.searchCount": "{count, plural, one {# role} other {# roles}} found",
  "roleHubs.searchLabel": "Search roles",
  "roleHubs.searchNone": "No role matches “{query}”.",
  "roleHubs.searchPlaceholder": "Search a role, e.g. nurse",
  "roleHubs.sentenceAria": "Choose a field",
  "roleHubs.standoutHeading": "What stands out",
  "roleHubs.standoutLede": "Each card leads with the one thing that sets the role apart right now.",
  "roleHubs.statusNew": "{count} new this week",
  "roleHubs.statusOpen": "{count} open jobs in these roles",
  "roleHubs.statusPostings": "{count} job ads with a salary",
  "roleHubs.statusRoles": "{count} roles",
  "roleHubs.statusUpdated": "Updated {date}",
  "roleHubs.tileNew": "new in 7 days",
  "roleHubs.tileOpen": "open jobs",
  "roleHubs.tilePay": "median a month",
  "roleHubs.catalogShowAll": "Show all {count}",
  "searchPanel.goAria": "Search",
  "localeMismatch.close": "Close",
  "localeMismatch.keepCurrent": "Keep {locale}",
  "localeMismatch.promptMessage": "Your browser is set to English. Would you like to switch to English?",
  "localeMismatch.switchToEnglish": "Switch to English",
  "search.refinements.company.section": "Company",
  "search.refinements.exclude": "Exclude {value}",
  "search.refinements.job.section": "Job",
  "search.refinements.location.section": "Location",
  "search.refinements.only": "Only {value}",
  "search.refinements.removeExclude": "Remove exclusion of {value}",
  "search.refinements.removeOnly": "Remove \"only {value}\" filter",
  "search.refinements.salary.section": "Salary",
  "backoffice.designSystem.nav": "Design system",
  "backoffice.hub.desc.designSystem": "Every design system component in today's and the next theme, light and dark.",
  "jobFlow.aria": "Your job search: {summary}",
  "jobFlow.scaleNote": "Bars use a square-root scale so the small stages stay visible; the numbers are exact.",
  "jobFlow.shareOfBrowsed": "{pct}% of browsed",
  "srpSalaryStrip.medianMarker": "Median {amount}",
  "srpSalaryStrip.outliersBelow": "{count} under {value}",
  "srpSalaryStrip.rough": "rough",
  "srpSalaryStrip.tooFew": "Too few postings state a salary to show this.",
  "jobDetailPageV2.salaryGauge.sample": "Based on {count, plural, one {# job posting} other {# job postings}}",
  "nav.tape.removeFilter": "Remove filter: {label}",
  "pagination.page": "Page {number}",
  "pagination.pages": "Pages",
  "jobDetailPageV2.fit.title": "Does it fit you?",
  "jobDetailPageV2.similarReadout.unit": "open now",
  "srpTemplate.newThisWeek.label": "New this week",
  "srpTemplate.source.indexToday": "Index today",
  "srpTemplate.source.ofOpenJobs": "Of open jobs",
  "srpTemplate.source.salaryStats": "From salary statistics",
  "srpTopEmployers.openJobs": "{count, plural, one {# open job} other {# open jobs}}",
  "workModelHub.figure.employers": "{count, plural, one {employer} other {employers}}",
  "lastSeen.newToday": "New today",
  "companyProfile.hero.score": "Employer Score",
  "salaryRolePage.hiringCompanies.grade": "Grade {grade}",
  "salaryRolePage.v2.cityChartDesc": "Middle half and median of advertised monthly pay in {count, plural, one {# city} other {# cities}}. The highest median is in {city}, {pay} a month.",
  "salaryRolePage.v2.employers.caption": "Median advertised pay by employer",
  "salaryRolePage.v2.employers.colAds": "Ads",
  "salaryRolePage.v2.employers.colEmployer": "Employer",
  "salaryRolePage.v2.employers.colMedian": "Median a month",
  "salaryRolePage.v2.employers.colSector": "Sector",
  "salaryRolePage.v2.levels.caption": "Median advertised pay by seniority level",
  "salaryRolePage.v2.levels.colAds": "Ads",
  "salaryRolePage.v2.levels.colLevel": "Level",
  "salaryRolePage.v2.levels.colMedian": "Median a month",
  "salaryRolePage.v2.levels.smallRough": "Fewer than 10 ads: indicative only.",
  "salaryRolePage.v2.marketBarDesc": "Median {median} a month. Half of the ads pay between {p25} and {p75}. Based on {count, plural, one {# job ad} other {# job ads}}.",
  "salaryRolePage.v2.marketBarDescMedianOnly": "Median {median} a month, based on {count, plural, one {# job ad} other {# job ads}}.",
  "salaryRolePage.v2.thin.rough": "rough",
  "salaryRolePage.v2.thin.tooFew": "Too few ads",
  "authors.index.subtitle": "The people behind JobCrawls' research-led guides to the Finnish job market.",
  "authors.index.title": "Authors",
  "authors.index.viewProfile": "View profile",
  "authors.profile.articlesHeading": "Articles on JobCrawls",
  "authors.profile.coverageHeading": "Areas of coverage",
  "authors.profile.noArticles": "No linked guides yet.",
  "salaryRolePage.v2.employers.subTable": "Median pay stated in the open ads of each employer.",
  "salaryIndexPage.rankColRole": "Role",
  "cvStudio.font.label": "Font",
  "jobDetailPageV2.aboutTheRole": "About the role",
  "jobDetailPageV2.aboutTheRole.note": "Summarised by JobCrawls from the job ad above.",
  "jobDetailPageV2.fact.education": "Education",
  "jobDetailPageV2.fact.experience": "Experience",
  "jobDetailPageV2.fact.field": "Field",
  "jobDetailPageV2.fact.languages": "Languages required",
  "jobDetailPageV2.fact.management": "Managing people",
  "jobDetailPageV2.fact.where": "Where and how",
  "jobDetailPageV2.keyFacts": "Key facts",
  "jobDetailPageV2.originalAd.asPublished": "As published by {company} on {host}",
  "jobDetailPageV2.originalAd.asPublishedNoHost": "As published by {company}",
  "jobDetailPageV2.originalAd.derived": "Written by JobCrawls from the ad.",
  "jobDetailPageV2.originalAd.open": "Open the ad",
  "jobDetailPageV2.originalAd.showAll": "Show the whole ad",
  "jobDetailPageV2.originalAd.showLess": "Show less",
  "jobDetailPageV2.originalAd.title": "Original job ad",
  "jobDetailPageV2.originalAd.translatedFromEn": "Translated by JobCrawls from the English ad.",
  "jobDetailPageV2.originalAd.translatedFromFi": "Translated by JobCrawls from the Finnish ad.",
  "jobDetailPageV2.originalAd.translatedFromSv": "Translated by JobCrawls from the Swedish ad.",
  "facetAutocomplete.remove": "Remove {value}",
  "hub.lead.myJobs": "Every job you save or apply to, from saved to hired.",
  "hub.lead.searchesAlerts": "Your saved searches, their new matches and the email alerts that bring them to you.",
  "hub.lead.watchlist": "Follow companies and roles to see new openings, employer score changes and hiring trends in one place.",
  "jobAlerts.newMatches.view": "View",
  "profile.cvTranslateReview.summary": "Summary",
  "profile.editLanguages.levelLabel": "Level",
  "profile.editLanguages.nameLabel": "Language",
  "taxIceberg.input.period.label": "Show amounts per month or per year",
  "tools.empty.browseJobs.v2": "Browse jobs",
  "tools.history.tabsLabel": "History",
  "tools.kanban.emptyBoard.body": "Save jobs from search, or add an off-site application with the button above, and they land here.",
  "tools.kanban.emptyBoard.title": "No saved or applied jobs yet",
  "watchlist.compare.caption": "Followed companies compared side by side",
  "watchlist.empty.browse.v2": "Browse top companies",
  "jobDetailPageV2.aboutEmployer": "About {company}",
  "jobAlerts.panel.browserBlocked": "Blocked in this browser. Allow notifications for JobCrawls in your browser settings.",
  "jobAlerts.panel.browserOn": "On in this browser",
  "jobAlerts.panel.browserTurnOff": "Turn off in this browser",
  "jobAlerts.panel.browserTurnOn": "Turn on notifications in this browser",
  "jobAlerts.panel.browserUnsupported": "Not supported in this browser. Choose Email, or use the JobCrawls app.",
  "jobAlerts.panel.channelBoth": "Both",
  "jobAlerts.panel.channelEmail": "Email",
  "jobAlerts.panel.channelPush": "Notifications",
  "jobAlerts.panel.channelsAppHint": "Notifications also reach the JobCrawls app when it is installed and you are signed in.",
  "jobAlerts.panel.channelsLegend": "How you get alerts",
  "srpAlertCta.channels.blocked": "Notifications are blocked in this browser. Allow them in your browser settings, or get alerts by email.",
  "srpAlertCta.channels.both": "Both",
  "srpAlertCta.channels.email": "Email",
  "srpAlertCta.channels.groupLabel": "How should we tell you?",
  "srpAlertCta.channels.guestPush": "Notifications need an account, so we will ask you to sign in.",
  "srpAlertCta.channels.push": "Notifications",
  "srpAlertCta.channels.turnOnHere": "Turn on notifications in this browser",
  "tools.activity.flowHint": "Save or apply to a job and the path from browsing to applying shows up here.",
  "tools.activity.hideFlow": "Hide the flow",
  "tools.activity.sectionHeading": "Your activity",
  "tools.activity.showFlow": "Show the flow",
  "tools.historySummary.closeDrawer": "Hide history",
  "tools.historySummary.explainer": "Jobs you opened, and the ones you hid from your searches.",
  "marketHeader.qa.remoteShareQuestion": "How many jobs in {location} are remote or hybrid?",
  "map.commute.clickToMove": "Or click the map to pick a start",
  "map.explorer.collapse": "Hide map options",
  "map.explorer.expand": "Show map options",
  "map.explorer.expandLabel": "Map options",
  "map.explorer.insightToggle": "Insight",
  "backoffice.hub.desc.plus": "JobCrawls Plus members, revenue, free-access requests, refunds and extensions.",
  "backoffice.plus.nav": "Plus",
  "backoffice.subpage.plusMember": "Plus member",
  "copyKit.applicationAddress": "Email (application address for this job)",
  "jobAlerts.unsubscribe.scoutExplanation": "This stops the Scout emails. Scout keeps picking in the app, and your saved searches and other alerts stay on.",
  "jobAlerts.unsubscribe.scoutSuccessBody": "You will no longer get Scout emails. Scout still shows its picks in the app, and you can switch emails back on in Scout settings.",
  "plus.agent.account.canUseTitle": "What it can use",
  "plus.agent.account.colCounted": "Counts toward the weekly limit",
  "plus.agent.account.colWhat": "What",
  "plus.agent.account.connectKeys": "Create a personal API key",
  "plus.agent.account.connectStep1": "In Claude or ChatGPT, add a connector with this address:",
  "plus.agent.account.connectStep2": "When it asks for a token or key, paste a personal API key. Create one below.",
  "plus.agent.account.connectTitle": "Connect in two steps",
  "plus.agent.account.connectedLastUsed": "Last used {when}",
  "plus.agent.account.connectedNeverUsed": "Not used yet",
  "plus.agent.account.connectedNone": "Nothing is connected yet.",
  "plus.agent.account.connectedTitle": "Connected",
  "plus.agent.account.copied": "Copied",
  "plus.agent.account.copy": "Copy",
  "plus.agent.account.counted": "Counted",
  "plus.agent.account.disconnect": "Disconnect",
  "plus.agent.account.exampleAnswer": "Three new picks. The best is a backend job with one office day and pay above the usual range for your role. One job you saved closes tomorrow and you haven't applied.",
  "plus.agent.account.exampleFollow": "Want me to tailor your CV for the first one and remind you on Friday?",
  "plus.agent.account.exampleNote": "An illustration of how it can work, not a real result.",
  "plus.agent.account.exampleTitle": "Example: a morning review",
  "plus.agent.account.exampleUser": "What's new for me today?",
  "plus.agent.account.intro": "Connect Claude or ChatGPT to JobCrawls. It can then search with your profile, read our pay and company data, and keep your tracker up to date.",
  "plus.agent.account.limitNote": "Every account you sign in with can use all of these, within a weekly limit. Plus and Pro raise it.",
  "plus.agent.account.limitSeePlans": "See the plans",
  "plus.agent.account.neverBody": "Send applications, email employers, or see anyone else's data. You apply yourself, on the employer's site.",
  "plus.agent.account.neverTitle": "What it will never do",
  "plus.agent.account.notCounted": "Not counted",
  "plus.agent.account.promptsBody": "Your assistant lists these once it is connected: Morning job review, Prepare me for this interview, Should I take this offer?, Plan my week of applying.",
  "plus.agent.account.promptsTitle": "Ready-made prompts",
  "plus.agent.account.rowAccount": "Your profile and CV, saved jobs and tracker, followed companies, alerts and Scout picks",
  "plus.agent.account.rowDocuments": "Tailored CVs, cover letters and interview kits",
  "plus.agent.account.rowInsights": "Pay data, listing history, past listings and company hiring history",
  "plus.agent.account.rowPublic": "Search jobs, job details, filters and net pay",
  "plus.agent.account.rowReports": "Your market report and match scores",
  "plus.agent.account.title": "JobCrawls in Claude or ChatGPT",
  "plus.agent.aiNote": "Scout can be wrong. Check the details on the employer's own page before you apply.",
  "plus.agent.askAboutJob": "Tell me about the job with id {jobId}: how well it fits me, what it pays against the market, and what I should ask the employer.",
  "plus.agent.budgetNote": "I reached the limit of what I can check in one answer. Ask a follow-up and I will continue.",
  "plus.agent.busyTitle": "Scout is still working on your last message",
  "plus.agent.cancel": "Cancel",
  "plus.agent.card.agency": "Agency",
  "plus.agent.card.commute": "{minutes} min",
  "plus.agent.card.companyOpen": "View employer",
  "plus.agent.card.employerScore": "Employer Score {grade}",
  "plus.agent.card.match": "Match {score}",
  "plus.agent.card.noPay": "Pay not stated",
  "plus.agent.card.open": "View job",
  "plus.agent.card.perMonth": "{range} a month",
  "plus.agent.card.source": "Source: {source}",
  "plus.agent.comingSoonBody": "Search stays open to everyone in the meantime.",
  "plus.agent.comingSoonCta": "Search jobs",
  "plus.agent.comingSoonTitle": "Scout is not open yet",
  "plus.agent.composerLabel": "Ask Scout",
  "plus.agent.composerPlaceholder": "Ask about jobs, pay or employers",
  "plus.agent.continueAsk": "Help me choose between these jobs: {query}",
  "plus.agent.continueBody": "Scout reads the ads, works out commute times, cuts out consultancies, checks the pay and tells you which are worth your time.",
  "plus.agent.continueButton": "Continue as a conversation",
  "plus.agent.continueLimitBody": "Search stays free in the meantime.",
  "plus.agent.continueQ1": "Which of these are product companies, not consulting?",
  "plus.agent.continueQ2": "Which can I reach in 45 minutes from home?",
  "plus.agent.continueQ3": "Which pay best for my level?",
  "plus.agent.continueSignInBody": "Sign in to continue as a conversation. It is free with an account.",
  "plus.agent.continueTitle": "Keep going with Scout",
  "plus.agent.conversationsOpen": "Conversations",
  "plus.agent.conversationsTitle": "Your conversations",
  "plus.agent.dailyLimitBody": "Try again tomorrow.",
  "plus.agent.dailyLimitTitle": "You've used today's Scout messages",
  "plus.agent.deleteAll": "Delete all conversations",
  "plus.agent.deleteAllConfirm": "Delete all your conversations? This cannot be undone.",
  "plus.agent.deleteAllYes": "Yes, delete all",
  "plus.agent.deleteOne": "Delete this conversation",
  "plus.agent.failedBody": "Nothing was changed. Try asking again in a moment.",
  "plus.agent.failedTitle": "Scout could not finish that",
  "plus.agent.followCv": "Which ones would my CV get past?",
  "plus.agent.followEmployer": "What is the first one like to work for?",
  "plus.agent.followPay": "Which of these pay best for my level?",
  "plus.agent.followReach": "Which can I reach in 45 minutes from home?",
  "plus.agent.freq.daily": "daily",
  "plus.agent.freq.instant": "instantly",
  "plus.agent.freq.weekly": "weekly",
  "plus.agent.genericErrorBody": "Check your connection and try again.",
  "plus.agent.genericErrorTitle": "That didn't go through",
  "plus.agent.kindDealbreaker": "Dealbreaker",
  "plus.agent.kindDislike": "Avoid",
  "plus.agent.kindLike": "Wants",
  "plus.agent.limitBody": "Your message is back in the box. Search and the rest of JobCrawls still work.",
  "plus.agent.loadError": "We could not load your conversations",
  "plus.agent.memoryAdd": "Add something to remember",
  "plus.agent.memoryAddButton": "Add",
  "plus.agent.memoryBody": "Things you told it. Scout uses the same list. Edit or remove anything.",
  "plus.agent.memoryEdit": "Edit",
  "plus.agent.memoryEmpty": "Nothing yet. Say \"no consulting firms\" or \"at most 2 office days\" and Scout offers to remember it.",
  "plus.agent.memoryRemove": "Remove",
  "plus.agent.memorySave": "Save",
  "plus.agent.memoryTitle": "What Scout remembers",
  "plus.agent.menuNote": "ask anything about your job search",
  "plus.agent.moreJobs": "Ask for more",
  "plus.agent.name": "Scout",
  "plus.agent.navLabel": "Scout",
  "plus.agent.neverBody": "Send applications or email employers. You apply yourself, on the employer's site. Nothing is saved or changed until you tap a button.",
  "plus.agent.neverTitle": "What it never does",
  "plus.agent.newConversation": "+ New conversation",
  "plus.agent.noConversations": "Your conversations show up here. We keep the last 20.",
  "plus.agent.pageIntro": "Scout searches the ads, works out commute times, checks pay and employers, and shows you the jobs worth your time. It only tells you what our data supports.",
  "plus.agent.pageTitle": "Talk to everything we know",
  "plus.agent.privacyNote": "Conversations are private to you and never used to train anything.",
  "plus.agent.proposal.alert": "Email me about \"{subject}\" ({frequency})",
  "plus.agent.proposal.copied": "Copied",
  "plus.agent.proposal.copy": "Copy",
  "plus.agent.proposal.done": "Done",
  "plus.agent.proposal.failed": "That did not go through. Nothing was changed.",
  "plus.agent.proposal.follow": "Follow {subject}",
  "plus.agent.proposal.hideDraft": "Hide the draft",
  "plus.agent.proposal.kit": "Build an interview kit for {subject}",
  "plus.agent.proposal.letter": "Draft a cover letter for {subject}",
  "plus.agent.proposal.limitReached": "You've used this week's allowance for this. It resets on Monday.",
  "plus.agent.proposal.move": "Move {subject} to {stage}",
  "plus.agent.proposal.notNow": "Not now",
  "plus.agent.proposal.note": "Add a note to {subject}",
  "plus.agent.proposal.open": "Open",
  "plus.agent.proposal.preferences": "Save to my profile: {subject}",
  "plus.agent.proposal.remember": "Remember: {subject}",
  "plus.agent.proposal.reminder": "Remind me about {subject} on {date}",
  "plus.agent.proposal.save": "Save {subject}",
  "plus.agent.proposal.savedSearch": "Save the search \"{subject}\"",
  "plus.agent.proposal.scout": "Keep looking with Scout",
  "plus.agent.proposal.showDraft": "Show the draft",
  "plus.agent.proposal.tailor": "Tailor my CV for {subject}",
  "plus.agent.recent": "Recent",
  "plus.agent.retry": "Try again",
  "plus.agent.says": "Scout",
  "plus.agent.searchesBody": "Open jobs found on employers' own career sites, past listings with their pay, company hiring history, Employer Scores and the trade register.",
  "plus.agent.searchesTitle": "What it searches",
  "plus.agent.send": "Send",
  "plus.agent.signInBody": "Scout is free with an account. Plus and Pro raise the weekly message limit.",
  "plus.agent.signInCta": "Sign in",
  "plus.agent.signInTitle": "Sign in to talk to Scout",
  "plus.agent.stage.applied": "Applied",
  "plus.agent.stage.hired": "Hired",
  "plus.agent.stage.interviewing": "Interviewing",
  "plus.agent.stage.offer": "Offer",
  "plus.agent.stage.rejected": "Rejected",
  "plus.agent.stage.saved": "Saved",
  "plus.agent.startersTitle": "Try asking",
  "plus.agent.step.calculated": "Calculated net pay",
  "plus.agent.step.commute": "Kept {count} of {total} within reach of {place}",
  "plus.agent.step.commuteChecked": "Checked commute times",
  "plus.agent.step.company": "Looked up {name}",
  "plus.agent.step.comparedPay": "Compared pay",
  "plus.agent.step.droppedAgencies": "Dropped {count} consultancies and agencies",
  "plus.agent.step.failed": "Could not check that",
  "plus.agent.step.generated": "Prepared a draft",
  "plus.agent.step.hiring": "Checked hiring history",
  "plus.agent.step.history": "Checked the listing history",
  "plus.agent.step.limitReached": "Weekly limit reached",
  "plus.agent.step.looked": "Checked {what}",
  "plus.agent.step.matched": "Matched {count} of {total} to your profile",
  "plus.agent.step.noData": "Not enough data to show",
  "plus.agent.step.pastListings": "{count, plural, one {Found # past listing} other {Found # past listings}}",
  "plus.agent.step.profile": "Read your profile",
  "plus.agent.step.proposed": "Prepared: {what}",
  "plus.agent.step.readAd": "{count, plural, one {Read # ad} other {Read # ads}}",
  "plus.agent.step.searched": "{count, plural, one {Searched # open job} other {Searched # open jobs}}",
  "plus.agent.step.tracker": "Read your saved jobs and lists",
  "plus.agent.steps": "What Scout did",
  "plus.agent.thumbsDown": "Not useful",
  "plus.agent.thumbsUp": "Yes, useful",
  "plus.agent.unavailableBody": "Try again in a few minutes. Search still works.",
  "plus.agent.unavailableTitle": "Scout is unavailable right now",
  "plus.agent.useful": "Was this useful?",
  "plus.agent.usingChange": "Change what Scout can use",
  "plus.agent.usingHome": "Your home address, for commute times",
  "plus.agent.usingProfile": "Your profile and CV, when a question needs them",
  "plus.agent.usingTitle": "Using",
  "plus.agent.usingTracker": "Your saved jobs, to skip ones you already track",
  "plus.agent.working": "Working on it",
  "plus.agent.you": "You",
  "plus.alerts.instant.cap": "Instant covers your {limit, plural, one {oldest alert search} other {# oldest alert searches}}. The rest arrive in your daily email.",
  "plus.alerts.instant.detail": "As soon as we find a match, at most one alert every 30 minutes. Nothing between 21:00 and 7:00.",
  "plus.alerts.instant.hint": "As soon as we find it",
  "plus.alerts.instant.label": "Instant",
  "plus.alerts.instant.overview": "Instant",
  "plus.apply.address.copied": "Copied",
  "plus.apply.address.copy": "Copy",
  "plus.apply.address.error": "We couldn't get your application address. Try again in a moment.",
  "plus.apply.address.help": "Use this as your email in the form, and we'll track replies for you. Mail still comes to your own inbox.",
  "plus.apply.address.label": "Application address for this job",
  "plus.apply.address.retry": "Try again",
  "plus.apply.address.signInBody": "Use one address on applications. Replies show up in My Jobs and still land in your inbox.",
  "plus.apply.afterNote": "Come back when you've applied and we'll move this job to Applied in My Jobs.",
  "plus.apply.autofill.emailHint": "The employer gets your application address for this job. Their replies come to your own inbox and are tracked in My Jobs.",
  "plus.apply.copyKit": "Copy my answers and cover letter",
  "plus.apply.forMe.answers": "Questions answered from your answer bank",
  "plus.apply.forMe.body": "{company} uses {vendor}, which we can fill in for you. We prepare everything, you check every field, then we send it to {company}'s own form.",
  "plus.apply.forMe.cv": "Your CV and cover letter for this job",
  "plus.apply.forMe.heading": "Apply for me",
  "plus.apply.forMe.prepare": "Prepare my application",
  "plus.apply.forMe.tracked": "Replies tracked through your application address",
  "plus.apply.menuItem": "Apply with your application address",
  "plus.apply.notRead": "Not read: you've used this week's {limit} {unit}. The email was still forwarded to you.",
  "plus.apply.openSite": "Open {site}",
  "plus.apply.sheet.close": "Close",
  "plus.apply.sheet.title": "Apply to {company}",
  "plus.apply.yourself.alone": "Apply yourself on {site}",
  "plus.apply.yourself.heading": "Or apply yourself on {site}",
  "plus.apply.yourself.siteFallback": "the employer's site",
  "plus.badge.label": "Plus",
  "plus.badge.labelPro": "Pro",
  "plus.company.deepDive.adsHeader": "New ads",
  "plus.company.deepDive.criticised": "Often criticised",
  "plus.company.deepDive.filing": "Latest filed accounts",
  "plus.company.deepDive.filingRevenueOnly": "Year ending {date}: revenue {revenue}",
  "plus.company.deepDive.filingValue": "Year ending {date}: revenue {revenue}, operating profit {profit}",
  "plus.company.deepDive.form": "Company form",
  "plus.company.deepDive.form.ab": "Limited company (Ab)",
  "plus.company.deepDive.form.ky": "Limited partnership (Ky)",
  "plus.company.deepDive.form.oy": "Limited company (Oy)",
  "plus.company.deepDive.form.oyj": "Public limited company (Oyj)",
  "plus.company.deepDive.form.tmi": "Sole trader (Tmi)",
  "plus.company.deepDive.growthDown": "Down {pct}% on the three months before",
  "plus.company.deepDive.growthFlat": "About the same as the three months before",
  "plus.company.deepDive.growthUp": "Up {pct}% on the three months before",
  "plus.company.deepDive.hiringHeading": "Hiring history",
  "plus.company.deepDive.hiringSource": "JobCrawls, {window}. New ads per month at a direct employer; the latest month is not over yet.",
  "plus.company.deepDive.hiringTitle": "{ads, plural, one {# new ad} other {# new ads}} in the last 10 months",
  "plus.company.deepDive.industry": "Industry",
  "plus.company.deepDive.lifecycle.bankruptcy": "In bankruptcy",
  "plus.company.deepDive.lifecycle.ceased": "Ceased",
  "plus.company.deepDive.lifecycle.liquidation": "In liquidation",
  "plus.company.deepDive.lifecycle.registered": "Registered",
  "plus.company.deepDive.lifecycle.restructuring": "In corporate restructuring",
  "plus.company.deepDive.monthHeader": "Month",
  "plus.company.deepDive.nothingYet": "We do not have enough about this employer for a deeper look yet.",
  "plus.company.deepDive.praised": "Often praised",
  "plus.company.deepDive.registered": "Registered",
  "plus.company.deepDive.registeredValue": "{year} ({age, plural, one {# year} other {# years}} ago)",
  "plus.company.deepDive.registryHeading": "From the trade register",
  "plus.company.deepDive.registrySource": "Source: Finnish Patent and Registration Office (PRH) open data.",
  "plus.company.deepDive.sources": "Sources",
  "plus.company.deepDive.status": "Status",
  "plus.company.deepDive.statusActive": "Active, no restructuring or bankruptcy on record",
  "plus.company.deepDive.statusLifecycle": "{state}{since, select, none {} other { since {since}}}",
  "plus.company.deepDive.themesHeading": "What people say",
  "plus.company.deepDive.themesNote": "Summarised from public discussion on {date}. Opinions, not facts about the employer.",
  "plus.company.deepDive.title": "Company deep dive",
  "plus.company.hire.adsHeading": "Their ads",
  "plus.company.hire.ats": "Apply through {vendor}",
  "plus.company.hire.daysOpen": "Usually stay up {days, plural, one {# day} other {# days}}",
  "plus.company.hire.interviews": "Usually {n, plural, one {one interview} other {# interviews}}",
  "plus.company.hire.intro": "The steps their ads usually list, from {ads, plural, one {# ad} other {# ads}} in the last 10 months.",
  "plus.company.hire.kit": "Prepare with an interview kit for one of their jobs",
  "plus.company.hire.noSteps": "Their ads rarely describe the process.",
  "plus.company.hire.reposted": "Reposted {count} of {total}",
  "plus.company.hire.statesPay": "State pay {count} of {total}",
  "plus.company.hire.step.background_check": "Background check",
  "plus.company.hire.step.case_task": "Case or take-home task",
  "plus.company.hire.step.interview": "Interview",
  "plus.company.hire.step.multiple_interviews": "More than one interview",
  "plus.company.hire.step.personality": "Personality assessment",
  "plus.company.hire.step.phone_screen": "Phone or video screening",
  "plus.company.hire.step.references": "References",
  "plus.company.hire.step.test": "Test or assessment",
  "plus.company.hire.step.trial": "Trial day or period",
  "plus.company.hire.stepCount": "In {count} of {total} ads",
  "plus.company.hire.title": "Their hiring process",
  "plus.company.pillars.gradeLabel": "{name}: grade {grade}",
  "plus.company.pillars.name.benefits": "Benefits",
  "plus.company.pillars.name.flexibility": "Flexibility",
  "plus.company.pillars.name.growth": "Growth",
  "plus.company.pillars.name.pay": "Pay",
  "plus.company.pillars.name.stability": "Stability",
  "plus.company.pillars.name.transparency": "Transparency",
  "plus.company.pillars.notEnough": "Not enough data yet",
  "plus.company.pillars.reason.benefits.high": "Names more benefits than most employers.",
  "plus.company.pillars.reason.benefits.low": "Few benefits named beyond the basics.",
  "plus.company.pillars.reason.benefits.mid": "Names the usual benefits.",
  "plus.company.pillars.reason.flexibility.few": "Most roles are on site.",
  "plus.company.pillars.reason.flexibility.most": "Most roles are hybrid or remote.",
  "plus.company.pillars.reason.flexibility.some": "Some roles are hybrid or remote.",
  "plus.company.pillars.reason.growth.down": "Hiring less lately than a few months ago.",
  "plus.company.pillars.reason.growth.high": "The hiring trend and the share of senior roles point up.",
  "plus.company.pillars.reason.growth.low": "Few senior roles and little growth in new ads.",
  "plus.company.pillars.reason.growth.mid": "The hiring trend and seniority mix are about average.",
  "plus.company.pillars.reason.growth.up": "Hiring more lately than a few months ago.",
  "plus.company.pillars.reason.pay.high": "Advertised pay is at the stronger end among employers we track.",
  "plus.company.pillars.reason.pay.low": "Advertised pay is on the lower side.",
  "plus.company.pillars.reason.pay.mid": "Advertised pay is around the middle.",
  "plus.company.pillars.reason.stability.mid": "Hiring pace and company age put it around the middle.",
  "plus.company.pillars.reason.stability.reposts": "{n} of {of} ads were posted again.",
  "plus.company.pillars.reason.stability.steady": "Hiring has been steady and the company has been around a while.",
  "plus.company.pillars.reason.stability.uneven": "Hiring has been uneven, or the company is young.",
  "plus.company.pillars.reason.transparency.count": "Pay stated in {n} of {of} ads.",
  "plus.company.pillars.reason.transparency.high": "Pay and hiring steps are usually stated.",
  "plus.company.pillars.reason.transparency.low": "Pay and hiring steps are rarely stated.",
  "plus.company.pillars.reason.transparency.mid": "Pay or hiring steps are sometimes stated.",
  "plus.company.pillars.subtitle": "Each part of the Employer Score as a letter, with the reason. Computed from job data, not reviews.",
  "plus.company.pillars.title": "The score in detail",
  "plus.company.reply.basis": "Among about {applications} applications JobCrawls users tracked with us. Not everyone who applied.",
  "plus.company.reply.days": "{days, plural, one {# day} other {# days}} to a first reply, typically",
  "plus.company.reply.interview": "{n} in 10 reached an interview",
  "plus.company.reply.interviewFew": "Fewer than 1 in 10 reached an interview",
  "plus.company.reply.replied": "{n} in 10 got a reply",
  "plus.company.reply.repliedFew": "Fewer than 1 in 10 got a reply",
  "plus.company.reply.title": "How {company} replies",
  "plus.company.reply.tooFew": "Not enough JobCrawls applications to {company} yet to show how they reply.",
  "plus.company.signIn.body": "Sign in to see this employer in more detail: the score by part, how they hire and reply, and their hiring history.",
  "plus.cvExport.download": "Download",
  "plus.cvExport.downloadAria": "Download {format}",
  "plus.cvExport.europass.desc": "Europass XML to upload in the Europass CV editor. Not yet confirmed with the portal, so check the result there.",
  "plus.cvExport.europass.name": "Europass (experimental)",
  "plus.cvExport.failed": "Could not create the file. Please try again.",
  "plus.cvExport.html.desc": "One self-contained web page that prints well.",
  "plus.cvExport.html.name": "HTML",
  "plus.cvExport.intro": "Your CV is turned into the file on this device. Nothing is uploaded.",
  "plus.cvExport.jsonresume.desc": "The open JSON Resume format, read by many themes and tools.",
  "plus.cvExport.jsonresume.name": "JSON Resume",
  "plus.cvExport.latex.desc": ".tex source. Clean needs no extra packages; Classic uses moderncv.",
  "plus.cvExport.latex.name": "LaTeX",
  "plus.cvExport.markdown.desc": "Plain .md file for notes, GitHub or your own site.",
  "plus.cvExport.markdown.name": "Markdown",
  "plus.cvExport.odt.desc": ".odt text document for LibreOffice, Word and Google Docs.",
  "plus.cvExport.odt.name": "OpenDocument",
  "plus.cvExport.overleaf": "Open in Overleaf",
  "plus.cvExport.rendercv.desc": "YAML file for the RenderCV tool, which turns it into a PDF.",
  "plus.cvExport.rendercv.name": "RenderCV",
  "plus.cvExport.signInBody": "Sign in to export your CV as LaTeX, JSON Resume, Markdown and more. PDF and Word stay open to everyone.",
  "plus.cvExport.templateClassic": "Classic",
  "plus.cvExport.templateClean": "Clean",
  "plus.cvExport.templateLabel": "LaTeX template",
  "plus.cvExport.text.desc": "Simple .txt with no tables or special characters, safe to paste into forms.",
  "plus.cvExport.text.name": "Plain text",
  "plus.cvExport.title": "Other formats",
  "plus.cvVersions.readOnly": "Read-only, you can still download it",
  "plus.feature.adDecoder.body": "See what the ad really asks for, what is optional and what to ask at the interview.",
  "plus.feature.adDecoder.title": "Ad decoder",
  "plus.feature.agent.body": "Ask Scout to find and judge jobs for you, using the whole JobCrawls dataset.",
  "plus.feature.agent.title": "Ask Scout",
  "plus.feature.applicationAddress.body": "Use one address on applications. Replies show up in My Jobs and still land in your inbox.",
  "plus.feature.applicationAddress.title": "Your application address",
  "plus.feature.applicationTimeline.body": "Every step of an application in one timeline, from the first save to the answer.",
  "plus.feature.applicationTimeline.title": "Application timeline",
  "plus.feature.applyFirst.body": "Your saved jobs, ordered by which to apply to first.",
  "plus.feature.applyFirst.title": "Apply-first order",
  "plus.feature.applyForMe.body": "Fill in the application from your profile. You review everything before it is sent.",
  "plus.feature.applyForMe.title": "Apply for me",
  "plus.feature.companyDeepDive.body": "A fuller picture of an employer: hiring pace, pay and how they advertise.",
  "plus.feature.companyDeepDive.title": "Company deep dive",
  "plus.feature.cvExportFormats.body": "Export your CV as LaTeX, RenderCV, JSON Resume, Markdown, plain text, HTML or OpenDocument.",
  "plus.feature.cvExportFormats.title": "More CV file formats",
  "plus.feature.cvVersions.body": "Keep a separate CV for each kind of role you apply to.",
  "plus.feature.cvVersions.title": "More CV versions",
  "plus.feature.employerPillars.body": "See the letter grade for each part of the Employer Score, with a one-line reason.",
  "plus.feature.employerPillars.title": "Employer Score pillars",
  "plus.feature.howTheyHire.body": "How this employer usually advertises, how long ads stay up and how often roles come back.",
  "plus.feature.howTheyHire.title": "How they hire",
  "plus.feature.instantAlerts.body": "Hear about a new matching job as soon as we find it, not in tomorrow's digest. Your oldest alert searches are instant, up to your plan's limit; the rest stay in the daily email.",
  "plus.feature.instantAlerts.title": "Instant alerts",
  "plus.feature.learnNext.body": "The skills that would open the most jobs for you, based on real ads.",
  "plus.feature.learnNext.title": "What to learn next",
  "plus.feature.likelyToHire.body": "Employers whose hiring pattern suggests a role like yours may open soon.",
  "plus.feature.likelyToHire.title": "Likely to hire soon",
  "plus.feature.listingHistory.body": "When it first appeared, when we last saw it live, and whether it has been advertised before.",
  "plus.feature.listingHistory.title": "See this job's full history",
  "plus.feature.missingKeywords.body": "See which words from the ad your CV does not mention yet.",
  "plus.feature.missingKeywords.title": "Missing keywords",
  "plus.feature.moreAi.body": "Tailor more CVs and write more cover letters and interview kits every week.",
  "plus.feature.moreAi.title": "Writing help",
  "plus.feature.negotiation.body": "Prepare your ask with real pay data and a script you can adjust.",
  "plus.feature.negotiation.title": "Salary negotiation help",
  "plus.feature.offerCompare.body": "Put two offers side by side, with pay, benefits and the employer behind them.",
  "plus.feature.offerCompare.title": "Compare offers",
  "plus.feature.pastListings.body": "Read the ads this employer ran before for the same role.",
  "plus.feature.pastListings.title": "Past listings",
  "plus.feature.payDetail.body": "Compare this pay with similar roles and with what the employer paid in past listings.",
  "plus.feature.payDetail.title": "Pay in detail",
  "plus.feature.plusMcp.body": "Use JobCrawls in Claude or ChatGPT, with higher weekly limits on the account tools.",
  "plus.feature.plusMcp.title": "JobCrawls in Claude or ChatGPT",
  "plus.feature.responseStats.body": "See how employers have responded to applications tracked on JobCrawls.",
  "plus.feature.responseStats.title": "Employer response stats",
  "plus.feature.rolesYouFit.body": "Job titles you may not have searched for that match your CV.",
  "plus.feature.rolesYouFit.title": "Roles you already fit",
  "plus.feature.savedJobWatch.body": "Know when a saved job changes, closes or gets reposted.",
  "plus.feature.savedJobWatch.title": "Saved-job watch",
  "plus.feature.scout.body": "Describe what you want in your own words. Scout reads every new job and sends the ones that fit, with reasons.",
  "plus.feature.scout.title": "Scout reads new jobs for you",
  "plus.feature.sortByMatch.body": "Put the jobs that fit your CV first, and hide the ones that are not for you.",
  "plus.feature.sortByMatch.title": "Sort by match",
  "plus.feature.trackerExtras.body": "Reminders, notes and signals on every job you track.",
  "plus.feature.trackerExtras.title": "Tracker extras",
  "plus.feature.watchlistPulse.body": "A weekly read on how hiring is moving at the companies you watch.",
  "plus.feature.watchlistPulse.title": "Watchlist pulse",
  "plus.feature.yourMarket.body": "A personal report on demand, pay and competition for the roles you are after.",
  "plus.feature.yourMarket.title": "Your market",
  "plus.job.agent.hint": "Fit, pay, the employer and what to ask",
  "plus.job.agent.label": "Ask Scout about this job",
  "plus.job.archive.adAsItWas": "The ad as it was",
  "plus.job.archive.backToList": "Back to past listings",
  "plus.job.archive.closed": "Closed. This job is no longer open.",
  "plus.job.archive.employerType": "Employer type",
  "plus.job.archive.gateBody": "Sign in to read closed ads as we stored them, with the pay they stated.",
  "plus.job.archive.hiringNowTitle": "{company} is hiring now",
  "plus.job.archive.kept": "Up {from} to {to}. Kept so you can see what was asked and offered.",
  "plus.job.archive.noText": "We did not store the text of this ad.",
  "plus.job.archive.notFoundBody": "Archived ads are kept for 12 months after they close.",
  "plus.job.archive.notFoundTitle": "We no longer have this ad",
  "plus.job.archive.payStated": "Pay stated",
  "plus.job.archive.payValueRange": "{min} to {max} a month",
  "plus.job.archive.payValueSingle": "{amount} a month",
  "plus.job.archive.tellMe": "Tell me when they post a role like this",
  "plus.job.archive.textNote": "Text stored by JobCrawls while the ad was live. The original page may be gone.",
  "plus.job.archive.workMode": "Work mode",
  "plus.job.collapse": "Hide details",
  "plus.job.cv.add": "Add what you have to your CV",
  "plus.job.cv.addCv": "Add your CV",
  "plus.job.cv.addKeyword": "Add {keyword} to your CV",
  "plus.job.cv.addNote": "Only add what is true. You confirm every change before it is saved.",
  "plus.job.cv.coversAll": "Your CV covers everything this ad asks for.",
  "plus.job.cv.label": "Your CV",
  "plus.job.cv.missingTitle": "Not in your CV yet",
  "plus.job.cv.more": "and {count} more",
  "plus.job.cv.noCv": "Add your CV to see what it is missing for this ad",
  "plus.job.cv.nothingToCompare": "This ad does not list skills to compare with.",
  "plus.job.cv.summary": "Covers {covered} of {total}{missing, select, none {} other {. Missing {missing}}}",
  "plus.job.decoder.basis": "Similar ads: the same role, narrowed to level and region while there are enough, last 12 months. A comparison, not a judgement of the employer.",
  "plus.job.decoder.benefitLine": "Does not name \"{name}\". {percent}% of similar ads do.",
  "plus.job.decoder.benefitShort": "no {name} named",
  "plus.job.decoder.experienceMore": "Asks more experience than most",
  "plus.job.decoder.experienceMoreLine": "Asks for {years}+ years of experience. {percent}% of similar ads ask for {fewer} or fewer. Requirements are often a wish list, so apply if the rest fits.",
  "plus.job.decoder.experienceTypicalLine": "Asks for {years}+ years of experience, in line with similar ads (the median ask is {median}).",
  "plus.job.decoder.finnishPreferredLine": "Finnish is listed as a plus. {percent}% of similar ads list it as a plus.",
  "plus.job.decoder.finnishRequiredLine": "Finnish is listed as required. {percent}% of similar ads require it.",
  "plus.job.decoder.finnishShort": "Finnish required",
  "plus.job.decoder.label": "Next to similar ads",
  "plus.job.decoder.noPayShort": "no pay stated",
  "plus.job.decoder.payNotStatedLine": "Does not state the pay. {percent}% of similar ads do.",
  "plus.job.decoder.payStatedLine": "States the pay. {percent}% of similar ads do.",
  "plus.job.decoder.sample": "Compared with {count, plural, one {# ad} other {# ads}}",
  "plus.job.decoder.stepsInterviews": "Ads that list steps usually name {count, plural, one {# interview} other {# interviews}}.",
  "plus.job.decoder.stepsLine": "Hiring steps in the ad: {steps}.",
  "plus.job.decoder.typical": "In line with similar ads",
  "plus.job.decoder.variableLine": "Part of the pay is variable or commission{percent, select, none {} other {. {percent}% of similar ads that state pay say so too}}.",
  "plus.job.decoder.variableShort": "variable pay",
  "plus.job.expand": "Show details",
  "plus.job.heading": "Job insights",
  "plus.job.history.closed": "We last saw it live {when}. It is no longer listed.",
  "plus.job.history.employerOpen": "This employer's ads usually stay up about {days, plural, one {# day} other {# days}} ({count} closed ads).",
  "plus.job.history.employerOpenRole": "This employer's ads for this role usually stay up about {days, plural, one {# day} other {# days}} ({count} closed ads).",
  "plus.job.history.firstSeen": "First seen on the employer's own site {date}",
  "plus.job.history.how": "How we know",
  "plus.job.history.howBody": "These dates come from each time our crawler saw the ad on the employer's own site. They are facts about the ad, not a judgement of the employer. Ads can be reposted for ordinary reasons, such as a renewed round or a new budget.",
  "plus.job.history.label": "Listing history",
  "plus.job.history.lastSeen": "Last confirmed live {when}",
  "plus.job.history.noReposts": "We have not seen this ad posted before.",
  "plus.job.history.repostsCount": "{count, plural, one {Advertised once before} other {Advertised # times before}}",
  "plus.job.history.repostsDates": "{count, plural, one {Advertised once before} other {Advertised # times before}}: {dates}",
  "plus.job.history.roleOpen": "Ads for this role usually stay up about {days, plural, one {# day} other {# days}} ({count} closed ads).",
  "plus.job.history.summarySeen": "Last seen live {when}",
  "plus.job.history.summaryUp": "{days, plural, =0 {Up since today} one {Up # day} other {Up # days}}{reposts, plural, =0 {} one {, posted once before} other {, posted # times before}}",
  "plus.job.history.withheld": "Repost history is not available for this ad yet.",
  "plus.job.level.junior": "Junior",
  "plus.job.level.manager": "Manager",
  "plus.job.level.mid": "Mid-level",
  "plus.job.level.senior": "Senior",
  "plus.job.loading": "Loading",
  "plus.job.nothingToShow": "Not enough comparable data for this job yet.",
  "plus.job.page.archiveHint": "Tap a past listing to read the original ad as we stored it. Closed ads have no apply button.",
  "plus.job.page.back": "Back to the job",
  "plus.job.page.binOver": "{from} and up",
  "plus.job.page.binRange": "{from} to {to}",
  "plus.job.page.binUnder": "Under {to}",
  "plus.job.page.distributionCount": "Ads",
  "plus.job.page.distributionMiddle": "Middle half: {low} to {high}",
  "plus.job.page.distributionRange": "Pay per month",
  "plus.job.page.distributionSourceAll": "{count, plural, one {# past listing} other {# past listings}} that stated pay, last 12 months. Pay per month, before tax.",
  "plus.job.page.distributionSourceNewest": "The {count} most recent of {total} past listings that stated pay, last 12 months. Pay per month, before tax.",
  "plus.job.page.distributionTitle": "Stated pay in {count, plural, one {# ad} other {# ads}}",
  "plus.job.page.errorBody": "Try again in a moment.",
  "plus.job.page.errorTitle": "Could not load the comparison",
  "plus.job.page.filterDirect": "Direct employers",
  "plus.job.page.filterEmployer": "{company} only",
  "plus.job.page.filterLevel": "{level}",
  "plus.job.page.filterRegion": "{region}",
  "plus.job.page.filtersLabel": "Filter past listings",
  "plus.job.page.listingEarlierAd": "earlier ad for this job",
  "plus.job.page.listingOpen": "Open the archived ad: {title}, {company}",
  "plus.job.page.listingPublicSector": "public sector",
  "plus.job.page.listingRange": "range",
  "plus.job.page.listingSingleFigure": "single figure",
  "plus.job.page.listingUp": "Up {from} to {to}",
  "plus.job.page.listingsCount": "{count, plural, one {# that stated pay} other {# that stated pay}}",
  "plus.job.page.listingsEmptyBody": "Try removing a filter. Only closed ads that stated pay are listed.",
  "plus.job.page.listingsEmptyTitle": "No past listings match",
  "plus.job.page.listingsHeading": "Past listings",
  "plus.job.page.listingsUnavailableBody": "The pay comparison above still holds. Try again later.",
  "plus.job.page.listingsUnavailableTitle": "Past listings are not available right now",
  "plus.job.page.notFoundBody": "The link may be old. Search for the role again.",
  "plus.job.page.notFoundTitle": "We could not find this job",
  "plus.job.page.paginationNav": "Past listings pages",
  "plus.job.page.paginationNext": "Next",
  "plus.job.page.paginationPage": "Page {page}",
  "plus.job.page.paginationPrevious": "Previous",
  "plus.job.page.subtitle": "{role} · {region} · last 12 months",
  "plus.job.page.subtitleNoRegion": "{role} · all of Finland · last 12 months",
  "plus.job.page.thisAdPay": "This job: {pay} a month",
  "plus.job.page.title": "What this role has paid",
  "plus.job.pay.barDescription": "Typical range for this role: {low} to {high} a month, median {median}. This ad: {job}.",
  "plus.job.pay.barHigh": "Upper quarter",
  "plus.job.pay.barLow": "Lower quarter",
  "plus.job.pay.barTypical": "Typical",
  "plus.job.pay.basisEstimate": "This ad does not state its pay. The band is our estimate from {count, plural, one {# comparable ad} other {# comparable ads}}.",
  "plus.job.pay.basisStated": "{count, plural, one {# ad} other {# ads}} that stated pay{months, select, none {} other {, last {months} months}}.",
  "plus.job.pay.byLevel": "By level",
  "plus.job.pay.collectiveAgreement": "Pay follows a collective agreement: {name}.",
  "plus.job.pay.estimate": "Estimate",
  "plus.job.pay.estimateSummary": "Estimated pay, not stated in the ad",
  "plus.job.pay.fullComparison": "See the full comparison",
  "plus.job.pay.label": "Pay",
  "plus.job.pay.levelRow": "{level}: median {amount} ({count} ads)",
  "plus.job.pay.net": "About {min} to {max} a month after tax, estimated for {year}.",
  "plus.job.pay.netSingle": "About {amount} a month after tax, estimated for {year}.",
  "plus.job.pay.pastListingsLink": "{count, plural, one {# past listing} other {# past listings}}",
  "plus.job.pay.perMonth": "Pay per month, before tax.",
  "plus.job.pay.regionOnlyRow": "{region}: median {amount} ({count} ads)",
  "plus.job.pay.regionRow": "{region}: median {amount}, all of Finland {finland}",
  "plus.job.pay.scope.finland": "Same role, all of Finland",
  "plus.job.pay.scope.level": "Same role and level, all of Finland",
  "plus.job.pay.scope.levelRegion": "Same role and level in this region",
  "plus.job.pay.scope.region": "Same role in this region, all levels",
  "plus.job.pay.sectorRow": "{sector}: median {amount} ({count} ads)",
  "plus.job.pay.trendFalling": "Falling: the median went from {from} to {to} over the last four quarters.",
  "plus.job.pay.trendRising": "Rising: the median went from {from} to {to} over the last four quarters.",
  "plus.job.pay.trendSteady": "Steady: the median stayed around {to} over the last four quarters.",
  "plus.job.pay.verdict.above": "Above the usual range",
  "plus.job.pay.verdict.below": "Below the usual range",
  "plus.job.pay.verdict.within": "Within the usual range",
  "plus.job.payPage.signIn": "Sign in to see what this role has paid: the pay breakdown and the closed ads that stated their pay, with the original ads.",
  "plus.job.preview.yourPosition": "Where the pay of this job sits",
  "plus.job.rowsLabel": "Insights about this job",
  "plus.job.sector.nonprofit": "Non-profit",
  "plus.job.sector.private": "Private sector",
  "plus.job.sector.public": "Public sector",
  "plus.job.signInBody": "Sign in to see how this ad compares: the pay breakdown, its listing history and what the ad leaves out.",
  "plus.job.time.justNow": "just now",
  "plus.job.unavailable": "Could not load this right now. Try again in a moment.",
  "plus.likely.basis": "Direct employers with 3 or more past ads for the role. Recruitment agencies are left out. Based on {n} ads.",
  "plus.likely.chooseRole": "Choose a role to see which employers tend to hire it.",
  "plus.likely.error": "We could not load this list. Try again in a moment.",
  "plus.likely.gap": "Usually every {n, plural, one {month} other {# months}}.",
  "plus.likely.growing": "Growing",
  "plus.likely.growingLine": "Hiring for {role} is picking up: {recent} ads in the last 3 months, {previous} in the 3 before.",
  "plus.likely.intro": "Employers that regularly hire {role} but have nothing open right now. A pattern from their past ads, not a promise.",
  "plus.likely.introRegion": "Employers that regularly hire {role} in your region but have nothing open right now. A pattern from their past ads, not a promise.",
  "plus.likely.loading": "Looking at past ads",
  "plus.likely.myRegion": "Only my region",
  "plus.likely.none": "No clear pattern for {role} yet. Try a more general title.",
  "plus.likely.noneOpen": "None open now.",
  "plus.likely.openApplication": "They take open applications: see their open-application ad",
  "plus.likely.pattern": "Posted {role} roles in {months}.",
  "plus.likely.roleLabel": "Role",
  "plus.likely.rolePlaceholder": "For example Backend developer",
  "plus.likely.scoreLabel": "Employer Score",
  "plus.likely.show": "Show employers",
  "plus.likely.tellMe": "Tell me when they post",
  "plus.likely.tellMeHint": "Get an alert when {company} posts {role}. You can turn it off any time.",
  "plus.likely.tellMeOn": "Alert on",
  "plus.likely.tellMeOnHint": "You will be alerted when {company} posts {role}. Click to turn it off.",
  "plus.likely.title": "Likely to hire soon",
  "plus.likely.website": "Their website",
  "plus.likely.yourRoles": "Roles from your profile",
  "plus.limit.getMore": "Get more with {tier}",
  "plus.limit.left": "{remaining} of {limit} {unit} left this week",
  "plus.limit.leftCount": "{used} of {limit} {unit} in use",
  "plus.limit.reachedCount": "You've reached your limit of {limit} {unit}.",
  "plus.limit.resetsMonday": "It resets Monday, {date}.",
  "plus.limit.topTier": "This is the highest limit we offer. It resets every Monday.",
  "plus.limit.unlimited": "Unlimited",
  "plus.limit.usedWeek": "You've used this week's {limit} {unit}.",
  "plus.limitsTable.atOnce": "{unit} at a time",
  "plus.limitsTable.caption": "Limits by plan",
  "plus.limitsTable.feature": "Feature",
  "plus.limitsTable.perWeek": "{unit} per week",
  "plus.market.basis": "From {count} {population}, {window}.",
  "plus.market.email.body": "Get this summary by email every Monday, in your language.",
  "plus.market.email.off": "Done. You will not get the weekly market email any more. You can turn it back on below.",
  "plus.market.email.title": "Weekly email",
  "plus.market.fit.average": "About {average} new ads a week on average.",
  "plus.market.fit.averageLabel": "Average {value}",
  "plus.market.fit.caveat": "Summer dips are normal. We have full data from January 2026, so no year-on-year claims yet.",
  "plus.market.fit.chart": "New ads a week, last 12 weeks",
  "plus.market.fit.chartDescription": "New ads for your role by week over the last {weeks} weeks, against an average of {average}.",
  "plus.market.fit.openNow": "open now for your role",
  "plus.market.fit.scope": "For your role across Finland, all levels.",
  "plus.market.fit.thisWeek": "new this week, against {average} a week on average",
  "plus.market.fit.title": "Jobs that fit you",
  "plus.market.hire.ads": "{count, plural, one {# ad} other {# ads}}",
  "plus.market.hire.finnish": "{share} of these jobs do not require Finnish.",
  "plus.market.hire.lead": "Direct employers with the most open ads for your role first seen in the last 90 days.",
  "plus.market.hire.none": "Not enough ads to name employers yet.",
  "plus.market.hire.title": "Who hires people like you",
  "plus.market.learn.added": "Added {skill} to your CV.",
  "plus.market.learn.cv": "See which words ads ask for that your CV misses",
  "plus.market.learn.have": "I already have this: add it to my CV",
  "plus.market.learn.jobs": "about {count} open jobs",
  "plus.market.learn.lead": "Skills your CV does not show yet, by how many of your role's jobs ask for them.",
  "plus.market.learn.noCv": "Add skills to your CV and we show which ones to learn next.",
  "plus.market.learn.noPay": "Too few ads with pay to compare.",
  "plus.market.learn.none": "Nothing stands out. Your CV covers what ads for your role ask for most.",
  "plus.market.learn.pay": "Ads listing it state about {diff} more a month ({count} ads).",
  "plus.market.learn.share": "In {share} of ads for your role.",
  "plus.market.learn.title": "What to learn next",
  "plus.market.learned.basis": "From {count, plural, one {# answer} other {# answers}}",
  "plus.market.learned.empty": "Nothing yet. Tell us when a job is not for you and it moves lower next time.",
  "plus.market.learned.remove": "Remove",
  "plus.market.learned.reset": "Reset what it has learned",
  "plus.market.learned.title": "What your match has learned",
  "plus.market.learned.toggle": "Change or reset",
  "plus.market.learnedItem.consulting": "Fewer consultancies",
  "plus.market.learnedItem.needsFinnish": "Fewer jobs that need Finnish",
  "plus.market.learnedItem.payTooLow": "Fewer jobs that pay as little as the ones you passed on",
  "plus.market.learnedItem.tooFar": "Fewer on-site jobs in the regions you said are too far",
  "plus.market.learnedItem.tooJunior": "Fewer jobs at this level or below",
  "plus.market.learnedItem.tooSenior": "Fewer jobs at this level or above",
  "plus.market.learnedItem.wrongCompany": "Fewer employers like the ones you passed on",
  "plus.market.noRole.body": "Add a job title you want, or your current one, to your profile. We read the market for that role. We only cover roles with enough ads to say something real.",
  "plus.market.noRole.cta": "Open my profile",
  "plus.market.noRole.title": "Tell us the role you are after",
  "plus.market.notForMe.close": "Close",
  "plus.market.notForMe.open": "Not for me because...",
  "plus.market.notForMe.saveFailed": "Could not save that. Try again.",
  "plus.market.notForMe.toast": "Got it. Showing {what} lower.",
  "plus.market.notForMe.undo": "Undo",
  "plus.market.page.allFinland": "All of Finland",
  "plus.market.page.error": "Your market could not be loaded just now. Try again in a moment.",
  "plus.market.page.loading": "Reading the market for your profile...",
  "plus.market.page.retry": "Try again",
  "plus.market.page.subtitle": "{role} · {place} · week of {date}",
  "plus.market.page.title": "Your market",
  "plus.market.pay.barDescription": "{basis, select, official {Your role: {low} to {high} a month, median {median}. Your current pay: {mine}.} other {Ads for your role: {low} to {high} a month, median {median}. Your current pay: {mine}.}}",
  "plus.market.pay.check.about": "{basis, select, official {About {tenths} in 10 people in your role earn more than your current pay.} other {About {tenths} in 10 of these ads state more than your current pay.}}",
  "plus.market.pay.check.atLeast": "{basis, select, official {More than 3 in 4 people in your role earn more than your current pay.} other {More than 3 in 4 of these ads state more than your current pay.}}",
  "plus.market.pay.check.atMost": "{basis, select, official {Fewer than 1 in 4 people in your role earn more than your current pay.} other {Fewer than 1 in 4 of these ads state more than your current pay.}}",
  "plus.market.pay.check.link": "Add current pay",
  "plus.market.pay.check.missing": "Add your current pay in your profile to see where it sits. It stays private.",
  "plus.market.pay.check.private": "Your current pay is private and only used here. The share is read from the quartiles, so it is approximate.",
  "plus.market.pay.median": "{basis, select, official {Your role {scope} pays a median of {median} a month, mostly between {low} and {high}.} other {Ads for your role {scope} state a typical {median} a month, mostly between {low} and {high}.}}",
  "plus.market.pay.none": "Too few ads state pay for your role to show a figure we can stand behind.",
  "plus.market.pay.population": "ads that stated pay",
  "plus.market.pay.scope.finland": "in Finland",
  "plus.market.pay.scope.level": "at your level",
  "plus.market.pay.scope.levelRegion": "at your level in your region",
  "plus.market.pay.scope.region": "in your region",
  "plus.market.pay.title": "Your pay against the market",
  "plus.market.preview.body": "See the market for the role you are after: how many jobs fit you each week, what they pay compared with your pay, who is hiring and what to learn next.",
  "plus.market.preview.fit": "Jobs that fit you, week by week",
  "plus.market.preview.hire": "Who hires people like you",
  "plus.market.preview.learn": "Skills to learn next and roles you already fit",
  "plus.market.preview.pay": "Your pay against ads that state pay",
  "plus.market.preview.signIn": "Sign in to see your market",
  "plus.market.preview.title": "See your own market",
  "plus.market.reason.consulting": "Consulting",
  "plus.market.reason.needsFinnish": "Needs Finnish",
  "plus.market.reason.payTooLow": "Pay too low",
  "plus.market.reason.tooFar": "Too far",
  "plus.market.reason.tooJunior": "Too junior",
  "plus.market.reason.tooSenior": "Too senior",
  "plus.market.reason.wrongCompany": "Wrong kind of company",
  "plus.market.roles.lead": "Other titles whose ads ask for what your CV has.",
  "plus.market.roles.missing": "missing: {skills}",
  "plus.market.roles.none": "No other title stands out yet.",
  "plus.market.roles.open": "{count} open",
  "plus.market.roles.overlap": "{share} overlap",
  "plus.market.roles.pay": "typical {pay}",
  "plus.market.roles.title": "Roles you already fit",
  "plus.market.sort.chip": "Best match",
  "plus.market.sort.hintOff": "Puts the jobs that fit your profile first. You choose what to show lower.",
  "plus.market.sort.hintOn": "Jobs that fit your profile come first. Nothing is hidden, and this looks at the {count} best-ranked results.",
  "plus.market.sort.noProfile": "Add your profile so we can tell what fits.",
  "plus.market.what.consulting": "consultancies",
  "plus.market.what.needsFinnish": "jobs that need Finnish",
  "plus.market.what.payTooLow": "pay like this or lower",
  "plus.market.what.tooFar": "jobs in this region",
  "plus.market.what.tooJunior": "jobs at this level or below",
  "plus.market.what.tooSenior": "jobs at this level or above",
  "plus.market.what.wrongCompany": "this kind of company",
  "plus.menu.scout.note": "picks for you each day",
  "plus.myjobs.applyFirst.deadline": "Closes in {hours, plural, one {# hour} other {# hours}}",
  "plus.myjobs.applyFirst.deadline.text": "The bar shows how far the ad is to its deadline.",
  "plus.myjobs.applyFirst.deadlineDays": "Closes in {days, plural, one {# day} other {# days}}",
  "plus.myjobs.applyFirst.lifetime": "Day {day}",
  "plus.myjobs.applyFirst.lifetime.basis": "Based on {count} closed ads, {window}.",
  "plus.myjobs.applyFirst.lifetime.text": "Half of ads like this are gone by day {median}.",
  "plus.myjobs.compare.aboutNet": "about {amount}",
  "plus.myjobs.compare.benefitGap": "{company}'s offer has none of: {missing}.",
  "plus.myjobs.compare.caption": "Your offers side by side",
  "plus.myjobs.compare.close": "Close",
  "plus.myjobs.compare.commute.loading": "Working it out",
  "plus.myjobs.compare.commute.needsHome": "Add your home address in your profile",
  "plus.myjobs.compare.commute.unknown": "Not available",
  "plus.myjobs.compare.commuteMin": "{minutes} min",
  "plus.myjobs.compare.decide": "Before you decide",
  "plus.myjobs.compare.error": "The comparison did not load",
  "plus.myjobs.compare.footnote": "Pay, holidays, benefits and trial period come from what you entered for each offer. After-tax figures are estimates, using {basis}. Commute is from your home address by your preferred way of travelling.",
  "plus.myjobs.compare.footnote.average": "the national average tax rate where no municipality was entered",
  "plus.myjobs.compare.footnote.municipality": "the tax rate of the municipality you entered, or the national average where you left it out",
  "plus.myjobs.compare.holidayDays": "{days} days",
  "plus.myjobs.compare.holidayGap": "{highCompany} gives {days, plural, one {# more holiday day} other {# more holiday days}} than {lowCompany}.",
  "plus.myjobs.compare.item": "Item",
  "plus.myjobs.compare.marketBasis": "{basis, select, official {{company}: Statistics Finland’s earnings for the occupation raised to today, with the differences from {count} ads that stated pay, {window}.} other {{company}: based on {count} ads that stated pay, {window}.}}",
  "plus.myjobs.compare.needTwo": "Comparison starts with two offers",
  "plus.myjobs.compare.needTwo.body": "Move two applications to Offer and enter what each offer says. Then they line up here.",
  "plus.myjobs.compare.negotiate": "Write that reply with the negotiation assistant",
  "plus.myjobs.compare.noGrade": "Not rated yet",
  "plus.myjobs.compare.noMarket": "Not enough ads to compare",
  "plus.myjobs.compare.notEntered": "Not entered",
  "plus.myjobs.compare.officeDays": "{days, plural, =0 {Fully remote} one {# day a week} other {# days a week}}",
  "plus.myjobs.compare.payGap": "{lowCompany}'s offer is {gap} a month lower than {highCompany}'s. Asking {lowCompany} for {target}, halfway between the two, is a fair place to start.",
  "plus.myjobs.compare.perMonth": "{amount} a month",
  "plus.myjobs.compare.retry": "Try again",
  "plus.myjobs.compare.row.benefits": "Benefits",
  "plus.myjobs.compare.row.commute": "Commute",
  "plus.myjobs.compare.row.holidays": "Holiday days",
  "plus.myjobs.compare.row.market": "Against the market",
  "plus.myjobs.compare.row.net": "After tax",
  "plus.myjobs.compare.row.notes": "Your notes",
  "plus.myjobs.compare.row.office": "Office days",
  "plus.myjobs.compare.row.pay": "Monthly pay",
  "plus.myjobs.compare.row.score": "Employer Score",
  "plus.myjobs.compare.row.trial": "Trial period",
  "plus.myjobs.compare.title": "Offer comparison",
  "plus.myjobs.compare.trialMonths": "{months, plural, one {# month} other {# months}}",
  "plus.myjobs.compare.verdict.above": "Above typical",
  "plus.myjobs.compare.verdict.below": "Below typical",
  "plus.myjobs.compare.verdict.nearHigh": "Just above typical",
  "plus.myjobs.compare.verdict.nearLow": "A little under typical",
  "plus.myjobs.compare.verdict.typical": "Typical",
  "plus.myjobs.debrief.feeling": "How it felt",
  "plus.myjobs.debrief.feeling.bad": "Not great",
  "plus.myjobs.debrief.feeling.good": "Good",
  "plus.myjobs.debrief.feeling.mixed": "Mixed",
  "plus.myjobs.debrief.notes": "What was asked, what you said, what you want to remember",
  "plus.myjobs.debrief.save": "Save notes",
  "plus.myjobs.debrief.saved": "Notes saved to the timeline.",
  "plus.myjobs.debrief.skip": "Not now",
  "plus.myjobs.debrief.thankYou": "Draft a thank-you",
  "plus.myjobs.debrief.title": "How did the interview on {date} go?",
  "plus.myjobs.draft.again": "Write it again",
  "plus.myjobs.draft.body": "Message",
  "plus.myjobs.draft.check": "Check the dates and names before you send it.",
  "plus.myjobs.draft.close": "Close",
  "plus.myjobs.draft.copied": "Copied",
  "plus.myjobs.draft.copy": "Copy",
  "plus.myjobs.draft.failed": "The draft did not work this time",
  "plus.myjobs.draft.failedBody": "Nothing was sent anywhere. Try again in a moment.",
  "plus.myjobs.draft.generate": "Write the draft",
  "plus.myjobs.draft.intro": "We write a short draft from your tracker. You read it, change it and send it from your own email.",
  "plus.myjobs.draft.mention": "Anything you want it to mention? (optional)",
  "plus.myjobs.draft.openMail": "Open in my email",
  "plus.myjobs.draft.subject": "Subject",
  "plus.myjobs.draft.title.feedback": "Ask for feedback",
  "plus.myjobs.draft.title.followUp": "Follow-up email",
  "plus.myjobs.draft.title.thankYou": "Thank-you email",
  "plus.myjobs.draft.working": "Writing the draft",
  "plus.myjobs.extras.cancel": "Cancel",
  "plus.myjobs.extras.contact": "Contact person",
  "plus.myjobs.extras.contact.email": "Email",
  "plus.myjobs.extras.contact.name": "Name",
  "plus.myjobs.extras.contact.phone": "Phone",
  "plus.myjobs.extras.contact.role": "Role",
  "plus.myjobs.extras.followUp": "Follow-up reminder",
  "plus.myjobs.extras.followUp.clear": "Clear reminder",
  "plus.myjobs.extras.followUp.date": "Or pick a date",
  "plus.myjobs.extras.followUp.in14": "In 2 weeks",
  "plus.myjobs.extras.followUp.in3": "In 3 days",
  "plus.myjobs.extras.followUp.in7": "In 1 week",
  "plus.myjobs.extras.followUp.set": "We will remind you on {date}.",
  "plus.myjobs.extras.heading": "Tracker tools",
  "plus.myjobs.extras.interviews": "Interviews",
  "plus.myjobs.extras.interviews.add": "Add an interview",
  "plus.myjobs.extras.interviews.calendar": "Add to calendar",
  "plus.myjobs.extras.interviews.date": "Date",
  "plus.myjobs.extras.interviews.place": "Place or video link",
  "plus.myjobs.extras.interviews.remind": "Remind me",
  "plus.myjobs.extras.interviews.remind.1d": "1 day before",
  "plus.myjobs.extras.interviews.remind.1h": "1 hour before",
  "plus.myjobs.extras.interviews.remind.3h": "3 hours before",
  "plus.myjobs.extras.interviews.remind.none": "No reminder",
  "plus.myjobs.extras.interviews.remove": "Remove interview",
  "plus.myjobs.extras.interviews.save": "Save interview",
  "plus.myjobs.extras.interviews.time": "Time",
  "plus.myjobs.extras.notes": "Dated notes",
  "plus.myjobs.extras.notes.add": "Add note",
  "plus.myjobs.extras.notes.hint": "Only you see these. They appear on the timeline.",
  "plus.myjobs.extras.notes.label": "New note",
  "plus.myjobs.extras.notes.remove": "Remove note",
  "plus.myjobs.extras.signals": "On this listing",
  "plus.myjobs.extras.timeline": "Open timeline",
  "plus.myjobs.limit.daily": "That is enough for today. Try again tomorrow.",
  "plus.myjobs.negotiation.adRange": "Their ad said {range}.",
  "plus.myjobs.negotiation.alsoAsk": "Also worth asking about",
  "plus.myjobs.negotiation.ask": "Asking for {ask} stays {inside}.",
  "plus.myjobs.negotiation.ask.insideAd": "inside their own range",
  "plus.myjobs.negotiation.ask.insideMarket": "inside what the role pays",
  "plus.myjobs.negotiation.atTop": "This offer is already at the top of what we can ground an ask in. The other items below may still be worth agreeing in writing.",
  "plus.myjobs.negotiation.basis": "Based on {count} similar ads that stated pay, {window}.",
  "plus.myjobs.negotiation.built": "Built only from the ad, your offer and our pay data. Check the figures before you send it.",
  "plus.myjobs.negotiation.check": "Check your offer",
  "plus.myjobs.negotiation.close": "Close",
  "plus.myjobs.negotiation.copied": "Copied",
  "plus.myjobs.negotiation.copy": "Copy",
  "plus.myjobs.negotiation.error": "We could not check this offer",
  "plus.myjobs.negotiation.failed": "The rewording did not work this time",
  "plus.myjobs.negotiation.item.base": "Base salary",
  "plus.myjobs.negotiation.item.benefits": "Benefits",
  "plus.myjobs.negotiation.item.benefits.ad": "The ad lists: {value}. Ask which of them apply to you.",
  "plus.myjobs.negotiation.item.benefits.none": "Not listed in the ad. Ask about lunch, sport and culture, commuting or bike benefit, and occupational health.",
  "plus.myjobs.negotiation.item.holidays": "Holidays",
  "plus.myjobs.negotiation.item.holidays.body": "The law and the collective agreement set the minimum; extra days or unpaid leave can be agreed.",
  "plus.myjobs.negotiation.item.notice": "Notice period",
  "plus.myjobs.negotiation.item.notice.body": "Check what your current contract requires and when you can really start.",
  "plus.myjobs.negotiation.item.remote": "Remote days",
  "plus.myjobs.negotiation.item.remote.ad": "The ad says {value}; agree the number of office days in writing.",
  "plus.myjobs.negotiation.item.remote.none": "The ad does not say. Agree the number of office days in writing.",
  "plus.myjobs.negotiation.item.start": "Start date and trial period",
  "plus.myjobs.negotiation.item.start.body": "Your notice period, and whether the trial period is the full six months. A trial period is at most six months and shorter if the contract is short.",
  "plus.myjobs.negotiation.item.training": "Training budget",
  "plus.myjobs.negotiation.item.training.ad": "The ad mentions: {value}.",
  "plus.myjobs.negotiation.item.training.none": "Not mentioned in the ad. Ask whether there is a yearly budget for courses or conferences.",
  "plus.myjobs.negotiation.needOffer": "Enter the monthly salary they offered to get started.",
  "plus.myjobs.negotiation.noAsk": "We have no figure to base a higher ask on, so the script asks whether there is room to talk.",
  "plus.myjobs.negotiation.noMarket": "There are too few similar ads with pay to compare this offer. The ad and your own figures are all the script uses.",
  "plus.myjobs.negotiation.offered": "Monthly salary they offered (EUR, before tax)",
  "plus.myjobs.negotiation.retry": "Try again",
  "plus.myjobs.negotiation.reword": "Reword it",
  "plus.myjobs.negotiation.script": "What you could say",
  "plus.myjobs.negotiation.script.language": "Script language",
  "plus.myjobs.negotiation.shorter": "Make it shorter",
  "plus.myjobs.negotiation.tes": "The ad names a collective agreement: {name}. Pay tables from it are not used here, so check the minimum pay for your role in the agreement itself.",
  "plus.myjobs.negotiation.title": "Salary negotiation assistant",
  "plus.myjobs.negotiation.update": "Check this figure",
  "plus.myjobs.negotiation.verdict.above": "Above the typical range",
  "plus.myjobs.negotiation.verdict.below": "Below the typical range",
  "plus.myjobs.negotiation.verdict.nearHigh": "A little over the typical {median}",
  "plus.myjobs.negotiation.verdict.nearLow": "A little under the typical {median}",
  "plus.myjobs.negotiation.verdict.typical": "Close to the typical {median}",
  "plus.myjobs.negotiation.whereItSits": "Where it sits",
  "plus.myjobs.negotiation.working": "Rewording the script",
  "plus.myjobs.negotiationButton.open": "Check an offer for this job",
  "plus.myjobs.offer.benefits": "Benefits, separated by commas",
  "plus.myjobs.offer.compare": "Compare offers",
  "plus.myjobs.offer.gross": "Monthly pay before tax (EUR)",
  "plus.myjobs.offer.heading": "Your offer",
  "plus.myjobs.offer.hint": "Enter what the offer says. We use it to compare offers and to prepare a counter. Only you see it.",
  "plus.myjobs.offer.holidays": "Holiday days a year",
  "plus.myjobs.offer.municipality": "Where you live (for the after-tax estimate)",
  "plus.myjobs.offer.negotiate": "Prepare a counter",
  "plus.myjobs.offer.office": "Office days a week",
  "plus.myjobs.offer.save": "Save offer details",
  "plus.myjobs.offer.saved": "Saved.",
  "plus.myjobs.offer.trial": "Trial period (months)",
  "plus.myjobs.panel.compare": "Compare offers",
  "plus.myjobs.panel.export": "Export tracker (CSV)",
  "plus.myjobs.panel.label": "Tools for My Jobs",
  "plus.myjobs.panel.signedOut": "Sort saved jobs by what closes first, set reminders, keep notes and interview dates, and compare offers. Free with an account.",
  "plus.myjobs.panel.watchCap": "Closing-soon notes cover {limit} of your {saved} saved jobs.",
  "plus.myjobs.reminder.debrief": "How did the interview go? Note it down while it is fresh.",
  "plus.myjobs.reminder.followUp": "Follow up. You set this reminder {days, plural, =0 {for today} one {for yesterday} other {# days ago}}.",
  "plus.myjobs.reminder.interview": "Interview {when}",
  "plus.myjobs.timeline.close": "Close",
  "plus.myjobs.timeline.error": "The timeline did not load",
  "plus.myjobs.timeline.error.body": "Your tracker is fine. Try again in a moment.",
  "plus.myjobs.timeline.event.applied": "Marked as applied",
  "plus.myjobs.timeline.event.appliedAutofill": "Applied with Apply for me",
  "plus.myjobs.timeline.event.appliedExternal": "Applied on the employer site",
  "plus.myjobs.timeline.event.debrief": "Interview notes",
  "plus.myjobs.timeline.event.emailInfo": "The employer asked for more information",
  "plus.myjobs.timeline.event.emailInvite": "Interview invite",
  "plus.myjobs.timeline.event.emailOffer": "Offer",
  "plus.myjobs.timeline.event.emailOther": "Email from the employer",
  "plus.myjobs.timeline.event.emailReceived": "Application received",
  "plus.myjobs.timeline.event.emailRejection": "Rejection",
  "plus.myjobs.timeline.event.from": "From {name}",
  "plus.myjobs.timeline.event.interview": "Interview",
  "plus.myjobs.timeline.event.note": "Your note",
  "plus.myjobs.timeline.event.postedAgain": "The ad was posted again",
  "plus.myjobs.timeline.event.reminder": "Follow-up reminder",
  "plus.myjobs.timeline.event.saved": "Saved",
  "plus.myjobs.timeline.event.takenDown": "The employer took the ad down",
  "plus.myjobs.timeline.history": "Everything so far",
  "plus.myjobs.timeline.next": "Suggested next steps",
  "plus.myjobs.timeline.noMail": "Replies from the employer to your JobCrawls application address will show up here.",
  "plus.myjobs.timeline.retry": "Try again",
  "plus.myjobs.timeline.source.listing": "The job listing",
  "plus.myjobs.timeline.source.mail": "Application address",
  "plus.myjobs.timeline.source.tracker": "Your tracker",
  "plus.myjobs.timeline.source.you": "You added this",
  "plus.myjobs.timeline.stands": "Where it stands",
  "plus.myjobs.timeline.status.appliedQuiet": "No reply in {workingDays} working days.",
  "plus.myjobs.timeline.status.appliedWaiting": "Applied {workingDays, plural, =0 {today} one {# working day ago} other {# working days ago}}. Nothing from the employer yet.",
  "plus.myjobs.timeline.status.hired": "You got the job.",
  "plus.myjobs.timeline.status.infoRequest": "The employer asked for more information, waiting on you.",
  "plus.myjobs.timeline.status.interviewDone": "Interview done. Note how it went while it is fresh.",
  "plus.myjobs.timeline.status.interviewUpcoming": "Interview {when}.",
  "plus.myjobs.timeline.status.inviteWaiting": "Interview invite for {when}, waiting on your reply.",
  "plus.myjobs.timeline.status.inviteWaitingNoDate": "Interview invite, waiting on your reply.",
  "plus.myjobs.timeline.status.offer": "You have an offer. Compare it, counter it or answer.",
  "plus.myjobs.timeline.status.postedAgain": "The ad was posted again. Ask before applying twice.",
  "plus.myjobs.timeline.status.rejected": "The employer said no. You can ask for feedback.",
  "plus.myjobs.timeline.status.saved": "You saved this job and have not applied yet.",
  "plus.myjobs.timeline.status.takenDown": "The employer took the ad down {days, plural, =0 {the same day you applied} one {# day after you applied} other {# days after you applied}}.",
  "plus.myjobs.timeline.step.compare": "Compare offers",
  "plus.myjobs.timeline.step.counter": "Prepare a counter",
  "plus.myjobs.timeline.step.debrief": "Note how the interview went.",
  "plus.myjobs.timeline.step.dismiss": "Not now",
  "plus.myjobs.timeline.step.feedback": "Ask what you could do better next time. Most employers answer a polite request.",
  "plus.myjobs.timeline.step.feedback.draft": "Draft a feedback request",
  "plus.myjobs.timeline.step.followUp": "No reply in {workingDays} working days. A short follow-up is fair now.",
  "plus.myjobs.timeline.step.followUp.draft": "Draft a follow-up",
  "plus.myjobs.timeline.step.offer": "An offer is waiting for your answer.",
  "plus.myjobs.timeline.step.prepare": "Prepare for the interview.",
  "plus.myjobs.timeline.step.prepareKit": "Build the interview kit",
  "plus.myjobs.timeline.step.reply": "The employer asked for something. Reply from your own email.",
  "plus.myjobs.timeline.step.similar": "Open jobs like this one",
  "plus.myjobs.timeline.step.similar.empty": "We found no similar open jobs from other employers right now.",
  "plus.myjobs.timeline.title": "Application timeline",
  "plus.myjobs.upNext.closesSoon": "Closes in {hours} h. You have not applied yet.",
  "plus.myjobs.upNext.closesTomorrow": "Closes tomorrow. You saved it but have not applied.",
  "plus.myjobs.upNext.lifetime": "Day {daysUp} of about {typicalDays} for ads like this",
  "plus.myjobs.upNext.postedAgain": "Posted again. Ask before applying twice.",
  "plus.myjobs.upNext.takenDown": "The employer took the ad down {days, plural, =0 {the same day} one {# day} other {# days}} after you applied",
  "plus.myjobs.watch.closesSoon": "Closes in {hours} h",
  "plus.myjobs.watch.closesSoon.detail": "Closes in about {hours} hours. You have not applied yet.",
  "plus.myjobs.watch.closesTomorrow": "Closes tomorrow",
  "plus.myjobs.watch.closesTomorrow.detail": "Closes tomorrow. You have not applied yet.",
  "plus.myjobs.watch.lifetime": "Day {daysUp} of about {typicalDays}",
  "plus.myjobs.watch.lifetime.basis": "Based on {count} closed ads for this role, {window}.",
  "plus.myjobs.watch.lifetime.detail": "No deadline. Ads for this role usually stay up about {typicalDays} days; this one has been up {daysUp}.",
  "plus.myjobs.watch.openNewListing": "Open the new listing",
  "plus.myjobs.watch.postedAgain": "Posted again",
  "plus.myjobs.watch.postedAgain.detail": "Posted again with a new listing. Your application may still be in their system; ask before applying twice.",
  "plus.myjobs.watch.takenDown": "Employer took it down",
  "plus.myjobs.watch.takenDown.detail": "The employer took this ad down {days, plural, =0 {the same day you applied} one {# day after you applied} other {# days after you applied}}. Interviews may already be underway; a short follow-up email is worth sending.",
  "plus.scout.chip.agencies": "No recruitment agencies",
  "plus.scout.chip.commute": "{minutes} min from {place}",
  "plus.scout.chip.consulting": "No consultancies",
  "plus.scout.chip.cycling": "{minutes} min from {place} by bike",
  "plus.scout.chip.driving": "{minutes} min from {place} by car",
  "plus.scout.chip.fields": "{names}",
  "plus.scout.chip.finnish": "Finnish not required",
  "plus.scout.chip.jobTypes": "{names}",
  "plus.scout.chip.levels": "Level: {names}",
  "plus.scout.chip.noOffice": "No office days",
  "plus.scout.chip.officeDays": "Max {days} office days",
  "plus.scout.chip.pay": "{amount}+ a month",
  "plus.scout.chip.regions": "In {names}",
  "plus.scout.chip.remoteness": "{names}",
  "plus.scout.chip.transit": "{minutes} min from {place} by public transport",
  "plus.scout.chip.walking": "{minutes} min from {place} on foot",
  "plus.scout.error.body": "Please try again in a moment.",
  "plus.scout.error.retry": "Try again",
  "plus.scout.error.title": "Scout could not load",
  "plus.scout.hub.body": "{count, plural, one {# pick today} other {# picks today}}. Scout reads new jobs for you.",
  "plus.scout.hub.open": "Open Scout",
  "plus.scout.hub.setup": "Tell Scout what you want and it reads every new job for you.",
  "plus.scout.hub.title": "Scout",
  "plus.scout.inbox.briefTitle": "What you told Scout",
  "plus.scout.inbox.capReached": "Scout has paused for today. It carries on tomorrow.",
  "plus.scout.inbox.earlier": "Earlier picks",
  "plus.scout.inbox.edit": "Edit",
  "plus.scout.inbox.fromNewJobs": "from {count, number} new jobs",
  "plus.scout.inbox.noAlerts": "Picks only show here. To get them by email or notification, turn on job alerts.",
  "plus.scout.inbox.noAlertsCta": "Turn on alerts",
  "plus.scout.inbox.noBriefBody": "Write it like you would tell a friend who works in recruiting. Finnish, Swedish or English all work.",
  "plus.scout.inbox.noBriefCta": "Set up Scout",
  "plus.scout.inbox.noBriefTitle": "Tell Scout what you are after",
  "plus.scout.inbox.noPicks": "No picks yet today. Scout checks every new job as it appears and tells you when one fits.",
  "plus.scout.inbox.paused": "Scout is paused",
  "plus.scout.inbox.pausedBody": "It is not reading new jobs. Your brief is kept.",
  "plus.scout.inbox.pausedUntilMonday": "Scout is paused until Monday. You've used this week's {limit, plural, one {# ad read} other {# ad reads}}.",
  "plus.scout.inbox.readsAs": "Scout reads this as:",
  "plus.scout.inbox.resume": "Resume Scout",
  "plus.scout.inbox.todayPicks": "Today: {count, plural, one {# pick} other {# picks}}",
  "plus.scout.monday.deadline": "Closes in {hours, plural, one {# hour} other {# hours}}",
  "plus.scout.monday.deadlineDays": "Closes in {days, plural, one {# day} other {# days}}",
  "plus.scout.monday.open": "Open",
  "plus.scout.monday.saved": "You saved this",
  "plus.scout.monday.scoutStrong": "Scout: strong fit",
  "plus.scout.monday.scoutWorth": "Scout: worth a look",
  "plus.scout.monday.subtitle": "Up to five jobs worth applying to this week.",
  "plus.scout.monday.title": "Your week",
  "plus.scout.page.subtitle": "Scout reads every new job against what you asked for and tells you which ones fit, with reasons from the ad.",
  "plus.scout.page.title": "Scout",
  "plus.scout.pick.check": "Check: {text}",
  "plus.scout.pick.dealbreaker": "Possible dealbreaker: {text}",
  "plus.scout.pick.found": "found {ago}",
  "plus.scout.pick.notForMe": "Not for me",
  "plus.scout.pick.payEstimate": "estimated {range}",
  "plus.scout.pick.payNotStated": "pay not stated",
  "plus.scout.pick.quoteLabel": "From the ad",
  "plus.scout.pick.save": "Save",
  "plus.scout.pick.saveFailed": "Could not save this job. Try again.",
  "plus.scout.pick.saved": "Saved",
  "plus.scout.pick.see": "See the job",
  "plus.scout.reason.company": "Wrong kind of company",
  "plus.scout.reason.editHint": "You can change it in your brief.",
  "plus.scout.reason.gotIt": "Got it. Scout has added that to your brief.",
  "plus.scout.reason.gotItNothing": "Got it. This pick is hidden.",
  "plus.scout.reason.gotItOfficeDays": "Got it. Scout will skip ads with {days} or more office days, and has added that to your brief.",
  "plus.scout.reason.level": "Too senior or junior",
  "plus.scout.reason.officeDays": "Too many office days",
  "plus.scout.reason.other": "Something else",
  "plus.scout.reason.title": "What was wrong with it?",
  "plus.scout.rule.agency": "Recruitment agency",
  "plus.scout.rule.commute": "Too far from {place}",
  "plus.scout.rule.commuteNoPlace": "Too far away",
  "plus.scout.rule.consulting": "Consulting or agency",
  "plus.scout.rule.dealbreaker": "Broke one of your rules",
  "plus.scout.rule.field": "Outside your field",
  "plus.scout.rule.finnish": "Finnish required",
  "plus.scout.rule.jobType": "Wrong kind of contract",
  "plus.scout.rule.level": "Wrong level",
  "plus.scout.rule.notAFit": "Not what you described",
  "plus.scout.rule.officeDays": "{days} or more office days",
  "plus.scout.rule.officeDaysNoLimit": "Too many office days",
  "plus.scout.rule.pay": "Pay stated under {amount}",
  "plus.scout.rule.payNoAmount": "Pay under your minimum",
  "plus.scout.rule.region": "Outside your area",
  "plus.scout.rule.remoteness": "Wrong work mode",
  "plus.scout.setup.addButton": "Add",
  "plus.scout.setup.addPlaceholder": "For example: small team",
  "plus.scout.setup.addPreference": "Add a line",
  "plus.scout.setup.briefCount": "{count} / {max}",
  "plus.scout.setup.briefLabel": "Your brief",
  "plus.scout.setup.briefPlaceholder": "For example: Backend role at a product company, not consulting. Real hybrid, two office days at most. Finnish not required. At least 5,000 euros a month.",
  "plus.scout.setup.commuteFailed": "Scout could not draw the area around {place}, so there is no commute rule yet.",
  "plus.scout.setup.commuteNoMap": "The map is not available right now, so there is no commute rule yet.",
  "plus.scout.setup.commutePrivacy": "Scout stores the area, not the address.",
  "plus.scout.setup.commuteRetry": "Try again",
  "plus.scout.setup.commuteWorking": "Drawing the area around {place}",
  "plus.scout.setup.delete": "Delete my brief",
  "plus.scout.setup.deleteConfirm": "Delete the brief and stop Scout? Past picks stay in your inbox for 30 days.",
  "plus.scout.setup.deleteNo": "Keep it",
  "plus.scout.setup.deleteYes": "Yes, delete",
  "plus.scout.setup.deliveryChannels": "Email and notifications follow your job alert settings.",
  "plus.scout.setup.deliveryDaily": "Once a day",
  "plus.scout.setup.deliveryDailyHint": "One message a morning with the day's picks.",
  "plus.scout.setup.deliveryHeading": "Tell me about picks",
  "plus.scout.setup.deliveryInbox": "Only in the app",
  "plus.scout.setup.deliveryInboxHint": "Picks wait here. No emails or notifications.",
  "plus.scout.setup.deliveryLabel": "How to tell you about picks",
  "plus.scout.setup.deliveryNow": "Right away",
  "plus.scout.setup.deliveryNowHint": "At most one message every 30 minutes, and none between 21:00 and 07:00.",
  "plus.scout.setup.dryRunApprox": "about {picks, number} picks from {total, number} new jobs",
  "plus.scout.setup.dryRunFailed": "Could not try the rules right now.",
  "plus.scout.setup.dryRunLoading": "Trying your rules on the last 7 days",
  "plus.scout.setup.dryRunLooser": "Without \"{rule}\": {adds, plural, one {+# pick} other {+# picks}}",
  "plus.scout.setup.dryRunNote": "This counts ads your rules let through. Scout then reads each one, so the real number of picks is lower.",
  "plus.scout.setup.dryRunOffice": "Office days are checked when Scout reads each ad, so they are not in this count.",
  "plus.scout.setup.dryRunRate": "About {perDay, number} a day. Loosen a rule if you want more.",
  "plus.scout.setup.dryRunResult": "{picks, plural, one {# pick} other {# picks}} from {total, number} new jobs",
  "plus.scout.setup.dryRunTitle": "Tried on the last 7 days",
  "plus.scout.setup.editTitle": "Your Scout brief",
  "plus.scout.setup.fromAgent": "added in a chat with Scout",
  "plus.scout.setup.fromNotForMe": "learned from Not for me",
  "plus.scout.setup.heading": "What are you looking for?",
  "plus.scout.setup.help": "Write it like you would tell a friend who works in recruiting. Include what would rule a job out. Finnish, Swedish or English all work.",
  "plus.scout.setup.inFavour": "Counts in its favour",
  "plus.scout.setup.kindDealbreaker": "Dealbreaker",
  "plus.scout.setup.kindDislike": "Avoid",
  "plus.scout.setup.kindLike": "Want",
  "plus.scout.setup.language": "Write the reasons in",
  "plus.scout.setup.noPayNote": "Ads without pay will not be ruled out. Scout will tell you what similar ads pay instead.",
  "plus.scout.setup.noPreferences": "Nothing yet.",
  "plus.scout.setup.noRules": "No rules yet. Scout will read every new job.",
  "plus.scout.setup.pageTitle": "Set up Scout",
  "plus.scout.setup.pause": "Pause Scout",
  "plus.scout.setup.placeUnmatched": "Scout could not match the place \"{place}\", so it is not a rule. Add it to a rule yourself or leave it out.",
  "plus.scout.setup.profileUsed": "Scout also uses your profile and CV when you have added them.",
  "plus.scout.setup.quota": "Scout has used today's allowance. Try again tomorrow, or edit the rules by hand.",
  "plus.scout.setup.read": "Read my brief",
  "plus.scout.setup.readFailed": "Scout could not read your brief just now. Try again, or add the rules yourself below.",
  "plus.scout.setup.reading": "Reading",
  "plus.scout.setup.readsAs": "Scout reads this as",
  "plus.scout.setup.remove": "Remove {label}",
  "plus.scout.setup.rulesOut": "Rules out a job",
  "plus.scout.setup.saveFailed": "Could not save. Try again.",
  "plus.scout.setup.saving": "Saving",
  "plus.scout.setup.start": "Start Scout",
  "plus.scout.setup.tooShort": "Write a sentence or two so Scout has something to go on.",
  "plus.scout.setup.update": "Save changes",
  "plus.scout.skipped.because": "Why: {rule}",
  "plus.scout.skipped.close": "Close",
  "plus.scout.skipped.empty": "Nothing was skipped today.",
  "plus.scout.skipped.more": "Showing the first {shown} of {total}.",
  "plus.scout.skipped.outside": "The other {count, number} new jobs were outside {field}.",
  "plus.scout.skipped.outsideAny": "The other {count, number} new jobs were outside your field.",
  "plus.scout.skipped.see": "See them",
  "plus.scout.skipped.sheetTitle": "Jobs Scout skipped",
  "plus.scout.skipped.title": "Skipped {count, plural, one {# job} other {# jobs}} for you",
  "plus.scout.unavailable.title": "Scout is not available yet",
  "plus.scout.verdict.strong": "Strong fit",
  "plus.scout.verdict.worth": "Worth a look",
  "plus.signIn.body": "Everything on JobCrawls works with a free account. Plus and Pro raise the weekly limits.",
  "plus.signIn.button": "Sign in",
  "plus.signIn.title": "Sign in to use this, free",
  "plus.tier.free": "Free",
  "plus.tier.plus": "Plus",
  "plus.tier.pro": "Pro",
  "plus.unit.adReads": "{count, plural, one {ad read} other {ad reads}}",
  "plus.unit.applications": "{count, plural, one {application} other {applications}}",
  "plus.unit.companies": "{count, plural, one {company} other {companies}}",
  "plus.unit.comparisons": "{count, plural, one {comparison} other {comparisons}}",
  "plus.unit.coverLetters": "{count, plural, one {cover letter} other {cover letters}}",
  "plus.unit.cvExports": "{count, plural, one {CV file} other {CV files}}",
  "plus.unit.cvVersions": "{count, plural, one {CV version} other {CV versions}}",
  "plus.unit.drafts": "{count, plural, one {draft} other {drafts}}",
  "plus.unit.emails": "{count, plural, one {employer email} other {employer emails}}",
  "plus.unit.followedCompanies": "{count, plural, one {followed company} other {followed companies}}",
  "plus.unit.instantSearches": "{count, plural, one {instant search} other {instant searches}}",
  "plus.unit.interviewKits": "{count, plural, one {interview kit} other {interview kits}}",
  "plus.unit.jobs": "{count, plural, one {job} other {jobs}}",
  "plus.unit.lookups": "{count, plural, one {lookup} other {lookups}}",
  "plus.unit.messages": "{count, plural, one {message} other {messages}}",
  "plus.unit.pages": "{count, plural, one {page} other {pages}}",
  "plus.unit.reminders": "{count, plural, one {reminder or interview} other {reminders and interviews}}",
  "plus.unit.reports": "{count, plural, one {report view} other {report views}}",
  "plus.unit.rewrites": "{count, plural, one {CV rewrite} other {CV rewrites}}",
  "plus.unit.searches": "{count, plural, one {match-sorted search} other {match-sorted searches}}",
  "plus.unit.tailoredCvs": "{count, plural, one {tailored CV} other {tailored CVs}}",
  "plus.unit.toolCalls": "{count, plural, one {tool call} other {tool calls}}",
  "plus.unit.translations": "{count, plural, one {CV translation} other {CV translations}}",
  "plus.unit.uses": "{count, plural, one {use} other {uses}}",
  "plus.unit.watchedJobs": "{count, plural, one {watched job} other {watched jobs}}",
  "plus.upsell.close": "Close",
  "plus.upsell.ctaTier": "Get {tier}, {price} a year",
  "plus.upsell.limits": "What you get on each plan",
  "plus.upsell.notNow": "Not now",
  "plus.upsell.plans": "See everything in Plus, or pay monthly",
  "plus.watchlist.pulse.basis": "Compared with each company's own last 3 months. Direct employers only.",
  "plus.watchlist.pulse.calm": "No big changes at the {total} companies you follow this week.",
  "plus.watchlist.pulse.empty": "Nothing to report yet. We need a few months of ads from the companies you follow before we can say who is speeding up.",
  "plus.watchlist.pulse.error": "We could not load the pulse. Try again in a moment.",
  "plus.watchlist.pulse.faster": "{count} of the {total} companies you follow {count, plural, one {is} other {are}} hiring faster.",
  "plus.watchlist.pulse.fasterInField": "{count} of the {total} companies you follow {count, plural, one {is} other {are}} hiring faster in {field}.",
  "plus.watchlist.pulse.fasterLine": "About {recent, plural, one {# new ad} other {# new ads}} a month lately, up from {before}.",
  "plus.watchlist.pulse.fieldLabel": "Field",
  "plus.watchlist.pulse.likelyLink": "See who is likely to hire soon",
  "plus.watchlist.pulse.newRoles": "{n, plural, one {# new role} other {# new roles}} at your level in the last two weeks.",
  "plus.watchlist.pulse.notCovered": "The pulse covers the first {limit, plural, one {# company} other {# companies}} you follow. {count, plural, one {# more is} other {# more are}} covered with {plan}.",
  "plus.watchlist.pulse.notCoveredTop": "The pulse covers the first {limit, plural, one {# company} other {# companies}} you follow. {count, plural, one {# more is} other {# more are}} left out.",
  "plus.watchlist.pulse.quiet": "{count, plural, one {# has} other {# have}} gone quiet.",
  "plus.watchlist.pulse.quietLine": "No new ads since {month}. They used to post about {before} a month.",
  "plus.watchlist.pulse.quietLineNoMonth": "No new ads for a while. They used to post about {before} a month.",
  "plus.watchlist.pulse.scoreChange": "Employer Score went from {from} to {to}.",
  "plus.watchlist.pulse.seePlan": "See what {plan} adds",
  "plus.watchlist.pulse.seeThem": "See {company}",
  "plus.watchlist.pulse.skipped": "{count, plural, one {# followed company is} other {# followed companies are}} left out: recruitment agencies and employers with too few ads.",
  "plus.watchlist.pulse.title": "This week's pulse",
  "plus.watchlist.pulse.trend.goneQuiet": "Gone quiet",
  "plus.watchlist.pulse.trend.speedingUp": "Speeding up",
  "plus.watchlist.pulse.trend.steady": "Steady",
  "tailorReview.fallback.quickTweaks": "Here are quick tweaks instead.",
  "plus.likely.introNoRole": "Employers that regularly hire for a role but have nothing open right now. A pattern from their past ads, not a promise.",
  "plus.scout.setup.back": "Back to Scout",
  "plus.agent.action.cv.body": "Then Scout can say how well you fit and what an ad asks for that your CV leaves out.",
  "plus.agent.action.cv.cta": "Add a CV",
  "plus.agent.action.cv.title": "Add your CV",
  "plus.agent.action.home.body": "For real commute times to every job. Only you see it.",
  "plus.agent.action.home.cta": "Add my address",
  "plus.agent.action.home.title": "Add your home address",
  "plus.agent.action.profile.body": "Your role, place, pay floor and languages. Every search and Scout start from them.",
  "plus.agent.action.profile.cta": "Open my profile",
  "plus.agent.action.profile.title": "Tell JobCrawls what you are after",
  "plus.agent.action.scout.body": "Scout reads every new job against what you asked for and keeps the ones worth your time.",
  "plus.agent.action.scout.cta": "Set up Scout",
  "plus.agent.action.scout.title": "Let Scout keep reading",
  "plus.agent.action.tracker.body": "Everything you saved or applied to, by stage.",
  "plus.agent.action.tracker.cta": "Open My Jobs",
  "plus.agent.action.tracker.title": "Your applications",
  "plus.agent.chart.col.ads": "Ads",
  "plus.agent.chart.col.high": "Upper quarter",
  "plus.agent.chart.col.low": "Lower quarter",
  "plus.agent.chart.col.median": "Median",
  "plus.agent.chart.col.row": "Where or what",
  "plus.agent.chart.medianOf": "{label}: median {median}, middle half {low} to {high}, {count} ads",
  "plus.agent.chart.netPay.title": "Where {gross} a month goes",
  "plus.agent.chart.netSource": "JobCrawls tax calculator. An estimate, not tax advice.",
  "plus.agent.chart.netSubtitle": "Per month, estimated with this year's Finnish tax rules",
  "plus.agent.chart.part.contributions": "Pension and insurance",
  "plus.agent.chart.part.net": "Take-home",
  "plus.agent.chart.part.tax": "Taxes",
  "plus.agent.chart.payByPlace.title": "What {role} jobs pay",
  "plus.agent.chart.payByRole.title": "Pay by role",
  "plus.agent.chart.payByRole.titlePlace": "Pay by role in {place}",
  "plus.agent.chart.paySource": "{basis, select, official {Statistics Finland’s earnings for the occupation, raised to today. Job ads only set the differences between rows; the number beside each row is how many ads.} mixed {Statistics Finland’s earnings for the occupation, raised to today, where the role has one; otherwise pay stated in job ads. The number beside each row is how many ads.} other {JobCrawls, pay stated in job ads. The number beside each row is how many ads.}}",
  "plus.agent.chart.paySubtitle": "{basis, select, ads {Gross pay per month: the middle half of ads, with the median marked} other {Gross pay per month: the middle half, with the median marked}}",
  "plus.agent.chart.payVsMarket.title": "This pay against the market",
  "plus.agent.chart.ref.thisAd": "This ad {amount}",
  "plus.agent.chart.ref.yourOffer": "Your offer {amount}",
  "plus.agent.chart.rough": "rough",
  "plus.agent.chart.row.finland": "All of Finland",
  "plus.agent.chart.row.market": "Similar ads",
  "plus.agent.chart.row.remote": "Remote",
  "plus.agent.chart.table": "Show as table",
  "plus.agent.chart.tooFew": "Too few ads",
  "plus.agent.link.jobPage": "Open the job",
  "plus.agent.link.salaryPage": "See all pay for {role}",
  "plus.agent.link.salaryPageGeneric": "Open the salary page",
  "plus.agent.link.taxCalculator": "Open in the tax calculator",
  "plus.agent.replies.label": "Quick replies",
  "plus.agent.action.editHere": "Fill in here",
  "plus.agent.action.openProfileLink": "Open profile",
  "plus.agent.action.savedHome": "I added my home address.",
  "plus.agent.action.savedPreferences": "I updated what I am looking for.",
  "plus.agent.action.moreInProfile": "More in your profile",
  "plus.agent.action.searchWithThis": "Search with this",
  "plus.agent.hero.body": "Scout has read every open job in Finland, the pay in past ads and how employers hire. Ask in your own words; it answers from that.",
  "plus.agent.hero.pulse": "Read this morning: {jobs} open jobs from {employers} employers, {fresh} of them new today.",
  "plus.agent.hero.title": "What should Scout look into?",
  "plus.agent.knows.open": "What Scout knows",
  "plus.agent.starter.find.source": "Every open ad in Finland, best fits first",
  "plus.agent.composer.count": "{count} of {max} characters",
  "plus.agent.import.education": "{count, plural, one {# degree or course} other {# degrees or courses}}",
  "plus.agent.import.experience": "Experience",
  "plus.agent.import.headline": "Headline",
  "plus.agent.import.jobs": "{count, plural, one {# job} other {# jobs}}",
  "plus.agent.import.languages": "Languages",
  "plus.agent.import.open": "Review in my profile",
  "plus.agent.import.replaceNote": "Replaces the CV in your profile for this language. Your contact details are only filled where empty.",
  "plus.agent.import.roles": "Roles to look for",
  "plus.agent.import.save": "Save to my profile",
  "plus.agent.import.saved": "Saved to your profile",
  "plus.agent.import.savedFollowUp": "I saved it to my profile.",
  "plus.agent.import.skills": "{count, plural, one {# skill} other {# skills}}",
  "plus.agent.import.title": "Save this to your profile?",
  "plus.agent.import.background": "Education and skills",
  "plus.agent.message.showAll": "Show all",
  "plus.agent.message.showLess": "Show less",
  "plus.agent.step.preparedProfile": "Read it into a profile update",
  "plus.agent.chart.archive.ads": "Number of ads",
  "plus.agent.chart.archive.employers": "Number of different employers",
  "plus.agent.chart.archive.pay": "Stated starting pay per month: the middle half of ads, with the median marked",
  "plus.agent.chart.archive.source": "{period, select, last_30_days {JobCrawls archive of job ads, the last 30 days.} last_90_days {JobCrawls archive of job ads, the last 90 days.} other {JobCrawls archive of every job ad we have stored.}}",
  "plus.feature.marketQuery.body": "Scout counts and compares across every ad we have stored: which skills are rising, where a role pays most, how hiring moves month by month.",
  "plus.feature.marketQuery.title": "Ask the whole archive",
  "plus.unit.queries": "{count, plural, one {data question} other {data questions}}",
  "plus.agent.step.archive": "Counted across the job-ad archive",
  "plus.agent.starter.commute": "{role} jobs I could reach within 30 minutes of the centre of {place}",
  "plus.agent.starter.commute.source": "Open jobs with public transport times",
  "plus.agent.starter.cv": "Paste your CV and Scout finds jobs that fit it",
  "plus.agent.starter.cv.prefill": "Find jobs that fit my CV:",
  "plus.agent.starter.cv.source": "It offers to fill in your profile too; you check it and save",
  "plus.agent.starter.defaultPlace": "Tampere",
  "plus.agent.starter.defaultRole": "nurse",
  "plus.agent.starter.find": "Find {role} jobs in {place} that pay at least {amount} a month",
  "plus.agent.starter.hidden": "Which employers regularly hire for {role} roles but have nothing open right now?",
  "plus.agent.starter.hidden.source": "Employers' hiring history from past ads",
  "plus.agent.starter.pay": "Is {amount} a month fair for a {role} in {place}?",
  "plus.agent.starter.pay.source": "Pay stated in real ads, by city, as a chart",
  "plus.agent.starter.rated": "{role} jobs posted this week at employers rated A or B",
  "plus.agent.starter.rated.source": "New ads, sorted by Employer Score",
  "plus.agent.usage.all": "Your plan and all limits",
  "plus.agent.usage.open": "Usage",
  "plus.agent.usage.title": "This week",
  "plus.agent.cv.pasteLabel": "Your CV or work history",
  "plus.agent.cv.pastePlaceholder": "Copy and paste your CV or your work history from another site",
  "plus.agent.cv.pasteSend": "Read my CV",
  "plus.agent.cv.uploadLink": "Upload a file in my profile",
  "plus.agent.card.prepApply": "Get ready to apply",
  "plus.agent.card.prepApplyMessage": "Help me apply to {title}",
  "plus.agent.card.save": "Save",
  "plus.agent.card.saved": "Saved in My Jobs",
  "plus.agent.proposal.alertInstant": "Tell me as soon as new \"{subject}\" jobs come in",
  "plus.agent.proposal.removeJob": "Remove {subject} from My Jobs",
  "plus.agent.proposal.searchAlertOff": "Stop emails for \"{subject}\" (keep it saved)",
  "plus.agent.proposal.searchAlertOn": "Email me about new jobs in \"{subject}\"",
  "plus.agent.proposal.searchRemove": "Delete the saved search \"{subject}\"",
  "plus.agent.proposal.searchRename": "Rename the saved search \"{subject}\"",
  "plus.agent.proposal.unfollow": "Take {subject} off your watchlist",
  "plus.agent.results.anyJob": "any job",
  "plus.agent.results.edit": "Edit this search",
  "plus.agent.results.in": "in {place}",
  "plus.agent.results.label": "Search results",
  "plus.agent.results.noAgencies": "no recruitment agencies",
  "plus.agent.results.noAgenciesSwitch": "No recruitment agencies",
  "plus.agent.results.pay": "Pay at least, € a month",
  "plus.agent.results.payFloor": "at least {amount} a month",
  "plus.agent.results.rankedByFit": "Best fit for you first",
  "plus.agent.results.rankedBySearch": "Closest to your search first",
  "plus.agent.results.remoteOnly": "remote only",
  "plus.agent.results.remoteOnlySwitch": "Remote only",
  "plus.agent.results.saveToProfile": "Make this what I am looking for",
  "plus.agent.results.savedToProfile": "Saved to your profile",
  "plus.agent.results.searchAgain": "Search again",
  "plus.agent.results.searchAgainMessage": "Search again: {search}",
  "plus.agent.results.seeAll": "{count, plural, one {See it on the search page} other {See all {countText} on the search page}}",
  "plus.agent.results.showMore": "Show {count} more",
  "plus.agent.results.title": "{count, plural, one {{countText} open job} other {{countText} open jobs}}",
  "plus.agent.results.what": "What",
  "plus.agent.results.whatPlaceholder": "Job title, skill or keyword",
  "plus.agent.results.where": "Where",
  "plus.agent.results.wherePlaceholder": "City or region",
  "plus.agent.card.estimate": "about {range} a month (our estimate, not in the ad)",
  "plus.agent.action.cvPasteHere": "Paste it here",
  "plus.agent.cv.orPaste": "or paste it below",
  "plus.agent.cv.uploadFailed": "That file could not be read. Upload a PDF, or paste the text instead.",
  "plus.agent.cv.uploadPdf": "Upload your CV (PDF)",
  "plus.agent.cv.uploading": "Reading your CV...",
  "plus.agent.paths.add": "Add to what I am looking for",
  "plus.agent.paths.added": "In your profile",
  "plus.agent.paths.alert": "Alert me",
  "plus.agent.paths.alertMessage": "Alert me about new {role} jobs",
  "plus.agent.paths.gap": "To show or learn: {gap}",
  "plus.agent.paths.label": "Other jobs you could do",
  "plus.agent.paths.noneOpen": "none open right now",
  "plus.agent.paths.openNow": "{count, plural, one {{countText} open now} other {{countText} open now}}",
  "plus.agent.paths.pay": "usually {pay} a month",
  "plus.agent.paths.showJobs": "Show me these jobs",
  "plus.agent.paths.showJobsMessage": "Show me {role} jobs",
  "plus.agent.paths.title": "Jobs your experience fits",
  "plus.agent.paths.youHave": "What you already bring",
  "plus.agent.results.rankedEasy": "Jobs you can start without experience first",
  "plus.agent.card.matchWhy": "What the match is made of",
  "plus.agent.card.notForMe": "Not for me",
  "plus.agent.card.notForMeAgency": "Agency",
  "plus.agent.card.notForMeDone": "Hidden: {title}. Scout will show fewer like it.",
  "plus.agent.card.notForMeFar": "Too far",
  "plus.agent.card.notForMeOther": "Something else",
  "plus.agent.card.notForMePay": "Pay too low",
  "plus.agent.card.notForMeRole": "Wrong kind of job",
  "plus.agent.card.notForMeUndo": "Undo",
  "plus.agent.card.notForMeWhy": "Why?",
  "plus.agent.memory.noAgencies": "Rather not jobs from recruitment agencies",
  "plus.agent.memory.notRole": "Not jobs like {role}",
  "plus.agent.memory.payLow": "Pay up to {pay} € a month is too low for me",
  "plus.agent.memory.tooFar": "{place} is too far for me",
  "plus.agent.part.benefits": "Benefits",
  "plus.agent.part.holidays": "Holidays",
  "plus.agent.part.jobType": "Job type",
  "plus.agent.part.languages": "Languages",
  "plus.agent.part.level": "Level",
  "plus.agent.part.pay": "Pay",
  "plus.agent.part.place": "Place",
  "plus.agent.part.title": "Role",
  "plus.agent.part.workMode": "Work mode",
  "plus.agent.askScout": "Ask Scout",
  "plus.agent.next.applyBeforeCloseMessage": "Help me apply to {subject} before it closes",
  "plus.agent.next.followUp": "Remind me to follow up",
  "plus.agent.next.followUpDraftMessage": "Draft a short follow-up for my application to {subject}",
  "plus.agent.next.followUpMessage": "Remind me to follow up on {subject} in a week",
  "plus.agent.next.interviewKit": "Prepare for the interview",
  "plus.agent.next.interviewKitMessage": "Help me prepare for the interview for {subject}",
  "plus.agent.next.offerCheck": "Check the offer",
  "plus.agent.next.offerCheckMessage": "Is the offer for {subject} a good one? Check it against market pay",
  "plus.agent.next.similar": "Find similar jobs",
  "plus.agent.next.similarMessage": "Find jobs like {subject} that are open now",
  "plus.agent.srpScoutAsk": "Which of the {search} jobs fit me best?",
  "plus.agent.srpScoutLine": "Not sure which to pick? Scout can rank these by how well they fit you and check the pay.",
  "plus.agent.compare.aboveMarket": "{pct}% above the middle",
  "plus.agent.compare.agency": "Recruitment agency",
  "plus.agent.compare.atMarket": "at the market middle",
  "plus.agent.compare.belowMarket": "{pct}% below the middle",
  "plus.agent.compare.caption": "Jobs side by side",
  "plus.agent.compare.closes": "Apply by",
  "plus.agent.compare.commute": "Commute",
  "plus.agent.compare.estimate": "about {range} (our estimate)",
  "plus.agent.compare.fit": "Fit for you",
  "plus.agent.compare.grade": "Employer Score",
  "plus.agent.compare.languages": "Languages asked",
  "plus.agent.compare.market": "Against the market",
  "plus.agent.compare.no": "No",
  "plus.agent.compare.pay": "Pay a month",
  "plus.agent.compare.where": "Where",
  "plus.agent.compare.yes": "Yes",
  "plus.agent.brief.closing": "{count, plural, one {{title} closes in {days, plural, one {# day} other {# days}}} other {{title} and {more} more saved jobs close soon}}",
  "plus.agent.brief.newJobs": "{count, plural, one {# new job in your alerts} other {# new jobs in your alerts}}",
  "plus.agent.brief.newJobsAsk": "Which of the new jobs in my alerts fit me best?",
  "plus.agent.brief.open": "Open",
  "plus.agent.brief.title": "Since you were last here",
  "plus.agent.brief.watch": "{count, plural, one {# employer you watch has new roles} other {# employers you watch have new roles}}",
  "plus.agent.brief.watchAsk": "What have the employers I watch posted lately?",
  "profileTabs.market": "Your market",
  "tailorSideBySide.experience": "Experience",
  "tailorSideBySide.legend": "Changes are in red: struck through in your CV, highlighted in the tailored one.",
  "tailorSideBySide.projects": "Projects",
  "tailorSideBySide.reordered": "Reordered so the skills this job asks for come first",
  "tailorSideBySide.skills": "Skills",
  "tailorSideBySide.switch": "Show version",
  "tailorSideBySide.tailored": "Tailored for this job",
  "tailorSideBySide.yourCv": "Your CV",
  "plus.agent.card.tailor": "Tailor my CV for this job",
  "plus.agent.card.tailorMessage": "Tailor my CV for {title}",
  "plus.limit.extraUsage": "Keep going with extra usage",
  "profile.signInMethods.connect": "Connect",
  "profile.signInMethods.connected": "Connected",
  "profile.signInMethods.disconnect": "Disconnect",
  "profile.signInMethods.disconnectAria": "Disconnect {provider}",
  "profile.signInMethods.emailPassword": "Email and password",
  "profile.signInMethods.errorGeneric": "Nothing was changed. Please try again.",
  "profile.signInMethods.errorInUse": "It is already connected to another account that has more than one sign-in method. Sign in with it and disconnect it there first.",
  "profile.signInMethods.errorSession": "Your session changed while connecting. Sign in again and retry.",
  "profile.signInMethods.errorTitle": "Couldn't connect that sign-in method",
  "profile.signInMethods.intro": "Connect more ways to sign in to this same account. If one of them already has its own JobCrawls account, the two are merged: saved jobs, searches and alerts end up in one place.",
  "profile.signInMethods.linkedBody": "You can now sign in with it, and you land in this account.",
  "profile.signInMethods.linkedTitle": "Sign-in method connected",
  "profile.signInMethods.loadError": "Couldn't load your sign-in methods.",
  "profile.signInMethods.title": "Sign-in methods",
  "profile.signInMethods.unlinkError": "Couldn't disconnect it. Please try again.",
  "hitTableB2.updated.daysAgo": "{value, plural, one {# day ago} other {# days ago}}",
  "hitTableB2.updated.hoursAgo": "{value} hr ago",
  "hitTableB2.updated.minutesAgo": "{value} min ago",
  "hitCardB2.details.estimatedPay": "Estimated pay",
  "jobDetailPageV2.fitLedger.noProfile": "We compare every job with your profile: pay, location, languages and experience.",
  "jobDetailPageV2.fitLedger.noProfile.link": "Fill in your profile →",
  "jobAlerts.panel.browserUnsupportedNoEmail": "Not supported in this browser. Use the JobCrawls app to get notifications.",
  "jobAlerts.panel.noEmailChannels": "Your account has no email address, so only notifications are available.",
  "srpAlertCta.channels.blockedNoEmail": "Notifications are blocked in this browser. Allow them in your browser settings to get alerts.",
  "srpAlertCta.channels.noEmail": "Your account has no email address, so only notifications are available.",
  "salaryRolePage.v2.faq.aHourly": "About {hourly} an hour, counting the {source, select, official {Statistics Finland median} estimate {estimated median} other {job-ad median}} of {monthly} a month over 160 working hours.",
  "salaryRolePage.v2.faq.aNet": "From {gross} a month, about {net} is left after tax and the employee’s own contributions, at the average municipal tax rate without church tax.",
  "salaryRolePage.v2.faq.qHourly": "What is the hourly pay for a {roleTitle}?",
  "salaryRolePage.v2.faq.qNet": "How much of a {roleTitle}’s pay is left after tax?",
  "companyProfile.section.hideAll": "Show less",
  "companyProfile.section.showAll": "Show all",
  "companyProfile.summary.businessId": "Business ID",
  "companyProfile.summary.inYear": "In {year}",
  "companyProfile.summary.perMonth": "A month, in ads that state pay",
  "companyProfile.summary.publicSales": "Sales to the public sector",
  "companyProfile.summary.registered": "Registered",
  "companyProfile.summary.shareOfAds": "In {pct}% of ads",
  "companyProfile.summary.sourceAds": "From its job ads",
  "companyProfile.summary.sourcePurchases": "Public purchase invoice data",
  "companyProfile.summary.sourceRegistry": "Finnish Trade Register",
  "companyProfile.summary.sourceScore": "From job ad signals, not reviews",
  "companyProfile.summary.sourceTax": "Finnish Tax Administration, {year}",
  "companyProfile.summary.taxableIncome": "Taxable income",
  "companyProfile.summary.taxesPaid": "Taxes paid",
  "companyProfile.summary.topBenefit": "Most mentioned benefit",
  "companyProfile.summary.topSkill": "Most asked skill",
  "companyProfile.summary.typicalPay": "Typical pay",
  "collectiveAgreementPage.bindingHeading": "Does it apply to every employer in the field?",
  "collectiveAgreementPage.bindingNoBody": "Not automatically. This agreement is not generally binding, so it binds only employers who belong to the signing employer federation (or who have signed it themselves). If your employer is not a member, a different agreement or only the Employment Contracts Act may apply. Ask your employer which agreement they follow.",
  "collectiveAgreementPage.bindingSourceYear": "Source: Confirmation Board annual review {year}.",
  "collectiveAgreementPage.bindingUnknownBody": "Unclear. The agreement is not named in the Confirmation Board reviews we have on file, so we cannot say whether it is generally binding. Check the agreement's Finlex page or ask the signing union.",
  "collectiveAgreementPage.bindingYesBody": "Yes. The Confirmation Board has found this agreement generally binding (yleissitova), so its minimum terms apply to every employer in its field, including employers who are not members of the signing employer federation. Your employment contract cannot agree on anything worse than these terms.",
  "collectiveAgreementPage.breadcrumbDirectory": "Collective agreements",
  "collectiveAgreementPage.browseAll": "All Finnish collective agreements",
  "collectiveAgreementPage.checkedAt": "Figures checked against these sources on {date}.",
  "collectiveAgreementPage.documentsHeading": "Read the agreement",
  "collectiveAgreementPage.eyebrow": "Collective agreement (TES)",
  "collectiveAgreementPage.guideBadge": "Plain-language guide",
  "collectiveAgreementPage.guideDisclaimer": "This summary is written by JobCrawls and is not part of the agreement. The agreement text is authoritative. For your own situation, ask your union or shop steward.",
  "collectiveAgreementPage.inForce": "In force {from} to {to}",
  "collectiveAgreementPage.keyFactsHeading": "At a glance",
  "collectiveAgreementPage.latestDecision": "Latest confirmation decision {date}, no. {number}",
  "collectiveAgreementPage.openAgreementPage": "Agreement page",
  "collectiveAgreementPage.relatedHeading": "Related agreements",
  "collectiveAgreementPage.salaryHeading": "What these jobs pay in practice",
  "collectiveAgreementPage.salaryIntro": "The agreement sets the floor. These pages show pay advertised in real job listings for the same roles.",
  "collectiveAgreementPage.scopeHeading": "Who the agreement covers",
  "collectiveAgreementPage.scopeTranslatedNote": "AI translation of the Finnish scope clause. The Finnish text on Finlex is the authoritative one.",
  "collectiveAgreementPage.sourcesHeading": "Sources",
  "companyProfile.jobProfile.payHeadingCompany": "{company} salaries by role",
  "salaryRolePage.v2.about.source": "Description: ESCO occupation \"{label}\". This service uses the ESCO classification of the European Commission.",
  "salaryRolePage.v2.about.title": "What does a {roleTitle} do?",
  "salaryRolePage.v2.faq.aStart": "{hasJunior, select, yes {Ads for junior roles put the median at {junior} a month{hasSenior, select, yes {, against {senior} for senior roles} other {}}. } other {}}",
  "salaryRolePage.v2.faq.qStart": "What is the starting pay for a {roleTitle}?",
  "salaryRolePage.v2.takeHome.gross": "Gross a month",
  "salaryRolePage.v2.takeHome.net": "Take-home a month",
  "salaryRolePage.v2.takeHome.note": "Gross pay from {source, select, official {Statistics Finland} estimate {the estimate above (job ads and Statistics Finland)} other {job ads}}. Take-home after income tax at the average municipal rate, without church tax, and the employee’s pension and unemployment insurance contributions.",
  "salaryRolePage.v2.takeHome.rowHigh": "{source, select, official {Best-paid tenth} estimate {Upper quarter of the range} other {Best-paid quarter of ads}}",
  "salaryRolePage.v2.takeHome.rowLow": "{source, select, official {Lowest-paid tenth} estimate {Lower quarter of the range} other {Lowest-paid quarter of ads}}",
  "salaryRolePage.v2.takeHome.rowMid": "Median",
  "salaryRolePage.v2.takeHome.title": "How much is left after tax",
  "salaryRolePage.v2.tes.link": "Pay tables and supplements in the agreement",
  "salaryRolePage.v2.tes.notBinding": "This agreement is not generally binding, so it applies only at employers that belong to the signing employer federation.",
  "salaryRolePage.v2.tes.text": "Under the {agreement}, the table pay is at least {hasMonthly, select, yes {{monthly} a month{hasHourly, select, yes { ({hourly} an hour)} other {}}} other {{hourly} an hour}} ({label}, from {validFrom}). It is a minimum: employers may pay more, not less.",
  "salaryRolePage.v2.tes.title": "Collective agreement minimum",
  "salaryRolePage.v2.intro.sources": "Sources:",
  "salaryRolePage.v2.intro.title": "Work and training",
  "backoffice.subpage.plusSeats": "Plus seats",
  "plus.r3.archive.addFilter": "Add a filter",
  "plus.r3.archive.alertBaseline": "Measured against {label} at {value}.",
  "plus.r3.archive.alertLabel": "Tell me when the top figure moves by",
  "plus.r3.archive.alertOn": "Email me about this",
  "plus.r3.archive.alertPercent": "percent",
  "plus.r3.archive.alertSet": "Update alert",
  "plus.r3.archive.alertsNote": "Alerts are checked once a week and sent by email.",
  "plus.r3.archive.ask": "Ask the archive",
  "plus.r3.archive.askHeading": "Ask a question",
  "plus.r3.archive.asking": "Counting ads",
  "plus.r3.archive.dim.benefit": "Benefit",
  "plus.r3.archive.dim.education": "Education",
  "plus.r3.archive.dim.field": "Field",
  "plus.r3.archive.dim.industry": "Industry",
  "plus.r3.archive.dim.jobType": "Job type",
  "plus.r3.archive.dim.level": "Level",
  "plus.r3.archive.dim.perk": "Perk",
  "plus.r3.archive.dim.region": "Region",
  "plus.r3.archive.dim.requiredLanguage": "Required language",
  "plus.r3.archive.dim.role": "Role",
  "plus.r3.archive.dim.skill": "Skill",
  "plus.r3.archive.dim.statesPay": "States pay",
  "plus.r3.archive.dim.summerJob": "Summer job",
  "plus.r3.archive.dim.visaSponsor": "Visa sponsorship",
  "plus.r3.archive.dim.workMode": "Work mode",
  "plus.r3.archive.error": "We could not run that question. Try again in a moment.",
  "plus.r3.archive.exportCsv": "Download CSV",
  "plus.r3.archive.filterDimension": "Filter",
  "plus.r3.archive.filterValues": "Is one of (separate with commas)",
  "plus.r3.archive.filterValuesHelp": "Use the names as search results show them, for example Backend Developer.",
  "plus.r3.archive.filtersHeading": "Only ads where",
  "plus.r3.archive.groupByLabel": "Split by",
  "plus.r3.archive.inWords": "Not sure which options fit? Ask Scout in your own words.",
  "plus.r3.archive.intro": "Ask a question of every job ad we have stored, since 2025. Pick what to count and how to split it. Save the questions you want to come back to.",
  "plus.r3.archive.invalid": "Check the question: it needs a title of at least three letters.",
  "plus.r3.archive.lastRun": "Last run {date}: {label} {value}",
  "plus.r3.archive.measureAds": "Number of ads",
  "plus.r3.archive.measureEmployers": "Number of employers",
  "plus.r3.archive.measureLabel": "Count",
  "plus.r3.archive.measurePay": "Stated pay (monthly)",
  "plus.r3.archive.menuLabel": "Archive",
  "plus.r3.archive.menuNote": "ask every stored ad",
  "plus.r3.archive.modeBreakdown": "A breakdown",
  "plus.r3.archive.modeLabel": "Show",
  "plus.r3.archive.modeMonth": "Ads per month",
  "plus.r3.archive.modeWeek": "Ads per week",
  "plus.r3.archive.neverRun": "Not run yet",
  "plus.r3.archive.noData": "No data yet: no stored ad matches this question. Loosen a filter or widen the period. This did not use a question.",
  "plus.r3.archive.openOnly": "Only ads that are open now",
  "plus.r3.archive.outcome.baseline": "We now measure changes against this answer.",
  "plus.r3.archive.outcome.fired": "Moved {change} percent, from {from} to {to}. We will reset the alert at the new figure.",
  "plus.r3.archive.outcome.notEnough": "Not enough data to measure a change: the starting figure is under 10.",
  "plus.r3.archive.outcome.quiet": "Moved {change} percent: under your alert.",
  "plus.r3.archive.pageTitle": "Archive",
  "plus.r3.archive.period30": "Last 30 days",
  "plus.r3.archive.period90": "Last 90 days",
  "plus.r3.archive.periodAll": "All stored ads",
  "plus.r3.archive.periodLabel": "Period",
  "plus.r3.archive.remove": "Delete",
  "plus.r3.archive.removeFilter": "Remove filter",
  "plus.r3.archive.runAgain": "Run again",
  "plus.r3.archive.sameNumbers": "Same numbers as last time.",
  "plus.r3.archive.save": "Save this question",
  "plus.r3.archive.saved": "Saved",
  "plus.r3.archive.savedCount": "{count} of {limit} saved",
  "plus.r3.archive.savedEmpty": "No saved questions yet. Ask one above and save it to see it again.",
  "plus.r3.archive.savedHeading": "Saved questions",
  "plus.r3.archive.titleLabel": "Your question in plain words",
  "plus.r3.archive.titlePlaceholder": "Which skills do backend developer ads ask for most?",
  "plus.r3.archive.tooSlow": "That question takes too long over the whole archive. Try a shorter period or add a filter.",
  "plus.r3.calendar.body": "Add this private link to Google Calendar, Apple Calendar or Outlook to see your interviews, follow-up reminders and application deadlines next to everything else. Anyone with the link can see them, so keep it to yourself.",
  "plus.r3.calendar.changeError": "We could not change your calendar link. Nothing was changed.",
  "plus.r3.calendar.close": "Close",
  "plus.r3.calendar.copied": "Copied",
  "plus.r3.calendar.copy": "Copy",
  "plus.r3.calendar.create": "Create calendar link",
  "plus.r3.calendar.keep": "Keep this one",
  "plus.r3.calendar.label": "Calendar link",
  "plus.r3.calendar.loadError": "We could not load your calendar link.",
  "plus.r3.calendar.rotate": "Get a new link",
  "plus.r3.calendar.rotateBody": "The old link stops working right away. Calendars that use it will go empty until you add the new link.",
  "plus.r3.calendar.rotateConfirm": "Get a new link",
  "plus.r3.calendar.rotateTitle": "Get a new calendar link?",
  "plus.r3.calendar.title": "Calendar feed",
  "plus.r3.calendar.turnOff": "Turn off",
  "plus.r3.changeSecurity.age": "Your age",
  "plus.r3.changeSecurity.calculate": "Show my dates",
  "plus.r3.changeSecurity.employerSize": "Employees at your employer",
  "plus.r3.changeSecurity.endDate": "Last day of work, if the notice names it (optional)",
  "plus.r3.changeSecurity.endFromNotice": "Your last day is worked out from the statutory notice period for your years of service. Use the date in your notice letter if it differs.",
  "plus.r3.changeSecurity.invalid": "Enter the notice date, your age, the number of employees, and either the last day of work or the years you have worked there.",
  "plus.r3.changeSecurity.notAdvice": "This is a planning aid, not legal advice.",
  "plus.r3.changeSecurity.noticeDate": "Day you were given notice",
  "plus.r3.changeSecurity.pageLead": "If you have been given notice, see the dates that matter and when each one falls.",
  "plus.r3.changeSecurity.pageTitle": "Change-security timeline",
  "plus.r3.changeSecurity.rules": "Rules version {version}, checked {date}.",
  "plus.r3.changeSecurity.smallEmployer": "Employers with fewer than {min} employees do not run change negotiations, so these rights may not apply to you.",
  "plus.r3.changeSecurity.statusIn": "In {days, plural, one {# day} other {# days}}",
  "plus.r3.changeSecurity.statusPassed": "Passed",
  "plus.r3.changeSecurity.statusToday": "Today",
  "plus.r3.changeSecurity.stepAllowance": "Apply for the change-security allowance by",
  "plus.r3.changeSecurity.stepEnds": "Your last day of work",
  "plus.r3.changeSecurity.stepOlderEnd": "Window for workers aged 55 and over closes",
  "plus.r3.changeSecurity.stepOlderStart": "Window for workers aged 55 and over opens",
  "plus.r3.changeSecurity.stepRegister": "Register as a job seeker",
  "plus.r3.changeSecurity.unverified": "These dates have not yet been checked against the legal text. Confirm them with TE services or your union.",
  "plus.r3.changeSecurity.yearsOfService": "Years you have worked there",
  "plus.r3.companySignals.body": "Hiring rhythm breaks, reopened roles, new offices and registry changes at the companies you follow.",
  "plus.r3.companySignals.error": "We could not load the signals. Try again in a moment.",
  "plus.r3.companySignals.intro": "Patterns in past ads and the company register. They hint that a company may hire soon. They are not a promise.",
  "plus.r3.companySignals.newOffice": "{ads, plural, one {# new ad} other {# new ads}} in {place}, where it has not advertised before.",
  "plus.r3.companySignals.noData": "No data yet for the companies you follow. We need a few months of ads before we can see a pattern.",
  "plus.r3.companySignals.noDataCompany": "No data yet for this company.",
  "plus.r3.companySignals.noSignals": "No signals right now at the companies you follow.",
  "plus.r3.companySignals.noSignalsCompany": "No signals right now.",
  "plus.r3.companySignals.notCovered": "Signals cover the first {limit, plural, one {# company} other {# companies}} you follow. {count, plural, one {# more is} other {# more are}} left out.",
  "plus.r3.companySignals.panelTitle": "Before-the-ad signals",
  "plus.r3.companySignals.registryAddress": "Registered address changed on {date}.",
  "plus.r3.companySignals.registryForm": "Legal form changed on {date}.",
  "plus.r3.companySignals.registryLifecycle": "Register status changed on {date}.",
  "plus.r3.companySignals.registryName": "Registered name changed on {date}: {from} to {to}.",
  "plus.r3.companySignals.registryNameShort": "Registered name changed on {date}.",
  "plus.r3.companySignals.reopenedRole": "{title} is back, posted {days, plural, =0 {today} one {# day ago} other {# days ago}}. It was advertised {count, plural, one {once} other {# times}} before.",
  "plus.r3.companySignals.rhythmBreak": "Usually hires {role} about every {gap} days. It has been {days} days since the last ad, and nothing is open now.",
  "plus.r3.companySignals.sectionTitle": "Before the ad",
  "plus.r3.companySignals.seeThem": "See {company}",
  "plus.r3.companySignals.source": "Source: JobCrawls ads and hiring history; PRH Trade Register and financial statements (CC BY 4.0); TED public procurement notices.",
  "plus.r3.companySignals.title": "Before-the-ad signals",
  "plus.r3.contractCountdown.daysLeft": "{days, plural, =0 {Your contract ends today} one {# day left on your contract} other {# days left on your contract}}",
  "plus.r3.contractCountdown.ended": "Your contract end date has passed. Update your current job.",
  "plus.r3.contractCountdown.intro": "On a fixed-term contract? Quiet watch switches to a full search a few weeks before it ends, with a plan for each week.",
  "plus.r3.contractCountdown.needsDate": "Set your contract to fixed-term with an end date in your current job to use this.",
  "plus.r3.contractCountdown.plan": "Week by week",
  "plus.r3.contractCountdown.switchOff": "Do not switch",
  "plus.r3.contractCountdown.switchOn": "Full search starts on {date}.",
  "plus.r3.contractCountdown.switchOption": "{weeks, number} {weeks, plural, one {week} other {weeks}} before it ends",
  "plus.r3.contractCountdown.switchWeeks": "Start a full search",
  "plus.r3.contractCountdown.switchedOn": "Full search started on {date}.",
  "plus.r3.contractCountdown.taskApplyToPicks": "Apply to Scout's picks",
  "plus.r3.contractCountdown.taskAskExtension": "Ask whether the contract can be extended",
  "plus.r3.contractCountdown.taskBookInterviews": "Book interviews",
  "plus.r3.contractCountdown.taskCheckBenefits": "Check unemployment benefit and union fund membership",
  "plus.r3.contractCountdown.taskRefreshCv": "Update your CV",
  "plus.r3.contractCountdown.taskRegister": "Register as a job seeker on Job Market Finland",
  "plus.r3.contractCountdown.taskTellNetwork": "Tell people you are looking",
  "plus.r3.contractCountdown.thisWeek": "This week",
  "plus.r3.contractCountdown.title": "Contract end countdown",
  "plus.r3.contractCountdown.weekLine": "{start} to {end}, {weeksLeft, number} {weeksLeft, plural, one {week} other {weeks}} to go",
  "plus.r3.currentJob.contractEnd": "Contract ends",
  "plus.r3.currentJob.contractFixedTerm": "Fixed-term",
  "plus.r3.currentJob.contractOther": "Other",
  "plus.r3.currentJob.contractPermanent": "Permanent",
  "plus.r3.currentJob.contractType": "Contract",
  "plus.r3.currentJob.fieldError": "Check this value.",
  "plus.r3.currentJob.fromProfile": "Filled in from your profile",
  "plus.r3.currentJob.intro": "Private. Used to compare you with the market and to find clear upgrades. Never shown to employers.",
  "plus.r3.currentJob.jobTitle": "Job title",
  "plus.r3.currentJob.loadError": "We could not load your current job. Try again in a moment.",
  "plus.r3.currentJob.missingForMarket": "Add title, level, region and pay to compare yourself with the market.",
  "plus.r3.currentJob.notSet": "Not set",
  "plus.r3.currentJob.officeDays": "Office days a week",
  "plus.r3.currentJob.pay": "Gross monthly pay (EUR)",
  "plus.r3.currentJob.readyForMarket": "Title, level, region and pay are set.",
  "plus.r3.currentJob.region": "Region",
  "plus.r3.currentJob.roleLevel": "Level",
  "plus.r3.currentJob.save": "Save",
  "plus.r3.currentJob.saveError": "We could not save. Check the highlighted fields and try again.",
  "plus.r3.currentJob.saved": "Saved",
  "plus.r3.currentJob.title": "Your current job",
  "plus.r3.currentJob.workPercentage": "Work percentage",
  "plus.r3.cvDateCheck.body": "Flag old graduation years and roles that make a CV read dated, and get a shorter version.",
  "plus.r3.cvDateCheck.cardTitle": "CV date check",
  "plus.r3.cvDateCheck.clean": "Nothing here is older than {years} years.",
  "plus.r3.cvDateCheck.error": "We could not check your dates. Try again in a moment.",
  "plus.r3.cvDateCheck.flagsTitle": "Lines that make the CV read dated",
  "plus.r3.cvDateCheck.intro": "Finds graduation years and roles older than {years} years, so you can decide what stays on the page.",
  "plus.r3.cvDateCheck.noData": "No data yet. Add roles or education to your CV first.",
  "plus.r3.cvDateCheck.oldGraduation": "Graduation year {year}",
  "plus.r3.cvDateCheck.oldRole": "Role that ended in {year}",
  "plus.r3.cvDateCheck.run": "Check my dates",
  "plus.r3.cvDateCheck.shorterCut": "Cut these roles: {roles}",
  "plus.r3.cvDateCheck.shorterHide": "Leave the years off these degrees: {degrees}",
  "plus.r3.cvDateCheck.shorterNote": "Your CV is not changed. Edit it yourself when you are ready.",
  "plus.r3.cvDateCheck.shorterTitle": "A shorter version",
  "plus.r3.cvDateCheck.title": "CV date check",
  "plus.r3.deadlineAlerts.body": "Get a reminder before application deadlines, including summer job deadlines.",
  "plus.r3.deadlineAlerts.title": "Deadline alerts",
  "plus.r3.debrief.for": "{title} at {company}",
  "plus.r3.debrief.forNoCompany": "{title}",
  "plus.r3.debrief.title": "How did the interview go?",
  "plus.r3.experienceFit.chip": "Up to {count} years asked",
  "plus.r3.experienceFit.flag.heading": "Seniority check",
  "plus.r3.experienceFit.flag.levelAbove": "This is a {adLevel} role. Your current level is {yourLevel}.",
  "plus.r3.experienceFit.flag.levelBelow": "This is a {adLevel} role. Your current level is {yourLevel}, so it may be a step down.",
  "plus.r3.experienceFit.flag.moreYears": "The ad asks for {adYears} years of experience. You have {yourYears}.",
  "plus.r3.experienceFit.graduates": "Open to new graduates",
  "plus.r3.experienceFit.graduatesChip": "Open to new graduates",
  "plus.r3.experienceFit.heading": "Experience asked for",
  "plus.r3.experienceFit.help": "Shows ads that ask for at most this many years, and ads that do not state any. Most ads do not.",
  "plus.r3.experienceFit.label": "Up to (years)",
  "plus.r3.fixedTerm.benefitsMissing": "Benefits it does not list: {items}.",
  "plus.r3.fixedTerm.benefitsOnly": "Benefits only it lists: {items}.",
  "plus.r3.fixedTerm.chipLength": "Fixed-term, {months, plural, one {# month} other {# months}}",
  "plus.r3.fixedTerm.chipNoLength": "Fixed-term, length not stated in the ad",
  "plus.r3.fixedTerm.contractLength": "The job ends after {months, plural, one {# month} other {# months}}. {other} has no end stated.",
  "plus.r3.fixedTerm.contractNoLength": "The job ends at a set time, and the ad does not state when. {other} has no end stated.",
  "plus.r3.fixedTerm.firstYear": "Earnings in the first year: about {fixed} before tax, against about {other} over twelve months. Monthly pay times months, nothing else.",
  "plus.r3.fixedTerm.givesUpIntro": "{fixed} is fixed-term. Compared with {other}:",
  "plus.r3.fixedTerm.givesUpTitle": "What the fixed-term offer gives up",
  "plus.r3.fixedTerm.grade": "Employer Score: {fixed}, against {other}.",
  "plus.r3.fixedTerm.holidays": "Holiday days: {fixed}, against {other}.",
  "plus.r3.fixedTerm.officeDays": "Office days a week: {fixed}, against {other}.",
  "plus.r3.fixedTerm.pay": "Pay: {fixed} a month, against {other} a month.",
  "plus.r3.fixedTerm.trial": "Trial period: {fixed, plural, one {# month} other {# months}}, against {other, plural, one {# month} other {# months}}.",
  "plus.r3.followUp.default": "Applied {days, plural, one {# day} other {# days}} ago, no reply yet.",
  "plus.r3.followUp.dismiss": "Not now",
  "plus.r3.followUp.draft": "Draft a message",
  "plus.r3.followUp.employer": "Applied {days, plural, one {# day} other {# days}} ago. This employer usually replies within {typical, plural, one {# day} other {# days}}.",
  "plus.r3.followUp.open": "Open timeline",
  "plus.r3.followUp.title": "Time to follow up",
  "plus.r3.funnel.applications": "Applications",
  "plus.r3.funnel.basis": "Counted from My Jobs. A reply means the application moved past applied or has an interview date.",
  "plus.r3.funnel.benchmark": "Members applying to similar roles: {replied}% got a reply, {interview}% reached an interview, {offer}% got an offer. Based on {applications} applications, {window}.",
  "plus.r3.funnel.benchmarkLimit": "You have used this week's market comparisons. Your own numbers stay free.",
  "plus.r3.funnel.benchmarkNone": "No member data yet for roles like this one.",
  "plus.r3.funnel.benchmarkNotEnough": "Not enough data yet to compare roles like this one.",
  "plus.r3.funnel.byMonth": "By month",
  "plus.r3.funnel.byRole": "By role",
  "plus.r3.funnel.empty": "No data yet. Applications you mark as applied in My Jobs build your funnel.",
  "plus.r3.funnel.hide": "Hide",
  "plus.r3.funnel.interviews": "Interviews",
  "plus.r3.funnel.offers": "Offers",
  "plus.r3.funnel.replies": "Replies",
  "plus.r3.funnel.title": "Your application funnel",
  "plus.r3.gracePlanner.anyField": "Any field",
  "plus.r3.gracePlanner.daysLeft": "{days, plural, =0 {Today is the last day} one {# day left} other {# days left}}",
  "plus.r3.gracePlanner.deadline": "Your grace period ends on {date}",
  "plus.r3.gracePlanner.ended": "The grace period has ended. Contact Migri now about your options.",
  "plus.r3.gracePlanner.field": "Your field",
  "plus.r3.gracePlanner.invalidDate": "Enter a date that is today or earlier.",
  "plus.r3.gracePlanner.languagesInAd": "Languages in the ad: {languages}",
  "plus.r3.gracePlanner.lastWeeks": "Less than two weeks left. Contact Migri if you have not already.",
  "plus.r3.gracePlanner.linkBlue": "EU Blue Card",
  "plus.r3.gracePlanner.linkChange": "Changing jobs",
  "plus.r3.gracePlanner.linkEnd": "When your employment ends",
  "plus.r3.gracePlanner.linkLookFor": "Extended permit to look for work",
  "plus.r3.gracePlanner.loadError": "Could not make the plan. Try again.",
  "plus.r3.gracePlanner.lossDate": "Last day of your job",
  "plus.r3.gracePlanner.migriHeading": "Official guidance from Migri",
  "plus.r3.gracePlanner.notLegal": "This is a planning aid, not legal advice. Check your exact deadline and options with Migri.",
  "plus.r3.gracePlanner.pageSubtitle": "Lost your job and need a new one before your permit situation changes? See how long you have, a plan for each week and jobs you can do in English.",
  "plus.r3.gracePlanner.pageTitle": "Grace period planner",
  "plus.r3.gracePlanner.permit": "Your permit",
  "plus.r3.gracePlanner.permitBlueCard": "EU Blue Card (6 months)",
  "plus.r3.gracePlanner.permitResidence": "Residence permit for work (3 months)",
  "plus.r3.gracePlanner.planHeading": "Week by week",
  "plus.r3.gracePlanner.rolesHeading": "Jobs you can do in English",
  "plus.r3.gracePlanner.rolesNone": "No open jobs match in this field right now. Try another field.",
  "plus.r3.gracePlanner.rolesRule": "These ads do not require Finnish or Swedish and name English as a required or optional language.",
  "plus.r3.gracePlanner.rolesUnavailable": "The job list is not available right now. Your plan above still stands.",
  "plus.r3.gracePlanner.submit": "Make my plan",
  "plus.r3.gracePlanner.taskApply": "Apply to jobs you can do in English",
  "plus.r3.gracePlanner.taskCheckMigri": "Check your permit conditions with Migri",
  "plus.r3.gracePlanner.taskLastDays": "Confirm your next step with Migri",
  "plus.r3.gracePlanner.taskNetwork": "Tell your network you are looking",
  "plus.r3.gracePlanner.taskPreparePermit": "Prepare the documents for a new permit",
  "plus.r3.gracePlanner.taskRegisterTe": "Register as a job seeker at the TE Office",
  "plus.r3.gracePlanner.taskUpdateCv": "Update your CV in English",
  "plus.r3.gracePlanner.weekHeading": "Week {week}: {start} to {end}",
  "plus.r3.hiringNow.line": "Opened {count, plural, one {# role} other {# roles}} in the last {days} days",
  "plus.r3.hiringNow.note": "A hiring-activity signal from the ads we see open, not a promise to hire.",
  "plus.r3.hiringNow.title": "Hiring right now",
  "plus.r3.interviewPrep.build": "Build my prep pack",
  "plus.r3.interviewPrep.building": "Building your pack",
  "plus.r3.interviewPrep.builtOn": "Built {date}",
  "plus.r3.interviewPrep.company": "The company",
  "plus.r3.interviewPrep.download": "Download as text",
  "plus.r3.interviewPrep.emptyPack": "No data yet for this employer or role, so there is nothing to build a pack from. This did not use any of your allowance.",
  "plus.r3.interviewPrep.error": "We could not build the pack. Try again in a moment.",
  "plus.r3.interviewPrep.gapCompany": "Company facts",
  "plus.r3.interviewPrep.gapDecoder": "Ad comparison",
  "plus.r3.interviewPrep.gapHiring": "How the employer hires",
  "plus.r3.interviewPrep.gapPay": "Pay in similar ads",
  "plus.r3.interviewPrep.gapResponse": "Reply times",
  "plus.r3.interviewPrep.gapReviews": "Review themes",
  "plus.r3.interviewPrep.intro": "The employer, the role and questions to practise, with the source next to every line.",
  "plus.r3.interviewPrep.noDataYet": "No data yet",
  "plus.r3.interviewPrep.notEnoughData": "Not enough data",
  "plus.r3.interviewPrep.notFound": "We could not find this job.",
  "plus.r3.interviewPrep.numberBasis": "From the role’s market median to its upper quartile, the same figures as its salary page ({n} ads that state pay set the differences).",
  "plus.r3.interviewPrep.numberToGive": "If asked for a number: {min} to {max} EUR a month, gross",
  "plus.r3.interviewPrep.openRoles": "Other open roles",
  "plus.r3.interviewPrep.pay": "Pay and the number to give",
  "plus.r3.interviewPrep.practice": "Practice questions",
  "plus.r3.interviewPrep.rebuild": "Build again with the latest data",
  "plus.r3.interviewPrep.role": "The role",
  "plus.r3.interviewPrep.roundCase": "Case",
  "plus.r3.interviewPrep.roundManager": "Hiring manager",
  "plus.r3.interviewPrep.roundScreening": "Screening",
  "plus.r3.interviewPrep.sourceLabel": "Source: {source}",
  "plus.r3.interviewPrep.sources": "Sources",
  "plus.r3.interviewPrep.strongAnswer": "What a strong answer covers",
  "plus.r3.interviewPrep.title": "Interview prep pack",
  "plus.r3.interviewPrep.toAsk": "Questions to ask them",
  "plus.r3.language.caution": "Based on what the ad says. If it matters, ask the employer.",
  "plus.r3.language.companyBasis": "From {count, plural, one {# ad} other {# ads}} at this employer, {window}. Read from the ad texts.",
  "plus.r3.language.companyEnglish": "{percent}% of its ads are written in English ({count} of {of})",
  "plus.r3.language.companyFinnish": "{percent}% are written in Finnish ({count} of {of})",
  "plus.r3.language.companyFinnishRequired": "Finnish is required in {percent}% of the ads that state a language requirement ({count} of {of})",
  "plus.r3.language.companySwedish": "{percent}% are written in Swedish ({count} of {of})",
  "plus.r3.language.companySwedishRequired": "Swedish is required in {percent}% of the ads that state a language requirement ({count} of {of})",
  "plus.r3.language.companyTitle": "Languages at this employer",
  "plus.r3.language.englishEnough": "English looks enough: the ad is in English and does not ask for Finnish",
  "plus.r3.language.finnishImplied": "Written in Finnish, no language requirement stated",
  "plus.r3.language.finnishPreferred": "Finnish is a plus, not required",
  "plus.r3.language.finnishRequired": "Finnish is required",
  "plus.r3.language.fromFields": "Read from the language fields we extracted, not from the ad text.",
  "plus.r3.language.label": "Language needed",
  "plus.r3.language.noData": "No data yet. This employer's ads have not been read for language.",
  "plus.r3.language.notEnough": "Not enough data. This employer has too few ads to show a share.",
  "plus.r3.language.quote": "From the ad: \"{clause}\"",
  "plus.r3.language.rowHint": "The languages this employer writes its ads in and asks for",
  "plus.r3.language.similar": "{percent}% of {count, plural, one {# similar ad} other {# similar ads}} do not require Finnish.",
  "plus.r3.language.swedishRequired": "Swedish is required",
  "plus.r3.language.unclear": "The ad does not say which language you need",
  "plus.r3.marketTracking.body": "See your estimated market pay month by month and get a nudge when the gap to your pay grows.",
  "plus.r3.marketTracking.title": "Market value over time",
  "plus.r3.marketValue.add.button": "Track this role",
  "plus.r3.marketValue.add.label": "Role to track",
  "plus.r3.marketValue.add.noMatches": "No role with enough ads matches.",
  "plus.r3.marketValue.add.placeholder": "Search a role, for example Nurse",
  "plus.r3.marketValue.add.search": "Search roles",
  "plus.r3.marketValue.add.threshold": "Nudge me when the gap passes (percent)",
  "plus.r3.marketValue.chart.description": "From {first} to {last} the middle pay moved from {firstValue} to {lastValue} a month.",
  "plus.r3.marketValue.chart.emptyBody": "This role has too few months with enough ads to draw a trend.",
  "plus.r3.marketValue.chart.emptyTitle": "Not enough data",
  "plus.r3.marketValue.chart.subtitle": "{basis, select, official {Median monthly pay for the role (EUR). The axis does not start at zero.} other {Middle monthly pay in ads that state pay (EUR). The axis does not start at zero.}}",
  "plus.r3.marketValue.email": "Email me once a month when the gap passes my threshold",
  "plus.r3.marketValue.emailOff": "The monthly market value email is off.",
  "plus.r3.marketValue.empty.body": "Track up to {limit} roles to see their market pay month by month.",
  "plus.r3.marketValue.empty.title": "No role tracked yet",
  "plus.r3.marketValue.error": "Market value could not be loaded just now.",
  "plus.r3.marketValue.estimate": "Estimate for your level and region: {median} a month, middle half {p25} to {p75} ({n} ads).",
  "plus.r3.marketValue.headline": "Market pay for {role}, month by month",
  "plus.r3.marketValue.lead": "Your estimated market pay, month by month, with a nudge when the gap to your pay grows.",
  "plus.r3.marketValue.loading": "Loading market value...",
  "plus.r3.marketValue.noPay": "Add your pay to your current job to get a nudge.",
  "plus.r3.marketValue.nudge.above": "The market is {pct}% above your pay. Your threshold is {threshold}%.",
  "plus.r3.marketValue.nudge.below": "The market is {pct}% below your pay. Your threshold is {threshold}%.",
  "plus.r3.marketValue.remove": "Stop tracking",
  "plus.r3.marketValue.source": "{basis, select, official {Statistics Finland’s earnings for the occupation, raised to today, set the latest month; JobCrawls monthly market snapshots set the movement before it. {n} ads in the latest month, counted cumulatively, so the series shows the trend, not a census.} other {JobCrawls monthly market snapshots. {n} ads in the latest month. The ads are counted cumulatively, so the series shows the trend, not a census.}}",
  "plus.r3.marketValue.title": "Market value over time",
  "plus.r3.moveCompare.body": "Compare staying with moving or switching jobs: net pay, demand, pay range and commute.",
  "plus.r3.moveCompare.commute": "Check the commute (optional)",
  "plus.r3.moveCompare.commuteHome": "Home address or area",
  "plus.r3.moveCompare.commuteNew": "New workplace",
  "plus.r3.moveCompare.commuteNow": "Workplace now",
  "plus.r3.moveCompare.compare": "Compare",
  "plus.r3.moveCompare.comparing": "Comparing...",
  "plus.r3.moveCompare.demand": "{open} open now, about {perWeek} new a week",
  "plus.r3.moveCompare.diff.less": "Moving leaves you {amount} less a month after tax.",
  "plus.r3.moveCompare.diff.more": "Moving leaves you {amount} more a month after tax.",
  "plus.r3.moveCompare.diff.same": "Net pay a month is the same either way.",
  "plus.r3.moveCompare.error": "The comparison could not be made just now.",
  "plus.r3.moveCompare.fit": "{pct}% of the skills ads ask for",
  "plus.r3.moveCompare.fromMunicipality": "Where you live now (for the tax rate)",
  "plus.r3.moveCompare.gross.current": "{value} (your pay, full time)",
  "plus.r3.moveCompare.gross.market": "{value} (median for the role)",
  "plus.r3.moveCompare.gross.offer": "{value} (the offer)",
  "plus.r3.moveCompare.invalid": "We could not match one of the places or the role. Check the spelling.",
  "plus.r3.moveCompare.lead": "Compare staying with moving or switching jobs: net pay after municipal tax, pay range, demand, commute and fit.",
  "plus.r3.moveCompare.minutes": "{minutes} min",
  "plus.r3.moveCompare.move": "Moving",
  "plus.r3.moveCompare.municipality": "Municipality (for the tax rate)",
  "plus.r3.moveCompare.needsJob": "Add your current job to the profile to compare with staying.",
  "plus.r3.moveCompare.noData.body": "We could not find enough ads or a pay for this move. This did not use one of your comparisons.",
  "plus.r3.moveCompare.noData.title": "Not enough data",
  "plus.r3.moveCompare.none": "Not enough data",
  "plus.r3.moveCompare.noneChosen": "Not chosen (national average tax rate)",
  "plus.r3.moveCompare.offer": "Offer, gross a month (optional)",
  "plus.r3.moveCompare.range": "{median} ({p25} to {p75}), {n} ads",
  "plus.r3.moveCompare.region": "Region to move to",
  "plus.r3.moveCompare.regionStay": "Same region as now",
  "plus.r3.moveCompare.role": "Role to switch to (optional)",
  "plus.r3.moveCompare.row.commute": "Commute each way",
  "plus.r3.moveCompare.row.demand": "Demand",
  "plus.r3.moveCompare.row.fit": "Fit with your CV",
  "plus.r3.moveCompare.row.gross": "Gross a month",
  "plus.r3.moveCompare.row.net": "Net a month",
  "plus.r3.moveCompare.row.range": "Pay range in ads",
  "plus.r3.moveCompare.section.title": "What if I moved",
  "plus.r3.moveCompare.sources": "Net pay comes from the JobCrawls net pay calculator (2026 tax year). Pay, demand and fit come from ads in the last 12 months.",
  "plus.r3.moveCompare.stay": "Staying",
  "plus.r3.moveCompare.tax": "Municipal tax {rate}%",
  "plus.r3.moveCompare.taxGeneric": "National average tax rate",
  "plus.r3.moveCompare.title": "What if I moved",
  "plus.r3.obligation.copied": "List copied",
  "plus.r3.obligation.copy": "Copy list for Työmarkkinatori",
  "plus.r3.obligation.counts": "Counts what is in My Jobs. Applications you sent elsewhere are not included until you add them.",
  "plus.r3.obligation.empty": "No applications counted this month yet. Mark a job as applied in My Jobs and it shows up here.",
  "plus.r3.obligation.export.date": "Date",
  "plus.r3.obligation.export.employer": "Employer",
  "plus.r3.obligation.export.footer": "Counted by JobCrawls, rule {version}. Source: {source}.",
  "plus.r3.obligation.export.header": "Job applications {month}",
  "plus.r3.obligation.export.how": "How",
  "plus.r3.obligation.export.how.autofill": "Sent with JobCrawls",
  "plus.r3.obligation.export.how.external": "On the employer's site",
  "plus.r3.obligation.export.how.manual": "Marked as applied",
  "plus.r3.obligation.export.link": "Link",
  "plus.r3.obligation.export.title": "Job",
  "plus.r3.obligation.list": "Counted applications",
  "plus.r3.obligation.met": "You have reached this month's target.",
  "plus.r3.obligation.onTrack": "{missing, plural, one {# more application} other {# more applications}} to reach the target. {days, plural, one {# day} other {# days}} left this month.",
  "plus.r3.obligation.openSource": "Open Työmarkkinatori",
  "plus.r3.obligation.plan": "Your own employment plan on Työmarkkinatori sets the number that applies to you. We count against {target} a month.",
  "plus.r3.obligation.progress": "{count} of {target} applications",
  "plus.r3.obligation.rule": "Rule {version}. Source: {source}.",
  "plus.r3.obligation.howCounted": "How this is counted",
  "plus.r3.obligation.close": "Close",
  "plus.r3.obligation.title": "Applications this month",
  "plus.r3.obligation.unchecked": "The rules can change. Check the current requirement at {source} before you rely on this count.",
  "plus.r3.obligation.warn": "Only {days, plural, =0 {today is} one {# day is} other {# days are}} left this month and you need {missing, plural, one {# more application} other {# more applications}} to reach the target of {target}.",
  "plus.r3.payInfoLetter.body": "A ready letter asking your employer for comparator pay, in Finnish, Swedish or English.",
  "plus.r3.payInfoLetter.build": "Write the letter",
  "plus.r3.payInfoLetter.copy": "Copy the letter",
  "plus.r3.payInfoLetter.field.comparator": "Who do you compare with? For example: customer service specialists in the same unit",
  "plus.r3.payInfoLetter.field.employer": "Employer",
  "plus.r3.payInfoLetter.field.language": "Letter language",
  "plus.r3.payInfoLetter.field.marketRef": "Add a line with the market pay for my role",
  "plus.r3.payInfoLetter.field.senderJob": "Your job title",
  "plus.r3.payInfoLetter.field.senderName": "Your name",
  "plus.r3.payInfoLetter.page.lead": "A ready letter asking your employer for the pay information the Equality Act gives you the right to ask for.",
  "plus.r3.payInfoLetter.page.title": "Pay information request",
  "plus.r3.payInfoLetter.pending": "This letter is a draft until the final text of the law is confirmed.",
  "plus.r3.payInfoLetter.title": "Pay information request",
  "plus.r3.payTools.body": "Prepare a pay talk and see how many job ads state their pay.",
  "plus.r3.payTools.raise": "Raise case",
  "plus.r3.payTools.title": "Pay tools",
  "plus.r3.payTools.tracker": "Pay transparency tracker",
  "plus.r3.payTransparency.after": "From 2027: {share} ({ads} ads)",
  "plus.r3.payTransparency.afterNone": "From 2027: no data yet",
  "plus.r3.payTransparency.before": "Before 2027: {share} ({ads} ads)",
  "plus.r3.payTransparency.beforeAfter": "Before and after 2027",
  "plus.r3.payTransparency.byRegion": "By region",
  "plus.r3.payTransparency.bySector": "By employer type",
  "plus.r3.payTransparency.drill.ads": "Ads",
  "plus.r3.payTransparency.drill.agencies": "Include staffing agencies",
  "plus.r3.payTransparency.drill.agency": "Agency",
  "plus.r3.payTransparency.drill.allSectors": "All types",
  "plus.r3.payTransparency.drill.employer": "Employer",
  "plus.r3.payTransparency.drill.empty": "No employers match. Employers need at least {min} ads to be listed.",
  "plus.r3.payTransparency.drill.lead": "See which employers state pay in their ads, and export the list.",
  "plus.r3.payTransparency.drill.load": "Show employers",
  "plus.r3.payTransparency.drill.search": "Search an employer",
  "plus.r3.payTransparency.drill.sector": "Employer type",
  "plus.r3.payTransparency.drill.share": "Share",
  "plus.r3.payTransparency.drill.signIn": "Sign in to see employers.",
  "plus.r3.payTransparency.drill.title": "Employer drill-down",
  "plus.r3.payTransparency.drill.withPay": "With pay",
  "plus.r3.payTransparency.error": "The employer list could not be loaded just now.",
  "plus.r3.payTransparency.export": "Export as CSV",
  "plus.r3.payTransparency.exportNone": "Nothing to export for these filters. This did not use one of your exports.",
  "plus.r3.payTransparency.framing": "The planned amendment to the Equality Act (HE 129/2026) is targeted to apply from 1 January 2027. It is meant to give job seekers pay information before the interview, not necessarily in the ad. This page shows how often ads already state pay.",
  "plus.r3.payTransparency.headline": "{share} of job ads in Finland state pay",
  "plus.r3.payTransparency.headlineSub": "Ads first seen from {from} to {to}.",
  "plus.r3.payTransparency.lead": "How many job ads in Finland say what the job pays, month by month, by sector and region.",
  "plus.r3.payTransparency.method": "Method",
  "plus.r3.payTransparency.noData.body": "The first monthly figures appear here once they have been calculated.",
  "plus.r3.payTransparency.noData.title": "No data yet",
  "plus.r3.payTransparency.rowValue": "{share} of {ads} ads",
  "plus.r3.payTransparency.salaryLink": "See pay by role in the salary guide",
  "plus.r3.payTransparency.sector.nonprofit": "Non-profits",
  "plus.r3.payTransparency.sector.other": "Other, including staffing agencies",
  "plus.r3.payTransparency.sector.private": "Private companies",
  "plus.r3.payTransparency.sector.public": "Public sector",
  "plus.r3.payTransparency.series.description": "The share of ads that state pay went from {first} in {firstMonth} to {last} in {lastMonth}.",
  "plus.r3.payTransparency.series.headline": "Share of ads that state pay, by month",
  "plus.r3.payTransparency.series.subtitle": "Percent of ads first seen in the month. Months with fewer than {min} ads are left out.",
  "plus.r3.payTransparency.source": "JobCrawls index, job ads in Finland, each ad counted once. {ads} ads, {withPay} with pay. Updated {date}.",
  "plus.r3.payTransparency.title": "Pay transparency tracker",
  "plus.r3.payTransparencyExport.body": "Drill into which employers, sectors and regions state pay, and export the numbers.",
  "plus.r3.payTransparencyExport.title": "Pay transparency data",
  "plus.r3.programmeCalendar.actionError": "We could not change that. Try again in a moment.",
  "plus.r3.programmeCalendar.alertOn": "We tell you on {day}, {days, plural, one {# day} other {# days}} before. Needs email or app alerts on in Searches & Alerts.",
  "plus.r3.programmeCalendar.basis": "Dates come from the last cycle we saw ({total, plural, one {# programme} other {# programmes}}). Employers can change them, so check the employer's own page.",
  "plus.r3.programmeCalendar.counter": "Programmes watched: {used} of {limit}",
  "plus.r3.programmeCalendar.counterUnlimited": "Programmes watched: {used}",
  "plus.r3.programmeCalendar.empty": "No data yet. We have not seen a trainee or graduate programme to list.",
  "plus.r3.programmeCalendar.emptySearch": "No programme matches your search.",
  "plus.r3.programmeCalendar.expected": "Expected {opens}",
  "plus.r3.programmeCalendar.expectedWindow": "Expect it from {opens}{closes, select, none {} other { to {closesOn}}}",
  "plus.r3.programmeCalendar.inDays": "{days, plural, =0 {should open today} one {opens in about # day} other {opens in about # days}}",
  "plus.r3.programmeCalendar.lastCycle": "Last cycle: first listed {opened}, {closed, select, open {still open} other {last seen {closedOn}}}",
  "plus.r3.programmeCalendar.loadError": "We could not load the programmes. Try again in a moment.",
  "plus.r3.programmeCalendar.loadMore": "Show more",
  "plus.r3.programmeCalendar.menu.label": "Programme calendar",
  "plus.r3.programmeCalendar.menu.note": "trainee and graduate programmes",
  "plus.r3.programmeCalendar.noDate": "No date to expect yet",
  "plus.r3.programmeCalendar.openNow": "Open now",
  "plus.r3.programmeCalendar.overdue": "should have opened {days, plural, one {# day} other {# days}} ago",
  "plus.r3.programmeCalendar.retry": "Try again",
  "plus.r3.programmeCalendar.search": "Search programmes",
  "plus.r3.programmeCalendar.searchPlaceholder": "Employer or programme",
  "plus.r3.programmeCalendar.signIn": "Sign in to see the programme calendar.",
  "plus.r3.programmeCalendar.subtitle": "Trainee and graduate programmes that come back every year, with the window to expect next.",
  "plus.r3.programmeCalendar.title": "Programme calendar",
  "plus.r3.programmeCalendar.unwatch": "Stop watching",
  "plus.r3.programmeCalendar.watch": "Alert me",
  "plus.r3.programmeCalendar.watching": "Watching",
  "plus.r3.programmeWatch.body": "Watch trainee and graduate programmes and hear when the next window is due.",
  "plus.r3.programmeWatch.title": "Programme calendar",
  "plus.r3.quietWatch.addToJob": "Edit your current job",
  "plus.r3.quietWatch.blockerGrade": "Choose your employer's grade to compare grades.",
  "plus.r3.quietWatch.blockerOffice": "Add your office days to compare office days.",
  "plus.r3.quietWatch.blockerPay": "Add your pay to compare pay.",
  "plus.r3.quietWatch.body": "Keep your job and hear only about clear upgrades, at most twice a month.",
  "plus.r3.quietWatch.currentGrade": "Your employer's grade",
  "plus.r3.quietWatch.fewerOfficeDays": "Fewer office days than today",
  "plus.r3.quietWatch.fewerOfficeDaysHelp": "Only remote jobs count when you go to the office, because a hybrid ad does not say how many days.",
  "plus.r3.quietWatch.gradeHelp": "The letter on your employer's company page.",
  "plus.r3.quietWatch.gradeNone": "Not set",
  "plus.r3.quietWatch.gradeUp": "Employer Score at least one grade higher",
  "plus.r3.quietWatch.intro": "I have a job, only tell me about clear upgrades. Scout stays quiet unless a job beats your current one, and tells you about at most two a month.",
  "plus.r3.quietWatch.loadError": "Could not load Quiet watch.",
  "plus.r3.quietWatch.modeFull": "Your contract is ending soon, so Scout is doing a full search now.",
  "plus.r3.quietWatch.modeQuiet": "Quiet watch is on.",
  "plus.r3.quietWatch.monthUsed": "This month: {used, number} of {max, number} {max, plural, one {ping} other {pings}} used.",
  "plus.r3.quietWatch.noBrief": "Set up Scout first, then Quiet watch can sit on top of it.",
  "plus.r3.quietWatch.noUsable": "Quiet watch needs at least one upgrade rule it can check. Fill in what is missing above.",
  "plus.r3.quietWatch.payGain": "Stated pay at least this much higher (%)",
  "plus.r3.quietWatch.payGainHelp": "Compared with your full-time pay, using the lowest figure the ad states. Ads without stated pay never count.",
  "plus.r3.quietWatch.recent": "Upgrades it found",
  "plus.r3.quietWatch.recentNone": "No upgrades yet. Scout stays quiet until one shows up.",
  "plus.r3.quietWatch.save": "Save",
  "plus.r3.quietWatch.saveError": "Could not save. Try again.",
  "plus.r3.quietWatch.saved": "Saved",
  "plus.r3.quietWatch.thresholds": "A job counts as an upgrade when it has any of these",
  "plus.r3.quietWatch.title": "Quiet watch",
  "plus.r3.quietWatch.toggle": "Only tell me about clear upgrades",
  "plus.r3.raiseCase.addPay": "Add your pay to see where it sits.",
  "plus.r3.raiseCase.allFinland": "All of Finland",
  "plus.r3.raiseCase.body": "A one-page brief for your pay talk: market pay for your role, the 12-month drift and the sources, as a PDF.",
  "plus.r3.raiseCase.build": "Build my raise case",
  "plus.r3.raiseCase.building": "Reading the market for your role...",
  "plus.r3.raiseCase.download": "Download as PDF",
  "plus.r3.raiseCase.error": "The raise case could not be built just now. Try again in a moment.",
  "plus.r3.raiseCase.left": "{count} briefs left this week",
  "plus.r3.raiseCase.link": "Build a raise case for your pay talk",
  "plus.r3.raiseCase.needsJob.body": "Add your title, level, region and pay to your profile. The brief compares them with the market.",
  "plus.r3.raiseCase.needsJob.cta": "Add my current job",
  "plus.r3.raiseCase.needsJob.title": "Add your current job first",
  "plus.r3.raiseCase.noData.body": "There are too few ads with stated pay for this role to say something real. This did not use one of your briefs.",
  "plus.r3.raiseCase.noData.title": "Not enough data",
  "plus.r3.raiseCase.page.subtitle": "A one-page brief for your pay talk, built from market data with its sources.",
  "plus.r3.raiseCase.page.title": "Raise case",
  "plus.r3.raiseCase.pdf.date": "Prepared {date}",
  "plus.r3.raiseCase.pdf.footer": "Market figures are estimates for the role, the same as on its salary page (Statistics Finland where the occupation is covered, otherwise what job ads state), not what any employer pays. Each sentence cites its source above.",
  "plus.r3.raiseCase.pdf.subtitle": "{place}, based on JobCrawls market data",
  "plus.r3.raiseCase.pdf.title": "Raise case: {role}",
  "plus.r3.raiseCase.pickRole.body": "We could not match \"{title}\" to a role with enough ads. Pick the closest one.",
  "plus.r3.raiseCase.pickRole.title": "Which role is yours?",
  "plus.r3.raiseCase.pickRole.use": "Use this role",
  "plus.r3.raiseCase.rebuild": "Build it again",
  "plus.r3.raiseCase.section.drift": "How it moved in 12 months",
  "plus.r3.raiseCase.section.floor": "Collective agreement floor",
  "plus.r3.raiseCase.section.marketPay": "What the market pays",
  "plus.r3.raiseCase.section.official": "Official statistics",
  "plus.r3.raiseCase.section.position": "Where your pay sits",
  "plus.r3.raiseCase.sectionEmpty": "Not enough data",
  "plus.r3.raiseCase.signIn": "Sign in to build your raise case.",
  "plus.r3.raiseCase.sources": "Sources",
  "plus.r3.raiseCase.title": "Raise case",
  "plus.r3.remoteRadar.error": "We could not change the remote radar. Try again in a moment.",
  "plus.r3.remoteRadar.help": "Instant alerts only for remote ads open to people in Finland, each with the reason, for example \"Remote within the EU\". Needs instant alerts. Best on a search without a place.",
  "plus.r3.remoteRadar.label": "Remote radar",
  "plus.r3.replies.basis": "Among about {applications} applications that JobCrawls members tracked, {window}. Not everyone who applied.",
  "plus.r3.replies.days": "Typically within {days, plural, one {# day} other {# days}}.",
  "plus.r3.replies.interview": "{n} in 10 reached an interview.",
  "plus.r3.replies.interviewFew": "Fewer than 1 in 10 reached an interview.",
  "plus.r3.replies.noData": "No data yet. Replies show here once JobCrawls members track applications to this employer.",
  "plus.r3.replies.notEnough": "Not enough data. We show replies once 20 applications to this employer are tracked.",
  "plus.r3.replies.replied": "{company} answered {n} in 10 tracked applicants",
  "plus.r3.replies.repliedFew": "{company} answered fewer than 1 in 10 tracked applicants",
  "plus.r3.replies.rowHint": "How this employer answers applicants",
  "plus.r3.replies.rowLabel": "Who replies",
  "plus.r3.replies.thisEmployer": "This employer",
  "plus.r3.replies.title": "Who actually replies",
  "plus.r3.savedQuestions.body": "Keep the questions you ask the archive, re-run them and get an alert when the answer moves.",
  "plus.r3.savedQuestions.title": "Saved questions",
  "plus.r3.scoutBriefs.body": "Run more than one search at once, each with its own CV version and Monday plan.",
  "plus.r3.scoutBriefs.title": "Search tracks",
  "plus.r3.scoutTracks.add": "Add a search",
  "plus.r3.scoutTracks.addHelp": "Run up to {limit, number} searches side by side, each with its own CV and Monday plan.",
  "plus.r3.scoutTracks.cvDefault": "My default CV",
  "plus.r3.scoutTracks.cvLabel": "CV for this search",
  "plus.r3.scoutTracks.loadError": "Could not load your searches.",
  "plus.r3.scoutTracks.mainName": "Main search",
  "plus.r3.scoutTracks.nameLabel": "Name of this search",
  "plus.r3.scoutTracks.namePlaceholder": "For example Teaching or Data roles",
  "plus.r3.scoutTracks.newTitle": "Add a search",
  "plus.r3.scoutTracks.noMain": "Set up your first search before adding another.",
  "plus.r3.scoutTracks.paused": "Paused",
  "plus.r3.scoutTracks.planEmpty": "No plan yet. It appears on Monday from the week's picks for this search.",
  "plus.r3.scoutTracks.planHeading": "Monday plan for this search",
  "plus.r3.scoutTracks.remove": "Remove this search",
  "plus.r3.scoutTracks.removeConfirm": "Remove this search and its picks? Your other searches stay.",
  "plus.r3.scoutTracks.removeNo": "Keep it",
  "plus.r3.scoutTracks.removeYes": "Yes, remove it",
  "plus.r3.scoutTracks.tabsLabel": "Your searches",
  "plus.r3.seenOnSite.ats": "On the employer's own hiring system as of today",
  "plus.r3.seenOnSite.detail": "Last seen {when} at {host}. Business ID {businessId} matches the PRH register.",
  "plus.r3.seenOnSite.own": "On the employer's own careers page as of today",
  "plus.r3.shiftsFilter.evening": "Ads that state evening work",
  "plus.r3.shiftsFilter.eveningChip": "Evening work",
  "plus.r3.shiftsFilter.fullTimeChip": "35 h or more a week",
  "plus.r3.shiftsFilter.heading": "Shifts and hours",
  "plus.r3.shiftsFilter.help": "These match what the ad says. An ad that does not mention its hours or shifts is not shown.",
  "plus.r3.shiftsFilter.hoursAny": "Any",
  "plus.r3.shiftsFilter.hoursFullTime": "Full-time, 35 h or more",
  "plus.r3.shiftsFilter.hoursLegend": "Weekly hours stated in the ad",
  "plus.r3.shiftsFilter.hoursPartTime": "Part-time, up to 30 h",
  "plus.r3.shiftsFilter.partTimeChip": "Up to 30 h a week",
  "plus.r3.shiftsFilter.shift": "Ads that state shift work",
  "plus.r3.shiftsFilter.shiftChip": "Shift work",
  "plus.r3.shiftsFilter.weekend": "Ads that state weekend work",
  "plus.r3.shiftsFilter.weekendChip": "Weekend work",
  "plus.r3.signals.listLabel": "Signals about this ad",
  "plus.r3.signals.loadFailed": "Could not load this right now. Try again in a moment.",
  "plus.r3.staleAd.chipNote": "Facts about this ad, not a verdict on the employer.",
  "plus.r3.staleAd.chipOpen": "Open {days, plural, one {# day} other {# days}}",
  "plus.r3.staleAd.chipReposted": "Posted again {count, plural, one {# time} other {# times}}",
  "plus.r3.staleAd.firstPosted": "First posted {date}.",
  "plus.r3.staleAd.notTracked": "Repost history is not tracked for this ad yet.",
  "plus.r3.staleAd.openOnly": "Open {days, plural, one {# day} other {# days}}.",
  "plus.r3.staleAd.openRepostedOnly": "Open {days, plural, one {# day} other {# days}}, reposted {reposts, plural, one {# time} other {# times}}.",
  "plus.r3.staleAd.openRepostedUsual": "Open {days, plural, one {# day} other {# days}}, reposted {reposts, plural, one {# time} other {# times}}. This employer usually fills similar roles in {usual, plural, one {# day} other {# days}}.",
  "plus.r3.staleAd.openUsual": "Open {days, plural, one {# day} other {# days}}. This employer usually fills similar roles in {usual, plural, one {# day} other {# days}}.",
  "plus.r3.staleAd.withheld": "Repost history is not shown for this ad because some first-seen dates in its history are not reliable.",
  "plus.r3.summerKit.actionError": "We could not change that alert. Try again in a moment.",
  "plus.r3.summerKit.alertAdd": "Remind me",
  "plus.r3.summerKit.alertCounter": "Deadline alerts: {used} of {limit}",
  "plus.r3.summerKit.alertCounterUnlimited": "Deadline alerts: {used}",
  "plus.r3.summerKit.alertHelp": "We email you {days, plural, one {# day} other {# days}} before the deadline. Needs email or app alerts on in Searches & Alerts.",
  "plus.r3.summerKit.alertNoDeadline": "No deadline to count down to",
  "plus.r3.summerKit.alertRemove": "Remove alert",
  "plus.r3.summerKit.alertSet": "Alert on",
  "plus.r3.summerKit.closesOn": "Closes {date}",
  "plus.r3.summerKit.daysLeft": "{days, plural, =0 {Closes today} one {# day left} other {# days left}}",
  "plus.r3.summerKit.digest": "Weekly summer job digest",
  "plus.r3.summerKit.digestHelp": "Every Monday from November to March: the summer jobs with the nearest deadlines.",
  "plus.r3.summerKit.empty": "No data yet. No summer jobs are open right now. They usually start to appear in October.",
  "plus.r3.summerKit.emptySearch": "No open summer jobs match your search.",
  "plus.r3.summerKit.expired": "{count, plural, one {# ad is left out because its deadline has passed.} other {# ads are left out because their deadlines have passed.}}",
  "plus.r3.summerKit.historyLocked": "{count, plural, one {# employer here hired last summer.} other {# employers here hired last summer.}} Sign in to see when they opened and closed.",
  "plus.r3.summerKit.lastYear": "Last summer: first listed {opened}, {closed, select, open {still open} other {last seen {closedOn}}}",
  "plus.r3.summerKit.lastYearDeadline": "Latest deadline last summer: {date}",
  "plus.r3.summerKit.loadError": "We could not load the summer jobs. Try again in a moment.",
  "plus.r3.summerKit.loadMore": "Show more",
  "plus.r3.summerKit.menu.label": "Summer job kit",
  "plus.r3.summerKit.menu.note": "deadlines, soonest first",
  "plus.r3.summerKit.noDeadline": "No deadline stated",
  "plus.r3.summerKit.offSeason": "Summer job season runs from November to March. The list below is what is open now.",
  "plus.r3.summerKit.retry": "Try again",
  "plus.r3.summerKit.search": "Search summer jobs",
  "plus.r3.summerKit.searchPlaceholder": "Role, employer or place",
  "plus.r3.summerKit.signIn": "Sign in to see the summer job kit.",
  "plus.r3.summerKit.subtitle": "Open summer jobs, soonest deadline first, with the days left.",
  "plus.r3.summerKit.summary": "{total, plural, one {# open summer job} other {# open summer jobs}}, {noDeadline} without a stated deadline",
  "plus.r3.summerKit.title": "Summer job kit",
  "plus.r3.summerKit.truncated": "There are more open summer jobs than we can list here. Narrow the search to see the rest.",
  "plus.r3.unit.alerts": "{count, plural, one {deadline alert} other {deadline alerts}}",
  "plus.r3.unit.briefs": "{count, plural, one {brief} other {briefs}}",
  "plus.r3.unit.checks": "{count, plural, one {CV date check} other {CV date checks}}",
  "plus.r3.unit.endpoints": "{count, plural, one {webhook endpoint} other {webhook endpoints}}",
  "plus.r3.unit.exports": "{count, plural, one {export} other {exports}}",
  "plus.r3.unit.letters": "{count, plural, one {letter} other {letters}}",
  "plus.r3.unit.programmes": "{count, plural, one {watched programme} other {watched programmes}}",
  "plus.r3.unit.savedQuestions": "{count, plural, one {saved question} other {saved questions}}",
  "plus.r3.unit.trackedRoles": "{count, plural, one {tracked role} other {tracked roles}}",
  "plus.r3.webhooks.body": "Send new Scout picks, stage changes and employer replies to your own tools.",
  "plus.r3.webhooks.title": "Webhooks",
  "plus.r4.automation.apiKeys": "Create an API key",
  "plus.r4.automation.body": "Create an API key, add JobCrawls in Zapier or Make, and paste the key. Each trigger you switch on shows up above as a webhook.",
  "plus.r4.automation.title": "Zapier and Make",
  "plus.r4.connections.button": "Connections",
  "plus.r4.connections.close": "Close",
  "plus.r4.connections.connect": "Connect",
  "plus.r4.connections.connected": "Connected",
  "plus.r4.connections.connectedNotice": "Connected.",
  "plus.r4.connections.disconnect": "Disconnect",
  "plus.r4.connections.error": "That did not work. Nothing was changed.",
  "plus.r4.connections.loadError": "We could not load this. Try again in a moment.",
  "plus.r4.connections.menuLabel": "Connections",
  "plus.r4.connections.menuNote": "webhooks, Zapier, Notion",
  "plus.r4.connections.notSetUp": "Not available yet",
  "plus.r4.connections.pageIntro": "Send what happens in your job search to your own tools, and keep My Jobs in step with Notion.",
  "plus.r4.connections.pageTitle": "Connections",
  "plus.r4.connections.reconnect": "The connection has expired. Disconnect and connect again.",
  "plus.r4.connections.title": "Connections",
  "plus.r4.employerMap.counts": "{companies, plural, one {# company} other {# companies}} and {jobs, plural, one {# job} other {# jobs}} on the map.",
  "plus.r4.employerMap.downloadGpx": "Download for Apple Maps apps (GPX)",
  "plus.r4.employerMap.downloadKml": "Download for Google My Maps (KML)",
  "plus.r4.employerMap.error": "We could not load the map. Try again in a moment.",
  "plus.r4.employerMap.intro": "Take the companies you follow and the jobs you saved to a map. Open the file in Google My Maps, or load the GPX file in an Apple Maps app.",
  "plus.r4.employerMap.missing": "{count, plural, one {# followed company is} other {# followed companies are}} left out: we have no registered address on file for {count, plural, one {it} other {them}}.",
  "plus.r4.employerMap.missingJobs": "{count, plural, one {# saved job is} other {# saved jobs are}} left out: remote, abroad or without a place.",
  "plus.r4.employerMap.noData": "No data yet. Follow a company or save a job with a place, and it appears here.",
  "plus.r4.employerMap.noHome": "Add a home address in your profile to draw rings around it.",
  "plus.r4.employerMap.ringOption": "{km} km",
  "plus.r4.employerMap.ringsLabel": "Rings from home",
  "plus.r4.employerMap.ringsNote": "Rings show straight-line distance, not travel time.",
  "plus.r4.employerMap.source": "Company places are from the PRH Trade Register (CC BY 4.0).",
  "plus.r4.employerMap.title": "Employer map",
  "plus.r4.followupTasks.body": "Each follow-up reminder becomes one task in your task app with the same due date. Tick it off there and the reminder closes in My Jobs.",
  "plus.r4.followupTasks.sync": "Sync now",
  "plus.r4.followupTasks.synced": "{created, plural, =0 {No new tasks} one {# task created} other {# tasks created}}, {closed, plural, =0 {none closed} one {# reminder closed} other {# reminders closed}}.",
  "plus.r4.followupTasks.title": "Follow-ups as tasks",
  "plus.r4.followupTasks.use": "Send follow-ups to this app",
  "plus.r4.inviteCalendar.addToCalendar": "Add to calendar",
  "plus.r4.inviteCalendar.addToMyJobs": "Add to My Jobs",
  "plus.r4.inviteCalendar.added": "Added to My Jobs",
  "plus.r4.inviteCalendar.ambiguousNoDate": "We found a time but no date. Enter the date to add it.",
  "plus.r4.inviteCalendar.ambiguousNoTime": "We found a date but no time. Enter the time to add it.",
  "plus.r4.inviteCalendar.ambiguousSeveral": "This email names more than one time. Which one was confirmed?",
  "plus.r4.inviteCalendar.ambiguousZone": "This email gives the time in a zone we cannot place. Enter the Finnish time to add it.",
  "plus.r4.inviteCalendar.error": "We could not read your invites. Try again in a moment.",
  "plus.r4.inviteCalendar.intro": "We read invites that reach your application address. Check the time, then add it to My Jobs and your calendar.",
  "plus.r4.inviteCalendar.kindInPerson": "In person",
  "plus.r4.inviteCalendar.kindPhone": "Phone call",
  "plus.r4.inviteCalendar.kindVideo": "Video call",
  "plus.r4.inviteCalendar.manualDate": "Date",
  "plus.r4.inviteCalendar.manualPlace": "Place or meeting link (optional)",
  "plus.r4.inviteCalendar.manualTime": "Time (Finnish time)",
  "plus.r4.inviteCalendar.none": "No interview invites yet.",
  "plus.r4.inviteCalendar.notTracked": "Mark this job as applied in My Jobs first, then add the interview.",
  "plus.r4.inviteCalendar.pasteLabel": "Email text",
  "plus.r4.inviteCalendar.pasteNone": "We could not find a date or time in that text.",
  "plus.r4.inviteCalendar.pasteRead": "Read the invite",
  "plus.r4.inviteCalendar.pasteTitle": "Paste an invite",
  "plus.r4.inviteCalendar.summary": "Interview: {job}",
  "plus.r4.inviteCalendar.title": "Interview invites",
  "plus.r4.inviteCalendar.useThis": "Use this time",
  "plus.r4.inviteCalendar.when": "{when} (Finnish time)",
  "plus.r4.leaveBy.action": "Work out when to leave",
  "plus.r4.leaveBy.detail": "{minutes} min by public transport, {transfers, plural, =0 {no changes} one {# change} other {# changes}}. Finnish time.",
  "plus.r4.leaveBy.failed": "We could not check the timetable. Try again in a moment.",
  "plus.r4.leaveBy.mapsLink": "Open in Google Maps",
  "plus.r4.leaveBy.nextInterview": "Your next interview: {when} (Finnish time)",
  "plus.r4.leaveBy.noHome": "Add your home address in your profile to get a leave-by time.",
  "plus.r4.leaveBy.noKey": "Timetables are not available right now. Use the map link instead.",
  "plus.r4.leaveBy.noPlace": "We could not place the interview address on a map.",
  "plus.r4.leaveBy.noRoute": "We found no public transport route that gets you there in time. Check the timetable yourself.",
  "plus.r4.leaveBy.outside": "Our timetable data covers Finland only. Use the map link instead.",
  "plus.r4.leaveBy.result": "Leave at {leave} to arrive {arrive}",
  "plus.r4.leaveBy.title": "Leave-by time",
  "plus.r4.linkedinImport.applied": "Added to your CV. Check it over before you send it anywhere.",
  "plus.r4.linkedinImport.apply": "Add to my CV",
  "plus.r4.linkedinImport.chooseFile": "LinkedIn ZIP file",
  "plus.r4.linkedinImport.error": "We could not read that file. Try again in a moment.",
  "plus.r4.linkedinImport.found": "Found {roles, plural, one {# role} other {# roles}}, {degrees, plural, one {# degree} other {# degrees}} and {skills, plural, one {# skill} other {# skills}}.",
  "plus.r4.linkedinImport.howTo": "On LinkedIn, open Settings, Data privacy, Get a copy of your data, pick the profile items and download the ZIP file. Then choose it here.",
  "plus.r4.linkedinImport.intro": "Fill your CV from LinkedIn without retyping. Your file is read once and is not stored.",
  "plus.r4.linkedinImport.missing": "Not in your file: {files}.",
  "plus.r4.linkedinImport.notZip": "That does not look like a LinkedIn data file. Choose the ZIP you downloaded from LinkedIn.",
  "plus.r4.linkedinImport.nothing": "That file has no roles, degrees or skills we can use.",
  "plus.r4.linkedinImport.reading": "Reading your file",
  "plus.r4.linkedinImport.title": "Import from LinkedIn",
  "plus.r4.linkedinImport.tooLarge": "That file is too large. Ask LinkedIn for the profile items only, not your whole archive.",
  "plus.r4.linkedinImport.withLinkedIn": "Import with LinkedIn",
  "plus.r4.linkedinImport.withLinkedInNote": "Available in the EU and EEA.",
  "plus.r4.notion.connect": "Connect Notion",
  "plus.r4.notion.connectFailed": "Notion was not connected. Try again.",
  "plus.r4.notion.connected": "Connected to {workspace}.",
  "plus.r4.notion.create": "Create the database",
  "plus.r4.notion.disconnect": "Disconnect",
  "plus.r4.notion.disconnectNote": "Disconnecting stops the sync. Your Notion pages stay as they are. Remove JobCrawls under Connections in Notion to end its access.",
  "plus.r4.notion.intro": "Mirror My Jobs in a Notion database. Stage and notes stay in step both ways.",
  "plus.r4.notion.justConnected": "Notion is connected. Pick a page for the database.",
  "plus.r4.notion.lastFailed": "The last sync did not work. We try again every minute.",
  "plus.r4.notion.lastOk": "Last sync {time}: {pushed} sent, {pulled} received.",
  "plus.r4.notion.linked": "{count, plural, one {# job} other {# jobs}} in step.",
  "plus.r4.notion.noPages": "No pages are shared with JobCrawls yet. Connect again and pick a page to share.",
  "plus.r4.notion.notConfigured": "Notion is not set up on this site yet.",
  "plus.r4.notion.open": "Open the database in Notion",
  "plus.r4.notion.pageHelp": "These are the pages you shared with JobCrawls in Notion.",
  "plus.r4.notion.pageNotShared": "Notion cannot reach that page. Share it with JobCrawls and try again.",
  "plus.r4.notion.pickPage": "Where should the database go?",
  "plus.r4.notion.rules": "If you change the same thing on both sides, JobCrawls wins. A saved job cannot be moved from Notion.",
  "plus.r4.notion.syncNow": "Sync now",
  "plus.r4.notion.title": "Notion",
  "plus.r4.savedSearchFeed.atom": "Atom feed",
  "plus.r4.savedSearchFeed.copied": "Copied",
  "plus.r4.savedSearchFeed.copy": "Copy",
  "plus.r4.savedSearchFeed.create": "Get a feed link",
  "plus.r4.savedSearchFeed.error": "We could not update the feed. Try again in a moment.",
  "plus.r4.savedSearchFeed.heading": "Feed link",
  "plus.r4.savedSearchFeed.help": "A private link for your feed reader. Anyone with the link can read this search, so keep it to yourself.",
  "plus.r4.savedSearchFeed.remove": "Remove feed",
  "plus.r4.savedSearchFeed.rotate": "Make a new link",
  "plus.r4.savedSearchFeed.rss": "RSS feed",
  "plus.r4.sheetExport.body": "Send your tracker to a new Google Sheet in your own Drive: dates, employers, stages and interviews. We can only see files we create.",
  "plus.r4.sheetExport.done": "Sheet created.",
  "plus.r4.sheetExport.export": "Export to a new sheet",
  "plus.r4.sheetExport.name": "JobCrawls My Jobs {date}",
  "plus.r4.sheetExport.open": "Open the sheet",
  "plus.r4.sheetExport.title": "Google Sheets",
  "plus.r4.travelClaim.addReminder": "Add the reminder to my calendar",
  "plus.r4.travelClaim.calculate": "Work out my claim",
  "plus.r4.travelClaim.capMunicipality": "Your municipality caps the kilometre compensation at {cap} EUR.",
  "plus.r4.travelClaim.capNational": "The kilometre compensation is capped at {cap} EUR.",
  "plus.r4.travelClaim.caveat": "This is a helper, not a promise. The reimbursement is discretionary and some municipalities set their own rules. Check the rules of your own employment area before you travel.",
  "plus.r4.travelClaim.deadline": "Claim by {date}. That is one month after the trip.",
  "plus.r4.travelClaim.distance": "Distance (km)",
  "plus.r4.travelClaim.invalid": "Enter a distance and the date of the trip.",
  "plus.r4.travelClaim.jobHours": "Hours a week on average (optional)",
  "plus.r4.travelClaim.jobWeeks": "How many weeks the job lasts (optional)",
  "plus.r4.travelClaim.kmPart": "Kilometre compensation",
  "plus.r4.travelClaim.link": "Unemployed? Work out the travel costs you can claim for this interview.",
  "plus.r4.travelClaim.municipality": "Your municipality",
  "plus.r4.travelClaim.nights": "Nights away (with receipts)",
  "plus.r4.travelClaim.nightsPart": "Overnight stays",
  "plus.r4.travelClaim.pageLead": "Work out what you can claim for travelling to a job interview while unemployed, and when to claim it by.",
  "plus.r4.travelClaim.pageTitle": "Interview travel claim",
  "plus.r4.travelClaim.reminder": "We suggest a reminder on {date}.",
  "plus.r4.travelClaim.reminderBody": "Claim by {date}.",
  "plus.r4.travelClaim.reminderSummary": "Claim your interview travel costs",
  "plus.r4.travelClaim.roundTrip": "The distance is one way: count both ways",
  "plus.r4.travelClaim.rules": "Rules version {version}, checked {date}. Source: {source}.",
  "plus.r4.travelClaim.tooFewHours": "The job should average at least {hours} hours a week to qualify.",
  "plus.r4.travelClaim.tooShort": "The job should last at least {weeks} weeks to qualify.",
  "plus.r4.travelClaim.total": "You could claim up to",
  "plus.r4.travelClaim.tripDate": "Date of the trip",
  "plus.r4.wallet.apple": "Add to Apple Wallet",
  "plus.r4.wallet.failed": "The pass could not be made right now. Try again in a moment.",
  "plus.r4.wallet.google": "Save to Google Wallet",
  "plus.r4.wallet.hint": "Shows on your lock screen near the time and place. If the time changes, add the pass again.",
  "plus.r4.wallet.past": "This interview has already started, so there is nothing to put in your wallet.",
  "plus.r4.wallet.timeUnknown": "Add the time of this interview first. A pass needs the exact start time.",
  "plus.r4.webhooks.add": "Add webhook",
  "plus.r4.webhooks.copied": "Copied",
  "plus.r4.webhooks.copy": "Copy",
  "plus.r4.webhooks.count": "{count} of {limit} endpoints",
  "plus.r4.webhooks.duplicate": "You already have a webhook with that address.",
  "plus.r4.webhooks.empty": "No webhooks yet. Add one above.",
  "plus.r4.webhooks.enabled": "On",
  "plus.r4.webhooks.error": "Something went wrong. Try again in a moment.",
  "plus.r4.webhooks.event.reply": "Employer replies",
  "plus.r4.webhooks.event.scout": "New Scout picks",
  "plus.r4.webhooks.event.stage": "Stage changes in My Jobs",
  "plus.r4.webhooks.eventsLabel": "Send me",
  "plus.r4.webhooks.intro": "We send a signed message to your address when Scout finds new picks, a job changes stage or an employer replies. Works with Zapier and Make too.",
  "plus.r4.webhooks.invalidEvents": "Choose at least one thing to send.",
  "plus.r4.webhooks.invalidUrl": "Use a public https address.",
  "plus.r4.webhooks.lastFailed": "Last delivery failed. We try again a few times.",
  "plus.r4.webhooks.lastOk": "Last delivery worked ({status}).",
  "plus.r4.webhooks.neverSent": "Nothing sent yet.",
  "plus.r4.webhooks.reason.blocked": "That address is not allowed.",
  "plus.r4.webhooks.reason.other": "The address answered with an error or not at all.",
  "plus.r4.webhooks.reason.timeout": "It took longer than five seconds.",
  "plus.r4.webhooks.remove": "Delete",
  "plus.r4.webhooks.rotate": "New secret",
  "plus.r4.webhooks.secretTitle": "Your signing secret. Copy it now: we show it only once.",
  "plus.r4.webhooks.switchedOff": "Switched off after repeated failures. Fix the address and switch it on again.",
  "plus.r4.webhooks.test": "Send a test",
  "plus.r4.webhooks.testFailed": "The test did not arrive. {reason}",
  "plus.r4.webhooks.testOk": "The test arrived ({status}).",
  "plus.r4.webhooks.title": "Webhooks",
  "plus.r4.webhooks.urlHelp": "It must be a public https address. Local and private addresses are not allowed.",
  "plus.r4.webhooks.urlLabel": "Address (https)",
  "plus.r4.webhooks.verifyNote": "Every message has a JobCrawls-Signature header: an HMAC-SHA256 of the timestamp and the body, made with your secret.",
  "plus.j.card.notNow": "Not now",
  "plus.j.fullscreen.close": "Close",
  "plus.j.glance.label": "Worth knowing",
  "plus.j.offer.replyDeadline": "Answer by (the date the employer gave you)",
  "plus.j.situation.body": "Pick what fits best. We use it to show you what matters at this point, and nothing else. You can change it any time in your profile.",
  "plus.j.situation.error": "Could not save that. Try again in a moment.",
  "plus.j.situation.inWork": "I have a job and I am not looking",
  "plus.j.situation.inWorkLooking": "I have a job and I am looking around",
  "plus.j.situation.newToFinland": "I am new to Finland",
  "plus.j.situation.noticeEnd": "Last day of your notice period",
  "plus.j.situation.outOfWork": "I am out of work",
  "plus.j.situation.save": "Save",
  "plus.j.situation.skip": "Skip for now",
  "plus.j.situation.studentGraduate": "I am a student or a recent graduate",
  "plus.j.situation.title": "Where are you in your job search?",
  "plus.j.situation.underNotice": "I am working my notice period",
  "plus.j.thisWeek.heading": "This week",
  "plus.j.toast.dismiss": "Not now",
  "plus.m.scoutNotForMe.chip": "Tell Scout {subject} is not for me",
  "plus.r3.archive.describe.busy": "Reading your question...",
  "plus.r3.archive.describe.button": "Fill in the form",
  "plus.r3.archive.describe.filled": "The form is filled in. Check it, then ask the archive.",
  "plus.r3.archive.describe.help": "We fill in the form below for you to check and change. Understanding a question uses one of your weekly questions.",
  "plus.r3.archive.describe.label": "Describe the question in your own words",
  "plus.r3.archive.describe.placeholder": "Which skills do backend developers ask for in remote ads?",
  "plus.r3.archive.describe.tooLong": "Keep the question to 300 characters.",
  "plus.r3.archive.describe.tooShort": "Write a little more, at least a few words.",
  "plus.r3.archive.describe.unclear": "We could not turn that into a question the archive can answer. Try counting ads or employers, or stated pay, and name a role, field or period. Nothing was used.",
  "plus.r3.changeSecurity.addToCalendar": "Add these dates to my calendar",
  "plus.r3.changeSecurity.icsAlarm": "In three days: {step}",
  "plus.r3.changeSecurity.icsNote": "Rules version {version}, checked {date}. A planning aid, not legal advice.",
  "plus.r3.changeSecurity.menuLabel": "Change-security timeline",
  "plus.r3.changeSecurity.menuNote": "dates after you are given notice",
  "plus.r3.currentJob.employer": "Your employer",
  "plus.r3.currentJob.employerGraded": "{name}: Employer Score grade {grade}",
  "plus.r3.currentJob.employerHelp": "Search by company name. Quiet watch uses its Employer Score grade, so you do not have to enter one.",
  "plus.r3.currentJob.employerPick": "{name} (grade {grade})",
  "plus.r3.currentJob.employerPickUngraded": "{name} (no grade yet)",
  "plus.r3.currentJob.employerRemove": "Remove employer",
  "plus.r3.currentJob.employerSearch": "Search for your employer",
  "plus.r3.currentJob.employerUngraded": "{name}: no Employer Score grade yet",
  "plus.r3.experienceFit.onlyStated": "Only ads that state years",
  "plus.r3.experienceFit.onlyStatedChip": "Only ads that state years",
  "plus.r3.gracePeriod.menuLabel": "Grace period planner",
  "plus.r3.gracePeriod.menuNote": "for foreign workers who lost a job",
  "plus.r3.obligation.guide": "Read the guide to the job-search obligation",
  "plus.r3.obligation.planOwn": "You set {target} a month. Your own employment plan on Työmarkkinatori sets the number that applies to you, so change it if your plan says something else.",
  "plus.r3.obligation.target.edit": "Change my number",
  "plus.r3.obligation.target.error": "Enter a whole number from 1 to 31.",
  "plus.r3.obligation.target.label": "Applications a month in my employment plan",
  "plus.r3.obligation.target.reset": "Use the standard {target}",
  "plus.r3.obligation.target.save": "Save",
  "plus.r3.quietWatch.gradeFromEmployer": "Compared with your employer, Employer Score grade {grade}.",
  "plus.r4.travelClaim.menuLabel": "Interview travel claim",
  "plus.r4.travelClaim.menuNote": "what you can claim for a trip",
  "plus.r5.adSignals.fromAd": "Read from the ad text. If something matters, check it with the employer.",
  "plus.r5.adSignals.heading": "Before you apply",
  "plus.r5.applyNow.badge": "Apply soon: may fill early",
  "plus.r5.applyNow.interviews": "The ad says interviews are held during the application period.",
  "plus.r5.applyNow.note": "A reason to apply early, not a promise that the job closes before the deadline.",
  "plus.r5.applyNow.nudgeDismiss": "Not now",
  "plus.r5.applyNow.nudgeLine": "Saved {days, plural, one {# day} other {# days}} ago. The ad says it may fill before the deadline.",
  "plus.r5.applyNow.nudgeOpen": "Open the ad",
  "plus.r5.applyNow.nudgeTitle": "Saved jobs that may fill early",
  "plus.r5.applyNow.rolling": "The ad says applications are reviewed as they arrive or that the job is filled as soon as someone fits.",
  "plus.r5.cardShelf.add": "Add to my cards",
  "plus.r5.cardShelf.addInvalid": "Choose a card or give it a name.",
  "plus.r5.cardShelf.addReminder": "Add the reminder to my calendar",
  "plus.r5.cardShelf.addTitle": "Add a card",
  "plus.r5.cardShelf.custom": "Another card or certificate",
  "plus.r5.cardShelf.empty": "No cards yet. Add the first one below.",
  "plus.r5.cardShelf.expires": "Expires on (leave empty to use the usual validity)",
  "plus.r5.cardShelf.issued": "Issued on",
  "plus.r5.cardShelf.lead": "Keep the cards employers ask for in one place, with expiry dates. You get one reminder 60 days before a card expires.",
  "plus.r5.cardShelf.loadError": "Your cards could not be loaded. Try again.",
  "plus.r5.cardShelf.loading": "Loading your cards",
  "plus.r5.cardShelf.name": "Name of the card",
  "plus.r5.cardShelf.pick": "Card",
  "plus.r5.cardShelf.reminderBanner": "Time to renew: {name} expires on {date}.",
  "plus.r5.cardShelf.reminderBody": "{name} expires on {date}. Renew it before then.",
  "plus.r5.cardShelf.reminderSummary": "Renew: {name}",
  "plus.r5.cardShelf.remove": "Remove",
  "plus.r5.cardShelf.renewWhere": "Renew at: {where}",
  "plus.r5.cardShelf.rules": "Validity periods checked {date}. Check the issuer's page before you rely on a date.",
  "plus.r5.cardShelf.saveError": "Your cards could not be saved. Try again.",
  "plus.r5.cardShelf.selfDeclared": "Added by you",
  "plus.r5.cardShelf.statusExpired": "Expired",
  "plus.r5.cardShelf.statusNone": "Does not expire",
  "plus.r5.cardShelf.statusSoon": "Expires in {days} days",
  "plus.r5.cardShelf.statusUnknown": "No expiry date added",
  "plus.r5.cardShelf.statusValid": "Valid until {date}",
  "plus.r5.cardShelf.title": "Your cards and certificates",
  "plus.r5.cardShelf.verified": "Verified by {issuer}",
  "plus.r5.cardShelf.walletNote": "Cards verified through the Finnish ID wallet are planned for the end of 2026. Until then every card is added by you.",
  "plus.r5.cards.advantage": "An advantage",
  "plus.r5.cards.caution": "Terms are the usual ones (checked {asOf}). The date printed on your card always counts.",
  "plus.r5.cards.expired": "Expired {date}",
  "plus.r5.cards.expiringSoon": "You have it, expires {date}",
  "plus.r5.cards.heldUndated": "In your profile, no date",
  "plus.r5.cards.missing": "Not in your profile",
  "plus.r5.cards.noTerm": "{renewal}",
  "plus.r5.cards.required": "Required",
  "plus.r5.cards.term": "Usually valid for {years, plural, one {# year} other {# years}}. {renewal}",
  "plus.r5.cards.title": "Cards and licences",
  "plus.r5.cards.valid": "You have it, valid to {date}",
  "plus.r5.degree.authority": "Who decides: {name}",
  "plus.r5.degree.caveat": "General information, not legal advice. Check the authority's own page for your case.",
  "plus.r5.degree.check": "Check",
  "plus.r5.degree.cost": "Cost: {amount} EUR",
  "plus.r5.degree.costRegulator": "Cost: the regulator sets its own fee. See its fee list.",
  "plus.r5.degree.costStatement": "A statement on your degree is optional and costs {amount} EUR.",
  "plus.r5.degree.decisionNeeded": "You need a recognition decision before you can work in this profession.",
  "plus.r5.degree.decisionNotNeeded": "You do not need a recognition decision to apply. Employers look at your degree and experience themselves.",
  "plus.r5.degree.dentist": "Dentist",
  "plus.r5.degree.doctor": "Doctor",
  "plus.r5.degree.engineer": "Engineer",
  "plus.r5.degree.lead": "Find out whether you need a recognition decision before you apply, who decides it, what it costs and how long it takes.",
  "plus.r5.degree.nurse": "Nurse",
  "plus.r5.degree.origin": "Where did you complete the degree?",
  "plus.r5.degree.originEu": "In an EU or EEA country",
  "plus.r5.degree.originNonEu": "Outside the EU and EEA",
  "plus.r5.degree.other": "Something else",
  "plus.r5.degree.otherHealth": "Other health care profession",
  "plus.r5.degree.pharmacist": "Pharmacist",
  "plus.r5.degree.profession": "Profession",
  "plus.r5.degree.rules": "Rules {version}, checked {date}. Source: {source}",
  "plus.r5.degree.stepApplyOph": "Apply to OPH for a recognition decision.",
  "plus.r5.degree.stepApplyRegulator": "Apply to the health care regulator for the right to practise.",
  "plus.r5.degree.stepApplyWithout": "Apply for jobs now. You do not have to wait for any decision.",
  "plus.r5.degree.stepLanguage": "Show the language skills the regulator asks for.",
  "plus.r5.degree.stepOptional": "If employers ask for it, request an optional statement on your degree from OPH.",
  "plus.r5.degree.stepPayFee": "Pay the fee.",
  "plus.r5.degree.stepRegister": "Get your right to practise registered, then apply for jobs in the profession.",
  "plus.r5.degree.stepWait": "Wait for the decision. It can take months, so apply early.",
  "plus.r5.degree.stepsTitle": "Steps",
  "plus.r5.degree.teacher": "Teacher",
  "plus.r5.degree.time": "Time: {min} to {max} months",
  "plus.r5.degree.title": "Foreign degree: cost and time",
  "plus.r5.hourlyPay.agreement": "The ad names a collective agreement. Pay follows its tables.",
  "plus.r5.hourlyPay.basisStandard": "Worked out on a {hours}-hour full-time month. Supplements for evenings, weekends and shifts come on top.",
  "plus.r5.hourlyPay.basisWeekly": "Worked out on the {hours} hours a month that the ad's weekly hours give. Supplements come on top.",
  "plus.r5.hourlyPay.disagrees": "The text and the ad's stated range differ: the text gives about {textMin} to {textMax} EUR a month, the range says {rangeMin} to {rangeMax}.",
  "plus.r5.hourlyPay.hourly": "{min} to {max} EUR an hour is about {monthMin} to {monthMax} EUR a month, before tax.",
  "plus.r5.hourlyPay.hourlySingle": "{min} EUR an hour is about {month} EUR a month, before tax.",
  "plus.r5.hourlyPay.monthlyInText": "The text states {min} to {max} EUR a month.",
  "plus.r5.hourlyPay.title": "Pay in the ad text",
  "plus.r5.interviewHold.add": "Hold these days in my calendar",
  "plus.r5.interviewHold.failed": "The hold could not be saved. Try again.",
  "plus.r5.interviewHold.feedLink": "Your feed link: {url}",
  "plus.r5.interviewHold.held": "Held in your calendar feed as a tentative, free-time block.",
  "plus.r5.interviewHold.limit": "You have reached the most holds your feed can carry. Remove one first.",
  "plus.r5.interviewHold.remove": "Remove the hold",
  "plus.r5.interviewHold.signIn": "Sign in to hold these days in your calendar.",
  "plus.r5.interviewHold.single": "The ad says interviews are held on {start}.",
  "plus.r5.interviewHold.title": "Interviews",
  "plus.r5.interviewHold.weeks": "The ad says interviews are held {start} to {end}.",
  "plus.r5.inviteReply.company": "Company (optional)",
  "plus.r5.inviteReply.connectGoogle": "Connect Google Calendar",
  "plus.r5.inviteReply.connectMicrosoft": "Connect Outlook Calendar",
  "plus.r5.inviteReply.copied": "Copied. Paste it into your mail and send it from there.",
  "plus.r5.inviteReply.copy": "Copy reply",
  "plus.r5.inviteReply.draftTitle": "Draft reply",
  "plus.r5.inviteReply.error": "Could not read your calendar. Try again later.",
  "plus.r5.inviteReply.find": "Find three free times",
  "plus.r5.inviteReply.intro": "We read only when you are busy from your calendar, never what the events are. You get three free times and a short reply to send from your own mail.",
  "plus.r5.inviteReply.jobTitle": "Job title (optional)",
  "plus.r5.inviteReply.noFreeTime": "No free time in the next days. The draft asks them to suggest a time.",
  "plus.r5.inviteReply.notConnected": "Connect a calendar to see your free times.",
  "plus.r5.inviteReply.notSetUp": "Not set up yet",
  "plus.r5.inviteReply.reconnect": "The calendar connection has expired. Connect it again.",
  "plus.r5.inviteReply.recruiter": "Recruiter name (optional)",
  "plus.r5.inviteReply.slotsTitle": "Your free times",
  "plus.r5.inviteReply.title": "Answer an invite with your free times",
  "plus.r5.moment.empty.title": "What were you hoping to find?",
  "plus.r5.moment.failed": "Could not send that. Try again later.",
  "plus.r5.moment.hidden.title": "Why hide this job?",
  "plus.r5.moment.skip": "Skip",
  "plus.r5.moment.thanks": "Thanks, that helps us fix the search.",
  "plus.r5.opintopolku.add": "Add ticked studies",
  "plus.r5.opintopolku.added": "Added to your profile. Review them in the CV before you send it.",
  "plus.r5.opintopolku.disabledLink": "That link is no longer shared, so nothing was imported. Create a new share link in Oma Opintopolku.",
  "plus.r5.opintopolku.error": "Could not read the link. Try again later.",
  "plus.r5.opintopolku.intro": "Paste the share link from Oma Opintopolku, then tick the degrees you want in your profile. Nothing is added until you tick it.",
  "plus.r5.opintopolku.invalidUrl": "Use the https link you got from Oma Opintopolku.",
  "plus.r5.opintopolku.linkLabel": "Share link",
  "plus.r5.opintopolku.pickTitle": "Tick the studies to add",
  "plus.r5.opintopolku.read": "Read studies",
  "plus.r5.opintopolku.title": "Add your studies from Opintopolku",
  "plus.r5.opintopolku.unreadable": "We could not find any studies on that page.",
  "plus.r5.paperwork.caution": "A starting point, not an official instruction. The issuer's current instructions win.",
  "plus.r5.paperwork.howLong": "Takes: {howLong}",
  "plus.r5.paperwork.title": "Paperwork to get ready",
  "plus.r5.paperwork.where": "Where: {where}",
  "plus.r5.paperwork.whoEither": "Ask the employer who arranges it",
  "plus.r5.paperwork.whoEmployer": "The employer arranges it",
  "plus.r5.paperwork.whoYou": "You order it",
  "plus.r5.partTime.benefit": "Benefit per month before the job (gross, EUR)",
  "plus.r5.partTime.benefitAfter": "Benefit still paid",
  "plus.r5.partTime.calculate": "Calculate",
  "plus.r5.partTime.caveat": "An estimate, not an official decision. Kela or your unemployment fund decides your benefit.",
  "plus.r5.partTime.ceiling": "The earnings ceiling lowered your benefit.",
  "plus.r5.partTime.earnings": "Pay from the job per month (gross, EUR)",
  "plus.r5.partTime.gain": "Gross gain compared with not working",
  "plus.r5.partTime.grossTotal": "Gross total (pay plus benefit)",
  "plus.r5.partTime.invalid": "Enter the benefit and the pay as numbers.",
  "plus.r5.partTime.kind": "Benefit type",
  "plus.r5.partTime.kindBasic": "Basic allowance",
  "plus.r5.partTime.kindEarnings": "Earnings-related allowance",
  "plus.r5.partTime.kindYleistuki": "Yleistuki (general support)",
  "plus.r5.partTime.lead": "See what a part-time job does to your unemployment benefit: the benefit drops by 50 cents for every euro you earn.",
  "plus.r5.partTime.netEarnings": "Pay after tax and contributions",
  "plus.r5.partTime.netPlusBenefit": "Pay after tax plus the benefit, before the benefit's own tax",
  "plus.r5.partTime.reduction": "Benefit lost to the pay",
  "plus.r5.partTime.rules": "Rules {version}, checked {date}. Source: {source}",
  "plus.r5.partTime.taxNote": "The benefit is taxable income too. Its tax withholding is not estimated here.",
  "plus.r5.partTime.title": "Should I take this part-time job?",
  "plus.r5.partTime.wage": "Your previous monthly wage (optional, for the earnings ceiling)",
  "plus.r5.partTime.yleistukiNote": "How yleistuki is handled is still being verified against the law. Treat this result as a rough guide.",
  "plus.r5.quit.caveat": "Not an official decision. The unemployment fund or Kela decides in your own case.",
  "plus.r5.quit.check": "Check",
  "plus.r5.quit.commute": "Commute per day, both ways (hours)",
  "plus.r5.quit.date": "Last day of employment, or the day you refuse",
  "plus.r5.quit.dismissedOwnConduct": "Lose a job because of my own conduct",
  "plus.r5.quit.event": "What are you thinking of doing?",
  "plus.r5.quit.invalid": "Choose a date to check.",
  "plus.r5.quit.lead": "Quitting or refusing work can delay your unemployment benefit. Check the waiting period and the reasons that count as valid.",
  "plus.r5.quit.noneFound": "None of the facts you gave match a valid reason.",
  "plus.r5.quit.otherReasons": "Other reasons to check by hand: {reasons}",
  "plus.r5.quit.partTime": "The work is part-time",
  "plus.r5.quit.pay": "Full-time pay of the work per month (gross, EUR)",
  "plus.r5.quit.payBelowAgreement": "The pay is below the collective agreement",
  "plus.r5.quit.quitFixedTerm": "Quit a fixed-term job",
  "plus.r5.quit.quitPermanent": "Quit a permanent job",
  "plus.r5.quit.reasonBreach": "the employer breaking the contract",
  "plus.r5.quit.reasonCommute": "a commute of over {hours} hours a day",
  "plus.r5.quit.reasonHealth": "a risk to your health",
  "plus.r5.quit.reasonPayAgreement": "pay under the collective agreement",
  "plus.r5.quit.reasonPayFloor": "pay under {amount} EUR a month",
  "plus.r5.quit.reasonViolence": "violence or harassment at work",
  "plus.r5.quit.refusedJobOffer": "Refuse a job offer",
  "plus.r5.quit.refusedMeasure": "Refuse an employment service or measure",
  "plus.r5.quit.rules": "Rules {version}, checked {date}. Source: {source}",
  "plus.r5.quit.title": "Before you resign or refuse",
  "plus.r5.quit.unverified": "This waiting period is still being verified against the Työmarkkinatori page.",
  "plus.r5.quit.validFound": "The facts you gave match a valid reason, so the waiting period may not apply:",
  "plus.r5.quit.waiting": "Waiting period: {days} days",
  "plus.r5.quit.window": "It runs from {from} to {until}.",
  "plus.r5.semantic.inLanguage": "Ad in {language}",
  "plus.r5.semantic.langEn": "English",
  "plus.r5.semantic.langFi": "Finnish",
  "plus.r5.semantic.langSv": "Swedish",
  "plus.r5.semantic.likeThis": "Jobs like this",
  "plus.r5.semantic.none": "No ad is close in meaning to this.",
  "plus.r5.semantic.notReady": "Search by meaning is not ready yet.",
  "plus.r5.semantic.placeholder": "For example sairaanhoitaja or registered nurse",
  "plus.r5.semantic.search": "Search",
  "plus.r5.semantic.subtitle": "Type a job in any language. We also show ads that mean the same in Finnish, Swedish and English.",
  "plus.r5.semantic.title": "Search by meaning",
  "plus.r5.skillGap.addCv": "Add your CV",
  "plus.r5.skillGap.askedIn": "Asked in {count, plural, one {# saved job} other {# saved jobs}}",
  "plus.r5.skillGap.has": "In your CV",
  "plus.r5.skillGap.lacks": "Not in your CV",
  "plus.r5.skillGap.limited": "Compared by name only. The skills taxonomy is not installed yet.",
  "plus.r5.skillGap.mentioned": "Only mentioned in your CV text",
  "plus.r5.skillGap.noCv": "Add your CV to compare your skills with this ad.",
  "plus.r5.skillGap.noSkills": "This ad lists no skills to compare.",
  "plus.r5.skillGap.savedCovered": "Already in your CV",
  "plus.r5.skillGap.savedLacking": "Most asked for and not in your CV",
  "plus.r5.skillGap.savedNone": "Save a few jobs that list skills and we will compare them with your CV.",
  "plus.r5.skillGap.savedSkipped": "{count, plural, one {# saved job was left out} other {# saved jobs were left out}} because {count, plural, one {it lists} other {they list}} no skills or {count, plural, one {is} other {are}} not on JobCrawls.",
  "plus.r5.skillGap.savedSubtitle": "The skills your saved jobs ask for most often that your CV does not list.",
  "plus.r5.skillGap.savedTitle": "Skills to learn for your saved jobs",
  "plus.r5.skillGap.source": "Skills are matched with ESCO, the European skills classification.",
  "plus.r5.skillGap.summary": "{has} of {total} skills are in your CV",
  "plus.r5.skillGap.title": "Skills you have and lack",
  "plus.r5.snapAd.another": "Snap another",
  "plus.r5.snapAd.checkHeading": "Check what we read",
  "plus.r5.snapAd.choose": "Take or choose a picture",
  "plus.r5.snapAd.deadlineAmbiguous": "The ad mentions more than one date. Pick the deadline yourself.",
  "plus.r5.snapAd.deadlineFrom": "From the ad: \"{quote}\"",
  "plus.r5.snapAd.deadlineNone": "The ad does not state a deadline. Leave it empty.",
  "plus.r5.snapAd.deadlinePast": "This date has already passed.",
  "plus.r5.snapAd.deadlineUnreadable": "We could not read a date. Type it if the ad has one.",
  "plus.r5.snapAd.fieldDeadline": "Application deadline",
  "plus.r5.snapAd.fieldEmployer": "Employer",
  "plus.r5.snapAd.fieldLocation": "Place",
  "plus.r5.snapAd.fieldTitle": "Job title",
  "plus.r5.snapAd.linkExact": "Same title and employer",
  "plus.r5.snapAd.linkHeading": "We may have this ad",
  "plus.r5.snapAd.linkNone": "Do not link, keep it as its own card",
  "plus.r5.snapAd.linkTitleOnly": "Same title, check the employer",
  "plus.r5.snapAd.notAnAd": "We could not find a job ad in this picture. Try a clearer photo, or add the job by hand.",
  "plus.r5.snapAd.notRead": "Not clear in the picture. Type it if you know it.",
  "plus.r5.snapAd.openMyJobs": "Open My Jobs",
  "plus.r5.snapAd.privacy": "The picture is sent once to be read and is not kept. Nothing is saved until you confirm.",
  "plus.r5.snapAd.readFailed": "We could not read this picture. Try again in a moment.",
  "plus.r5.snapAd.reading": "Reading the ad",
  "plus.r5.snapAd.save": "Save to My Jobs",
  "plus.r5.snapAd.saveFailed": "We could not save this. Try again.",
  "plus.r5.snapAd.saved": "Saved to My Jobs.",
  "plus.r5.snapAd.savedExists": "This job is already in My Jobs.",
  "plus.r5.snapAd.subtitle": "Take a photo of a paper ad or pick a screenshot. You check what we read, then it becomes a card in My Jobs.",
  "plus.r5.snapAd.title": "Snap a job ad",
  "plus.r5.snapAd.tooLarge": "This picture is too large. Try a smaller one.",
  "plus.r5.subsidy.build": "Write the paragraph",
  "plus.r5.subsidy.copied": "Copied",
  "plus.r5.subsidy.copy": "Copy the paragraph",
  "plus.r5.subsidy.employer": "Employer (optional)",
  "plus.r5.subsidy.ineligible": "The job starts today or has already started. A wage subsidy has to be agreed before the job starts.",
  "plus.r5.subsidy.ineligibleTitle": "The subsidy is not possible for this start date",
  "plus.r5.subsidy.language": "Language of the paragraph",
  "plus.r5.subsidy.lawNote": "Current law applies until the 2027 reform (HE 179/2026). The employment services decide the subsidy; nothing here is a promise.",
  "plus.r5.subsidy.lead": "A short paragraph you can send an employer to bring up a wage subsidy.",
  "plus.r5.subsidy.role": "Role (optional)",
  "plus.r5.subsidy.rules": "Rules {version}, checked {date}. Source: {source}",
  "plus.r5.subsidy.start": "Planned start date (optional)",
  "plus.r5.subsidy.title": "Bring a wage subsidy with you",
  "plus.r5.subsidy.warningTitle": "Agree the subsidy before you sign",
  "plus.r5.whatToSend.application_in_english": "the application in English",
  "plus.r5.whatToSend.application_in_finnish": "the application in Finnish",
  "plus.r5.whatToSend.application_in_swedish": "the application in Swedish",
  "plus.r5.whatToSend.certificates": "copies of certificates",
  "plus.r5.whatToSend.checkBlocking": "Add {items} before you send it.",
  "plus.r5.whatToSend.checkButton": "Check draft",
  "plus.r5.whatToSend.checkFailed": "The draft could not be checked. Try again.",
  "plus.r5.whatToSend.checkLabel": "Check my draft against the ad",
  "plus.r5.whatToSend.checkMissing": "The draft does not mention {items}.",
  "plus.r5.whatToSend.checkOk": "The draft covers what the ad asks for.",
  "plus.r5.whatToSend.cover_letter": "a cover letter",
  "plus.r5.whatToSend.cv": "your CV",
  "plus.r5.whatToSend.email": "The ad asks for the application by email.",
  "plus.r5.whatToSend.formOnly": "Apply through the form or link only. The ad says not to send it by email.",
  "plus.r5.whatToSend.include": "Include:",
  "plus.r5.whatToSend.portfolio": "a portfolio or work samples",
  "plus.r5.whatToSend.references": "references",
  "plus.r5.whatToSend.salary_request": "a salary request",
  "plus.r5.whatToSend.title": "What to send, and how",
  "plus.r5.whyMatch.adSparse": "This ad lists no skills, languages or years of experience to compare.",
  "plus.r5.whyMatch.addCv": "Add your CV",
  "plus.r5.whyMatch.experience": "Your work history spans {years, plural, one {# year} other {# years}}, and the ad asks for {requiredYears, plural, one {# year} other {# years}}",
  "plus.r5.whyMatch.intro": "Each reason points to a line in your CV and a line in the ad.",
  "plus.r5.whyMatch.language": "You speak {language}, and the ad requires it",
  "plus.r5.whyMatch.limitHint": "You have used this week's job insights.",
  "plus.r5.whyMatch.noCv": "Add your CV to see why this job matches you.",
  "plus.r5.whyMatch.nothing": "We found nothing we can point to in both your CV and this ad.",
  "plus.r5.whyMatch.skill": "You have {skill}, and the ad asks for it",
  "plus.r5.whyMatch.theAd": "The ad",
  "plus.r5.whyMatch.title": "Why this matches",
  "plus.r5.whyMatch.titleReason": "Your CV names a role close to \"{title}\"",
  "plus.r5.whyMatch.yourCv": "Your CV",
  "plus.r3.interviewPrep.gapScore": "Employer Score",
  "plus.r3.snapAd.body": "Photograph a job ad from a poster or a screenshot and save it to My Jobs with its deadline.",
  "plus.r3.snapAd.title": "Snap a job ad",
  "plus.r5.whatToSend.checkUnchecked": "We could not check this draft against what the ad asks you to send.",
  "plus.agent.card.near.noPay": "Ad states no pay",
  "plus.agent.card.near.payBelow": "Best paid below your floor",
  "plus.agent.card.near.payRange": "Pay range reaches your floor",
  "plus.agent.card.near.remote": "Remote, open to Finland",
  "plus.agent.results.widened": "{exact, plural, =0 {No exact matches, so here are the closest} one {1 exact match, then the closest} other {{exactText} exact matches, then the closest}}",
  "plus.agent.starter.hiringMine": "Which companies are hiring the most for my role right now?",
  "plus.agent.starter.hiringRole": "Which companies are hiring the most for {role} roles right now?",
  "plus.agent.starter.hiringCount.source": "Open ads counted per employer",
  "plus.agent.card.estimateShort": "~{range} a month",
  "plus.agent.jobSheet.about": "About the job",
  "plus.agent.jobSheet.ask": "Ask Scout about this job",
  "plus.agent.jobSheet.benefits": "Benefits",
  "plus.agent.jobSheet.close": "Close",
  "plus.agent.jobSheet.closed": "This ad is no longer open",
  "plus.agent.jobSheet.deadline": "Apply by {date}",
  "plus.agent.jobSheet.duties": "What you would do",
  "plus.agent.jobSheet.fullPage": "Open job page",
  "plus.agent.jobSheet.languages": "Languages: {languages}",
  "plus.agent.jobSheet.loadError": "This job did not load. The job page still has it.",
  "plus.agent.jobSheet.posted": "Posted {date}",
  "plus.agent.jobSheet.requirements": "What they ask for",
  "plus.agent.jobSheet.skills": "Skills",
  "plus.agent.card.alsoAt": "{count, plural, one {+# place} other {+# places}}",
  "plus.agent.card.more": "More for {title}",
  "plus.agent.compareSelect.add": "Add to compare",
  "plus.agent.compareSelect.barLabel": "Jobs to compare",
  "plus.agent.compareSelect.clear": "Clear",
  "plus.agent.compareSelect.count": "{count, plural, one {# job picked} other {# jobs picked}}",
  "plus.agent.compareSelect.go": "Compare",
  "plus.agent.compareSelect.jobRef": "{title} (id {id})",
  "plus.agent.compareSelect.message": "Compare these jobs side by side: {jobs}",
  "plus.agent.compareSelect.pickMore": "Pick one more job to compare",
  "plus.agent.compareSelect.remove": "Remove from compare",
  "plus.agent.jobSheet.market": "Pay against similar jobs",
  "plus.agent.jobSheet.marketDescription": "Market for similar jobs: {low} to {high} a month (median {median}, {count} jobs)",
  "plus.agent.jobSheet.marketSample": "{count, plural, one {Based on # job listing} other {Based on # job listings}}",
  "plus.agent.results.weakFit": "Nothing here fits you strongly yet",
  "plus.agent.card.abroad": "Outside Finland",
  "plus.agent.card.fit": "Fit {grade}",
  "plus.agent.card.fitTitle": "Fit {grade}: {score} of 100 for your profile",
  "plus.agent.jobSheet.whyFits": "Why it fits me",
  "plus.agent.jobSheet.whyFitsNote": "Compares the ad with your CV. Counts once a week for this job.",
  "nav.sheet.apple": "Continue with Apple",
  "nav.sheet.keepApple": "Keep these, continue with Apple",
  "jobDetailPage.machineTranslationNote": "May be machine-translated",
  "search.placeRemote.hint": "Remote jobs can be done from anywhere, so they are hidden here by default.",
  "search.placeRemote.toggle": "Also show remote jobs",
  "appDownload.banner.body": "Job alerts, saved jobs and deadline reminders on your phone",
  "appDownload.banner.close": "Close the app banner",
  "appDownload.banner.open": "Open app",
  "appDownload.banner.title": "JobCrawls app",
  "appDownload.offer.follow": "Following. Your Watchlist is in the app too.",
  "appDownload.offer.open": "Open in app",
  "appDownload.offer.savedJob": "Job saved. The app has your saved jobs too, with deadline reminders.",
  "appDownload.offer.savedSearch": "Alert on. The app can also notify you on your phone when new matches arrive.",
  "salaryRolePage.v3.actualAdsRow": "Advertised pay",
  "salaryRolePage.v3.actualAria": "Advertised pay median {ads}, earnings with supplements median {stats}.",
  "salaryRolePage.v3.actualHeading": "{roleTitle} earnings with supplements are about {gap} higher than ads say",
  "salaryRolePage.v3.actualStatsRow": "Earnings with supplements",
  "salaryRolePage.v3.actualText": "Job ads state the base pay. Statistics Finland counts everyone in the job, shift supplements included.",
  "salaryRolePage.v3.chartAria": "Distribution of advertised pay with what raises and lowers it. Median {median}.",
  "salaryRolePage.v3.chartAverage": "average {value}",
  "salaryRolePage.v3.chartAverageShort": "average",
  "salaryRolePage.v3.chartCaption": "Based on {count, plural, one {# job ad} other {# job ads}} that state the pay.",
  "salaryRolePage.v3.chartEmployers": "Public employers such as {publicNames} advertise more than private ones such as {privateNames}.",
  "salaryRolePage.v3.chartHeading": "What raises and lowers {roleTitle} pay?",
  "salaryRolePage.v3.chartMedian": "median {value}",
  "salaryRolePage.v3.chartMedianShort": "median",
  "salaryRolePage.v3.chartThin": "A hollow dot means fewer than 20 ads.",
  "salaryRolePage.v3.ctaButton": "See the jobs",
  "salaryRolePage.v3.ctaText": "{hasTop, select, yes {The best-paid ad offers {top} · } other {}}{newWeek, plural, one {# new this week} other {# new this week}}",
  "salaryRolePage.v3.ctaTitle": "{count, plural, one {# open {roleTitle} job} other {# open {roleTitle} jobs}}",
  "salaryRolePage.v3.faq.aPayMonth": "Job ads put the median salary at {median} and the average at {average} a month.{hasStats, select, yes { Statistics Finland puts earnings with supplements at about {stats}.} other {}}",
  "salaryRolePage.v3.faq.aSector": "Private employers advertise about {gap} {dir, select, less {less} other {more}} than public employers such as wellbeing services counties.",
  "salaryRolePage.v3.faq.qSector": "What is {roleTitle} pay in the private sector?",
  "salaryRolePage.v3.heroLede": "The median salary is {median} and the average {average} a month. About {net} is left after tax.",
  "salaryRolePage.v3.heroSentence": "{roleTitle} pay is typically {figure} {unit}.",
  "salaryRolePage.v3.heroUnitHour": "an hour",
  "salaryRolePage.v3.heroUnitMonth": "a month",
  "salaryRolePage.v3.heroUnitNet": "a month after tax",
  "salaryRolePage.v3.relatedHeading": "Pay in related roles",
  "salaryRolePage.v3.sourcesHeading": "Where the {roleTitle} pay estimate comes from",
  "salaryRolePage.v3.sourcesMethod": "Full method and sources",
  "salaryRolePage.v3.tableCaption": "{roleTitle} pay in job ads by factor, compared with the median of {median}",
  "salaryRolePage.v3.tableColAds": "Ads",
  "salaryRolePage.v3.tableColDelta": "Difference",
  "salaryRolePage.v3.tableColDriver": "Factor",
  "salaryRolePage.v3.tableColPay": "Estimated pay",
  "salaryRolePage.v3.tableToggle": "Show the figures as a table",
  "salaryRolePage.v3.toggleHour": "Hour",
  "salaryRolePage.v3.toggleLabel": "Show pay",
  "salaryRolePage.v3.toggleMonth": "Month",
  "salaryRolePage.v3.toggleNet": "Take-home",
  "salaryRolePage.v3.ctaTitleNoCount": "Open {roleTitle} jobs",
  "salaryRolePage.v3.faqHeading": "Common questions about {roleTitle} pay",
  "salaryRolePage.v3.faqSub": "Short answers from the same figures.",
  "salaryHub.chart.aria": "Distribution of monthly pay. {summary}",
  "salaryHub.chart.axisGross": "Gross pay per month",
  "salaryHub.chart.axisNet": "Take-home pay per month",
  "salaryHub.chart.lbAdsOf": "Ads: {name}",
  "salaryHub.chart.lbAllAds": "All job ads",
  "salaryHub.chart.lbBottom": "Bottom 10%",
  "salaryHub.chart.lbIr": "Incl. part-time",
  "salaryHub.chart.lbJobAds": "Job ads",
  "salaryHub.chart.lbTop": "Top 10%",
  "salaryHub.chart.mkAverage": "Average",
  "salaryHub.chart.mkBottom": "Bottom 10%",
  "salaryHub.chart.mkMedian": "Median",
  "salaryHub.chart.mkMedianAds": "Median, job ads",
  "salaryHub.chart.mkMedianFull": "Median, full-timers",
  "salaryHub.chart.mkMedianOf": "Median, {name}",
  "salaryHub.chart.mkQuintile": "{p}% ≈{pay}",
  "salaryHub.chart.mkTop": "Top 10%",
  "salaryHub.chart.tipAds": "Job ads offering less",
  "salaryHub.chart.tipEstimate": "≈ read off the fitted curve",
  "salaryHub.chart.tipFull": "Full-timers earning less",
  "salaryHub.chart.tipGross": "a month before tax",
  "salaryHub.chart.tipGroup": "{name} earning less",
  "salaryHub.chart.tipGroupAds": "{name} ads offering less",
  "salaryHub.chart.tipIr": "All earners below",
  "salaryHub.chart.tipNet": "take-home, from {gross} gross",
  "salaryHub.chart.tipOthers": "Other groups earning less: {min}% to {max}%",
  "salaryHub.faq.aAds": "Ads quote starting pay, usually the first step of a collective agreement pay scale, before experience increments, shift supplements and overtime. Only about {share}% of ads state pay: public employers far more often than private ones, better-paid occupations a little less often. We checked whether that skews the figure. Weighting each ad by how often jobs in its occupation and sector state pay gives a median of {adjusted} a month instead of {ads}, so the gap to official pay is not caused by the ads that leave pay out.",
  "salaryHub.faq.aAverage": "{news} a month before tax for full-time employees in {quarter} (preliminary, Statistics Finland). The median, a better guide to a typical salary, was {median} in {year}, the latest year with a median; at today’s pay level that is about {medianNow}.",
  "salaryHub.faq.aBelow": "About {share}% of full-time employees earn less than the average ({mean} in {quarter}), by our fit of Statistics Finland’s published figures.",
  "salaryHub.faq.aGood": "For a full-time job it sits between the bottom 10% line ({p10}) and the median ({median}): about {share}% of full-timers earn less. As a first job in care, retail or hospitality it is above most starting pay in ads.",
  "salaryHub.faq.aJobs": "By occupation group, {hiName} have the highest median at {hiPay} a month and {loName} the lowest at {loPay}: {ratio} times apart. Occupation divides pay more than education, age, sector, region or gender.",
  "salaryHub.faq.aNet": "About {net} a month with 2026 tax rules, the national average municipal tax, age 40 and no church tax.",
  "salaryHub.faq.aRegion": "Less than people expect. {top} has the highest median at {topPay}; every other region sits between {min} and {max}, so the gap between regions is {ratio} times.",
  "salaryHub.faq.qAds": "Why is pay in job ads lower than official salaries?",
  "salaryHub.faq.qAverage": "What is the average salary in Finland?",
  "salaryHub.faq.qBelow": "How many people earn less than the average?",
  "salaryHub.faq.qGood": "Is {pay} a month a good salary in Finland?",
  "salaryHub.faq.qJobs": "Which jobs pay the most and the least in Finland?",
  "salaryHub.faq.qNet": "How much of {news} is left after tax?",
  "salaryHub.faq.qRegion": "Do salaries differ much between regions?",
  "salaryHub.gaps.cap": "Median monthly pay, full-time employees, {year} raised to the {quarter} pay level. Ratio = higher median divided by lower. Statistics Finland tables 15au, 15av and 15b2, CC BY 4.0.",
  "salaryHub.gaps.rowAria": "{split}: {hi} {hiPay}, {lo} {loPay}, {ratio} times",
  "salaryHub.numbers.cap": "All figures are gross monthly pay. Take-home figures use our tax calculator with 2026 rules, the national average municipal tax, age 40 and no church tax.",
  "salaryHub.numbers.colFigure": "Figure",
  "salaryHub.numbers.colPay": "€ / month",
  "salaryHub.numbers.colSource": "Source",
  "salaryHub.numbers.colWhen": "When",
  "salaryHub.numbers.colWho": "Who is counted",
  "salaryHub.numbers.lede": "{ir}, {median} and {news} are all correct. They count different people.",
  "salaryHub.numbers.rowAds": "Median starting pay offered",
  "salaryHub.numbers.rowAverage": "Average",
  "salaryHub.numbers.rowMedian": "Median",
  "salaryHub.numbers.rowTails": "Bottom and top 10% lines",
  "salaryHub.numbers.srcIr": "Income register (experimental)",
  "salaryHub.numbers.srcStatFin": "Statistics Finland {table}",
  "salaryHub.numbers.title": "Sources",
  "salaryHub.numbers.whenAds": "Last 12 months",
  "salaryHub.numbers.whenLatest": "{year}, latest with a median",
  "salaryHub.numbers.whenQuarter": "{quarter}, preliminary",
  "salaryHub.numbers.whoAds": "{ads} full-time job ads in Finland that state pay, {employers} employers",
  "salaryHub.numbers.whoAll": "Everyone paid wages that month, part-timers included",
  "salaryHub.numbers.whoFull": "Full-time employees",
  "salaryHub.story.capAdsAll": "Job ads: {count} full-time ads in Finland that state pay, last 12 months.",
  "salaryHub.story.capAdsMatched": "Job ads: full-time ads in Finland that state pay, last 12 months, matched by {by, select, occupation {occupation code} sector {employer sector} region {region of the job} other {group}}.",
  "salaryHub.story.capAdsNone": "Job ads do not record {split}, so the dashed curve is all {count} ads.",
  "salaryHub.story.capFit": "Curves pass through the published points; between them the shape is our estimate (≈). Tall, narrow ad curves are cut at the top. CC BY 4.0.",
  "salaryHub.story.capIr": "Incl. part-time: income register, everyone paid wages in {period}, drawn from the published counts in 500 € pay bands.",
  "salaryHub.story.capPeople": "Full-timers: Statistics Finland table {table}, full-time employees {year}, raised to the {quarter} pay level.",
  "salaryHub.story.everyone": "Everyone",
  "salaryHub.story.exploreLink": "{split, select, occ {Compare every occupation} edu {Every education level} age {Every age group} region {Every region} other {Explore}}",
  "salaryHub.story.exploreTitle": "Explore the data yourself",
  "salaryHub.story.h1": "Average and median salary in Finland {year}",
  "salaryHub.story.hintHover": "Hover a grey curve to compare it.",
  "salaryHub.story.hintTap": "Tap a name to compare it.",
  "salaryHub.story.keyAds": "Job ads, last 12 months",
  "salaryHub.story.keyPeople": "Full-timers, ≈{quarter} level",
  "salaryHub.story.layerAds": "Job ads",
  "salaryHub.story.layerIr": "Incl. part-time",
  "salaryHub.story.layerQuint": "Quintiles",
  "salaryHub.story.modeGross": "Gross",
  "salaryHub.story.modeGroup": "Show pay as",
  "salaryHub.story.modeNet": "Net",
  "salaryHub.story.readFewAds": "Too few ads to compare one of these groups.",
  "salaryHub.story.readNoAds": "Job ads do not record {split}.",
  "salaryHub.story.readNone": "Half of full-timers earn under <b>{median}</b>; the bottom 10% under <b>{p10}</b> and the top 10% over <b>{p90}</b>. Job ads offer a median <lo>{ads}</lo> to start.",
  "salaryHub.story.readPair": "The median for {hiName} is <b>{hiPay}</b>, {ratio} times the <lo>{loPay}</lo> for {loName}.",
  "salaryHub.story.readPairAds": "In job ads: <b>{hiAds}</b> against <lo>{loAds}</lo>.",
  "salaryHub.story.s1Sub": "Half earn under ≈<b>{median}</b> a month at today’s pay level ({year}: {medianPub}, the latest published median). High salaries pull the average up to <b>{mean}</b> ({quarter}), so about <b>{share}%</b> earn less than it. The dashed curve is what job ads offer today.",
  "salaryHub.story.s1Title": "Most full-timers earn less than the average.",
  "salaryHub.story.s2Sub": "The median is <b>{hiPay}</b> for {hiName} and <lo>{loPay}</lo> for {loName}, {ratio} times less. Even the lowest-paid tenth of {hiName} out-earn the best-paid tenth of {loName}.",
  "salaryHub.story.s2SubOverlap": "The median is <b>{hiPay}</b> for {hiName} and <lo>{loPay}</lo> for {loName}, {ratio} times less.",
  "salaryHub.story.s2Title": "Your job is the biggest divide.",
  "salaryHub.story.s3Sub": "A bachelor's degree median of <lo>{bachelor}</lo> is barely above a vocational college diploma ({college}). A master's lifts it to <b>{master}</b>. Ads do not record degrees, so the dashed curve is all ads.",
  "salaryHub.story.s3Title": "A master's degree is where pay jumps.",
  "salaryHub.story.s4Sub": "The median rises from <lo>{young}</lo> at {youngAge} to <b>{peak}</b> at {peakAge}, then eases to {late} by {lateAge}.",
  "salaryHub.story.s4Title": "Pay climbs until your late 40s.",
  "salaryHub.story.s5Sub": "{top} leads at <b>{topPay}</b>; every other region sits between <lo>{min}</lo> and {max}. But jobs are not spread evenly: {top} has {peopleShare}% of full-time employees and {adsShare}% of job ads, so each curve here is sized by how many people work there.",
  "salaryHub.story.s5Title": "Where you live matters least.",
  "salaryHub.story.s6Sub": "Ads that state pay offer a median of <lo>{ads}</lo> to start, about {gap} under the typical full-timer. Ads quote the first step of the pay scale, before experience, shifts and overtime.",
  "salaryHub.story.s6Title": "Job ads start lower than what people earn.",
  "salaryHub.story.show": "Show",
  "salaryHub.story.splitBy": "Split by",
  "salaryHub.story.statement": "What you do sets your pay <hl>far more</hl> than where you live.",
  "salaryHub.story.stepAria": "Step {n}: {title}",
  "salaryHub.story.stepsLabel": "Story steps",
  "salaryHub.story.capWeight": "Each curve is sized by its share of full-time employees (ad curves by their share of ads).",
  "salaryHub.story.layerWeight": "Size by headcount",
  "salaryHub.gaps.lede": "The best- and worst-paid group in each way of splitting pay. Pick a row to open it in the chart.",
  "salaryRolePage.v3.aiHeading": "How will AI change {roleTitle} work?",
  "salaryRolePage.v3.aiModeAutomation": "Research suggests some of the routine tasks in this job are likely to be automated.",
  "salaryRolePage.v3.aiModeMixed": "Research suggests AI will automate some tasks in this job and support others.",
  "salaryRolePage.v3.aiScaleHigh": "High",
  "salaryRolePage.v3.aiScaleLow": "Low",
  "salaryRolePage.v3.aiScaleMedium": "Moderate",
  "salaryRolePage.v3.kindCity": "Location",
  "salaryRolePage.v3.kindFilterLabel": "Highlight",
  "salaryRolePage.v3.kindLanguage": "Languages",
  "salaryRolePage.v3.kindLevel": "Experience",
  "salaryRolePage.v3.kindSector": "Employer",
  "salaryRolePage.v3.kindSkill": "Skills",
  "salaryRolePage.v3.landBetterJobs": "{count, plural, one {# open job pays more} other {# open jobs pay more}}",
  "salaryRolePage.v3.landHint": "Type your monthly base pay to see it on the curve. Nothing is saved or sent.",
  "salaryRolePage.v3.landLabel": "Where does your pay land?",
  "salaryRolePage.v3.landNet": "About {net} is left after tax.",
  "salaryRolePage.v3.landResult": "You earn more than {pct}% of the ads.",
  "salaryRolePage.v3.landUnit": "€ / month",
  "salaryRolePage.v3.youLabel": "You",
  "salaryHub.story.scrollHint": "Scroll for the story",
  "salaryHub.chart.mkAverageYear": "Average {quarter} · {year}: {pub}",
  "salaryHub.chart.mkMedianYear": "Median ≈ today · {year}: {pub}",
  "salaryHub.growth.fieldCap": "Median monthly pay of full-time employees at 25 to 29 and in the best-paid age band from 40 to 59, {year} raised to the {quarter} pay level. This compares different people of different ages in the same year, not the same people over time, so it mixes career growth with differences between generations. Statistics Finland table 15av, CC BY 4.0.",
  "salaryHub.growth.fieldTitle": "By field of study: from age 25 to 29 to the peak",
  "salaryHub.growth.lede": "Some fields start modestly and climb steeply; in others pay is flat for most of a career. And in some occupations the best-paid go much further above the typical pay than in others.",
  "salaryHub.growth.median": "Median",
  "salaryHub.growth.occCap": "Median monthly pay against the line the best-paid 10% start from, full-time employees, {year} raised to the {quarter} pay level. Statistics Finland table 15au, CC BY 4.0.",
  "salaryHub.growth.occTitle": "By occupation: how far the best-paid get",
  "salaryHub.growth.peak": "Peak",
  "salaryHub.growth.peakAge": "peak at {age}",
  "salaryHub.growth.rowAria": "{name}: {from} to {to}, up {pct}%",
  "salaryHub.growth.start": "Age 25 to 29",
  "salaryHub.growth.title": "Where pay keeps growing",
  "salaryHub.growth.top": "Top 10% start at",
  "salaryHub.numbers.rowMedianNow": "Median, estimated for today",
  "salaryHub.numbers.srcNow": "{year} median × earnings index (14uw, 14uv)",
  "salaryHub.numbers.whenNow": "{quarter}, our estimate",
  "salaryHub.story.capAged": "Statistics Finland’s latest breakdowns are for {year}. Each curve is raised to {period} by how much average full-time pay has grown since (about {pct}% overall, by sector and by gender where published), so the shapes are {year}’s and the levels are estimates (≈). The published {year} figures are under Sources.",
  "salaryHub.numbers.rowAdsAdjusted": "Median starting pay, weighted for which jobs state pay",
  "salaryHub.numbers.whoAdsAdjusted": "All {all} full-time ads in Finland; the {stated} that state pay are weighted by how often their occupation and sector state pay",
  "salaryHub.chart.lbIrOf": "{name}, incl. part-time",
  "salaryHub.chart.tipGroupIr": "{name} incl. part-time, below",
  "salaryHub.story.capIrGroups": "Dotted: income register, everyone in the group paid wages in {period}, part-timers included, drawn from the published counts in 500 € pay bands.",
  "salaryHub.story.keyIr": "Incl. part-time, {period}",
  "salaryHub.faq.title": "Questions about pay in Finland",
  "footer.mobileAppLink": "Mobile app",
  "navigation.menu.getPlus": "Get Plus",
  "navigation.menu.internal": "Internal",
  "navigation.menu.internal.allTools": "All {count} tools",
  "navigation.menu.internal.onThisPage": "On this page",
  "navigation.menu.internal.srpIndexability": "Why is this search indexed or not?",
  "navigation.menu.internal.viewAsFree": "See the site as a free user",
  "navigation.menu.internal.yourTools": "Your tools",
  "navigation.menu.scout.all": "All conversations",
  "navigation.menu.scout.askPlaceholder": "Ask Scout about your search",
  "navigation.menu.scout.askSubmit": "Send to Scout",
  "navigation.menu.scout.heading": "Scout",
  "navigation.menu.scout.picks": "Today's picks",
  "navigation.menu.scout.state.needsOk": "needs your OK",
  "navigation.menu.scout.state.working": "working",
  "navigation.menu.scout.untitled": "New conversation",
  "navigation.menu.tools": "Tools",
  "navigation.menu.yourSearch": "Your search",
  "salaryRolePage.v3.chartTail": "The chart stops at {edge}; a few ads above that pay up to {max}.",
  "salaryHub.chart.axisHour": "Gross pay per hour",
  "salaryHub.chart.tipHour": "an hour before tax",
  "salaryHub.story.capHourly": "Per hour: Statistics Finland table {table}, total earnings per hour paid of all wage earners {year}, full-time and part-time, raised to the {quarter} pay level.",
  "salaryHub.story.keyHourly": "All wage earners, per hour, ≈{quarter} level",
  "salaryHub.story.readHourly": "This is pay per hour paid, so shorter hours do not count against part-timers. {share}% of wage earners work part-time. Job ads are left out: they quote full-time monthly pay.",
  "salaryHub.story.capAdsParent": "Job ads: full-time ads in Finland that state pay, last 12 months, for the whole major group {name} (ads are not matched to subgroups).",
  "salaryHub.story.crumbAll": "All occupations",
  "salaryHub.story.crumbsLabel": "Occupation level",
  "salaryHub.story.readSubAds": "Job ads are matched to major groups only, so the dashed curve is all ads for {name}.",
  "salaryHub.story.subgroupsOf": "Subgroups of {name} ({count})",
  "salaryRolePage.v3.chartAriaOfficial": "Distribution of pay in the occupation, with what raises and lowers it. Median {median}.",
  "salaryRolePage.v3.chartCaptionOfficial": "The curve is Statistics Finland’s earnings for the occupation, raised to {quarter}.{hasAds, select, yes { Each marker applies the pay difference seen in job ads to it: {count, plural, one {# ad} other {# ads}} state the pay.} other {}}",
  "salaryRolePage.v3.faq.aGoodOfficial": "{dir, select, up {The median of {median} is {pct}% above} down {The median of {median} is {pct}% below} other {The median of {median} is level with}} the median for all full-time employees in Finland ({all}).",
  "salaryRolePage.v3.faq.aPayOfficial": "The median salary is about {median} and the average about {average} a month, from Statistics Finland’s earnings for the occupation raised to {quarter}.{hasAds, select, yes { Job ads for the role state a median of {ads}: ads quote base pay, without shift supplements.} other {}}",
  "salaryRolePage.v3.faq.aSectorOfficial": "In the private sector the median is about {privatePay} a month, against about {publicPay} in {publicName}.",
  "salaryRolePage.v3.heroLedeOfficial": "The median salary is {median} and the average {average} a month. The figures are Statistics Finland’s earnings for the occupation group “{occupation}” ({year}), raised to {quarter}. About {net} is left after tax.",
  "salaryRolePage.v3.landResultOfficial": "You earn more than about {pct}% of full-time employees in the occupation.",
  "salaryRolePage.v3.sectorColNow": "Median now",
  "salaryRolePage.v3.sectorColPeople": "Full-time employees",
  "salaryRolePage.v3.sectorColPublished": "Median {year}",
  "salaryRolePage.v3.sectorColSector": "Employer",
  "salaryRolePage.v3.sectorHeading": "{roleTitle} pay by employer sector, and starting pay",
  "salaryRolePage.v3.sectorIn.local": "municipalities",
  "salaryRolePage.v3.sectorIn.private": "the private sector",
  "salaryRolePage.v3.sectorIn.state": "central government",
  "salaryRolePage.v3.sectorIn.wellbeing": "wellbeing services counties",
  "salaryRolePage.v3.sectorText": "Statistics Finland’s median for full-time employees in each employer sector, raised to {quarter} with that sector’s own pay growth.",
  "salaryRolePage.v3.sectorTopSentence": "Pay is highest in {top} (about {topPay}) and lowest in {bottom} (about {bottomPay}).",
  "salaryRolePage.v3.sourcesCap": "Statistics Finland publishes earnings by occupation once a year; the latest is {year}. Like the salary hub, we raise each figure by how much average full-time pay has grown since in the employer sectors where the occupation works, so today’s levels are estimates (≈).",
  "salaryRolePage.v3.sourcesRowAverageNow": "Average, estimated for today",
  "salaryRolePage.v3.sourcesRowNow": "Median, estimated for today",
  "salaryRolePage.v3.sourcesRowSpreadNow": "Middle half, estimated for today",
  "salaryRolePage.v3.sourcesSrcCurve": "Read off the curve through the 10%, median and 90% lines",
  "salaryRolePage.v3.sourcesSrcNow": "{year} figures × pay growth since (+{pct}%, 14uw/14uv)",
  "salaryRolePage.v3.sourcesTextOfficial": "Every figure on this page, who it counts and where it comes from. The headline is Statistics Finland’s; the job ads only set the differences between cities, sectors, levels, skills and languages.",
  "salaryRolePage.v3.sourcesWhoAds": "{count, plural, one {# job ad} other {# job ads}} for the role that state the pay",
  "salaryRolePage.v3.sourcesWhoOccupation": "Full-time employees in “{occupation}”, {count}",
  "salaryRolePage.v3.tableCaptionOfficial": "{roleTitle} pay by factor: the difference seen in job ads, applied to the median of {median}",
  "companyProfile.share.chartCredit": "Chart and prices: {link}, delayed by at least 15 minutes.",
  "companyProfile.share.chartTitle": "Share price chart from TradingView",
  "companyProfile.share.heading": "Share price",
  "companyProfile.share.listedOwn": "Listed on {market}.",
  "companyProfile.share.listedParent": "Part of {parent}, which is listed on {market}.",
  "companyProfile.share.marketFirstNorth": "First North Growth Market Finland",
  "companyProfile.share.marketMain": "Nasdaq Helsinki",
  "companyProfile.share.showChart": "Show share price chart",
  "companyProfile.share.thirdPartyNote": "Loads a delayed chart from TradingView.",
  "companyProfile.share.marketLabel": "Market",
  "salaryRolePage.afterRent.city": "City",
  "salaryRolePage.afterRent.gross": "Pay",
  "salaryRolePage.afterRent.leadPayDiffers": "Pay is highest in {payCity}, but the most is left after rent in {leftCity}: {left} a month once a one-room flat is paid for. That is {diff} more than in {payCity}.",
  "salaryRolePage.afterRent.leadPaySame": "Pay is highest in {leftCity}, and the most is left after rent there too: {left} a month once a one-room flat is paid for. That is {diff} more than in {lastCity}.",
  "salaryRolePage.afterRent.left": "Left",
  "salaryRolePage.afterRent.net": "Take-home",
  "salaryRolePage.afterRent.note": "Pay is the median in each city’s job ads. Take-home is after income tax at the city’s 2026 municipal rate, without church tax, and the employee’s pension and unemployment insurance contributions. Rent is the median total rent of a non-subsidised one-room flat in Q{quarter} {year}; Espoo’s figure covers Espoo and Kauniainen.",
  "salaryRolePage.afterRent.rent": "One-room rent",
  "salaryRolePage.afterRent.source": "Rents: Statistics Finland, rents of dwellings (CC BY 4.0)",
  "salaryRolePage.afterRent.title": "What is left after rent",
  "salaryRolePage.afterRent.leadEven": "Pay in these cities differs by up to {payGap} a month, but rent evens it out: once a one-room flat is paid for, the gap is {leftGap}.",
  "companyProfile.industry.colCompany": "This company",
  "companyProfile.industry.colIndustry": "Industry",
  "companyProfile.industry.heading": "Compared with its industry",
  "companyProfile.industry.industryLine": "Industry: {industry}",
  "companyProfile.industry.leadIndustry": "The industry has {enterprises} companies and {staff} full-time equivalent employees. {direction, select, up {Staffing grew {pct} in {year}.} down {Staffing fell {pct} in {year}.} other {Staffing held steady in {year}.}}",
  "companyProfile.industry.leadMargin": "{verdict, select, above {{company}’s operating margin is above the industry’s: {company_margin} against {industry_margin}.} below {{company}’s operating margin is below the industry’s: {company_margin} against {industry_margin}.} other {{company}’s operating margin is close to the industry’s: {company_margin} against {industry_margin}.}}",
  "companyProfile.industry.leadRevenue": "{verdict, select, above {{company} brings in {ratio} times as much revenue per employee as the industry average.} below {{company} brings in {pct} less revenue per employee than the industry average.} other {{company} brings in about as much revenue per employee as the industry average.}}",
  "companyProfile.industry.note": "Industry figures cover every company in the industry in {year}. Average pay is the wage bill per full-time equivalent, before tax, including bonuses.{hasStatement, select, yes { The company’s figures are from its {fiscalYear} financial statement.} other {}}{hasWikidata, select, yes { Its revenue per employee is from Wikidata ({wikidataYear}) and covers the whole group, including staff abroad.} other {}}",
  "companyProfile.industry.perMonth": "{amount}/month",
  "companyProfile.industry.rowMargin": "Operating margin",
  "companyProfile.industry.rowPay": "Average pay",
  "companyProfile.industry.rowRevenue": "Revenue per employee",
  "companyProfile.industry.rowStaff": "Change in staff",
  "labourTightness.barHidden": "fewer than 5 vacancies in the register",
  "labourTightness.barNone": "no vacancies in the register",
  "labourTightness.barRegister": "Employment service register",
  "labourTightness.barWithAds": "Register and JobCrawls ads",
  "labourTightness.chartAria": "Unemployed jobseekers per open job, register only and with JobCrawls ads",
  "labourTightness.colRegister": "Register",
  "labourTightness.colRole": "Role",
  "labourTightness.colWithAds": "With ads",
  "labourTightness.hubHeading": "Jobseekers per open job",
  "labourTightness.hubLede": "At the end of {month}, Finland had <b>{real}</b> unemployed jobseekers per open job, counting JobCrawls ads as well as the employment service register. The register alone gives {official}, because it only sees vacancies reported to the public employment services. The gap is widest in professional work, which is mostly advertised elsewhere.",
  "labourTightness.hubLooseHeading": "Most jobseekers per open job",
  "labourTightness.hubTightHeading": "Tightest markets",
  "labourTightness.meaning": "The lower the number, the tighter the market: more openings for each jobseeker, and employers compete harder to hire. Across all occupations the figure is {national} ({nationalOfficial} in the register alone).",
  "labourTightness.roleHeading": "How tight is the {roleTitle} job market?",
  "labourTightness.roleLede": "At the end of {month}, the occupation group {group} had <b>{real}</b> unemployed jobseekers per open job, counting JobCrawls ads as well as the employment service register. The register alone gives {official}: it only sees vacancies reported to the public employment services, and many jobs, most professional ones among them, are advertised only elsewhere.",
  "labourTightness.roleLedeNoOfficial": "At the end of {month}, the occupation group {group} had <b>{real}</b> unemployed jobseekers per open job, counting JobCrawls ads as well as the employment service register. The register alone lists {vacancies, select, hidden {fewer than five vacancies} other {no vacancies}} for the group, so it gives no ratio of its own.",
  "labourTightness.rowAll": "All occupations",
  "labourTightness.source": "JobCrawls analysis of Statistics Finland and JobCrawls data. Unemployed jobseekers and vacancies: Statistics Finland, <link>Employment Service Statistics</link> (CC BY 4.0), end of {month}. Open jobs are the register’s vacancies plus JobCrawls ads that are not on Job Market Finland. One ad can be for several positions, and ads we could not place in an occupation group are left out.",
  "labourTightness.adsHeading": "How many {roleTitle} jobs are open?",
  "labourTightness.adsLede": "At the end of {month}, JobCrawls had <b>{count, plural, one {# open ad} other {# open ads}}</b> in the occupation group {group}.",
  "labourTightness.adsNoRatio": "There is no jobseekers-per-job figure for this group: the official employment service register no longer publishes it separately.",
  "labourTightness.adsSource": "JobCrawls data: ads open on the last day of each month in the occupation group, each ad counted once.",
  "labourTightness.adsTrendAria": "JobCrawls ads open at the end of each month",
  "profileTabs.recruiters": "Recruiters",
  "talent.audience.agencies": "Staffing and recruitment agencies can see my card",
  "talent.audience.agenciesHelp": "Agency requests are always marked as such and name their client, or say it is confidential.",
  "talent.audience.gradeAny": "Any employer",
  "talent.audience.gradeHelp": "Companies without a grade are left out when you pick one",
  "talent.audience.gradeLabel": "Employer Score",
  "talent.audience.gradeOnlyA": "A only",
  "talent.audience.gradeOrBetter": "{grade} or better",
  "talent.audience.industries": "Industries",
  "talent.audience.removeCompany": "Remove {name}",
  "talent.audience.sizes": "Company size",
  "talent.blocker.cvScore": "Your CV check score needs to go up first.",
  "talent.blocker.notVisible": "Recruiter visibility is off.",
  "talent.blocker.paused": "You are taking a break.",
  "talent.card.cvGate": "Your CV check score is {score}. Recruiters see cards from {min} up.",
  "talent.card.fixCv": "Improve my CV",
  "talent.card.languages": "Languages",
  "talent.card.perMonth": "a month",
  "talent.card.regions": "Where",
  "talent.card.roles": "Looking for",
  "talent.card.salary": "Salary expectation",
  "talent.card.salaryRange": "{min} to {max}",
  "talent.card.years": "{years, plural, one {# year} other {# years}} of experience",
  "talent.contact.floorHelp": "Requests whose range tops out below this cannot be sent. Leave empty to accept any range.",
  "talent.contact.floorLabel": "Lowest salary I will hear about (€ a month, gross)",
  "talent.contact.intro": "Every contact request must show a salary range. Recruiters cannot message you directly.",
  "talent.contact.limitLabel": "Requests a week, at most",
  "talent.contact.notPaused": "Not paused",
  "talent.contact.pauseFor": "Hide for {days} days",
  "talent.contact.pauseLabel": "Take a break",
  "talent.contact.pausedUntil": "Hidden until {date}",
  "talent.decline.location": "Location",
  "talent.decline.notLooking": "Not looking right now",
  "talent.decline.other": "Other",
  "talent.decline.role": "Not the right role",
  "talent.decline.salary": "Salary",
  "talent.guest.body": "Save your CV for free, then choose which companies can see an anonymous version of it and the lowest salary you will hear about.",
  "talent.guest.cta": "Save my CV for free",
  "talent.guest.title": "Let recruiters find you, on your terms",
  "talent.inbox.accept": "Accept and share my contact details",
  "talent.inbox.agencyFrom": "{agency} (agency) for {client}",
  "talent.inbox.confidentialClient": "a confidential client",
  "talent.inbox.decline": "Decline",
  "talent.inbox.emptyTitle": "No requests yet",
  "talent.inbox.failed": "That did not go through. Try again.",
  "talent.inbox.intro": "Recruiters see your name and contact details only after you accept. Unanswered requests expire after 14 days.",
  "talent.inbox.jobLink": "Open the job ad",
  "talent.inbox.loadFailed": "Could not load your requests.",
  "talent.inbox.noReason": "No reason given",
  "talent.inbox.reasonLabel": "Reason (optional)",
  "talent.inbox.report": "Report",
  "talent.inbox.salary": "{min} to {max} a month",
  "talent.inbox.status.accepted": "Accepted: they have your contact details",
  "talent.inbox.status.declined": "Declined",
  "talent.inbox.status.expired": "Expired",
  "talent.inbox.status.pending": "Waiting for you",
  "talent.inbox.status.withdrawn": "Withdrawn",
  "talent.inbox.title": "Contact requests",
  "talent.industry.consulting": "Consulting and professional services",
  "talent.industry.education": "Education",
  "talent.industry.finance": "Finance and insurance",
  "talent.industry.healthcare": "Health and social care",
  "talent.industry.logistics": "Transport and logistics",
  "talent.industry.manufacturing": "Manufacturing",
  "talent.industry.media": "Media and communications",
  "talent.industry.retail": "Retail and wholesale",
  "talent.industry.technology": "Technology",
  "talent.loadFailed": "Your recruiter settings did not load. Reload the page to try again.",
  "talent.notice.immediately": "Can start now",
  "talent.notice.longer": "More than 3 months notice",
  "talent.notice.oneMonth": "1 month notice",
  "talent.notice.threeMonths": "3 months notice",
  "talent.notice.twoMonths": "2 months notice",
  "talent.notice.twoWeeks": "2 weeks notice",
  "talent.notice.unset": "Not stated",
  "talent.remoteness.hybrid": "Hybrid",
  "talent.remoteness.onsite": "On site",
  "talent.remoteness.remote": "Remote",
  "talent.saveFailed": "Your last change was not saved. Try again.",
  "talent.size.large": "250 to 999 staff",
  "talent.size.medium": "50 to 249 staff",
  "talent.size.micro": "1 to 9 staff",
  "talent.size.small": "10 to 49 staff",
  "talent.size.xlarge": "1,000 or more staff",
  "talent.visibility.consent": "I agree that JobCrawls shows an anonymous version of my profile (without my name, photo, contact details or employer names) to recruiters who pass my filters, and shares my name and contact details with a recruiter only when I accept their request. I can turn this off at any time, and my profile is removed from search at once.",
  "talent.visibility.intro": "Recruiters at verified companies search anonymous cards and send requests with a salary range. You decide who sees you, and you share your name only with those you accept.",
  "talent.visibility.live": "Your card is ready for recruiters.",
  "talent.visibility.liveEarly": "Recruiter access opens in stages. When it does, only companies that pass your filters can see your card.",
  "talent.visibility.notLive": "Recruiters cannot see you yet.",
  "talent.visibility.switch": "Show my anonymous card to recruiters",
  "talent.visibility.title": "Let recruiters find you",
  "talent.market.noRole": "Add the role you want under Search & applying to see what ads for it pay.",
  "talent.market.position": "{basis, select, official {{position, select, below_p25 {Your floor is below what most people in the role earn, so it turns away few requests.} below_median {Your floor is below the median: most people in the role earn at least that.} above_median {Your floor is above the median: fewer than half of the people in the role earn that.} other {Fewer than 1 in 4 people in the role earn your floor, so expect few requests.}}} other {{position, select, below_p25 {Your floor is below most of these ads, so it turns away few requests.} below_median {Your floor is below the median: most of these ads reach it.} above_median {Your floor is above the median: fewer than half of these ads reach it.} other {Fewer than 1 in 4 of these ads reach your floor, so expect few requests.}}}}",
  "talent.market.range": "{basis, select, official {{role} in Finland pays a median of {median} a month, and the middle half earn {p25} to {p75}.} other {Ads for {role} in Finland that state pay: the middle half offer {p25} to {p75} a month, median {median}.}}",
  "talent.market.rangeRegion": "{basis, select, official {{role} in {region} pays a median of {median} a month, and the middle half earn {p25} to {p75}.} other {Ads for {role} in {region} that state pay: the middle half offer {p25} to {p75} a month, median {median}.}}",
  "talent.audience.hideEmployerMissing": "Your profile names no current employer. Add your current job, or add your employer to the list below.",
  "talent.audience.preview.agencies": "staffing and recruitment agencies",
  "talent.audience.preview.anonymous": "Only their verified recruiters, and only your anonymous card. Your name stays hidden until you accept a request.",
  "talent.audience.preview.count": "Recruiters at {count, plural, one {# employer} other {# employers}} of the {total} hiring now could see your card.",
  "talent.audience.preview.examples": "For example, the busiest of them:",
  "talent.audience.preview.failed": "The preview did not load. Your filters still apply.",
  "talent.audience.preview.loading": "Counting employers…",
  "talent.audience.preview.never": "Never shown to: {list}.",
  "talent.audience.preview.none": "No employer hiring right now passes these filters. Loosen one to be found.",
  "talent.audience.preview.openJobs": "{count, plural, one {# open job} other {# open jobs}}",
  "talent.audience.preview.title": "Who would see your card",
  "talent.audience.preview.yourEmployer": "{name} (your current employer)",
  "footer.ownersLink": "Who owns employers",
  "owners.attribution": "Parent companies from GLEIF (CC0) and Wikidata (CC0). Contains data from the Finnish Patent and Registration Office (PRH) trade register, CC BY 4.0. Ownership research and job counts by JobCrawls. Updated {date}.",
  "owners.breadcrumb.current": "Owners",
  "owners.eyebrow": "Employers · Ownership",
  "owners.filter.all": "All",
  "owners.filter.label": "Type of owner",
  "owners.intro": "Behind many employers is a larger owner: a listed group, a private equity fund, a foreign parent or a city. These are the {owners} owners whose companies posted at least 10 jobs in the last 12 months, {jobs} jobs at {employers} employers in all, largest first.",
  "owners.member.jobs": "{jobs, plural, one {# job} other {# jobs}}",
  "owners.member.more": "and {count, plural, one {# more hiring company} other {# more hiring companies}}",
  "owners.method.corrections": "See something wrong or out of date? Email {email} and we will fix it.",
  "owners.method.excluded": "People are never listed as owners, so family-owned groups are left out. So are companies whose sources disagree about who owns them, until we have checked them.",
  "owners.method.jobs": "Jobs are the job ads we found from each company in the last 12 months, counted once each, added up across the companies the owner controls. Staffing companies post many ads per hire, so you can hide them.",
  "owners.method.owner": "An owner is the top of a company’s chain of control: whoever holds more than half of it, or of the company above it. Minority shareholders are not owners here.",
  "owners.method.sources": "Each step of ownership names its source and the day we checked it: GLEIF and Wikidata, the Finnish trade register, or the company’s own annual report, release or website, which we read and matched to the trade register.",
  "owners.method.title": "How we built this list",
  "owners.noResults": "No owners of this type in the list.",
  "owners.staffing.badge": "Staffing",
  "owners.step.source": "according to {source}, {date}",
  "owners.title": "Who owns Finland's employers?",
  "owners.type.company": "Company group",
  "owners.type.cooperative": "Cooperative",
  "owners.type.foundation": "Foundation",
  "owners.type.insurer": "Pension or mutual insurer",
  "owners.type.listed": "Listed company",
  "owners.type.municipality": "Municipality",
  "owners.type.other": "Other owner",
  "owners.type.privateEquity": "Private equity",
  "owners.type.state": "The state",
  "owners.type.wellbeingCounty": "Wellbeing services county",
  "salaryReports.basedOn": "Based on {n} reports from JobCrawls users, full-time equivalent before tax.",
  "salaryReports.company.emptyCta": "Work at {company}? Share your pay anonymously.",
  "salaryReports.company.headline": "{role} at {company}: median {median} a month (most report between {p25} and {p75}).",
  "salaryReports.company.lockedCta": "Share your pay to see every role",
  "salaryReports.company.title": "Pay at {company}",
  "salaryReports.cta.hiredPrompt": "Congratulations! Share what they offered and help the next person negotiate.",
  "salaryReports.cta.share": "Share your pay",
  "salaryReports.cta.shareReward": "Share your pay, get Plus free",
  "salaryReports.extrasLine": "{bonus} of {bonusOf} get a bonus, {shift} of {shiftOf} get shift or evening allowances.",
  "salaryReports.form.alreadyReported": "You have already shared your pay at this employer in the last 12 months. Delete that report below if you want to send a new one.",
  "salaryReports.form.basePay": "Base pay before tax (€)",
  "salaryReports.form.basePayHelp": "Without bonuses, allowances or holiday pay. Those go below.",
  "salaryReports.form.benefit": "Car or phone benefit",
  "salaryReports.form.bonus": "Bonus or commission per year (€, optional)",
  "salaryReports.form.confirmBody": "That is about {pay} a month full time, which is far from what we usually see ({low} to {high}). Is it gross pay per {period}, before tax?",
  "salaryReports.form.confirmFix": "Let me fix it",
  "salaryReports.form.confirmTitle": "Is this figure right?",
  "salaryReports.form.confirmYes": "Yes, it is right",
  "salaryReports.form.consent": "I agree that JobCrawls stores this report and uses it in pay figures that combine at least 5 reports. My name and account are never shown, and I can delete the report at any time on this page.",
  "salaryReports.form.dontKnow": "I don't know",
  "salaryReports.form.employer": "Employer",
  "salaryReports.form.employerChange": "Change",
  "salaryReports.form.employerHelp": "Not in the list? Type the full name and use it as written.",
  "salaryReports.form.employerSearch": "Search for your employer",
  "salaryReports.form.employerUseTyped": "Use \"{name}\"",
  "salaryReports.form.employment": "Working time",
  "salaryReports.form.employmentFullTime": "Full time",
  "salaryReports.form.employmentHourly": "Paid by the hour",
  "salaryReports.form.employmentPartTime": "Part time",
  "salaryReports.form.experience": "Years in this field",
  "salaryReports.form.experienceYears": "{range} years",
  "salaryReports.form.experienceZero": "Less than a year",
  "salaryReports.form.figureYear": "This pay is for",
  "salaryReports.form.fixErrors": "Some answers need a look. They are marked above.",
  "salaryReports.form.genericError": "Something went wrong. Your report was not saved; please try again.",
  "salaryReports.form.hours": "Hours per week",
  "salaryReports.form.howWeUseBody": "Your report is stored without your name or email. It only appears inside figures that combine at least 5 reports, rounded to the nearest 50 €, and small employers never get their own figures.",
  "salaryReports.form.howWeUseTitle": "How we use this",
  "salaryReports.form.invalid": "Check this value.",
  "salaryReports.form.jobTitle": "Job title",
  "salaryReports.form.jobTitleHelp": "Pick from the list when your title is there.",
  "salaryReports.form.lastYear": "Last year",
  "salaryReports.form.level": "Level",
  "salaryReports.form.loadError": "We could not load this page. Please reload and try again.",
  "salaryReports.form.no": "No",
  "salaryReports.form.notSaying": "Rather not say",
  "salaryReports.form.payPeriod": "Per",
  "salaryReports.form.periodHour": "hour",
  "salaryReports.form.periodMonth": "month",
  "salaryReports.form.periodYear": "year",
  "salaryReports.form.privacy": "Privacy policy",
  "salaryReports.form.region": "Region",
  "salaryReports.form.regionHelp": "Where you work. We publish pay by region, never by town.",
  "salaryReports.form.rejectBody": "That looks like an hourly or yearly figure, or a typo. Check the amount and the \"per\" choice, then send again.",
  "salaryReports.form.rejectTitle": "Check the amount and period",
  "salaryReports.form.required": "Fill this in.",
  "salaryReports.form.sectionJob": "Your job",
  "salaryReports.form.sectionPay": "Your pay",
  "salaryReports.form.shift": "Shift or evening allowances",
  "salaryReports.form.signInBody": "Sign in or create a free account first. We use the account only to stop duplicate reports; your name is never shown.",
  "salaryReports.form.stillEmployed": "Do you still work there?",
  "salaryReports.form.stillEmployedNo": "No, it ended in the last 12 months",
  "salaryReports.form.submit": "Send my report",
  "salaryReports.form.subtitle": "Share your pay anonymously and see what employers pay, role by role. It takes about 90 seconds.",
  "salaryReports.form.subtitleReward": "Share your pay anonymously and get {days} days of Plus free. It takes about 90 seconds.",
  "salaryReports.form.tes": "Is your pay set by a collective agreement (TES)?",
  "salaryReports.form.thisYear": "This year",
  "salaryReports.form.title": "Share your pay",
  "salaryReports.form.verifyBody": "Open the confirmation email we sent when you signed up, then come back to this page.",
  "salaryReports.form.verifyTitle": "Confirm your email first",
  "salaryReports.form.viaAgency": "I am employed through a staffing agency (name the company you work at)",
  "salaryReports.form.workMode": "Where you work",
  "salaryReports.form.workModeHybrid": "Hybrid",
  "salaryReports.form.workModeOnsite": "On site",
  "salaryReports.form.workModeRemote": "Remote",
  "salaryReports.form.yes": "Yes",
  "salaryReports.level.director": "Director",
  "salaryReports.level.executive": "Executive",
  "salaryReports.level.expert": "Expert",
  "salaryReports.level.intern": "Intern or trainee",
  "salaryReports.level.junior": "Junior",
  "salaryReports.level.manager": "Manager",
  "salaryReports.level.mid": "Mid-level",
  "salaryReports.level.senior": "Senior",
  "salaryReports.levelsLine": "By level: {levels}.",
  "salaryReports.mine.delete": "Delete",
  "salaryReports.mine.deleteConfirm": "Delete this report? It leaves every figure at the next update. A free Plus you got for it stays.",
  "salaryReports.mine.deleteError": "Deleting failed. Please try again.",
  "salaryReports.mine.row": "{title} at {employer}, {year}",
  "salaryReports.mine.title": "Your reports",
  "salaryReports.result.another": "Share another job",
  "salaryReports.result.compareAll": "Your pay is about {pay} a month full time. The median for all full-time employees in Finland is {median}, so you earn more than about {percentile} % of them.",
  "salaryReports.result.compareOccupation": "Your pay is about {pay} a month full time. For {occupation}, the official median is {median}, so you earn more than about {percentile} % of them.",
  "salaryReports.result.compareSource": "Source: Statistics Finland, structure of earnings, raised to the latest quarter.",
  "salaryReports.result.compareTitle": "How your pay compares",
  "salaryReports.result.rewardAlready": "You have already had the free Plus for a report this year, so this one does not add more. It still counts.",
  "salaryReports.result.rewardCap": "The free Plus offer is full this month. Your report still counts.",
  "salaryReports.result.rewardGranted": "Plus is on for your account until {date}. No card, nothing renews.",
  "salaryReports.result.savedTitle": "Thank you. Your report is in.",
  "salaryReports.result.seeEmployer": "See pay at {company}",
  "salaryReports.role.line": "JobCrawls users report a median of {median} a month ({n} reports).",
  "salaryReports.role.lockedCta": "Share your pay to see which employers pay most",
  "salaryReports.role.topTitle": "What employers pay, from user reports",
  "salaryReports.table.median": "Median / month",
  "salaryReports.table.official": "Official median",
  "salaryReports.table.range": "Middle half",
  "salaryReports.table.reports": "Reports",
  "salaryReports.table.role": "Role",
  "salaryReports.table.rangeValue": "{low} to {high}",
  "salaryReports.cta.hubPrompt": "Know what your job pays? Share it anonymously, and see what employers pay role by role.",
  "backoffice.subpage.salaryReports": "Salary reports",
  "salaryReports.cta.pricingLine": "Or get Plus free by sharing your pay.",
  "owners.pagination.aria": "Owner pages",
  "owners.pagination.next": "Next",
  "owners.pagination.page": "Page {number}",
  "owners.pagination.previous": "Previous",
  "owners.showing": "Showing {from}–{to} of {total}",
  "owners.staffing.hide": "Hide staffing companies",
  "owners.tree.holding": "holding company",
  "owners.tree.ownerJobs": "{jobs, plural, one {# job} other {# jobs}} at the owner itself",
  "owners.card.hiring": "{count, plural, one {# hiring company} other {# hiring companies}}",
  "owners.card.jobsUnit": "jobs in 12 months",
  "owners.card.more": "+{count} more",
  "owners.insight.foreign": "Foreign groups own {share} of these jobs. The largest is {name}{country, select, none {} other { ({country})}}, with {jobs} jobs.",
  "owners.insight.privateEquity": "Private equity owns {share}, led by {name} with {jobs} jobs at {employers, plural, one {# employer} other {# employers}}.",
  "owners.kind.finnish": "Finnish groups",
  "owners.kind.foreign": "Foreign groups",
  "owners.kind.listed": "Listed companies",
  "owners.kind.privateEquity": "Private equity",
  "owners.kind.public": "State and cities",
  "owners.mix.aria": "Share of jobs by kind of owner",
  "owners.mix.title": "Who owns the hiring",
  "owners.tree.hide": "Hide the ownership tree",
  "owners.tree.jobsUnit": "jobs",
  "owners.tree.show": "Show the ownership tree",
  "owners.joint.badge": "Jointly owned",
  "owners.joint.shares": "Controlled jointly, none with a majority: {owners}",
  "salaryReports.wp.contract": "Contract",
  "salaryReports.wp.contractFixed": "Fixed-term",
  "salaryReports.wp.contractOther": "Other",
  "salaryReports.wp.contractPermanent": "Permanent",
  "salaryReports.wp.intro": "Answer what you like. These answers only appear as company-wide totals from at least 5 people, never one by one.",
  "salaryReports.wp.officeDays": "Days a week at the office, in practice",
  "salaryReports.wp.openness": "Is pay discussed openly?",
  "salaryReports.wp.opennessClosed": "No, pay is kept quiet",
  "salaryReports.wp.opennessOpen": "Yes, and the criteria are clear",
  "salaryReports.wp.opennessPartly": "Partly",
  "salaryReports.wp.overtime": "Overtime",
  "salaryReports.wp.overtimeMixed": "It depends",
  "salaryReports.wp.overtimeNone": "Rarely or never",
  "salaryReports.wp.overtimeOften": "Often",
  "salaryReports.wp.overtimePaid": "Paid",
  "salaryReports.wp.overtimePay": "Is overtime compensated?",
  "salaryReports.wp.overtimeSometimes": "Sometimes",
  "salaryReports.wp.overtimeTimeOff": "As time off",
  "salaryReports.wp.overtimeUnpaid": "Not compensated",
  "salaryReports.wp.raise": "Raise in the last 12 months",
  "salaryReports.wp.raise3to7": "3 to 7 %",
  "salaryReports.wp.raiseGeneral": "Only the general (TES) increase",
  "salaryReports.wp.raiseNone": "No raise",
  "salaryReports.wp.raiseOver7": "Over 7 %",
  "salaryReports.wp.raiseTooNew": "I joined less than a year ago",
  "salaryReports.wp.raiseUnder3": "Under 3 %",
  "salaryReports.wp.ratingGrowth": "Growth and learning",
  "salaryReports.wp.ratingManagement": "Management",
  "salaryReports.wp.ratingPayFairness": "Fairness of pay",
  "salaryReports.wp.ratingWorkload": "Workload (5 = very manageable)",
  "salaryReports.wp.ratingsTitle": "Rate the employer from 1 (poor) to 5 (excellent)",
  "salaryReports.wp.recommend": "Would you recommend it to a friend?",
  "salaryReports.wp.section": "Working there (optional)",
  "salaryReports.wpCard.basis": "From JobCrawls users who shared their pay at this employer. Each figure needs at least 5 answers.",
  "salaryReports.wpCard.contract": "{permanent} % have a permanent contract.",
  "salaryReports.wpCard.office": "Office days in practice: a median of {days} a week.",
  "salaryReports.wpCard.openness": "{open} % say pay is discussed openly.",
  "salaryReports.wpCard.overtime": "Overtime: {often} % often, {sometimes} % sometimes.",
  "salaryReports.wpCard.overtimePay": "When there is overtime, {paid} % get it paid and {timeOff} % as time off.",
  "salaryReports.wpCard.raise": "In the last 12 months, {more} % got more than the general increase, {general} % only the general increase and {none} % no raise.",
  "salaryReports.wpCard.ratingGrowth": "growth",
  "salaryReports.wpCard.ratingManagement": "management",
  "salaryReports.wpCard.ratingPayFairness": "fairness of pay",
  "salaryReports.wpCard.ratingWorkload": "workload",
  "salaryReports.wpCard.ratings": "Ratings out of 5: {list}.",
  "salaryReports.wpCard.recommend": "{share} % would recommend it to a friend.",
  "salaryReports.wpCard.title": "Working at {company}",
  "fromAssistant.strip.connect": "Connect JobCrawls",
  "fromAssistant.strip.dismiss": "Dismiss",
  "fromAssistant.strip.signedIn": "Want your assistant to keep going with your own saved jobs and alerts? Connect JobCrawls.",
  "fromAssistant.strip.signedOut": "Came here from your AI assistant? Connect JobCrawls to it for free and keep searching jobs and pay in Finland right in the chat.",
  "company.follow.scoutPrompt.cta": "Set up Scout",
  "company.follow.scoutPrompt.text": "Let Scout tell you when {company} opens a role like yours.",
  "jobDetailPage.returnPrompt.guestTracker.body": "Sign in and every job you apply to is saved in My Jobs, on all your devices.",
  "jobDetailPage.returnPrompt.guestTracker.dismiss": "Not now",
  "jobDetailPage.returnPrompt.guestTracker.signIn": "Sign in",
  "jobDetailPage.returnPrompt.guestTracker.title": "Keep your applications in one place",
  "srpAlertCta.obligation.bannerText": "Need to apply for jobs every month? Get new jobs like this as soon as they are posted.",
  "srpAlertCta.obligation.subText": "Alerts help you reach your monthly target. Daily or weekly, turn off anytime.",
  "dataUse.ai.blockLabel": "Reuse terms, plain text",
  "dataUse.ai.body": "The same terms in machine-readable form: in <llms>llms.txt</llms>, as a schema.org Dataset licence on our job search, salary, place and research pages, and in the description of the JobCrawls connector. If you cite a figure for someone, link to the page it came from.",
  "dataUse.ai.heading": "For AI assistants",
  "dataUse.breadcrumb.home": "Home",
  "dataUse.eyebrow": "For journalists, researchers and AI assistants",
  "dataUse.intro": "Can you quote a JobCrawls number? Usually yes. This page says what you may reuse and how to credit it, where each number comes from, and who to ask.",
  "dataUse.latest.allResearch": "All Data Desk research",
  "dataUse.latest.downloadCsv": "Figures (CSV)",
  "dataUse.latest.downloadPng": "Chart (PNG)",
  "dataUse.latest.heading": "Latest figures",
  "dataUse.latest.intro": "The {month} edition of the JobCrawls Data Desk. Each chart is updated monthly; download the chart or its figures as a CSV file.",
  "dataUse.latest.readArticle": "Method and findings",
  "dataUse.latest.updated": "Figures as of {date}",
  "dataUse.method.editorial": "Editorial standards",
  "dataUse.method.editorial.body": "How we source, check and correct what we publish.",
  "dataUse.method.employerScore": "Employer Score",
  "dataUse.method.employerScore.body": "How the letter grade for each employer is built from pay, flexibility, hiring stability and growth.",
  "dataUse.method.heading": "Methodology",
  "dataUse.method.research": "Data Desk research",
  "dataUse.method.research.body": "Each article states what was counted, on which day, and the caveats.",
  "dataUse.method.salary": "Salary methodology",
  "dataUse.method.salary.body": "How pay figures from job ads are collected, normalised to monthly euros and trimmed.",
  "dataUse.press.body": "For interviews, custom figures or questions about our data, write to:",
  "dataUse.press.corrections": "Found an error in a published figure? Write to {email}.",
  "dataUse.press.heading": "Press contact",
  "dataUse.press.response": "A person reads every message. We reply to press and research requests within two business days.",
  "dataUse.rule.aggregate.credit": "Credit \"Source: JobCrawls\" with a visible link to the jobcrawls.com page the figures came from. Where a link is impossible (print, broadcast or a spoken answer), name \"JobCrawls (jobcrawls.com)\".",
  "dataUse.rule.aggregate.reuse": "Free to reuse, including commercially. You may copy, adapt, combine, publish and redistribute them.",
  "dataUse.rule.aggregate.what": "Aggregate statistics (pay, counts, shares)",
  "dataUse.rule.agreementNames.credit": "Credit \"Translation: JobCrawls\" with a link to the agreement page.",
  "dataUse.rule.agreementNames.reuse": "Free to reuse. The translations are unofficial; the Finnish name in Finlex is authoritative.",
  "dataUse.rule.agreementNames.what": "Collective agreement names we translated",
  "dataUse.rule.aiExposure.credit": "Credit the OECD and the OECD publication linked under the figure.",
  "dataUse.rule.aiExposure.reuse": "The scores are the OECD's and are reusable under the OECD's terms. Our match of a role to an occupation code is reusable like any aggregate.",
  "dataUse.rule.aiExposure.what": "AI exposure by occupation",
  "dataUse.rule.community.credit": "Cite the original sources linked in each insight instead.",
  "dataUse.rule.community.reuse": "Not reusable. They summarise other people's writing, which is not ours to license.",
  "dataUse.rule.community.what": "Community insights about employers",
  "dataUse.rule.companyFacts.credit": "Credit JobCrawls with a link to the page you quote.",
  "dataUse.rule.companyFacts.reuse": "Quote single facts and short passages, as the law allows. Ask us before copying in bulk.",
  "dataUse.rule.companyFacts.what": "Other JobCrawls content (company profiles, Employer Score grades, articles)",
  "dataUse.rule.dataDesk.credit": "Credit \"JobCrawls Data Desk\" with a link to the article page.",
  "dataUse.rule.dataDesk.reuse": "Share, embed and cite them. Show a chart whole and unaltered; resizing is fine. The CSV of a chart's figures is reusable like any aggregate.",
  "dataUse.rule.dataDesk.what": "Data Desk charts and research",
  "dataUse.rule.listings.credit": "Link to the listing on jobcrawls.com, or to the employer's own ad, instead.",
  "dataUse.rule.listings.reuse": "Not for redistribution. Do not copy listings or their text into another service or dataset.",
  "dataUse.rule.listings.what": "Individual job listings",
  "dataUse.rule.noEndorsement": "In every case, do not suggest that JobCrawls endorses you or your use of the data.",
  "dataUse.rule.openData.credit": "Credit the original publisher, as shown under each figure.",
  "dataUse.rule.openData.reuse": "Reusable under its own licence (such as CC BY 4.0 or CC0), not ours.",
  "dataUse.rule.openData.what": "Open data we republish",
  "dataUse.rule.tmt.credit": "Credit them as the listing states.",
  "dataUse.rule.tmt.reuse": "Shown under Job Market Finland's own terms, which JobCrawls cannot license to you.",
  "dataUse.rule.tmt.what": "Job Market Finland listings",
  "dataUse.rules.caption": "What you may reuse from JobCrawls, and how to credit it",
  "dataUse.rules.col.credit": "How to credit",
  "dataUse.rules.col.reuse": "Reuse",
  "dataUse.rules.col.what": "What",
  "dataUse.rules.heading": "What you may do",
  "dataUse.rules.termsNote": "The same terms are section 7.5 of our <link>Terms of Service</link>, which is the binding English version.",
  "dataUse.sources.col.dataset": "Dataset",
  "dataUse.sources.col.licence": "Licence",
  "dataUse.sources.col.publisher": "Publisher",
  "dataUse.sources.col.yourUse": "Your reuse",
  "dataUse.sources.heading": "Where each number comes from",
  "dataUse.sources.intro": "Every chart and figure on JobCrawls names its source on the line beneath it. These are all the datasets those lines can name, and how each may be reused.",
  "dataUse.sources.notListed": "Some sources we use are not on this list because their licence does not allow reuse, or because we are still waiting for the publisher to confirm it. They are not covered by these terms. If you cannot find a figure's source here, ask us before reusing it.",
  "dataUse.sources.open.caption": "Open datasets shown on JobCrawls, by publisher",
  "dataUse.sources.open.heading": "Open data we republish",
  "dataUse.sources.open.intro": "{count} open datasets from {publishers} publishers. Reuse them under their own licence, credited to the publisher.",
  "dataUse.sources.own.caption": "Datasets JobCrawls produces",
  "dataUse.sources.own.heading": "Our own data",
  "dataUse.sources.reuse.aggregate": "Free, with a credit link",
  "dataUse.sources.reuse.cite": "Quote with a link",
  "dataUse.sources.reuse.none": "Not reusable",
  "dataUse.sources.reuse.ownTerms": "Under the publisher's terms",
  "dataUse.sources.reuse.translation": "Free, credit \"Translation: JobCrawls\"",
  "dataUse.sources.thirdParty.caption": "Third-party data shown on JobCrawls with its own terms",
  "dataUse.sources.thirdParty.heading": "Other data on our pages",
  "dataUse.title": "Press and data use",
  "footer.dataUse": "Press and data use",
  "season.action.allFinland": "All of Finland",
  "season.action.button": "Get alerts",
  "season.action.error": "Something went wrong and the alert didn't switch on. Please try again.",
  "season.action.field": "Field",
  "season.action.manage": "Manage alerts",
  "season.action.note": "Summer jobs and fixed-term roles. You can turn the alert off any time.",
  "season.action.pending": "Almost there: confirm your email address from the message we sent, and the alert starts.",
  "season.action.place": "Place",
  "season.action.signInNote": "You sign in or create a free account first, so we know where to send the alerts.",
  "season.action.success": "You're set. {channels, select, push {We'll notify you} both {We'll email and notify you} other {We'll email you}} when new summer jobs match.",
  "season.action.title": "Get new summer jobs the day they are posted",
  "season.allFields": "All fields",
  "season.eyebrow": "Summer jobs {year}",
  "season.metaDescription": "Half of last summer’s summer jobs were posted by {when}. See when each field opens and get an alert the day new summer jobs are posted.",
  "season.metaTitle": "Summer jobs {year} in Finland: when they open, by field",
  "season.method.p1": "We count every summer job ad in Finland that our crawler first saw between {from} and {to}, once per ad even when it was posted in several places. An ad counts as a summer job when it is marked as one or its title says so (kesätyö, sommarjobb, summer job).",
  "season.method.p2": "\"Posted by\" is the day we first saw an ad and \"came down\" the day we last saw it, so both are accurate to about a week: last winter we checked most sites weekly. We added many employers in early January, so some ads posted in December only show up in January. If anything, the real opening dates are earlier.",
  "season.method.p3": "Fields with fewer than {min} ads are left out rather than estimated. We do not use first-seen dates from 20 September to 6 October 2026, when a change in how we identify ads gave old ads new dates.",
  "season.method.title": "How we counted",
  "season.methodLink": "How we counted",
  "season.month": "{m, select, jan {January} feb {February} mar {March} apr {April} may {May} jun {June} jul {July} aug {August} sep {September} oct {October} nov {November} other {December}}",
  "season.monthIn": "{m, select, jan {in January} feb {in February} mar {in March} apr {in April} may {in May} jun {in June} jul {in July} aug {in August} sep {in September} oct {in October} nov {in November} other {in December}}",
  "season.more.calendar.body": "How the season runs, and why some employers open their applications much earlier than others.",
  "season.more.calendar.title": "When to apply",
  "season.more.kit.body": "What to prepare now, so you can apply the day an ad goes up.",
  "season.more.kit.title": "Have your application ready",
  "season.more.title": "Get ready before the ads open",
  "season.pitch.all": "Last summer, half of the summer jobs we tracked were posted by {when}, and half of them came down within {weeks, plural, one {a week} other {# weeks}}. Set an alert now and hear about each new one the day it is posted.",
  "season.pitch.allNoClose": "Last summer, half of the summer jobs we tracked were posted by {when}. Set an alert now and hear about each new one the day it is posted.",
  "season.pitch.field": "{field}: half of last summer’s jobs were posted by {when}, and half came down within {weeks, plural, one {a week} other {# weeks}}.",
  "season.pitch.fieldNoClose": "{field}: half of last summer’s jobs were posted by {when}.",
  "season.seeSeason": "See every field and set an alert",
  "season.source": "Source: JobCrawls job archive, {count} summer job ads in Finland first seen {from} to {to}. Fields with fewer than {min} ads are left out.",
  "season.strip.caption": "Share of each field’s summer job ads that we first saw in each month of last season.",
  "season.strip.description": "Last season, more summer jobs were posted {month} than in any other month.",
  "season.strip.title": "When each field opens",
  "season.title": "Summer jobs {year}: apply before everyone else",
  "season.when": "{part, select, early {early {month}} mid {mid-{month}} other {late {month}}}",
  "season.byField.title": "Last summer, field by field",
  "changeNegotiations.agencyTag": "Staffing agency",
  "changeNegotiations.alertError": "We couldn't turn the alert on. Please try again.",
  "changeNegotiations.alertOffSub": "One switch. You sign in once, and you can turn it off any time.",
  "changeNegotiations.alertOnSub": "On. Manage it in Searches & Alerts.",
  "changeNegotiations.alertPending": "Almost there: check your inbox to confirm your email.",
  "changeNegotiations.alertRow": "Alert me about new {role} jobs",
  "changeNegotiations.alertRowWithPlace": "Alert me about new {role} jobs in {place}",
  "changeNegotiations.alertTitle": "Start before your last day",
  "changeNegotiations.alsoAnnounced": "Also announced",
  "changeNegotiations.announcedOn": "Announced {date}",
  "changeNegotiations.announcedTitle": "What was announced",
  "changeNegotiations.breadcrumbIndex": "Change negotiations",
  "changeNegotiations.employerOpenJobs": "{count, plural, one {# open job} other {# open jobs}} for this role",
  "changeNegotiations.eventType": "{type, select, layoffs {Dismissals} temporary_layoffs {Temporary layoffs} other {Change negotiations}}",
  "changeNegotiations.eyebrow": "Change negotiations",
  "changeNegotiations.gradeLabel": "Employer Score {grade}",
  "changeNegotiations.hiringIntro": "Pick your role from the roles {company} itself advertises. We then show other employers with open jobs for it nearby.",
  "changeNegotiations.hiringTitle": "Who is hiring your role now",
  "changeNegotiations.index.empty": "No current change negotiations to show right now.",
  "changeNegotiations.index.intro": "Employers that announced change negotiations or layoffs in the last 120 days, newest first. Each one cites the employer's own release. Open one to see who is hiring the same roles nearby.",
  "changeNegotiations.index.rowSub": "{type, select, layoffs {Dismissals} temporary_layoffs {Temporary layoffs} other {Change negotiations}}, {date}",
  "changeNegotiations.index.title": "Change negotiations now: who is hiring",
  "changeNegotiations.intro": "What {company} announced, who is hiring people in the same roles nearby, and what to check while you are still employed.",
  "changeNegotiations.noEmployers": "No other employer has open jobs for this role nearby right now. The alert below tells you when one does.",
  "changeNegotiations.noRoles": "{company} has no open ads right now, so there are no roles to pick from.",
  "changeNegotiations.peopleAffected": "The release says up to {count, plural, one {# person} other {# people}} may be affected.",
  "changeNegotiations.rankingNote": "Ranked by open jobs for the role, then Employer Score. From our own job index, updated daily.",
  "changeNegotiations.readRelease": "Read the release on {host}",
  "changeNegotiations.rightChangeSecurityBody": "If you are dismissed for financial or production reasons, register as a jobseeker with the employment services within 60 days of the dismissal date. That opens change security: a one-off change security allowance, an employment plan and possibly training. You can register during your notice period.",
  "changeNegotiations.rightChangeSecurityLink": "Change security on Job Market Finland",
  "changeNegotiations.rightChangeSecurityTitle": "Register for change security within 60 days",
  "changeNegotiations.rightResignBody": "Found a new job during the negotiations or your notice period? Check your notice period and how to resign in writing before you hand in your notice, so you know which rules apply to you.",
  "changeNegotiations.rightResignLink": "How to resign in Finland",
  "changeNegotiations.rightResignTitle": "Before you resign",
  "changeNegotiations.rightWaitingBody": "Being dismissed for financial or production reasons does not set a waiting period. Resigning yourself usually does: unemployment benefit is then not paid for 45 days after a permanent job ends.",
  "changeNegotiations.rightWaitingLink": "Waiting periods on Job Market Finland",
  "changeNegotiations.rightWaitingTitle": "Know the waiting period",
  "changeNegotiations.rightsIntro": "Three things to check while you are still employed. This is a guide, not a decision: your unemployment fund, Kela or the employment services decide in your own case.",
  "changeNegotiations.rightsTitle": "Your rights, in order",
  "changeNegotiations.rolePickerLabel": "Your role",
  "changeNegotiations.scopeFinland": "{count, plural, one {# open job} other {# open jobs}} for {role} in Finland",
  "changeNegotiations.scopeRegion": "{count, plural, one {# open job} other {# open jobs}} for {role} in {region}",
  "changeNegotiations.searchJobs": "Search all jobs",
  "changeNegotiations.seeAllJobs": "See all {role} jobs",
  "changeNegotiations.sourceNote": "Source: the employer's own release. We show only its headline and date; the release itself has the details.",
  "changeNegotiations.title": "{company} change negotiations: who is hiring now",
  "changeNegotiations.titleWithRole": "{company} change negotiations: who is hiring {role} now",
  "companyProfile.timeline.layoffEvent": "{type, select, layoffs {Announced dismissals} temporary_layoffs {Announced temporary layoffs} other {Announced change negotiations}}",
  "companyProfile.timeline.layoffEventPageLink": "Who is hiring the same roles now",
  "footer.careerPathsLink": "Career paths",
  "footer.summerJobsSeasonLink": "Summer jobs",
  "footer.taxIcebergLink": "Take-home pay calculator",
  "notificationPrefs.cadence.daily": "Daily",
  "notificationPrefs.cadence.inDigest": "In your digest",
  "notificationPrefs.cadence.instant": "Right away",
  "notificationPrefs.cadence.mondays": "Mondays",
  "notificationPrefs.cadence.monthly": "Monthly",
  "notificationPrefs.cadence.onEvent": "When it happens",
  "notificationPrefs.cadence.seasonal": "In season",
  "notificationPrefs.cadence.weekly": "Weekly",
  "notificationPrefs.channel.appLocal": "On your phone",
  "notificationPrefs.channel.email": "Email",
  "notificationPrefs.channel.inApp": "In JobCrawls",
  "notificationPrefs.channel.push": "Push",
  "notificationPrefs.channel.telegram": "Telegram",
  "notificationPrefs.channel.webhook": "Webhook",
  "notificationPrefs.kind.accountService": "Account messages",
  "notificationPrefs.kind.alertConfirmation": "Alert confirmation",
  "notificationPrefs.kind.archiveChangeAlerts": "Archive change alerts",
  "notificationPrefs.kind.forwardedEmployerMail": "Forwarded employer mail",
  "notificationPrefs.kind.instantAlerts": "Instant alerts",
  "notificationPrefs.kind.jobAlertDigest": "Job alert digest",
  "notificationPrefs.kind.journeyNudges": "Reminders and tips",
  "notificationPrefs.kind.marketValueNudge": "Market value check",
  "notificationPrefs.kind.mobileLocalReminders": "App reminders",
  "notificationPrefs.kind.mondayPlan": "Monday plan",
  "notificationPrefs.kind.plusAccountEmails": "Plus account emails",
  "notificationPrefs.kind.savedJobWatch": "Saved job changes",
  "notificationPrefs.kind.scoutPicks": "Scout picks",
  "notificationPrefs.kind.seasonNotices": "Season notices",
  "notificationPrefs.kind.thresholdAlerts": "Company threshold alerts",
  "notificationPrefs.kind.watchlistDigest": "Watchlist digest",
  "notificationPrefs.kind.watchlistPulse": "Watchlist pulse",
  "notificationPrefs.kind.webhooks": "Webhook events",
  "notificationPrefs.kind.yourMarketWeekly": "Your market weekly",
  "notificationPrefs.kindDesc.accountService": "Data export and account deletion confirmations. We have to send these.",
  "notificationPrefs.kindDesc.alertConfirmation": "Confirms your address when you turn on email alerts, with one reminder. Alerts cannot start without it.",
  "notificationPrefs.kindDesc.archiveChangeAlerts": "Your saved archive questions, when the answer changes.",
  "notificationPrefs.kindDesc.forwardedEmployerMail": "Employer replies to your application address, sent on to your inbox. They stay in My Jobs either way.",
  "notificationPrefs.kindDesc.instantAlerts": "A new job for one of your instant searches, as soon as we find it.",
  "notificationPrefs.kindDesc.jobAlertDigest": "New jobs for the saved searches you turned alerts on for, in one message.",
  "notificationPrefs.kindDesc.journeyNudges": "An interview tomorrow, a good day to follow up, an obligation coming up.",
  "notificationPrefs.kindDesc.marketValueNudge": "A note once a month when pay for your role moves past your threshold.",
  "notificationPrefs.kindDesc.mobileLocalReminders": "Deadlines, interviews and follow-ups the JobCrawls app reminds you of on your phone.",
  "notificationPrefs.kindDesc.mondayPlan": "Your week's applications, deadlines and follow-ups, on Monday morning.",
  "notificationPrefs.kindDesc.plusAccountEmails": "Receipts, renewals and changes to your plan. We have to send these.",
  "notificationPrefs.kindDesc.savedJobWatch": "A saved job closes soon, is taken down or is posted again.",
  "notificationPrefs.kindDesc.scoutPicks": "Jobs Scout read for you and thinks fit your brief, with its reasons. Off keeps the picks in the app.",
  "notificationPrefs.kindDesc.seasonNotices": "Summer job deadlines and programme openings, in season.",
  "notificationPrefs.kindDesc.thresholdAlerts": "A watched company's score or number of open roles crosses the line you set.",
  "notificationPrefs.kindDesc.watchlistDigest": "New jobs at the companies and roles you watch, in an email of its own.",
  "notificationPrefs.kindDesc.watchlistPulse": "What changed at the companies you watch, inside the Monday digest.",
  "notificationPrefs.kindDesc.webhooks": "Scout picks, stage changes and employer replies sent to your own tools.",
  "notificationPrefs.kindDesc.yourMarketWeekly": "Pay, demand and skills for your role, on Mondays.",
  "notificationPrefs.page.budgetEmail": "Reminders, tips and other non-alert emails: at most {perWeek, plural, one {# email} other {# emails}} a week. Alerts you asked for do not count toward this.",
  "notificationPrefs.page.budgetInstant": "Instant alerts and Scout: at most one message every {minutes} minutes, and nothing between {start} and {end}.",
  "notificationPrefs.page.budgetPush": "Push reminders: at most {perDay} a day and {perWeek} a week.",
  "notificationPrefs.page.budgetQuiet": "Quiet hours: no reminders between {start} and {end}. On the day of an interview, from {interviewEnd}.",
  "notificationPrefs.page.budgetsHeading": "How often we contact you",
  "notificationPrefs.page.budgetsIntro": "These limits are built in and apply to everyone, so a busy week never turns into a flood.",
  "notificationPrefs.page.cadenceLabel": "How often: {kind}",
  "notificationPrefs.page.channelsLabel": "Sent by",
  "notificationPrefs.page.eyebrow": "Account",
  "notificationPrefs.page.intro": "Everything JobCrawls can send you, in one place. Switch off what you do not need; the rest keeps working.",
  "notificationPrefs.page.loadError": "We could not load your notification settings. Reload the page to try again.",
  "notificationPrefs.page.loadErrorTitle": "Settings did not load",
  "notificationPrefs.page.manage": "Settings",
  "notificationPrefs.page.marketingHeading": "News and offers",
  "notificationPrefs.page.marketingIntro": "A separate choice from everything above. Switching it on or off never changes your notifications.",
  "notificationPrefs.page.needsSetup": "Switch this on from its own settings first.",
  "notificationPrefs.page.notLive": "Not live yet",
  "notificationPrefs.page.required": "Always sent",
  "notificationPrefs.page.saveError": "That change was not saved. Try again.",
  "notificationPrefs.page.saved": "Saved",
  "notificationPrefs.page.setUp": "Set up",
  "notificationPrefs.page.teamsPlaceholder": "Team accounts are on the way. Their notifications will show up here.",
  "notificationPrefs.page.title": "Notifications",
  "notificationPrefs.product.account": "Account",
  "notificationPrefs.product.myJobs": "My Jobs",
  "notificationPrefs.product.scout": "Scout",
  "notificationPrefs.product.searchAlerts": "Search alerts",
  "notificationPrefs.product.teams": "Teams",
  "notificationPrefs.product.watchlist": "Watchlist",
  "notificationPrefs.unsubscribe.explanation": "This stops \"{kind}\" emails. Everything else you get from JobCrawls stays as it is.",
  "notificationPrefs.unsubscribe.heading": "Stop \"{kind}\" emails",
  "notificationPrefs.unsubscribe.manageLink": "Notification settings",
  "notificationPrefs.unsubscribe.successBody": "You will no longer get \"{kind}\" emails. You can switch them back on, or change anything else, in your notification settings.",
  "plus.earn.block.title": "Help others, earn Plus",
  "plus.earn.capReached": "This month’s free Plus days have all been given. Anything you share still counts, and the offer opens again next month.",
  "plus.earn.interview.already": "You have shared a report for this interview.",
  "plus.earn.interview.body": "After an interview, share the format and the questions anonymously. Each report gives {days} days of Plus, for up to {max} reports a year. Nothing about a company shows until {floor} people have shared.",
  "plus.earn.interview.cancel": "Cancel",
  "plus.earn.interview.difficulty": "How hard was it?",
  "plus.earn.interview.difficulty.easy": "Easy",
  "plus.earn.interview.difficulty.hard": "Hard",
  "plus.earn.interview.difficulty.medium": "Medium",
  "plus.earn.interview.difficulty.none": "Rather not say",
  "plus.earn.interview.format.assignment": "Home assignment",
  "plus.earn.interview.format.group": "Group interview",
  "plus.earn.interview.format.onsite": "At the workplace",
  "plus.earn.interview.format.phone": "Phone",
  "plus.earn.interview.format.test": "Aptitude or personality test",
  "plus.earn.interview.format.video": "Video call",
  "plus.earn.interview.formats": "How was it held?",
  "plus.earn.interview.invalid": "Pick at least one format and write at least one question.",
  "plus.earn.interview.open": "Share this interview anonymously",
  "plus.earn.interview.outcome": "Where it stands",
  "plus.earn.interview.outcome.offer": "Got an offer",
  "plus.earn.interview.outcome.rejected": "Not chosen",
  "plus.earn.interview.outcome.waiting": "Waiting to hear",
  "plus.earn.interview.outcome.withdrew": "I withdrew",
  "plus.earn.interview.privacy": "We store the employer, the job title, the month and your answers. Not your name, your email or the date of the interview.",
  "plus.earn.interview.questions": "Questions you were asked, one per line",
  "plus.earn.interview.rounds": "Rounds so far",
  "plus.earn.interview.save": "Share report",
  "plus.earn.interview.saved": "Report shared. Thank you.",
  "plus.earn.interview.title": "Share an interview",
  "plus.earn.interview.year": "{count} of {max} reports rewarded this year",
  "plus.earn.intro": "Share what you learn while you search and we add days of Plus to your account the moment you save. Others get better figures, you get higher limits.",
  "plus.earn.off": "Earning Plus is paused right now. Anything you share still helps other job seekers.",
  "plus.earn.replies.body": "In My Jobs, note when an employer replied, invited you to an interview or turned you down. Every {per} logged replies give {days} days of Plus, up to {max} days a year. Applications count once, after you have tracked them for {min} days.",
  "plus.earn.replies.cta": "Open My Jobs",
  "plus.earn.replies.progress": "{count} of {per} toward your next {days} days",
  "plus.earn.replies.title": "Log employer replies",
  "plus.earn.replies.year": "{days} of {max} days earned this year",
  "plus.earn.reply.already": "You have logged the reply for this application.",
  "plus.earn.reply.countsFrom": "Logged from {date} on, this reply counts toward Plus.",
  "plus.earn.reply.date": "Date of the reply",
  "plus.earn.reply.hint": "Shared without your name. It shows other job seekers how fast this employer replies.",
  "plus.earn.reply.interviewed": "Invited to interview",
  "plus.earn.reply.label": "Did the employer reply?",
  "plus.earn.reply.logged": "Reply logged. Thank you.",
  "plus.earn.reply.rejected": "Turned me down",
  "plus.earn.reply.replied": "Replied",
  "plus.earn.reply.save": "Log reply",
  "plus.earn.reply.tooNew": "Saved. Applications count toward Plus after {days} days of tracking, so this one does not add to your progress.",
  "plus.earn.reward.cap": "Saved. This month’s free Plus days have all been given, so this one does not add days.",
  "plus.earn.reward.granted": "{days} days of Plus added. Your Plus now runs until {date}.",
  "plus.earn.reward.off": "Saved. Earning Plus is paused right now.",
  "plus.earn.reward.yearMax": "Saved. You have earned the most Plus days this way for this year.",
  "plus.earn.rulesNote": "Earned days add to the end of your current plan. If you pay for Plus or Pro, your next payment moves later by the same number of days.",
  "plus.earn.salary.body": "Tell us your pay anonymously and get {days} days of Plus, once a year.",
  "plus.earn.salary.cta": "Share your pay",
  "plus.earn.salary.title": "Share your pay",
  "plus.earn.saveError": "That did not save. Try again in a moment.",
  "plus.earn.title": "Earn days of Plus",
  "plus.limit.earn": "Or earn Plus days by sharing what you know",
  "plus.limit.zeroCount": "Your plan includes 0 {unit} for now.",
  "plus.limit.zeroWeek": "Your plan includes 0 {unit} a week for now.",
  "plus.upsell.earn": "Or earn Plus days by sharing what you know",
  "rulesHub.askScout": "Ask Scout about your situation",
  "rulesHub.askScout.prompt": "Which rules apply to my situation right now, and what should I do about them this week?",
  "rulesHub.cards.body": "The cards employers ask for in one place, with expiry dates and a reminder 60 days before one runs out.",
  "rulesHub.cards.title": "Card shelf",
  "rulesHub.changeSecurity.body": "If you have been given notice: the dates that matter and when each one falls.",
  "rulesHub.changeSecurity.title": "Change-security timeline",
  "rulesHub.degree.body": "Whether you need a recognition decision before you apply, who decides, what it costs and how long it takes.",
  "rulesHub.degree.title": "Foreign degree recognition",
  "rulesHub.grace.body": "Lost a job on a work-based permit? A countdown, a weekly plan and jobs you can do in English.",
  "rulesHub.grace.title": "Grace period planner",
  "rulesHub.group.benefits": "While you look for work",
  "rulesHub.group.cards": "Your cards and permits",
  "rulesHub.group.leaving": "Losing or leaving a job",
  "rulesHub.group.moving": "New to Finland",
  "rulesHub.lead": "What the rules say at the moments that matter: losing a job, living on benefits while you look, and moving to Finland. Guidance, not legal advice.",
  "rulesHub.partTime.body": "What a part-time job does to your unemployment benefit before you say yes.",
  "rulesHub.partTime.title": "Part-time job calculator",
  "rulesHub.resign.body": "Quitting or refusing work can delay your unemployment benefit. Check the waiting period and the reasons that count as valid.",
  "rulesHub.resign.title": "Before you resign or refuse",
  "rulesHub.travel.body": "What you can claim back for a trip to a job interview.",
  "rulesHub.travel.title": "Interview travel claim",
  "rulesHub.wageSubsidy.body": "A short paragraph you can send an employer to bring up a wage subsidy.",
  "rulesHub.wageSubsidy.title": "Wage subsidy paragraph",
  "scout.firstRun.back": "Back",
  "scout.firstRun.brief.atCompany": "Jobs like the ones at {company}",
  "scout.firstRun.brief.body": "Say it the way you would to a friend: the work, the place, what you will not do. Scout turns it into rules you can edit.",
  "scout.firstRun.brief.fromDoor": "Filled in from the page you came from. Change anything.",
  "scout.firstRun.brief.label": "Your brief",
  "scout.firstRun.brief.noRules": "No hard rules: Scout will judge every new job against your words.",
  "scout.firstRun.brief.parseError": "Scout could not read that just now. You can still go on: it will use your words as they are.",
  "scout.firstRun.brief.placeholder": "For example: backend developer in Helsinki or remote, no consulting firms, at least 4 500 a month",
  "scout.firstRun.brief.read": "Turn it into rules",
  "scout.firstRun.brief.reading": "Reading your brief",
  "scout.firstRun.brief.remove": "Remove {rule}",
  "scout.firstRun.brief.rolePair": "Move from {from} to {to}",
  "scout.firstRun.brief.rules": "Scout will only send jobs that match these. Remove any that are wrong.",
  "scout.firstRun.brief.summer": "Summer jobs",
  "scout.firstRun.brief.title": "What should Scout look for?",
  "scout.firstRun.brief.tooShort": "A few more words, please.",
  "scout.firstRun.brief.whatWhere": "{what} in {where}",
  "scout.firstRun.cv.body": "Paste or import your CV and Scout can judge fit.",
  "scout.firstRun.cv.linkedin": "Import from LinkedIn instead",
  "scout.firstRun.cv.pasteLabel": "Paste your CV or LinkedIn profile text",
  "scout.firstRun.cv.pasteMessage": "Here is my CV. Read it into my profile.",
  "scout.firstRun.cv.pasteNote": "Scout reads it into your profile and shows you what it found before anything is saved.",
  "scout.firstRun.cv.title": "Add your CV (optional)",
  "scout.firstRun.delivery.channel": "Scout uses the same channels as your alerts: email, and push in the app. You can change them in Searches & Alerts.",
  "scout.firstRun.delivery.daily": "Daily picks",
  "scout.firstRun.delivery.dailyNote": "The day's best matches each morning. Best when you are searching hard.",
  "scout.firstRun.delivery.monday": "The Monday plan",
  "scout.firstRun.delivery.mondayNote": "One message a week: the jobs worth applying to and what to do first.",
  "scout.firstRun.delivery.quiet": "Quiet watch",
  "scout.firstRun.delivery.quietNote": "Scout stays quiet and only speaks up for a job that is clearly better than the one you have.",
  "scout.firstRun.delivery.start": "Start Scout",
  "scout.firstRun.delivery.title": "How should Scout tell you?",
  "scout.firstRun.finnish.basic": "Basics (A1 to A2)",
  "scout.firstRun.finnish.body": "Many ads ask for Finnish, so Scout needs to know where you stand.",
  "scout.firstRun.finnish.fluent": "Fluent (C1 or above)",
  "scout.firstRun.finnish.middle": "Getting by at work (B1 to B2)",
  "scout.firstRun.finnish.native": "Native",
  "scout.firstRun.finnish.none": "None yet",
  "scout.firstRun.finnish.title": "How much Finnish do you speak?",
  "scout.firstRun.graduation.autumn": "Autumn {year}",
  "scout.firstRun.graduation.body": "Graduate programmes and first jobs often open months before graduation, so it helps Scout to know.",
  "scout.firstRun.graduation.done": "I have already graduated",
  "scout.firstRun.graduation.spring": "Spring {year}",
  "scout.firstRun.graduation.title": "When do you expect to graduate?",
  "scout.firstRun.lead": "Six quick answers, about a minute. Then Scout reads new jobs for you every day and tells you which ones are worth your time, and why.",
  "scout.firstRun.next": "Next",
  "scout.firstRun.notice.body": "Scout plans your search back from this date, so the weeks before your last day count.",
  "scout.firstRun.notice.label": "Last day of your notice period",
  "scout.firstRun.notice.title": "When does your notice period end?",
  "scout.firstRun.obligation.body": "My Jobs counts the ones that qualify, so you can see each month how close you are. Not sure? Leave it at 4.",
  "scout.firstRun.obligation.label": "Applications a month",
  "scout.firstRun.obligation.title": "How many applications a month does your employment plan ask for?",
  "scout.firstRun.pay.body": "Private to you. Scout uses it to tell a real step up from a sideways move.",
  "scout.firstRun.pay.label": "Gross pay a month, euros",
  "scout.firstRun.pay.title": "What do you earn now? (optional)",
  "scout.firstRun.reoffer.body": "One minute of setup, and Scout reads every new job for you and sends the ones worth your time.",
  "scout.firstRun.reoffer.cta": "Set up Scout",
  "scout.firstRun.reoffer.title": "Let Scout look for you",
  "scout.firstRun.result.back": "Back to where you were",
  "scout.firstRun.result.later": "Scout has started. Your first picks will be waiting in Scout as new jobs come in.",
  "scout.firstRun.result.lead": "Each reason quotes the ad itself, so you can check it. From now on Scout sends new ones as they come in.",
  "scout.firstRun.result.none": "Nothing from the last 7 days is a clear fit yet. Scout keeps reading every new job and tells you when one is.",
  "scout.firstRun.result.open": "Open Scout",
  "scout.firstRun.result.picks": "See all picks",
  "scout.firstRun.result.title": "What Scout found this week",
  "scout.firstRun.result.working": "Scout is reading the last 7 days of jobs against your brief",
  "scout.firstRun.saveError": "Could not save that. Try again in a moment.",
  "scout.firstRun.situation.body": "Scout uses this to show what matters at this point, and nothing else. You can change it any time in your profile.",
  "scout.firstRun.situation.title": "Where are you right now?",
  "scout.firstRun.skip": "Skip for now",
  "scout.firstRun.skipStep": "Skip this question",
  "scout.firstRun.step": "Step {n} of {total}",
  "scout.firstRun.title": "Let Scout look for you",
  "workspace.career": "Career",
  "workspace.career.note": "paths, skills, programmes",
  "workspace.career.programmes": "Graduate programmes",
  "workspace.career.skills": "Skills to learn",
  "workspace.career.summer": "Summer job kit",
  "workspace.career.yours": "Your career",
  "workspace.menu.heading": "Your workspaces",
  "workspace.pay": "Pay",
  "workspace.pay.market": "Your market value",
  "workspace.pay.net": "Net pay",
  "workspace.pay.note": "salaries, net pay, your raise",
  "workspace.pay.raise": "Raise case",
  "workspace.pay.share": "Share your salary",
  "workspace.pay.yours": "Your pay",
  "workspace.rules": "Rights and rules",
  "workspace.rules.note": "notice, benefits, permits",
  "workspace.search": "Search",
  "workspace.search.note": "results, map and AI search",
  "workspace.tabBar.more": "More",
  "workspace.tabBar.moreTitle": "More workspaces",
  "careerSwitch.aiCompare": "Exposure to AI and automation in the OECD research: {fromBand} for {from}, {toBand} for {to}.",
  "careerSwitch.alert.body": "Get an email when new {to} jobs are posted, so you can apply while they are fresh.",
  "careerSwitch.alert.button": "Create job alert",
  "careerSwitch.alert.failed": "Could not create the alert. Try again.",
  "careerSwitch.alert.heading": "Watch {to} jobs",
  "careerSwitch.alert.on": "Alert on",
  "careerSwitch.band.high": "high",
  "careerSwitch.band.low": "low",
  "careerSwitch.band.medium": "moderate",
  "careerSwitch.breadcrumb.careerPaths": "Career paths",
  "careerSwitch.faq.canI": "Can I switch from {from} to {to}?",
  "careerSwitch.faq.heading": "Questions",
  "careerSwitch.faq.jobs": "Where do I find a first job as {to}?",
  "careerSwitch.faq.jobsAnswer": "{entry, plural, =0 {None of the open {to} jobs is at entry level right now; the full list has {open, plural, one {# job} other {# jobs}}.} one {# of the open {to} jobs is at junior level or asks for at most a year of experience.} other {# of the open {to} jobs are at junior level or ask for at most a year of experience.}}",
  "careerSwitch.faq.skills": "What do I need to learn to work as {to}?",
  "careerSwitch.faq.skillsAnswer": "Ads for {to} often ask for {add}, which ads for {from} rarely do.",
  "careerSwitch.firstJobs.all": "See all {open, plural, one {# open job} other {# open jobs}}",
  "careerSwitch.firstJobs.empty": "No open {to} job is at entry level right now.",
  "careerSwitch.firstJobs.heading": "First jobs to look at",
  "careerSwitch.firstJobs.intro": "Open {to} jobs at junior level or asking for at most a year of experience, newest first, one per employer.",
  "careerSwitch.heading": "Switching from {from} to {to}",
  "careerSwitch.level.intern": "Trainee",
  "careerSwitch.level.junior": "Junior",
  "careerSwitch.method": "Pairs are chosen from the skills in job ads, not from tracked career moves: we list a pair when the target has 20 or more open jobs, both roles have a salary page, and their ads ask for enough of the same skills. Pay is the median from the salary pages. Data as of {date}.",
  "careerSwitch.otherFrom": "Other moves from {from}",
  "careerSwitch.otherInto": "Other roles that lead to {to}",
  "careerSwitch.payLinks": "Pay in full: {fromLink} and {toLink}.",
  "careerSwitch.skills.add": "Skills to add",
  "careerSwitch.skills.esco": "In the EU skills classification (ESCO)",
  "careerSwitch.skills.escoAdd": "Essential for {to}: {skills}.",
  "careerSwitch.skills.escoKeep": "Essential to both: {skills}.",
  "careerSwitch.skills.heading": "Skills you keep, skills to add",
  "careerSwitch.skills.keep": "Skills you keep",
  "careerSwitch.skills.source": "From the skills named in job ads for both roles over the last 12 months{esco, select, yes {, and ESCO v1.2 (European Commission)} other {}}. A skill counts as kept when ads for both roles ask for it, and as one to add when ads for {to} often ask for it and ads for {from} rarely do.",
  "careerSwitch.verdict.less": "Moving from {from} to {to} pays less: the median is {toPay} a month against {fromPay}, {diff} less ({netDiff} after tax), and there are {open, plural, one {# open {to} job} other {# open {to} jobs}} in Finland now.",
  "careerSwitch.verdict.more": "Moving from {from} to {to} pays more: the median is {toPay} a month against {fromPay}, {diff} more ({netDiff} after tax), and there are {open, plural, one {# open {to} job} other {# open {to} jobs}} in Finland now.",
  "careerSwitch.verdict.noPay": "There are {open, plural, one {# open {to} job} other {# open {to} jobs}} in Finland now.",
  "careerSwitch.verdict.same": "Moving from {from} to {to} keeps your pay at about the same level: the median is {toPay} a month against {fromPay}, and there are {open, plural, one {# open {to} job} other {# open {to} jobs}} in Finland now.",
  "careerSwitch.verdict.skills": "Ads for both roles ask for skills such as {keep}.",
  "careerSwitch.years": "{years, plural, =0 {No experience required} one {# year of experience} other {# years of experience}}",
  "careerSwitchLinks.heading": "Where you could go from here",
  "careerSwitchLinks.intro": "Roles whose ads ask for many of the skills {role} ads do, each with 20 or more open jobs. Matched by skills, not by tracking people’s moves.",
  "careerSwitchLinks.keeps": "Carries over: {skills}",
  "careerSwitchLinks.payLess": "Median {pay} a month, {diff} less",
  "careerSwitchLinks.payMore": "Median {pay} a month, {diff} more",
  "careerSwitchLinks.payOnly": "Median {pay} a month",
  "roleOutlook.ai.groupFallback": "this occupation group",
  "roleOutlook.ai.high": "High exposure to AI and automation for {group}, in the OECD research: many tasks can be supported or automated, which changes the work more than it removes it.",
  "roleOutlook.ai.label": "AI",
  "roleOutlook.ai.low": "Low exposure to AI and automation for {group}, in the OECD research.",
  "roleOutlook.ai.medium": "Moderate exposure to AI and automation for {group}, in the OECD research: parts of the work change, most of it stays.",
  "roleOutlook.demand.chartDescription": "The role’s share of all new job ads per month from {first} to {last}; {latest} in the latest month.",
  "roleOutlook.demand.coverageNote": "The chart shows the role’s share of all new ads each month, not raw counts: the number of employers we follow grew in January 2026, so earlier months are left out.",
  "roleOutlook.demand.falling": "Its share of all new ads fell {pct} in {recent} compared with {prior}.",
  "roleOutlook.demand.label": "Demand",
  "roleOutlook.demand.now": "{open, plural, one {# open job} other {# open jobs}} in Finland now, and {ads, plural, one {# new ad} other {# new ads}} in the last 12 months.",
  "roleOutlook.demand.nowOnly": "{open, plural, one {# open job} other {# open jobs}} in Finland now.",
  "roleOutlook.demand.rising": "Its share of all new ads rose {pct} in {recent} compared with {prior}.",
  "roleOutlook.demand.steady": "Its share of all new ads held steady in {recent} compared with {prior}.",
  "roleOutlook.heading": "Outlook for {role}",
  "roleOutlook.intro": "What our job-ad archive, pay data and AI research show for this role so far. It describes what has happened, not a forecast.",
  "roleOutlook.methodLink": "How we count",
  "roleOutlook.notForecast": "We do not extend these figures into the future.",
  "roleOutlook.pay.ads": "Pay stated in ads moved {change} between {fromQuarter} and {toQuarter} (the median of each quarter’s ads).",
  "roleOutlook.pay.label": "Pay",
  "roleOutlook.pay.official": "Statistics Finland put the median for {occupation} at {median} a month in {year}. Earnings in its sectors have risen {growth} since then, which puts it at about {projected} in {quarter}.",
  "roleOutlook.sources": "Sources: the JobCrawls job-ad archive (since {archiveFrom}, one count per job across channels); Statistics Finland, earnings statistics (CC BY 4.0); for AI exposure, OECD, Nedelkoska and Quintini (2018), by ISCO occupation group, matched to roles and reviewed by JobCrawls.",
  "salaryMethodology.outlook.ai": "AI exposure is the OECD research by Nedelkoska and Quintini (2018), by ISCO occupation group. We match roles to groups and review every match and band by hand, and we show it with that attribution.",
  "salaryMethodology.outlook.archive": "Demand comes from our own job-ad archive, which starts in May 2025: open jobs now, new ads in the last 12 months, and each role’s share of all new ads per month, counted once per job across channels. We compare shares rather than raw counts because the number of employers we follow grew in January 2026.",
  "salaryMethodology.outlook.noForecast": "All of this describes what has happened. We never extend our own trends into the future and call it a forecast.",
  "salaryMethodology.outlook.pay": "Pay trends use the median pay stated in ads per quarter (20 or more pay-stating ads each) and, where a role is mapped to an occupation group, Statistics Finland’s earnings statistics (CC BY 4.0), with the measured growth in earnings since the published year.",
  "salaryMethodology.outlook.skills": "Career-switch pages compare the skills named in both roles’ job ads over the last 12 months and, where both roles are mapped, the essential skills in ESCO v1.2 (European Commission, reusable with attribution). We list a pair only when the target has 20 or more open jobs and both roles have a salary page.",
  "salaryMethodology.outlook.title": "Role outlook and career-switch pages: sources and reuse",
  "careerSwitchIndex.from": "From {role}",
  "careerSwitchIndex.heading": "Career switches with the most evidence",
  "careerSwitchIndex.intro": "{count} moves between roles whose ads ask for many of the same skills, each into a role with 20 or more open jobs. Each page shows the pay difference, the skills you keep and add, and the first jobs to look at.",
  "careerSwitch.payBasisAds": "The figure for {role} is the median pay stated in job ads, because Statistics Finland publishes none for this occupation.",
  "companyProfile.badges.visaEvidenceHeading": "What the ads say about visa or relocation help",
  "companyProfile.badges.visaEvidenceKindPermit": "Visa or work permit",
  "companyProfile.badges.visaEvidenceKindRelocation": "Moving or housing",
  "companyProfile.badges.visaEvidenceNote": "Quoted from the ads. Terms can differ by role, so check them with the employer.",
  "search.refinements.mentionsRelocationSupport.filter": "Mentions visa or relocation help",
  "search.refinements.mentionsRelocationSupport.help": "Read from the ad text of jobs added since October 2026. Check the details with the employer.",
  "workInFinland.alert.banner": "Get new jobs without Finnish by email",
  "workInFinland.alert.dismiss": "Dismiss",
  "workInFinland.alert.error": "Something went wrong. We couldn't turn on alerts. Please try again.",
  "workInFinland.alert.manage": "Manage alerts",
  "workInFinland.alert.pending": "Almost there: check your inbox to confirm your email and turn on alerts.",
  "workInFinland.alert.sub": "Weekly or daily digest in English. Unsubscribe anytime.",
  "workInFinland.alert.success": "You're set. {channels, select, push {We'll notify you} both {We'll email and notify you} other {We'll email you}} about new jobs without Finnish.",
  "workInFinland.alert.toggle": "Get job alerts",
  "workInFinland.breadcrumb": "Work in Finland",
  "workInFinland.employers.empty": "No employer qualifies yet. We started reading visa and relocation help from the ad text in October 2026, so this list grows as new ads arrive.",
  "workInFinland.employers.englishJobs": "{count, plural, one {# open job} other {# open jobs}} without Finnish",
  "workInFinland.employers.heading": "Employers whose ads mention visa or relocation help",
  "workInFinland.employers.kindPermit": "Visa or work permit",
  "workInFinland.employers.kindRelocation": "Moving or housing",
  "workInFinland.employers.lead": "Each of these has an ad from the last 12 months that offers help with a visa, work permit, moving or housing, and an open job that does not require Finnish. We quote the ad; check the terms with the employer.",
  "workInFinland.employers.readAd": "Read the ad: {title}",
  "workInFinland.jobs.count": "<b>{count}</b> open jobs in Finland do not list Finnish as a requirement, from {employers, plural, one {# employer} other {# employers}}.",
  "workInFinland.jobs.countUnavailable": "Search the open jobs in Finland that do not list Finnish as a requirement.",
  "workInFinland.jobs.heading": "Jobs that don't require Finnish, right now",
  "workInFinland.jobs.relocationOnly": "Only ads that mention visa or relocation help",
  "workInFinland.jobs.searchLabel": "Job title, skill or company",
  "workInFinland.jobs.searchPlaceholder": "For example: software developer",
  "workInFinland.jobs.searchSubmit": "Search jobs without Finnish",
  "workInFinland.jobs.seeAll": "See all jobs without Finnish",
  "workInFinland.lead": "Jobs you can do without Finnish, employers whose ads offer visa or relocation help, what you'd take home, and the permit rules in the order you'll meet them.",
  "workInFinland.rules.degreeBody": "Most jobs do not need it. Regulated professions such as teacher, nurse or doctor do: the Finnish National Agency for Education (OPH) decides most of them and Valvira decides health care. An OPH decision costs {fee} and takes about {minMonths} to {maxMonths} months.",
  "workInFinland.rules.degreeLink": "Recognition of qualifications (OPH)",
  "workInFinland.rules.degreeTitle": "Degree recognition",
  "workInFinland.rules.graceBody": "Your permit is not withdrawn at once. You have 3 months to find a new job, or 6 months with a specialist permit, an EU Blue Card or a work-based permit you have held for at least two years. Your employer tells Migri the job has ended.",
  "workInFinland.rules.graceLink": "End of employment (Migri)",
  "workInFinland.rules.graceTitle": "If the job ends",
  "workInFinland.rules.guide": "Guide: the best job sites in Finland",
  "workInFinland.rules.heading": "The rules, in the order you meet them",
  "workInFinland.rules.permitBody": "From outside the EU and EEA you usually need a residence permit for an employed person. In 2026 the job must pay at least {employed} a month gross, not counting supplements such as evening pay. A specialist permit or an EU Blue Card needs at least {specialist} a month. EU and EEA citizens do not need a permit to work; they register their right of residence.",
  "workInFinland.rules.permitLinkBlueCard": "EU Blue Card (Migri)",
  "workInFinland.rules.permitLinkEmployed": "Permit for an employed person (Migri)",
  "workInFinland.rules.permitLinkIncome": "Income requirement (Migri)",
  "workInFinland.rules.permitLinkSpecialist": "Specialist permit (Migri)",
  "workInFinland.rules.permitTitle": "Work permit and its salary threshold",
  "workInFinland.rules.source": "Figures from Migri and OPH, checked on {date}. This is a summary, not legal advice.",
  "workInFinland.tax.full": "See the full tax iceberg for this salary",
  "workInFinland.tax.grossLabel": "Gross pay a month (EUR)",
  "workInFinland.tax.heading": "What you'd take home",
  "workInFinland.tax.municipalityLabel": "Where you'll live",
  "workInFinland.tax.preset": "I'm moving to Finland",
  "workInFinland.tax.presetNote": "This preset leaves out church tax, because you only pay it if you join a Finnish church, and asks where you'll live, because each municipality sets its own tax rate.",
  "workInFinland.tax.result": "On <b>{gross}</b> a month in {municipality} you keep about <b>{net}</b> after tax and social contributions, {keep} of your gross pay. Your employer pays about {cost} a month in all.",
  "workInFinland.title": "Work in Finland",
  "companyProfile.badges.visaSupportLegacyCaption": "Named in {ads, plural, one {# ad} other {# ads}}",
  "bridge.agreement.cta": "Check your pay",
  "bridge.agreement.sentence": "Wondering whether you are underpaid? See where your pay lands against {roleTitle} job ads and this agreement’s floor.",
  "bridge.company.cta": "See the take-home pay",
  "bridge.company.plusCta": "Build an interview pack",
  "bridge.company.plusSentence": "An interview coming up at {company}? Get a prep pack with their pay, what they ask for and questions to ask.",
  "bridge.company.sentence": "An interview or an offer at {company}? See what pay at their median leaves you after tax.",
  "bridge.label": "Next step",
  "bridge.payTransparency.cta": "Look up your role’s pay",
  "bridge.payTransparency.sentence": "Planning to ask your employer about pay? Know the going rate for your role first.",
  "bridge.salaryRole.cta": "Prepare your pay talk",
  "bridge.salaryRole.sentence": "Facing a pay talk or an offer? Work out what to ask for as a {roleTitle}, with a script to say it.",
  "bridge.taxIceberg.cta": "Compare two salaries",
  "bridge.taxIceberg.plusCta": "Compare offers and moves",
  "bridge.taxIceberg.plusSentence": "Weighing an offer or a move? Compare pay, tax and rent in two places side by side.",
  "bridge.taxIceberg.sentence": "Weighing an offer against your current pay? Put the two side by side and see what each leaves you.",
  "collectiveAgreementPage.faqQBinding": "Is {agreement} generally binding?",
  "collectiveAgreementPage.faqQMinimum": "What is the minimum pay under {agreement}?",
  "collectiveAgreementPage.minimumAnswer": "{hasMonthly, select, yes {The table pay for {label} under this agreement is {monthly} a month{hasHourly, select, yes { ({hourly} an hour)} other {}}} other {The minimum hourly wage for {label} under this agreement is {hourly}}}, from {validFrom}.",
  "collectiveAgreementPage.minimumSource": "Source: the agreement’s pay table, checked {date}.",
  "salaryNegotiate.adjusted": "Adjusted for {what}: its ads pay {pct} compared with all ads for the role ({count, plural, one {# ad} other {# ads}}).",
  "salaryNegotiate.adsOnly": "Statistics Finland publishes no earnings for this role’s occupation group, so the estimate comes from the pay stated in {count, plural, one {# job ad} other {# job ads}}.",
  "salaryNegotiate.answer": "Ask for {low} to {high} a month.",
  "salaryNegotiate.answerSource": "That is the median to the upper quartile of the JobCrawls pay estimate for {roleTitle} in Finland{where}, rounded to €50.",
  "salaryNegotiate.breadcrumbHere": "Negotiation prep",
  "salaryNegotiate.breadcrumbSalary": "Salary Data",
  "salaryNegotiate.copied": "Copied",
  "salaryNegotiate.copy": "Copy",
  "salaryNegotiate.dataNote": "Figures are JobCrawls aggregates of the pay stated in Finnish job ads. You may reuse them with a link to this page as the source.",
  "salaryNegotiate.dataNoteLink": "How the figures are made",
  "salaryNegotiate.faqAAsk": "Ask for {low} to {high} a month: the median to the upper quartile of the JobCrawls pay estimate for the role, rounded to €50.",
  "salaryNegotiate.faqANegotiable": "Benefits such as lunch, sports and culture benefit and a work phone, the number of remote days, and holiday above the legal 2 to 2.5 days a month.",
  "salaryNegotiate.faqHeading": "Questions",
  "salaryNegotiate.faqQAsk": "How much should I ask for as a {roleTitle} in Finland?",
  "salaryNegotiate.faqQFloor": "What is the lowest pay a {roleTitle} can be paid?",
  "salaryNegotiate.faqQNegotiable": "What can you negotiate besides pay in Finland?",
  "salaryNegotiate.floorLabel": "The floor",
  "salaryNegotiate.floorLink": "Read the agreement",
  "salaryNegotiate.floorRaised": "The estimate’s median is below the collective agreement’s table pay, so the low end starts at the agreement floor instead.",
  "salaryNegotiate.handJobs": "See open {roleTitle} jobs",
  "salaryNegotiate.handOfferCompare": "Compare two offers",
  "salaryNegotiate.handRaiseCase": "Build a one-page raise case",
  "salaryNegotiate.handSalaryPage": "Back to {roleTitle} pay",
  "salaryNegotiate.handTaxCompare": "Compare two salaries after tax",
  "salaryNegotiate.handWatch": "Watch your market value",
  "salaryNegotiate.heading": "{roleTitle}: salary negotiation prep",
  "salaryNegotiate.inputsHeading": "Fit it to you",
  "salaryNegotiate.inputsHint": "All three are optional. Nothing is saved or sent: the numbers stay in your browser.",
  "salaryNegotiate.landAbove": "You are above the upper quartile. Argue from your results, and use what else is negotiable below.",
  "salaryNegotiate.landBelow": "You are below the median, so the range below is a fair ask, not a stretch.",
  "salaryNegotiate.landEmpty": "Type your pay above to see where it lands on the estimate.",
  "salaryNegotiate.landHeading": "Where you land",
  "salaryNegotiate.landInside": "You are inside the range already: aim for its top end.",
  "salaryNegotiate.landNet": "About {net} a month is left after tax.",
  "salaryNegotiate.landResult": "On this estimate, about {pct}% of the pay in the role is below yours.",
  "salaryNegotiate.levelAll": "Any level",
  "salaryNegotiate.levelLabel": "Level",
  "salaryNegotiate.negBaseBody": "The monthly base pay is the main lever and it follows you into every later raise. Name one number, the top of your range, rather than a range of your own.",
  "salaryNegotiate.negBaseTitle": "Base pay",
  "salaryNegotiate.negBenefitsBody": "Lunch benefit, the sports and culture benefit and a work phone are common in Finland and taxed lightly or not at all, so they can be worth more to you than the same sum added to pay.",
  "salaryNegotiate.negBenefitsTitle": "Benefits",
  "salaryNegotiate.negFloorBody": "Where a collective agreement covers the job, its table pay is the floor: an employer may pay more, never less. A generally binding agreement applies to every employer in the field, members or not.",
  "salaryNegotiate.negFloorTitle": "The collective agreement minimum",
  "salaryNegotiate.negHolidayBody": "The Annual Holidays Act gives 2 days of paid holiday for each full month worked, 2.5 after a year. Extra days, or a holiday bonus where no agreement requires one, are yours to ask for.",
  "salaryNegotiate.negHolidayTitle": "Holiday above the legal minimum",
  "salaryNegotiate.negRemoteBody": "How many days a week you work from home is often easier to agree on than pay. Ask for it in the contract, not just in the interview.",
  "salaryNegotiate.negRemoteTitle": "Remote days",
  "salaryNegotiate.negotiableHeading": "What you can negotiate in Finland",
  "salaryNegotiate.nextHeading": "Take it further",
  "salaryNegotiate.noRange": "There are too few {roleTitle} ads with pay to give a range to ask for yet. What is negotiable and the script below still apply.",
  "salaryNegotiate.optionAds": "{name} ({count, plural, one {# ad} other {# ads}})",
  "salaryNegotiate.payLabel": "Current or offered pay",
  "salaryNegotiate.payUnit": "€ / month",
  "salaryNegotiate.placeAll": "All of Finland",
  "salaryNegotiate.placeLabel": "Place",
  "salaryNegotiate.rangeFigure": "{low} to {high} a month",
  "salaryNegotiate.rangeHeading": "Your range to ask for",
  "salaryNegotiate.rangeReason": "The median is what a typical person in the role earns, and the upper quartile is where the better-paid quarter starts, so anything in between is an ask an employer has heard before.",
  "salaryNegotiate.scriptHeading": "What to say",
  "salaryNegotiate.scriptNote": "A template, not advice: fill in the brackets and say it in your own words.",
  "salaryNegotiate.scriptOffer": "Thank you for the offer, I would like to join. Before I accept, I would like to talk about the pay. {roleTitle} pay in Finland is around {low} to {high} a month right now, and with [what you bring] I am asking for {ask} a month. Can we get there?",
  "salaryNegotiate.scriptRaise": "I would like to talk about my pay. {roleTitle} pay in Finland is around {low} to {high} a month right now. Over the past year I have [two concrete results], so I am asking for {ask} a month from [date]. What would it take to get there?",
  "salaryNegotiate.scriptTabOffer": "For an offer",
  "salaryNegotiate.scriptTabRaise": "For a raise",
  "salaryNegotiate.whereSep": "{place, select, none {} other {, {place}}}{level, select, none {} other {, {level} level}}",
  "salaryNegotiate.widenLevel": "Only {count, plural, one {# ad} other {# ads}} at {level} level state pay, under the 10 we need, so the range uses every level.",
  "salaryNegotiate.widenPlace": "{place} has only {count, plural, one {# ad} other {# ads}} with pay for this role, under the 10 we need, so the range uses all of Finland.",
  "forEmployers.claim.lead": "Work at a company we list?",
  "forEmployers.claim.link": "Claim your company page, it takes a few minutes",
  "teams.claim.checkNow": "Check now",
  "teams.claim.checking": "Checking…",
  "teams.claim.claimedBody": "The employer portal is open: your Employer Score and what drives it, how your page is doing, corrections, the free careers page and your API keys.",
  "teams.claim.claimedTitle": "You manage this page",
  "teams.claim.disputeBody": "A wrong website on the record, or a claim that should not be there. A person reads these; access never waits for it.",
  "teams.claim.disputeLabel": "What is wrong",
  "teams.claim.disputeSend": "Send to JobCrawls",
  "teams.claim.disputeSent": "Thanks. We will look at it and reply by email.",
  "teams.claim.disputeTitle": "Something wrong?",
  "teams.claim.disputeTooShort": "Tell us what is wrong in a sentence or two.",
  "teams.claim.dnsLabel": "DNS: a TXT record on {names}",
  "teams.claim.eyebrow": "JobCrawls for employers",
  "teams.claim.fileLabel": "Or a file at {url} containing this line",
  "teams.claim.getToken": "Show my code",
  "teams.claim.loadError": "The claim details did not load. Try again in a moment.",
  "teams.claim.noDomain": "We have no website of the company’s own on record, so we cannot check a domain. Tell us the right website below and we will fix the record.",
  "teams.claim.notFound": "This company has no public page on JobCrawls, so there is nothing to claim yet.",
  "teams.claim.notYet": "We could not find the code yet. DNS changes can take a few minutes to show; press \"Check now\" again in a moment.",
  "teams.claim.openPortal": "Open the employer portal",
  "teams.claim.othersBody": "You can still claim it: everyone who proves they work here gets access. If you think a claim is wrong, tell us below.",
  "teams.claim.othersTitle": "Someone else has claimed this page too",
  "teams.claim.subtitle": "Show that you work at {company} and the employer portal opens straight away, with no wait for us.",
  "teams.claim.title": "Claim the {company} page",
  "teams.claim.verified": "Done. You now manage the {company} page.",
  "teams.claim.whatYouGet": "Claiming does not change your grade, hide reviews or remove jobs from search. Corrections you report go to a person who checks them.",
  "teams.claim.workBody": "Fastest. Use the work account you have at {domain}. We only check the email address; you stay signed in to JobCrawls as yourself.",
  "teams.claim.workError": "That work account did not match {domain}. Try another account, or use the DNS record or the file.",
  "teams.claim.workGoogle": "Google Workspace",
  "teams.claim.workMicrosoft": "Microsoft work account",
  "teams.claim.workTitle": "Sign in with your work account",
  "teams.claim.workUnavailable": "Work account sign-in is not available yet. Use the DNS record or the file below, it takes a couple of minutes.",
  "teams.claimLine.link": "Claim this page",
  "teams.claimLine.text": "Work at {company}?",
  "rolePaySource.ads": "Based on {count, plural, one {# job ad} other {# job ads}} that state the pay.",
  "rolePaySource.adsNoCount": "Based on job ads that state the pay.",
  "rolePaySource.official": "Statistics Finland’s earnings for the occupation group “{occupation}” ({year}), raised to {quarter}. Job ads only set the differences by place and level.",
  "rolePaySource.officialShort": "Statistics Finland’s earnings for the occupation, raised to today. Job ads only set the differences by place and level.",
  "salaryInference.rolePayOfficial": "The employer did not state pay in this listing. We show what the role pays: Statistics Finland’s earnings for the occupation, raised to today, moved by the differences job ads show for this place and level. The same figures as the role’s salary page. Amounts are in EUR per month.",
  "taxIceberg.roles.official": "Statistics Finland",
  "plus.earn.company.basis": "Shared anonymously by JobCrawls members. Latest report {month}.",
  "plus.earn.company.difficulty": "Rated {difficulty} out of 5 for difficulty.",
  "plus.earn.company.questions": "Questions people were asked",
  "plus.earn.company.shape": "{reports, plural, one {# person} other {# people}} shared their interview. Usually {rounds, plural, one {# round} other {# rounds}}, most often: {formats}.",
  "plus.earn.company.shareCta": "Had an interview here? Share it from My Jobs.",
  "plus.earn.company.title": "Interviews here",
  "forTeams.ci.alert": "Alert me on these",
  "forTeams.ci.alertNote": "Free with a team workspace: one filter with a Monday digest. Sign in and claim your company to get one.",
  "forTeams.ci.any": "All",
  "forTeams.ci.count": "{total, plural, one {# signal} other {# signals}}, newest first. Showing up to 100.",
  "forTeams.ci.empty": "Nothing matched in the last 7 days. Try a wider filter.",
  "forTeams.ci.error": "We could not load the signals. Try again in a moment.",
  "forTeams.ci.feedTitle": "The last 7 days",
  "forTeams.ci.filters": "Narrow it down",
  "forTeams.ci.industry": "Industry",
  "forTeams.ci.kind": "Signal",
  "forTeams.ci.paid1": "Up to 50 saved filters, with alerts as they come, every morning or every Monday",
  "forTeams.ci.paid2": "Webhooks into your CRM (company_signal.new) and a CSV of every match",
  "forTeams.ci.paid3": "A shared watchlist of up to 1,000 companies and an API key",
  "forTeams.ci.paid4": "Seats for your whole team, paid by card or invoice, active the moment you buy",
  "forTeams.ci.paidTitle": "What a paid workspace adds",
  "forTeams.ci.region": "Region",
  "forTeams.ci.reuse": "How you may reuse these figures",
  "forTeams.ci.sources": "Sources: JobCrawls job index; PRH Trade Register and financial statements (CC BY 4.0); TED public procurement notices. News and other sources we may not republish are left out.",
  "forTeams.ci.subtitle": "Hiring spikes, new offices, first hires in a new field, public contracts won and Trade Register changes, from our job index and open registers. The last 7 days, free to look at.",
  "forTeams.ci.title": "Which Finnish companies are hiring and growing right now",
  "forTeams.eyebrow": "JobCrawls for teams",
  "forTeams.hub.ci.body": "For sales and business development: which companies are hiring faster, opening offices, winning public contracts or changing in the register, with alerts.",
  "forTeams.hub.ci.title": "Company signals",
  "forTeams.hub.claim.body": "For employers: claim your page in minutes with your work account or a DNS record, see how candidates find you and correct what is wrong.",
  "forTeams.hub.claim.title": "Your company page",
  "forTeams.hub.doorsTitle": "Pick where you start",
  "forTeams.hub.open": "Open",
  "forTeams.hub.press.body": "For journalists and researchers: the figures you may quote, where they come from and the monthly data files.",
  "forTeams.hub.press.title": "Press and research",
  "forTeams.hub.subtitle": "Recruiters, sales teams, employers and career advisors use the same data as Finland’s job seekers. Sign up and start at once: no demo, no sales call, no waiting.",
  "forTeams.hub.title": "Hiring data for the people who work with it",
  "notificationPrefs.kind.teamsSignalAlerts": "Company signal alerts",
  "notificationPrefs.kindDesc.teamsSignalAlerts": "Hiring spikes, new offices, public contracts and register changes at the companies your workspace’s filters cover.",
  "plus.r3.companySignals.contractWon": "Won a public contract from {buyer} on {date}: {title}.",
  "plus.r3.companySignals.contractWonShort": "Won a public contract on {date}.",
  "plus.r3.companySignals.financialsPublished": "Registered its financial statement on {date}.",
  "plus.r3.companySignals.hiringDown": "Hiring has slowed: {ads, plural, one {# new ad} other {# new ads}} in {month}, against about {usual} a month before.",
  "plus.r3.companySignals.hiringUp": "Hiring is up: {ads, plural, one {# new ad} other {# new ads}} in {month}, against about {usual} a month before.",
  "plus.r3.companySignals.newField": "First ads in {field}: {ads, plural, one {# ad} other {# ads}} since {month}.",
  "teams.signals.addHeading": "New signal filter",
  "teams.signals.adminsOnly": "Workspace admins can save signal filters.",
  "teams.signals.cadence": "Alert me",
  "teams.signals.companies": "Also these companies (ids, one per line)",
  "teams.signals.csv": "Download as CSV",
  "teams.signals.daily": "Every morning",
  "teams.signals.email": "Email the workspace members",
  "teams.signals.feedEmpty": "Nothing matched in the last 30 days.",
  "teams.signals.feedHeading": "Signals in the last 30 days",
  "teams.signals.filtersEmpty": "No signal filters yet. Save one below.",
  "teams.signals.filtersHeading": "Saved signal filters",
  "teams.signals.industries": "Industries (none picked: all)",
  "teams.signals.instant": "As they come (at most hourly)",
  "teams.signals.intro": "Save a filter and we tell you when a company in it starts hiring faster, opens a new office, wins a public contract or changes in the Trade Register. Every signal comes from our job index or open registers, with its source.",
  "teams.signals.invalid": "Give the filter a name.",
  "teams.signals.kind.contractWon": "Public contract won",
  "teams.signals.kind.financialsPublished": "Financial statement filed",
  "teams.signals.kind.hiringSpike": "Hiring up or down",
  "teams.signals.kind.newField": "First hire in a new field",
  "teams.signals.kind.newOffice": "New office or city",
  "teams.signals.kind.registryChange": "Trade Register change",
  "teams.signals.kind.reopenedRole": "Role advertised again",
  "teams.signals.kinds": "Signals (none picked: all)",
  "teams.signals.limit": "You have reached your plan's limit: a free workspace has one filter with the Monday digest. Paid seats give you 50 filters and every timing.",
  "teams.signals.name": "Name",
  "teams.signals.regions": "Regions (none picked: all of Finland)",
  "teams.signals.remove": "Remove filter",
  "teams.signals.save": "Save filter",
  "teams.signals.seen": "Found {date}",
  "teams.signals.show": "Show its signals",
  "teams.signals.showAll": "All filters",
  "teams.signals.webhook": "Send to our webhooks (company_signal.new)",
  "teams.signals.weekly": "Every Monday",
  "forTeams.hub.rec.body": "For in-house and agency recruiters: who is hiring before the ad, pay for every role, and candidates who chose to be found.",
  "forTeams.hub.rec.title": "Recruiters",
  "forTeams.rec.agency1": "Hiring signals with alerts by industry and region, to reach companies before they post",
  "forTeams.rec.agency2": "Free candidate search. Contact requests from agencies open after the in-house launch.",
  "forTeams.rec.agency3": "Webhooks and CSV into your CRM",
  "forTeams.rec.agencyTitle": "Recruitment agencies",
  "forTeams.rec.any": "All",
  "forTeams.rec.cta": "Claim your company",
  "forTeams.rec.demoIntro": "Companies whose hiring jumped, that started hiring in a new field or a new region, or that advertised a role again, in the last 7 days.",
  "forTeams.rec.demoTitle": "Hiring right now, before the ads say so",
  "forTeams.rec.empty": "Nothing in the last 7 days for this filter.",
  "forTeams.rec.fair1": "Every request names the role and a monthly salary range that reaches the candidate’s floor.",
  "forTeams.rec.fair2": "Candidates choose how many requests a week they get, and which companies may see them.",
  "forTeams.rec.fair3": "Contact details show only after the candidate says yes.",
  "forTeams.rec.fairTitle": "Fair to candidates, so they answer",
  "forTeams.rec.inHouse1": "Your company page, claimed in minutes: correct it and see how candidates find you",
  "forTeams.rec.inHouse2": "Pay for every role from Statistics Finland and live ads, to set a range candidates accept",
  "forTeams.rec.inHouse3": "Free candidate search and contact requests",
  "forTeams.rec.inHouseTitle": "In-house recruiters",
  "forTeams.rec.industry": "Industry",
  "forTeams.rec.region": "Region",
  "forTeams.rec.startTitle": "Start in minutes",
  "forTeams.rec.step1": "Sign in and claim your company, or join it from a colleague’s invite.",
  "forTeams.rec.step3": "Search candidates and save signal alerts.",
  "forTeams.rec.subtitle": "Hiring signals from every Finnish employer we crawl, pay for every role, and a candidate database where people opt in, set their salary floor and choose who may contact them.",
  "forTeams.rec.title": "Find who is hiring before the ad, and candidates who want to be found",
  "forTeams.adv.about": "About JobCrawls",
  "forTeams.adv.alreadySeated": "This account already holds a seat. See it on your Plus account page.",
  "forTeams.adv.b.newToFinland": "Search jobs in English, see which employers work in English, and work out your net pay in Finland before you apply.",
  "forTeams.adv.b.student": "Summer jobs and trainee programmes open months ahead. Set an alert now and hear about new ones the day they are posted.",
  "forTeams.adv.b.underNotice": "Start before your notice ends: see who is hiring for your work now, what it pays after tax, and save searches that tell you about new jobs.",
  "forTeams.adv.b.unemployed": "Search every job in Finland in one place, set alerts, and keep the four applications a month you report in a log you can copy straight into Job Market Finland.",
  "forTeams.adv.bizCountry": "Country code",
  "forTeams.adv.bizEmail": "Billing email",
  "forTeams.adv.bizVat": "VAT number (outside Finland)",
  "forTeams.adv.checkoutDone": "Payment received. Your organisation and its join link are below.",
  "forTeams.adv.coachCode": "Your coach code: {code}",
  "forTeams.adv.coachIntro": "A coach seat is free. Your clients enter your coach code to share what they choose with you, such as their tracker, and can stop at any time.",
  "forTeams.adv.coachStart": "Get my coach code",
  "forTeams.adv.coachTitle": "For coaches",
  "forTeams.adv.copied": "Copied",
  "forTeams.adv.copy": "Copy link",
  "forTeams.adv.editorial": "Editorial standards",
  "forTeams.adv.free1": "One search across company career pages, job boards and Job Market Finland, with alerts for new jobs.",
  "forTeams.adv.free2": "A tracker for their applications that also keeps the job-search obligation log you ask them for.",
  "forTeams.adv.free3": "Pay, net pay and employer facts from open data, so they know what to ask for.",
  "forTeams.adv.freeTitle": "What your clients get free",
  "forTeams.adv.handoutsIntro": "One page per situation, to print or share. Each link opens the right starting point.",
  "forTeams.adv.handoutsTitle": "Hand-outs",
  "forTeams.adv.joinButton": "Take the seat",
  "forTeams.adv.joinError": "This link does not work any more, or its seats are all taken. Ask your advisor for a new one.",
  "forTeams.adv.joinIntro": "Your advisor gave you JobCrawls Plus. Take the seat to start.",
  "forTeams.adv.joinLink": "Join link to share with your clients",
  "forTeams.adv.joinTitle": "Take your seat",
  "forTeams.adv.joined": "Done. You have Plus from {org} until {date}.",
  "forTeams.adv.k.employer": "Employer (change security)",
  "forTeams.adv.k.employmentArea": "Employment area or TE services",
  "forTeams.adv.k.outplacement": "Outplacement or career service",
  "forTeams.adv.mineSeats": "{used} of {limit} seats taken. Ends {date}.",
  "forTeams.adv.mineTitle": "Your organisations",
  "forTeams.adv.months": "Term",
  "forTeams.adv.monthsValue": "{months, plural, one {# month} other {# months}}",
  "forTeams.adv.orgIntro": "Give your clients JobCrawls Plus for a term. They take a seat through your join link. You see anonymous totals only, and only from groups of 10 or more. Pay by card, or choose an invoice and start at once.",
  "forTeams.adv.orgKind": "Organisation type",
  "forTeams.adv.orgName": "Organisation name",
  "forTeams.adv.orgTitle": "Seats for your organisation",
  "forTeams.adv.payCard": "Pay by card",
  "forTeams.adv.payInvoice": "Invoice, start now",
  "forTeams.adv.pricingNotSet": "Seat prices are not set yet.",
  "forTeams.adv.print": "Print",
  "forTeams.adv.quote": "{net} € + VAT {vat} € = {gross} €",
  "forTeams.adv.report": "People who applied: {applied}. In interviews: {interviewing}. Hired: {hired}.",
  "forTeams.adv.reportFloor": "Totals appear once 10 or more people take part.",
  "forTeams.adv.s.newToFinland": "New to Finland",
  "forTeams.adv.s.student": "Students and graduates",
  "forTeams.adv.s.underNotice": "Under notice",
  "forTeams.adv.s.unemployed": "Out of work",
  "forTeams.adv.seats": "Seats",
  "forTeams.adv.sheetFree": "Free. No account needed to search.",
  "forTeams.adv.signIn": "Sign in to continue",
  "forTeams.adv.subtitle": "For TE and employment-area advisors, career services and coaches. Your clients search every job site in Finland in one place, in Finnish, Swedish or English, for free.",
  "forTeams.adv.title": "A free job search tool you can hand to the people you advise",
  "forTeams.adv.trustBody": "Read how we check our data and who runs JobCrawls.",
  "forTeams.adv.trustTitle": "Who we are",
  "forTeams.hub.adv.body": "For employment services, career services and coaches: hand-outs for your clients, Plus seats for your organisation and a free coach seat.",
  "forTeams.hub.adv.title": "Career advisors",
  "dataUse.desk.pitch": "Get each new edition by email, once a month.",
  "dataUse.desk.signIn": "Sign in to get new editions by email",
  "dataUse.desk.stop": "Stop",
  "dataUse.desk.subscribe": "Email me new editions",
  "dataUse.desk.subscribed": "You get each new edition by email.",
  "notificationPrefs.kind.advisorMonthly": "Monthly note for advisors",
  "notificationPrefs.kind.dataDeskEditions": "Data Desk monthly edition",
  "notificationPrefs.kind.employerMonthly": "Your company page this month",
  "notificationPrefs.kind.teamsPayBenchmark": "Pay benchmark changes",
  "notificationPrefs.kindDesc.advisorMonthly": "New guides and the season dates worth passing on to the people you advise, once a month.",
  "notificationPrefs.kindDesc.dataDeskEditions": "The new monthly figures on the Finnish job market, with charts and CSV files you may reuse.",
  "notificationPrefs.kindDesc.employerMonthly": "Views, follows and apply clicks on your claimed company page, once a month.",
  "notificationPrefs.kindDesc.teamsPayBenchmark": "Once a month, when the pay for a role your workspace watches moves by 3% or more.",
  "teams.signals.payAdd": "Watch",
  "teams.signals.payIntro": "Watch the roles you hire for. Once a month we email you when their typical pay moves by 3% or more, from the same figures as our salary pages.",
  "teams.signals.payLimit": "Your plan watches up to {limit} roles.",
  "teams.signals.payNow": "{median} € a month",
  "teams.signals.payRole": "Role, for example Nurse or Software Developer",
  "teams.signals.payTitle": "Pay benchmarks",
  "teams.signals.payUnknown": "We have no pay figure for that role yet. Try the name used in job ads.",
  "teams.signals.presetLeads": "Start from hiring leads",
  "teams.signals.presetLeadsName": "Hiring leads",
  "dataUse.desk.failed": "That did not work. Try again in a moment.",
  "forTeams.adv.bizCountryHelp": "Two letters, for example FI or SE",
  "forTeams.adv.formInvalid": "Check the details: a name of 2 to 120 characters, 1 to 500 seats, a valid Business ID and billing email, and a VAT number outside Finland.",
  "forTeams.adv.invoiceNote": "With an invoice, seats work at once and run to the full term when the invoice is paid.",
  "forTeams.adv.invoiceOpen": "You already have an open invoice for seats. Once it is paid you can order more.",
  "forTeams.rec.error": "We could not load the signals. Try again in a moment.",
  "teams.signals.companiesHelp": "A company id is the last part of its JobCrawls page address, for example valo-oy.",
  "teams.signals.loadFailed": "We could not load the signals. Reload the page to try again.",
  "backoffice.hub.desc.tickets": "Plan and track work: tickets, projects and docs, shared with Claude through MCP.",
  "backoffice.tickets.nav": "Tickets",
  "backoffice.demoAccounts.nav": "Demo accounts",
  "backoffice.hub.desc.demoAccounts": "Open a ready-made demo account for each product, to test it or show it to someone.",
  "backoffice.hub.desc.traffic": "Sessions, sources, pages, funnels, doors, web vitals and a live replay, from our own event log.",
  "backoffice.traffic.nav": "Traffic",
  "demoAccount.banner.exit": "Exit demo",
  "demoAccount.banner.label": "Demo account",
  "demoAccount.banner.text": "Demo account. The people in it are made up, and nothing you do here reaches anyone: no emails, payments or public changes.",
  "backoffice.errors.nav": "Errors",
  "backoffice.hub.desc.errors": "Browser and server errors, grouped, source-mapped and alerted on, with links to AWS logs and metrics.",
  "teams.shell.brand": "Prospector",
  "teams.shell.developers": "API and MCP",
  "teams.shell.filters": "Saved filters",
  "teams.shell.jobSearch": "Job search",
  "teams.shell.navLabel": "Prospector",
  "teams.shell.signOut": "Sign out",
  "teams.shell.signals": "Signals",
  "teams.shell.watchlist": "Watchlist",
  "forTeams.adv.bizLanguage": "Invoice language",
  "forTeams.adv.bizLanguageHelp": "Receipts and invoices are written and emailed in this language. You can open any of them in another language later.",
  "billing.businessId.found": "{name}, {address}. Filled in from the company register.",
  "billing.businessId.foundVat": "{name}, {address}, VAT registered. Filled in from the company register.",
  "billing.businessId.help": "A Finnish Y-tunnus fills in the rest from the company register.",
  "billing.businessId.inactive": "{name} is no longer active in the company register. Check the business ID.",
  "billing.businessId.label": "Business ID",
  "billing.businessId.looking": "Looking it up…",
  "billing.businessId.notFound": "Not found in the company register. Check the number, or fill in the details yourself.",
  "billing.methods.back": "Back",
  "billing.methods.bank": "Online bank",
  "billing.methods.credit": "Invoice or instalments",
  "billing.methods.creditcard": "Card",
  "billing.methods.mobile": "Mobile payment",
  "billing.methods.more": "All methods on Paytrail",
  "billing.methods.payWith": "Pay with {name}",
  "billing.methods.secure": "Payments are handled by Paytrail, a Finnish payment service. We never see your bank or card details.",
  "billing.methods.title": "Choose how to pay {amount}",
  "billing.methods.wallets": "Fastest",
  "teams.shell.companies": "Companies",
  "teams.channels.add": "Add channel",
  "teams.channels.body": "Paste the channel’s incoming webhook address. Every signal filter with webhooks on then posts its new signals there.",
  "teams.channels.chat": "Chat",
  "teams.channels.invalid": "That is not an incoming webhook address for the chat you picked.",
  "teams.channels.limit": "Webhooks are full on this plan. A bigger plan raises the limit.",
  "teams.channels.off": "Switched off after repeated failures. Remove it and add it again.",
  "teams.channels.remove": "Remove channel",
  "teams.channels.test": "Send a test",
  "teams.channels.testFail": "Not posted",
  "teams.channels.testOk": "Posted",
  "teams.channels.title": "Alerts in Slack, Discord or Teams",
  "teams.channels.url": "Incoming webhook address",
  "teams.shell.integrations": "Integrations",
  "teams.shell.byline": "by JobCrawls",
  "outpost.nav.apiKeys": "API keys",
  "outpost.nav.candidates": "Candidates",
  "outpost.nav.careersPage": "Careers page",
  "outpost.nav.jobs": "Job ads",
  "outpost.nav.label": "Outpost",
  "outpost.promoted.explain": "The employer paid to show this job here. It matches your search; the rest of the list is in our usual order.",
  "outpost.promoted.label": "Promoted",
  "backoffice.hub.desc.visitors": "Organisations that visited the employer pages in the last 30 days, with the pages they read.",
  "backoffice.visitors.nav": "Visitors",
  "employerRanking.backLink": "All employers",
  "employerRanking.col.ads": "Ads in 12 months",
  "employerRanking.col.apply": "Apply clicks per ad",
  "employerRanking.col.employer": "Employer",
  "employerRanking.col.follows": "Follows per 1,000 views",
  "employerRanking.col.grade": "Employer Score",
  "employerRanking.col.rank": "Rank",
  "employerRanking.empty.body": "The ranking is built each night. Check back tomorrow.",
  "employerRanking.empty.title": "No ranking yet",
  "employerRanking.grade.aria": "Employer Score {grade}",
  "employerRanking.group.industry": "By industry",
  "employerRanking.group.region": "By region",
  "employerRanking.group.size": "By company size",
  "employerRanking.input.apply": "apply clicks per ad",
  "employerRanking.input.employerScore": "Employer Score",
  "employerRanking.input.follows": "follows per 1,000 profile views",
  "employerRanking.input.save": "apply clicks per saved job",
  "employerRanking.method.data": "Follows, applications and saves are counted from visitors who accepted analytics, over the last {days} days.",
  "employerRanking.method.fair": "Claiming a profile gives no boost, nothing is sold and paying changes nothing. Staffing agencies are not ranked.",
  "employerRanking.method.floors": "An employer needs at least {ads} ads in the last 12 months to be ranked. Once visit data is in use it also needs at least {views} profile views in the last 90 days. Below a floor no rank is computed.",
  "employerRanking.method.floorsViewsUnchecked": "The profile view floor is not applied at the moment, because we do not have visit data yet.",
  "employerRanking.method.heading": "How the ranking works",
  "employerRanking.method.inputs": "The ranking mixes up to four things: the Employer Score, follows per 1,000 profile views, apply clicks per ad and apply clicks per saved job. Inputs in use today: {inputs}.",
  "employerRanking.method.mix": "Each input becomes a place among the ranked employers, so inputs on different scales can be mixed. The Employer Score counts for {score}, follows for {follows}, apply clicks per ad for {apply} and apply clicks per save for {save}. If an employer has no figure for an input, the others carry its weight.",
  "employerRanking.method.reuse": "These figures may be reused as aggregates with the credit “Source: JobCrawls” and a link to this page.",
  "employerRanking.method.score": "The Employer Score comes from our own job data: pay, flexibility, hiring stability, growth, benefits and transparency. It is shown as a letter grade only.",
  "employerRanking.navLink": "See the employer ranking",
  "employerRanking.note.scoreOnly": "We do not have enough visit data to use follows, applications and saves yet. They will join the ranking when the data is there.",
  "employerRanking.note.scoreOnlyTitle": "Ranked on the Employer Score alone",
  "employerRanking.population": "{ranked, plural, one {# employer is} other {# employers are}} ranked here, out of {eligible, plural, one {# employer} other {# employers}} considered. The rest are below the floors.",
  "employerRanking.scope.overall": "All employers",
  "employerRanking.scope.sizeBand": "{band} staff",
  "employerRanking.scopes.aria": "Choose a ranking",
  "employerRanking.showing": "The table shows the top {count}.",
  "employerRanking.subtitle.scoreOnly": "Employers in Finland ranked by their Employer Score. Updated nightly.",
  "employerRanking.subtitle.withBehaviour": "Employers in Finland ranked by their Employer Score and by what job seekers do on their pages: following, applying and saving. Updated nightly.",
  "employerRanking.table.caption": "Employers ranked in: {scope}",
  "employerRanking.title": "Employer ranking",
  "pulse.answer.label": "{value} out of {max}",
  "pulse.dismiss": "Not now",
  "pulse.failed": "Could not save that. Try again later.",
  "pulse.note": "One quick question. Not linked to your profile, shown only as a group.",
  "pulse.scale.consider.high": "Definitely",
  "pulse.scale.consider.low": "Definitely not",
  "pulse.scale.employer.high": "Very appealing",
  "pulse.scale.employer.low": "Not appealing",
  "pulse.scale.process.high": "Great",
  "pulse.scale.process.low": "Poor",
  "pulse.thanks": "Thanks, noted.",
  "pulse.question.consider": "Would you consider working at {company}?",
  "pulse.question.employer": "How appealing is {company} as an employer?",
  "pulse.question.process": "How did the hiring process at {company} feel?",
  "plus.r3.companySignals.projectAnnounced": "Its job ads mention a project: {project}.",
  "plus.r3.companySignals.systemAdopting": "Is introducing {system} ({category}), according to its job ads.",
  "plus.r3.companySignals.systemFirstUse": "Its job ads started naming {system} ({category}) after a gap of at least six months.",
  "plus.r3.companySignals.systemMigration": "Is moving from {from} to {to} ({category}), according to its job ads.",
  "knowledge.removal.confirm": "Remove my details",
  "knowledge.removal.confirmBody": "Press the button to finish. We delete the details we hold about you and make sure they are not added again.",
  "knowledge.removal.confirmTitle": "Finish the removal",
  "knowledge.removal.doneBody": "They will not be added again. Nothing more is needed from you.",
  "knowledge.removal.doneTitle": "Your details are removed",
  "knowledge.removal.email": "Work email address",
  "knowledge.removal.error": "Something went wrong. Try again in a moment, or write to {contact}.",
  "knowledge.removal.expired": "This link has expired or was already used. If your details are still listed, ask again from this page.",
  "knowledge.removal.how": "Enter your name and the work email address you want removed. We send a link to that address to check that it is yours. When you follow it, we delete the details we hold and make sure they are not added again.",
  "knowledge.removal.invalid": "Check your name and email address and try again.",
  "knowledge.removal.keep": "To stop anyone adding you again we keep only a scrambled fingerprint of your email address and name, not the details themselves.",
  "knowledge.removal.name": "Your name",
  "knowledge.removal.send": "Send me the confirmation link",
  "knowledge.removal.sentBody": "We send a confirmation link to {email}. Follow it to finish the removal. If nothing arrives, write to {contact} and we will help.",
  "knowledge.removal.sentTitle": "Request received",
  "knowledge.removal.subtitle": "If your name and work contact details appear in the shared contacts that Prospector customers use, you can ask us to remove them here. You do not need an account.",
  "knowledge.removal.title": "Remove my details",
  "plus.r3.companySignals.fieldSpikeDown": "Hiring in {field} has slowed: {ads, plural, one {# new ad} other {# new ads}} in {month}, against about {usual} a month before.",
  "plus.r3.companySignals.fieldSpikeUp": "Hiring in {field} is up: {ads, plural, one {# new ad} other {# new ads}} in {month}, against about {usual} a month before.",
  "plus.r3.companySignals.financialsRevenue": "Revenue {direction, select, up {up} other {down}} {pct}% on the year before, from {from} to {to} (year ended {date}).",
  "plus.r3.companySignals.financialsStaff": "Staff {direction, select, up {up} other {down}} {pct}% on the year before, from {from} to {to} people (year ended {date}).",
  "plus.r3.companySignals.groupAcquired": "{known, select, yes {Gained a subsidiary: {name} (seen {date}).} other {Gained a new subsidiary (seen {date}).}}",
  "plus.r3.companySignals.groupAcquiredBy": "{known, select, yes {Got a new parent company: {name} (seen {date}).} other {Got a new parent company (seen {date}).}}",
  "plus.r3.companySignals.groupMerged": "{known, select, yes {A merger with {name} was registered on {date}.} other {A merger was registered on {date}.}}",
  "plus.r3.companySignals.layoffAnnounced": "{headcount, plural, =0 {Change negotiations or layoffs announced on {date}.} other {Change negotiations or layoffs announced on {date}, affecting up to # people.}}",
  "plus.r3.companySignals.seniorHiring": "Hiring senior people: {ads, plural, one {# senior or leadership ad} other {# senior or leadership ads}} in {month}, mostly in {fields}.",
  "plus.r3.companySignals.seniorHiringLeadership": "Hiring senior people, including director or executive roles: {ads, plural, one {# senior or leadership ad} other {# senior or leadership ads}} in {month}, mostly in {fields}.",
  "teams.shell.triggers": "Triggers",
  "teams.signals.kind.fieldSpike": "Hiring up or down in one field",
  "teams.signals.kind.seniorHiring": "Senior hiring",
  "professionalPhoto.again": "Make more",
  "professionalPhoto.error.failed": "Professional photos aren't available right now. Try again in a moment.",
  "professionalPhoto.error.quota": "You've used today's professional photos. They reset tomorrow.",
  "professionalPhoto.error.refused": "This photo couldn't be edited. Try a clear photo of just your face and shoulders.",
  "professionalPhoto.error.save": "Couldn't save this photo. Try again.",
  "professionalPhoto.generate": "Make professional photos",
  "professionalPhoto.intro": "Pick up to three looks and we'll make a professional version of your photo in each. Your face and proportions stay the same, and a dark face gets better light. Check that each one still looks like you before you use it.",
  "professionalPhoto.loading": "Making your photos",
  "professionalPhoto.original": "Your photo now",
  "professionalPhoto.privacy": "Your photo is sent to OpenAI to make these. The results are saved to your account so you can switch later; delete any you don't want. Your profile photo only changes when you choose one.",
  "professionalPhoto.style.office": "Office look",
  "professionalPhoto.style.studio": "Studio portrait",
  "professionalPhoto.title": "Professional photo",
  "professionalPhoto.use": "Use this photo",
  "profile.profilePhoto.makeProfessional": "Make it professional",
  "professionalPhoto.deleteAria": "Delete this photo",
  "professionalPhoto.error.delete": "Couldn't delete this photo. Try again.",
  "professionalPhoto.inspectAria": "View this photo larger",
  "professionalPhoto.loadingElapsed": "{seconds} s",
  "professionalPhoto.loadingHint": "This usually takes about 30 seconds. You can close this: the photos are saved to your account when they're ready.",
  "professionalPhoto.looks": "Looks (up to {max})",
  "professionalPhoto.new": "New",
  "professionalPhoto.saved": "Your professional photos",
  "professionalPhoto.style.formal": "Formal",
  "professionalPhoto.style.outdoor": "Outdoors",
  "professionalPhoto.style.smartCasual": "Smart casual",
  "professionalPhoto.viewer.close": "Close viewer",
  "professionalPhoto.viewer.compare": "Compare with my photo",
  "professionalPhoto.viewer.delete": "Delete",
  "professionalPhoto.viewer.hint": "Check the eyes, hairline and shoulders up close. Use the arrow keys to switch photos.",
  "professionalPhoto.viewer.next": "Next photo",
  "professionalPhoto.viewer.position": "{current} of {total}",
  "professionalPhoto.viewer.previous": "Previous photo",
  "professionalPhoto.viewer.single": "Show only this one",
  "professionalPhoto.viewer.title": "Photo viewer",
  "professionalPhoto.viewer.zoomAria": "Zoom in or out",
  "professionalPhoto.viewer.zoomIn": "Press to zoom in",
  "professionalPhoto.viewer.zoomOut": "Press to zoom out",
  "tailorPhoto.none": "No photo",
  "tailorPhoto.profile": "Profile photo",
  "tailorPhoto.reason.casualField": "A smart casual photo suits this job (field: {field}).",
  "tailorPhoto.reason.default": "A business photo is the safe choice for this job.",
  "tailorPhoto.reason.formalField": "A formal photo suits this job (field: {field}).",
  "tailorPhoto.reason.managerRole": "A business photo suits a manager role (field: {field}).",
  "tailorPhoto.reason.seniorRole": "A formal photo suits this role (level: {level}).",
  "tailorPhoto.suggested": "Suggested",
  "tailorPhoto.title": "Photo on this CV",
  "backoffice.category.data": "Data & crawling",
  "backoffice.category.products": "Products & accounts",
  "backoffice.category.sales": "Sales & outreach",
  "backoffice.category.trafficErrors": "Traffic & errors",
  "backoffice.hub.desc.reviewQueues": "Approve sub-brands, layoff notices, systems in job ads, AI exposure scores and shared company facts before pages use them.",
  "backoffice.reviewQueues.nav": "Review queues",
  "backoffice.subpage.journeyNudges": "Journey nudges",
  "backoffice.subpage.suspendedRecruiters": "Suspended recruiters",
  "outpost.shell.brand": "Outpost",
  "outpost.shell.byline": "by JobCrawls",
  "outpost.shell.jobSearch": "Job search",
  "outpost.shell.signOut": "Sign out",
  "teams.claim.openProspector": "Open Prospector",
  "teams.claim.prospectorBody": "Your Prospector workspace is now linked to {company}, with triggers picked from what the company does.",
  "employers.companyPicker.label": "Company name",
  "employers.companyPicker.noMatches": "No company by that name on JobCrawls. Try the official name or a shorter part of it.",
  "employers.companyPicker.placeholder": "Start typing your company name",
  "teams.claim.pickPrompt": "Which company do you work at?",
  "outpost.nav.home": "Dashboard",
  "outpost.nav.jobBoards": "Job boards",
  "teams.shell.dashboard": "Dashboard",
  "teams.shell.pipeline": "Pipeline",
  "outpost.nav.ads": "Ad builder",
  "teams.shell.account": "Your account",
  "teams.shell.close": "Close",
  "teams.shell.due": "{count, plural, one {# next step due} other {# next steps due}}",
  "teams.shell.members": "Members and plan",
  "teams.shell.more": "More",
  "teams.shell.moreLabel": "More workspace tools",
  "teams.shell.newHits": "{count, plural, one {# new trigger} other {# new triggers}}",
  "teams.shell.workspace": "Workspace: {name}",
  "outpost.shell.company": "Company",
  "demo.banner.body": "Everything here is sample data. Click around and change anything: it stays in this browser, and nobody else sees it.",
  "demo.banner.exit": "Exit demo",
  "demo.banner.outpost": "Outpost demo",
  "demo.banner.plus": "JobCrawls Plus demo",
  "demo.banner.prospector": "Prospector demo",
  "demo.banner.startOver": "Start over",
  "demo.view": "View demo",
  "plus.r5.whyMatch.adMinimumYears": "Minimum experience: {years, plural, one {# year} other {# years}}",
  "plus.r5.whyMatch.adRequiredLanguage": "Required languages: {language}",
  "profile.account.resetTest.button": "Reset test account",
  "profile.account.resetTest.error": "Reset failed. Please try again.",
  "profile.account.resetTest.working": "Resetting…",
  "cityPageV2.market.netPaySentence": "At the median, take-home pay is about <b>{net}</b> (municipal tax {rate}, no church tax). <link>Work out your own take-home pay</link>",
  "marketHeader.qa.employersAnswerInflected": "The employers with the most open jobs in {townLocative} include {companies}.",
  "marketHeader.qa.employersQuestionInflected": "Which companies are hiring in {townLocative}?",
  "marketHeader.qa.fieldsAnswerInflected": "Most jobs in {townLocative} are in {fields}.",
  "marketHeader.qa.fieldsQuestionInflected": "What kinds of jobs are available in {townLocative}?",
  "marketHeader.qa.languageQuestionInflected": "What languages are required in {townLocative}?",
  "marketHeader.qa.openJobsAnswerInflected": "{count, plural, one {There is # open job} other {There are # open jobs}} in {townLocative} on JobCrawls right now, collected from employers' own career sites and Työmarkkinatori.",
  "marketHeader.qa.openJobsQuestionInflected": "How many jobs are open in {townLocative}?",
  "marketHeader.qa.remoteShareQuestionInflected": "How many jobs in {townLocative} are remote or hybrid?",
  "marketHeader.qa.salaryQuestionInflected": "What is the average salary in {townLocative}?",
  "tools.applicationState.hired": "Hired",
  "tools.applicationState.interviewing": "Interviewing",
  "tools.applicationState.none": "None",
  "tools.applicationState.offer": "Offer",
  "tools.applicationState.rejected": "Rejected",
  "companyProfile.correction.body": "Page: {url}. What is incorrect, and what should it say?",
  "companyProfile.correction.link": "Report a correction",
  "companyProfile.correction.subject": "Correction: {company}",
  "companyProfile.trademarkNote": "Company names and logos belong to their owners and appear here for identification only. No affiliation or endorsement is implied.",
  "jobDetailAlertCta.expiredBannerText": "This one has closed. Get alerted when a new {role} job like this opens",
  "jobDetailAlertCta.expiredBannerTextWithLocation": "This one has closed. Get alerted when a new {role} job in {location} opens",
  "jobDetailPageV2.expired.closed": "This listing has closed",
  "jobDetailPageV2.expired.seeSimilar": "See similar open jobs",
  "backoffice.hub.desc.knowledgeGraph": "Browse and search the feature docs: what each part of the product does and how it is built.",
  "backoffice.knowledgeGraph.nav": "Knowledge graph",
  "backoffice.hub.desc.jobData": "Chart salary stats, trends and live job data queries, and build Claude prompts for content.",
  "backoffice.jobData.nav": "Job data",
  "jobDetailPage.recruitingViaAgency": "Recruiting via {agencyName}",
  "jobDetailPage.staffingAssignmentAtClient": "Employed by the agency, working at {clientName}",
  "setupGuide.alertsAction": "Turn on alerts",
  "setupGuide.alertsBody": "Save a search and turn on alerts, and new matching jobs come to you.",
  "setupGuide.alertsTitle": "Searches and alerts",
  "setupGuide.cardAction": "Continue",
  "setupGuide.cardBody": "{handled} of {total} done. A complete profile brings better matches.",
  "setupGuide.cardDismiss": "Hide setup card",
  "setupGuide.cardTitle": "Finish setting up",
  "setupGuide.close": "Close",
  "setupGuide.completeBody": "Your profile, watchlist and alerts are ready. New matches will show up in your alerts and on your Watchlist.",
  "setupGuide.completeTitle": "You are all set",
  "setupGuide.cvAction": "Add your CV",
  "setupGuide.cvBody": "Upload your CV or fill it in. It powers Match my CV and your application kits.",
  "setupGuide.cvTitle": "Your CV",
  "setupGuide.doneLabel": "Done",
  "setupGuide.editAction": "Edit",
  "setupGuide.homeAction": "Set your home",
  "setupGuide.homeBody": "Your home address gives you commute times on every job.",
  "setupGuide.homeTitle": "Home and commute",
  "setupGuide.introBody1": "Your saved jobs, searches and profile now follow you to every device.",
  "setupGuide.introBody2": "Tell us what you do and what you want, and we rank jobs by how well they fit.",
  "setupGuide.introBody3": "Follow companies and turn on alerts, and new jobs reach you before you go looking.",
  "setupGuide.introLater": "Later",
  "setupGuide.introNext": "Next",
  "setupGuide.introStart": "Set up your profile",
  "setupGuide.introStepOf": "{current} of {total}",
  "setupGuide.introTitle1": "You are signed in",
  "setupGuide.introTitle2": "Better matches start with you",
  "setupGuide.introTitle3": "Let the jobs come to you",
  "setupGuide.languagesAction": "Add languages",
  "setupGuide.languagesBody": "Many jobs in Finland ask for Finnish, Swedish or English. Add the ones you speak.",
  "setupGuide.languagesTitle": "Languages",
  "setupGuide.lede": "A few minutes here and the jobs, alerts and reminders you get fit you. Skip anything you like and come back later.",
  "setupGuide.pageTitle": "Get set up",
  "setupGuide.preferencesAction": "Set preferences",
  "setupGuide.preferencesBody": "Remote or on site, full or part time, and the least you would take.",
  "setupGuide.preferencesTitle": "Work model and pay",
  "setupGuide.progress": "{handled} of {total} done",
  "setupGuide.reportingAction": "See how",
  "setupGuide.reportingBody": "Keep a list of the jobs you apply for, ready to copy into Työmarkkinatori.",
  "setupGuide.reportingExport": "Export applied jobs",
  "setupGuide.reportingGotIt": "Got it",
  "setupGuide.reportingNote": "JobCrawls does not send anything to Työmarkkinatori or TE services for you. How many jobs to apply for and your review period are in your own employment plan.",
  "setupGuide.reportingOpenTmt": "Open Työmarkkinatori",
  "setupGuide.reportingRules": "Read about the job-search obligation",
  "setupGuide.reportingStep1": "When you apply for a job, mark it as applied in JobCrawls. Jobs you applied for elsewhere can be added in Applied jobs.",
  "setupGuide.reportingStep2": "When your report is due, export your applied jobs for that period. You get employer, position, date applied and a link for each.",
  "setupGuide.reportingStep3": "Copy each application into Työmarkkinatori, the way your employment plan tells you to.",
  "setupGuide.reportingTitle": "Report to Työmarkkinatori",
  "setupGuide.rolesAction": "Choose roles",
  "setupGuide.rolesBody": "The job titles you want and where you want to work.",
  "setupGuide.rolesTitle": "Roles and places",
  "setupGuide.sectionProfile": "Your profile",
  "setupGuide.sectionReporting": "Report your job search",
  "setupGuide.sectionStayInLoop": "Stay in the loop",
  "setupGuide.skillsAction": "Add skills",
  "setupGuide.skillsBody": "The skills on your CV decide which jobs rank first when you match your CV.",
  "setupGuide.skillsTitle": "Skills",
  "setupGuide.skipAction": "Skip",
  "setupGuide.skippedLabel": "Skipped",
  "setupGuide.undoSkipAction": "Do it now",
  "setupGuide.watchlistAction": "Find companies",
  "setupGuide.watchlistBody": "Follow companies you would like to work for and see when they post new jobs.",
  "setupGuide.watchlistSecondary": "Open your watchlist",
  "setupGuide.watchlistTitle": "Watchlist",
  "guestAlertForm.consent": "We'll email you a link to confirm. Confirming creates a free JobCrawls account for this address so you can manage your alerts. No password. Unsubscribe or delete it any time.",
  "guestAlertForm.emailLabel": "Your email",
  "guestAlertForm.emailPlaceholder": "name@example.com",
  "guestAlertForm.error": "Something went wrong and we couldn't send the link. Please try again.",
  "guestAlertForm.invalidEmail": "Enter an email address like name@example.com.",
  "guestAlertForm.sent": "Check your inbox to confirm. No password needed.",
  "guestAlertForm.submit": "Get alerts",
  "guestAlertForm.submitting": "Sending…",
  "jobAlerts.confirm.guestExistingBody": "Your alert is on and added to your JobCrawls account. Sign in to see it with your other searches.",
  "jobAlerts.confirm.guestExplanation": "Confirm your email address to start your job alert. This creates a free JobCrawls account for this address, with no password.",
  "jobAlerts.confirm.guestInvalidLink": "This confirmation link is invalid, has expired or was already used. If your alert is not on yet, ask for it again from a search.",
  "jobAlerts.confirm.guestSuccessBody": "We'll email you new jobs every Monday. To change the alert or save jobs, sign in with a code we send to this address. No password needed.",
  "jobAlerts.confirm.guestSuccessHeading": "Your job alert is on",
  "jobAlerts.confirm.manageAlerts": "Manage your alerts",
  "salaryRolePage.cite.copied": "Copied",
  "salaryRolePage.cite.copy": "Copy",
  "salaryRolePage.cite.heading": "Cite this page",
  "salaryRolePage.cite.htmlLabel": "HTML link",
  "salaryRolePage.cite.intro": "You are free to quote and reuse these figures, also commercially, with a link back to this page.",
  "salaryRolePage.cite.link": "Cite this page",
  "salaryRolePage.cite.quoteAds": "{title}: median {median} a month (JobCrawls, based on {count} job ads, updated {date}). {url}",
  "salaryRolePage.cite.quoteLabel": "Quote with the figure",
  "salaryRolePage.cite.quoteOfficial": "{title}: median {median} a month (JobCrawls, based on Statistics Finland earnings data, updated {date}). {url}",
  "salaryRolePage.cite.reference": "JobCrawls ({year}). {title}. Updated {date}. {url}",
  "salaryRolePage.cite.referenceLabel": "Reference",
  "salaryRolePage.cite.updatedLine": "Updated {date}",
  "backoffice.subpage.companyValuation": "Company valuation",
  "dataUse.cite.heading": "How to cite JobCrawls data",
  "dataUse.cite.inTextExample": "Nurses in Finland earn a median of €3,850 a month (JobCrawls, October 2026).",
  "dataUse.cite.inTextLabel": "In running text",
  "dataUse.cite.intro": "Name JobCrawls and link to the exact page the figure came from, not the home page. Every page with figures has a “Cite this data” box with the text ready to copy.",
  "dataUse.cite.qualifier": "Keep what the figure is. When a salary page credits Statistics Finland, credit both, for example “JobCrawls, based on Statistics Finland earnings data”. Use the date the page shows, not the day you read it, and link the page rather than quoting old figures as current.",
  "dataUse.cite.referenceFormat": "JobCrawls (year). Page title. Updated date. Page address.",
  "dataUse.cite.referenceLabel": "In a reference list",
  "search.refinements.isBusinessOpportunity.filter": "Business opportunity",
  "teams.claim.emailBody": "Send us an email from your work address and a person checks it and gives you access. This takes longer than the options above, usually a working day.",
  "teams.claim.emailButton": "Email {email}",
  "teams.claim.emailSubject": "Claim the {company} page",
  "teams.claim.emailTitle": "Or email us",
  "teams.claim.emailCompanyId": "(Company id: {companyId})",
  "teams.claim.emailHi": "Hi,",
  "teams.claim.emailIntro": "I work at {company} and would like to manage its JobCrawls page.",
  "teams.claim.emailName": "My name:",
  "teams.claim.emailRole": "My role:",
  "teams.claim.careersFirstLabel": "Add this line anywhere in the text of your careers page, {url}",
  "teams.claim.careersLabel": "Or this line anywhere in the text of your careers page, {url}",
  "teams.claim.codeBody": "Anyone who can edit the {domain} DNS or website can do this. Add one of these, then press \"Check now\". You can remove it once you are in.",
  "teams.claim.codeBodyCareers": "Anyone who can edit your careers page can do this. Add the line below to the page text, then press \"Check now\". You can remove it once you are in.",
  "teams.claim.codeTitle": "Add a code to your website or careers page",
  "teams.claim.emailCodeBadEmail": "Use your address at {domain}.",
  "teams.claim.emailCodeBody": "We send a 6-digit code to your address at {domain}. Type it in here and the portal opens.",
  "teams.claim.emailCodeExpired": "That code has expired or was tried too many times. Send a new one.",
  "teams.claim.emailCodeInputLabel": "Code from the email",
  "teams.claim.emailCodeLabel": "Your work email",
  "teams.claim.emailCodeRateLimited": "Wait a minute before asking for another code. You can get five codes a day.",
  "teams.claim.emailCodeResend": "Send a new code",
  "teams.claim.emailCodeSend": "Send the code",
  "teams.claim.emailCodeSent": "We sent a code to {email}. It works for 30 minutes.",
  "teams.claim.emailCodeTitle": "Get a code at your work email",
  "teams.claim.emailCodeVerify": "Confirm",
  "teams.claim.emailCodeWrong": "That code does not match. Check the latest email and try again.",
  "teams.claim.metaLabel": "Or this tag in the head section of your homepage, {url}",
  "profile.cvImport.emptyPdf": "We found no text in that PDF. If it is a scanned image, export your CV as a text PDF and try again.",
  "profile.cvImport.unreadablePdf": "We could not read that PDF. It may be damaged or password-protected. Save it again as a PDF and try once more.",
  "srpCvOrder.profileHint": "Add your CV on your profile to put the jobs that match it first.",
  "srpAlertCta.channels.emailMe": "Email me",
  "yourFit.cv.compared": "Compared with this job",
  "yourFit.cv.label": "Your CV",
  "yourFit.cv.noCv": "Add your CV to compare",
  "yourFit.cv.skills": "Shows {have} of the {total} skills the ad lists",
  "yourFit.mobile.default": "Compare it with your profile and CV",
  "yourFit.mobile.grade": "Fit {grade} for your profile",
  "yourFit.sheet.close": "Close",
  "profile.howto.toggle": "How is my data used?",
  "watchlist.company.matchingRoles": "Recent jobs that could match you",
  "watchlist.company.newRoleChip": "New",
  "talent.blocker.thinProfile": "Your CV needs a title and a summary of a couple of sentences.",
  "talent.preview.edit": "Edit my profile",
  "talent.preview.empty": "Add a title and a summary of a couple of sentences to your CV, and this is where you will see what recruiters get.",
  "talent.preview.intro": "These parts of your profile, without your name, photo, contact details or employer names. To change them, edit your profile.",
  "talent.preview.title": "What recruiters see",
  "cvStudio.panel.expand": "Open a larger preview",
  "resignation.checkContract": "Your employment contract or collective agreement may set a different period; check it before sending. This is not legal advice.",
  "resignation.reset": "Rewrite from the details",
  "resignation.section.details": "Details",
  "resignation.timeline.end": "Your employment ends",
  "resignation.timeline.given": "You hand it in",
  "resignation.timeline.length": "{unit, select, days {{count, plural, one {# day} other {# days}}} other {{count, plural, one {# month} other {# months}}}} notice",
  "savedSearches.confirmRemove.historyBody": "{count, plural, one {# search you ran but did not save will be removed.} other {# searches you ran but did not save will be removed.}} Your saved searches and alerts stay.",
  "savedSearches.confirmRemove.historyTitle": "Clear search history?",
  "searchesHub.history.clear": "Clear history",
  "searchesHub.history.description": "Searches you ran recently. Save the ones you want to keep coming back to.",
  "searchesHub.history.jobs": "{count, plural, one {# job} other {# jobs}}",
  "searchesHub.history.removeAria": "Remove \"{title}\" from history",
  "searchesHub.history.save": "Save",
  "searchesHub.history.saveAria": "Save \"{title}\"",
  "searchesHub.history.showAll": "Show all {count}",
  "searchesHub.history.showFewer": "Show fewer",
  "searchesHub.history.title": "Search history",
  "searchesHub.saved.empty": "Nothing saved yet. Press “Save search” on the results page, or save one from your search history below.",
  "searchesHub.saved.title": "Saved & alerts",
  "srpSaveSearch.save": "Save search",
  "srpSaveSearch.saved": "Saved",
  "talent.audience.blockHelpExample": "Such as a former employer or a client",
  "talent.audience.blockLabelOther": "Other companies",
  "talent.audience.hideEmployerFromProfile": "From your profile: {names}.",
  "talent.audience.hideEmployerShort": "My current employer",
  "talent.audience.introMerged": "Recruiters only ever see your anonymous card. Choose which companies get to see it, and what a request has to offer.",
  "talent.audience.neverIntro": "These companies never see your card, even if they pass every filter above.",
  "talent.audience.neverTitle": "Never show it to",
  "talent.audience.onlyWatchlist": "Only companies on my Watchlist",
  "talent.audience.showIntro": "A company has to pass every filter you set. Leave one empty to allow any.",
  "talent.audience.showTitle": "Show my card to",
  "talent.audience.titleMerged": "Who can see and contact you",
  "talent.audience.watchlistEdit": "Open your Watchlist",
  "talent.audience.watchlistEmpty": "Your Watchlist is empty, so turning this on hides your card from everyone.",
  "talent.audience.watchlistHelp": "Companies you follow later are added on your next visit here.",
  "talent.audience.watchlistList": "On your Watchlist: {names}.",
  "talent.audience.watchlistMore": "{count, plural, one {# more} other {# more}}",
  "talent.audience.watchlistNone": "You follow no companies yet.",
  "talent.contact.groupTitle": "Contact requests",
  "translation.test": "Translation Test: English"
};

export default messages;
